import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const lazyLoadGql = (typeof window !== 'undefined') && (window?.blink?.performanceFlags?.isLazyLoadGqlEnabled === 'true');
export function lazyGql(factory) {
    let cached = null;
    if (!lazyLoadGql) {
        return factory();
    }
    return new Proxy({}, {
        get(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return cached[prop];
        },
        set(_target, prop, value) {
            if (cached === null) {
                cached = factory();
            }
            cached[prop] = value;
            return true;
        },
        has(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return prop in cached;
        },
        ownKeys() {
            if (cached === null) {
                cached = factory();
            }
            return Reflect.ownKeys(cached);
        },
        getOwnPropertyDescriptor(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return Object.getOwnPropertyDescriptor(cached, prop);
        },
        getPrototypeOf() {
            if (cached === null) {
                cached = factory();
            }
            return Object.getPrototypeOf(cached);
        },
        setPrototypeOf(_target, proto) {
            if (cached === null) {
                cached = factory();
            }
            return Object.setPrototypeOf(cached, proto);
        },
        defineProperty(_target, prop, descriptor) {
            if (cached === null) {
                cached = factory();
            }
            return Object.defineProperty(cached, prop, descriptor);
        },
        deleteProperty(_target, prop) {
            if (cached === null) {
                cached = factory();
            }
            return delete cached[prop];
        },
        isExtensible() {
            if (cached === null) {
                cached = factory();
            }
            return Object.isExtensible(cached);
        },
        preventExtensions() {
            if (cached === null) {
                cached = factory();
            }
            Object.preventExtensions(cached);
            return true;
        },
        apply(_target, thisArg, argumentsList) {
            if (cached === null) {
                cached = factory();
            }
            return cached.apply(thisArg, argumentsList);
        },
        construct(_target, argumentsList, newTarget) {
            if (cached === null) {
                cached = factory();
            }
            return Reflect.construct(cached, argumentsList, newTarget);
        }
    });
}
const defaultOptions = {};
export var A3AnalysisTypeEnum;
(function (A3AnalysisTypeEnum) {
    A3AnalysisTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    A3AnalysisTypeEnum["Change"] = "CHANGE";
    A3AnalysisTypeEnum["Data"] = "DATA";
    A3AnalysisTypeEnum["RelatedInsights"] = "RELATED_INSIGHTS";
    A3AnalysisTypeEnum["Table"] = "TABLE";
    A3AnalysisTypeEnum["Unknown"] = "UNKNOWN";
    A3AnalysisTypeEnum["Visualization"] = "VISUALIZATION";
})(A3AnalysisTypeEnum || (A3AnalysisTypeEnum = {}));
export var A3ColumnType;
(function (A3ColumnType) {
    A3ColumnType["Attribute"] = "ATTRIBUTE";
    A3ColumnType["Measure"] = "MEASURE";
})(A3ColumnType || (A3ColumnType = {}));
export var AiAnswerState;
(function (AiAnswerState) {
    AiAnswerState["Disabled"] = "DISABLED";
    AiAnswerState["Enabled"] = "ENABLED";
    AiAnswerState["NotSet"] = "NOT_SET";
})(AiAnswerState || (AiAnswerState = {}));
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel["Modify"] = "MODIFY";
    AccessLevel["ReadOnly"] = "READ_ONLY";
})(AccessLevel || (AccessLevel = {}));
export var AccessLevelEnum;
(function (AccessLevelEnum) {
    AccessLevelEnum["Full"] = "FULL";
    AccessLevelEnum["ReportBookView"] = "REPORT_BOOK_VIEW";
})(AccessLevelEnum || (AccessLevelEnum = {}));
export var AccessMode;
(function (AccessMode) {
    AccessMode["Modify"] = "MODIFY";
    AccessMode["NoAccess"] = "NO_ACCESS";
    AccessMode["ReadOnly"] = "READ_ONLY";
})(AccessMode || (AccessMode = {}));
export var AccessType;
(function (AccessType) {
    AccessType["User"] = "USER";
    AccessType["UserGroup"] = "USER_GROUP";
})(AccessType || (AccessType = {}));
export var ActionAvailability;
(function (ActionAvailability) {
    ActionAvailability["ContextMenuOnly"] = "CONTEXT_MENU_ONLY";
    ActionAvailability["Global"] = "GLOBAL";
    ActionAvailability["Worksheet"] = "WORKSHEET";
})(ActionAvailability || (ActionAvailability = {}));
export var ActionContext;
(function (ActionContext) {
    ActionContext["ContextMenu"] = "CONTEXT_MENU";
    ActionContext["Menu"] = "MENU";
    ActionContext["None"] = "NONE";
    ActionContext["Primary"] = "PRIMARY";
})(ActionContext || (ActionContext = {}));
export var ActionSelect;
(function (ActionSelect) {
    ActionSelect["Apikey"] = "APIKEY";
    ActionSelect["Basic"] = "BASIC";
    ActionSelect["Bearer"] = "BEARER";
    ActionSelect["None"] = "NONE";
})(ActionSelect || (ActionSelect = {}));
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["App"] = "APP";
    ActionTypes["Callback"] = "CALLBACK";
    ActionTypes["Url"] = "URL";
})(ActionTypes || (ActionTypes = {}));
export var AggregateFunctionTypeEnum;
(function (AggregateFunctionTypeEnum) {
    AggregateFunctionTypeEnum["Aggregate"] = "AGGREGATE";
    AggregateFunctionTypeEnum["AggrDistinct"] = "AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    AggregateFunctionTypeEnum["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    AggregateFunctionTypeEnum["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Average"] = "AVERAGE";
    AggregateFunctionTypeEnum["Count"] = "COUNT";
    AggregateFunctionTypeEnum["CountDistinct"] = "COUNT_DISTINCT";
    AggregateFunctionTypeEnum["Growth"] = "GROWTH";
    AggregateFunctionTypeEnum["Max"] = "MAX";
    AggregateFunctionTypeEnum["Median"] = "MEDIAN";
    AggregateFunctionTypeEnum["Min"] = "MIN";
    AggregateFunctionTypeEnum["None"] = "NONE";
    AggregateFunctionTypeEnum["Percentile"] = "PERCENTILE";
    AggregateFunctionTypeEnum["Rank"] = "RANK";
    AggregateFunctionTypeEnum["RankPercentile"] = "RANK_PERCENTILE";
    AggregateFunctionTypeEnum["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    AggregateFunctionTypeEnum["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    AggregateFunctionTypeEnum["StdDeviation"] = "STD_DEVIATION";
    AggregateFunctionTypeEnum["Sum"] = "SUM";
    AggregateFunctionTypeEnum["TableAggr"] = "TABLE_AGGR";
    AggregateFunctionTypeEnum["Variance"] = "VARIANCE";
})(AggregateFunctionTypeEnum || (AggregateFunctionTypeEnum = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    AggregationType["Average"] = "AVERAGE";
    AggregationType["Count"] = "COUNT";
    AggregationType["Max"] = "MAX";
    AggregationType["Median"] = "MEDIAN";
    AggregationType["Min"] = "MIN";
    AggregationType["None"] = "NONE";
    AggregationType["Percentile"] = "PERCENTILE";
    AggregationType["Rank"] = "RANK";
    AggregationType["RankPercentile"] = "RANK_PERCENTILE";
    AggregationType["StdDeviation"] = "STD_DEVIATION";
    AggregationType["Sum"] = "SUM";
    AggregationType["UniqueCount"] = "UNIQUE_COUNT";
    AggregationType["Variance"] = "VARIANCE";
})(AggregationType || (AggregationType = {}));
export var AlertType;
(function (AlertType) {
    AlertType["Anomaly"] = "Anomaly";
    AlertType["Scheduled"] = "Scheduled";
    AlertType["ScheduledByAttribute"] = "ScheduledByAttribute";
    AlertType["Threshold"] = "Threshold";
    AlertType["ThresholdByAttribute"] = "ThresholdByAttribute";
})(AlertType || (AlertType = {}));
export var AnalysisActionResponseStatus;
(function (AnalysisActionResponseStatus) {
    AnalysisActionResponseStatus["Done"] = "DONE";
    AnalysisActionResponseStatus["Failed"] = "FAILED";
})(AnalysisActionResponseStatus || (AnalysisActionResponseStatus = {}));
export var AnalysisActionType;
(function (AnalysisActionType) {
    AnalysisActionType["Delete"] = "DELETE";
    AnalysisActionType["Save"] = "SAVE";
})(AnalysisActionType || (AnalysisActionType = {}));
export var AnalysisAlgorithmTypeEnum;
(function (AnalysisAlgorithmTypeEnum) {
    AnalysisAlgorithmTypeEnum["AbsDiffMajority"] = "ABS_DIFF_MAJORITY";
    AnalysisAlgorithmTypeEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisAlgorithmTypeEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisAlgorithmTypeEnum["Forecast"] = "FORECAST";
    AnalysisAlgorithmTypeEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisAlgorithmTypeEnum["LinearRegression"] = "LINEAR_REGRESSION";
    AnalysisAlgorithmTypeEnum["MadMedian"] = "MAD_MEDIAN";
    AnalysisAlgorithmTypeEnum["Shesd"] = "SHESD";
    AnalysisAlgorithmTypeEnum["StdevMean"] = "STDEV_MEAN";
    AnalysisAlgorithmTypeEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisAlgorithmTypeEnum["WhatIf"] = "WHAT_IF";
})(AnalysisAlgorithmTypeEnum || (AnalysisAlgorithmTypeEnum = {}));
export var AnalysisClassEnum;
(function (AnalysisClassEnum) {
    AnalysisClassEnum["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    AnalysisClassEnum["CrossCorrelation"] = "CROSS_CORRELATION";
    AnalysisClassEnum["CustomRAnalysis"] = "CUSTOM_R_ANALYSIS";
    AnalysisClassEnum["DiffExplanation"] = "DIFF_EXPLANATION";
    AnalysisClassEnum["Forecast"] = "FORECAST";
    AnalysisClassEnum["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisClassEnum["OutlierDetection"] = "OUTLIER_DETECTION";
    AnalysisClassEnum["TrendAnalysis"] = "TREND_ANALYSIS";
    AnalysisClassEnum["WhatIf"] = "WHAT_IF";
})(AnalysisClassEnum || (AnalysisClassEnum = {}));
export var AnalysisSortBy;
(function (AnalysisSortBy) {
    AnalysisSortBy["ExpiresIn"] = "EXPIRES_IN";
    AnalysisSortBy["LastAnalyzed"] = "LAST_ANALYZED";
    AnalysisSortBy["Name"] = "NAME";
    AnalysisSortBy["Status"] = "STATUS";
    AnalysisSortBy["TriggeredBy"] = "TRIGGERED_BY";
})(AnalysisSortBy || (AnalysisSortBy = {}));
export var AnalysisState;
(function (AnalysisState) {
    AnalysisState["Completed"] = "COMPLETED";
    AnalysisState["Failed"] = "FAILED";
    AnalysisState["NoInsights"] = "NO_INSIGHTS";
    AnalysisState["Paused"] = "PAUSED";
    AnalysisState["Running"] = "RUNNING";
    AnalysisState["Scheduled"] = "SCHEDULED";
})(AnalysisState || (AnalysisState = {}));
export var AnalysisType;
(function (AnalysisType) {
    AnalysisType["Forecast"] = "FORECAST";
    AnalysisType["KeyDrivers"] = "KEY_DRIVERS";
    AnalysisType["KpiAnomalyDetection"] = "KPI_ANOMALY_DETECTION";
    AnalysisType["WhatIf"] = "WHAT_IF";
})(AnalysisType || (AnalysisType = {}));
export var AnomalyDirectionEnum;
(function (AnomalyDirectionEnum) {
    AnomalyDirectionEnum["High"] = "HIGH";
    AnomalyDirectionEnum["Low"] = "LOW";
    AnomalyDirectionEnum["Unknown"] = "UNKNOWN";
})(AnomalyDirectionEnum || (AnomalyDirectionEnum = {}));
export var AnswerColumnCustomCalendarType;
(function (AnswerColumnCustomCalendarType) {
    AnswerColumnCustomCalendarType["EndOfDateBucket"] = "END_OF_DATE_BUCKET";
    AnswerColumnCustomCalendarType["FormattedDateBucketString"] = "FORMATTED_DATE_BUCKET_STRING";
})(AnswerColumnCustomCalendarType || (AnswerColumnCustomCalendarType = {}));
export var AnswerColumnEffectiveType;
(function (AnswerColumnEffectiveType) {
    AnswerColumnEffectiveType["Attribute"] = "ATTRIBUTE";
    AnswerColumnEffectiveType["Measure"] = "MEASURE";
    AnswerColumnEffectiveType["Unknown"] = "UNKNOWN";
})(AnswerColumnEffectiveType || (AnswerColumnEffectiveType = {}));
export var AnswerColumnFormatType;
(function (AnswerColumnFormatType) {
    AnswerColumnFormatType["Currency"] = "CURRENCY";
    AnswerColumnFormatType["None"] = "NONE";
    AnswerColumnFormatType["Percentage"] = "PERCENTAGE";
})(AnswerColumnFormatType || (AnswerColumnFormatType = {}));
export var AnswerColumnPropVersion;
(function (AnswerColumnPropVersion) {
    AnswerColumnPropVersion["PreV1"] = "PRE_V1";
    AnswerColumnPropVersion["V1"] = "V1";
})(AnswerColumnPropVersion || (AnswerColumnPropVersion = {}));
export var AnswerColumnSortType;
(function (AnswerColumnSortType) {
    AnswerColumnSortType["Ascending"] = "ASCENDING";
    AnswerColumnSortType["Descending"] = "DESCENDING";
    AnswerColumnSortType["Unknown"] = "UNKNOWN";
})(AnswerColumnSortType || (AnswerColumnSortType = {}));
export var AnswerColumnType;
(function (AnswerColumnType) {
    AnswerColumnType["FilterColumn"] = "FILTER_COLUMN";
    AnswerColumnType["GrowthColumn"] = "GROWTH_COLUMN";
    AnswerColumnType["SageColumn"] = "SAGE_COLUMN";
    AnswerColumnType["VizSpecificColumn"] = "VIZ_SPECIFIC_COLUMN";
})(AnswerColumnType || (AnswerColumnType = {}));
export var AnswerContextType;
(function (AnswerContextType) {
    AnswerContextType["ChangeAnalysis"] = "CHANGE_ANALYSIS";
    AnswerContextType["CohortAnswer"] = "COHORT_ANSWER";
    AnswerContextType["DownloadAnswer"] = "DOWNLOAD_ANSWER";
    AnswerContextType["EditPinboardViz"] = "EDIT_PINBOARD_VIZ";
    AnswerContextType["ExploreAnswer"] = "EXPLORE_ANSWER";
    AnswerContextType["KpiMonitor"] = "KPI_MONITOR";
    AnswerContextType["NewAnswer"] = "NEW_ANSWER";
    AnswerContextType["PinboardViz"] = "PINBOARD_VIZ";
    AnswerContextType["SavedAnswer"] = "SAVED_ANSWER";
    AnswerContextType["SpotterNewAnswer"] = "SPOTTER_NEW_ANSWER";
    AnswerContextType["SpotIq"] = "SPOT_IQ";
    AnswerContextType["UnaggregatedAnswer"] = "UNAGGREGATED_ANSWER";
    AnswerContextType["View"] = "VIEW";
})(AnswerContextType || (AnswerContextType = {}));
export var AnswerJoinPathAmbiguityErrorType;
(function (AnswerJoinPathAmbiguityErrorType) {
    AnswerJoinPathAmbiguityErrorType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    AnswerJoinPathAmbiguityErrorType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(AnswerJoinPathAmbiguityErrorType || (AnswerJoinPathAmbiguityErrorType = {}));
export var AssociatedActionContext;
(function (AssociatedActionContext) {
    AssociatedActionContext["ContextMenu"] = "CONTEXT_MENU";
    AssociatedActionContext["Menu"] = "MENU";
    AssociatedActionContext["None"] = "NONE";
    AssociatedActionContext["Primary"] = "PRIMARY";
})(AssociatedActionContext || (AssociatedActionContext = {}));
export var AtlasJoinType;
(function (AtlasJoinType) {
    AtlasJoinType["Cross"] = "CROSS";
    AtlasJoinType["Inner"] = "INNER";
    AtlasJoinType["Left"] = "LEFT";
    AtlasJoinType["Outer"] = "OUTER";
    AtlasJoinType["Right"] = "RIGHT";
})(AtlasJoinType || (AtlasJoinType = {}));
export var Augmentation_Column_Type;
(function (Augmentation_Column_Type) {
    Augmentation_Column_Type["AugmentData"] = "AUGMENT_DATA";
    Augmentation_Column_Type["TsObject"] = "TS_OBJECT";
})(Augmentation_Column_Type || (Augmentation_Column_Type = {}));
export var AuthTokenType;
(function (AuthTokenType) {
    AuthTokenType["Bearer"] = "Bearer";
    AuthTokenType["Cookie"] = "Cookie";
})(AuthTokenType || (AuthTokenType = {}));
export var AuthenticationType;
(function (AuthenticationType) {
    AuthenticationType["Extoauth"] = "EXTOAUTH";
    AuthenticationType["Iam"] = "IAM";
    AuthenticationType["KeyPair"] = "KEY_PAIR";
    AuthenticationType["Oauth"] = "OAUTH";
    AuthenticationType["OauthWithPkce"] = "OAUTH_WITH_PKCE";
    AuthenticationType["OauthWithServicePrincipal"] = "OAUTH_WITH_SERVICE_PRINCIPAL";
    AuthenticationType["PersonalAccessToken"] = "PERSONAL_ACCESS_TOKEN";
    AuthenticationType["ServiceAccount"] = "SERVICE_ACCOUNT";
})(AuthenticationType || (AuthenticationType = {}));
export var AxisTypes;
(function (AxisTypes) {
    AxisTypes["Color"] = "COLOR";
    AxisTypes["X"] = "X";
    AxisTypes["Y"] = "Y";
})(AxisTypes || (AxisTypes = {}));
export var BackgroundFormatTypes;
(function (BackgroundFormatTypes) {
    BackgroundFormatTypes["Gradient"] = "GRADIENT";
    BackgroundFormatTypes["Solid"] = "SOLID";
})(BackgroundFormatTypes || (BackgroundFormatTypes = {}));
export var BlankTrueFalse;
(function (BlankTrueFalse) {
    BlankTrueFalse["False"] = "False";
    BlankTrueFalse["True"] = "True";
})(BlankTrueFalse || (BlankTrueFalse = {}));
export var BulkEditColumAttributes;
(function (BulkEditColumAttributes) {
    BulkEditColumAttributes["Additive"] = "ADDITIVE";
    BulkEditColumAttributes["Aggregation"] = "AGGREGATION";
    BulkEditColumAttributes["AttributionDimension"] = "ATTRIBUTION_DIMENSION";
    BulkEditColumAttributes["CalendarType"] = "CALENDAR_TYPE";
    BulkEditColumAttributes["ColumnType"] = "COLUMN_TYPE";
    BulkEditColumAttributes["CurrencyInfo"] = "CURRENCY_INFO";
    BulkEditColumAttributes["FormatPattern"] = "FORMAT_PATTERN";
    BulkEditColumAttributes["GeoConfig"] = "GEO_CONFIG";
    BulkEditColumAttributes["Hidden"] = "HIDDEN";
    BulkEditColumAttributes["Index"] = "INDEX";
    BulkEditColumAttributes["Name"] = "NAME";
    BulkEditColumAttributes["Search"] = "SEARCH";
    BulkEditColumAttributes["SpotIqPreference"] = "SPOT_IQ_PREFERENCE";
})(BulkEditColumAttributes || (BulkEditColumAttributes = {}));
export var CcaColumnConfigAction;
(function (CcaColumnConfigAction) {
    CcaColumnConfigAction["Reset"] = "RESET";
    CcaColumnConfigAction["Save"] = "SAVE";
})(CcaColumnConfigAction || (CcaColumnConfigAction = {}));
export var CcaColumnConfigType;
(function (CcaColumnConfigType) {
    CcaColumnConfigType["Chart"] = "CHART";
    CcaColumnConfigType["Ubr"] = "UBR";
    CcaColumnConfigType["User"] = "USER";
})(CcaColumnConfigType || (CcaColumnConfigType = {}));
export var CategoryType;
(function (CategoryType) {
    CategoryType["Currency"] = "CURRENCY";
    CategoryType["Custom"] = "CUSTOM";
    CategoryType["Number"] = "NUMBER";
    CategoryType["Percentage"] = "PERCENTAGE";
})(CategoryType || (CategoryType = {}));
export var ChangeAnalysisInsightStatus;
(function (ChangeAnalysisInsightStatus) {
    ChangeAnalysisInsightStatus["ChangeAnalysisDataFetchForAihFailed"] = "CHANGE_ANALYSIS_DATA_FETCH_FOR_AIH_FAILED";
    ChangeAnalysisInsightStatus["ChangeAnalysisFailed"] = "CHANGE_ANALYSIS_FAILED";
    ChangeAnalysisInsightStatus["GroupAggregateNotSupported"] = "GROUP_AGGREGATE_NOT_SUPPORTED";
    ChangeAnalysisInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(ChangeAnalysisInsightStatus || (ChangeAnalysisInsightStatus = {}));
export var ChartResponsiveLayout;
(function (ChartResponsiveLayout) {
    ChartResponsiveLayout["AutoOff"] = "AUTO_OFF";
    ChartResponsiveLayout["AutoOn"] = "AUTO_ON";
    ChartResponsiveLayout["UserPreferredOff"] = "USER_PREFERRED_OFF";
    ChartResponsiveLayout["UserPreferredOn"] = "USER_PREFERRED_ON";
})(ChartResponsiveLayout || (ChartResponsiveLayout = {}));
export var ChartSpecificColumnType;
(function (ChartSpecificColumnType) {
    ChartSpecificColumnType["MeasureNames"] = "MEASURE_NAMES";
    ChartSpecificColumnType["MeasureValues"] = "MEASURE_VALUES";
    ChartSpecificColumnType["Undefined"] = "UNDEFINED";
})(ChartSpecificColumnType || (ChartSpecificColumnType = {}));
export var ChartType;
(function (ChartType) {
    ChartType["Area"] = "AREA";
    ChartType["Bar"] = "BAR";
    ChartType["Bubble"] = "BUBBLE";
    ChartType["Candlestick"] = "CANDLESTICK";
    ChartType["Column"] = "COLUMN";
    ChartType["CustomChart"] = "CUSTOM_CHART";
    ChartType["Funnel"] = "FUNNEL";
    ChartType["GeoArea"] = "GEO_AREA";
    ChartType["GeoBubble"] = "GEO_BUBBLE";
    ChartType["GeoEarthArea"] = "GEO_EARTH_AREA";
    ChartType["GeoEarthBar"] = "GEO_EARTH_BAR";
    ChartType["GeoEarthBubble"] = "GEO_EARTH_BUBBLE";
    ChartType["GeoEarthGraph"] = "GEO_EARTH_GRAPH";
    ChartType["GeoEarthHeatmap"] = "GEO_EARTH_HEATMAP";
    ChartType["GeoHeatmap"] = "GEO_HEATMAP";
    ChartType["GridTable"] = "GRID_TABLE";
    ChartType["Heatmap"] = "HEATMAP";
    ChartType["Kpi"] = "KPI";
    ChartType["Line"] = "LINE";
    ChartType["LineColumn"] = "LINE_COLUMN";
    ChartType["LineStackedColumn"] = "LINE_STACKED_COLUMN";
    ChartType["None"] = "NONE";
    ChartType["Pareto"] = "PARETO";
    ChartType["Pie"] = "PIE";
    ChartType["PivotTable"] = "PIVOT_TABLE";
    ChartType["Sankey"] = "SANKEY";
    ChartType["Scatter"] = "SCATTER";
    ChartType["SpiderWeb"] = "SPIDER_WEB";
    ChartType["StackedArea"] = "STACKED_AREA";
    ChartType["StackedBar"] = "STACKED_BAR";
    ChartType["StackedColumn"] = "STACKED_COLUMN";
    ChartType["Treemap"] = "TREEMAP";
    ChartType["Waterfall"] = "WATERFALL";
    ChartType["WhiskerScatter"] = "WHISKER_SCATTER";
})(ChartType || (ChartType = {}));
export var ChartVizPropVersion;
(function (ChartVizPropVersion) {
    ChartVizPropVersion["V2"] = "V2";
    ChartVizPropVersion["V2Dot1"] = "V2DOT1";
    ChartVizPropVersion["V3"] = "V3";
    ChartVizPropVersion["V4"] = "V4";
    ChartVizPropVersion["V4Dot1"] = "V4DOT1";
    ChartVizPropVersion["V4Dot2"] = "V4DOT2";
})(ChartVizPropVersion || (ChartVizPropVersion = {}));
export var ChipType;
(function (ChipType) {
    ChipType["Filter"] = "FILTER";
    ChipType["Parameter"] = "PARAMETER";
})(ChipType || (ChipType = {}));
export var ClientAction;
(function (ClientAction) {
    ClientAction["ChangeVisualConfiguration"] = "CHANGE_VISUAL_CONFIGURATION";
    ClientAction["HighlightFilters"] = "HIGHLIGHT_FILTERS";
    ClientAction["HighlightTable"] = "HIGHLIGHT_TABLE";
    ClientAction["SeeResults"] = "SEE_RESULTS";
})(ClientAction || (ClientAction = {}));
export var CohortConditionCombinationType;
(function (CohortConditionCombinationType) {
    CohortConditionCombinationType["All"] = "ALL";
    CohortConditionCombinationType["Any"] = "ANY";
})(CohortConditionCombinationType || (CohortConditionCombinationType = {}));
export var CohortGroupingType;
(function (CohortGroupingType) {
    CohortGroupingType["BinBased"] = "BIN_BASED";
    CohortGroupingType["ColumnBased"] = "COLUMN_BASED";
    CohortGroupingType["GroupBased"] = "GROUP_BASED";
})(CohortGroupingType || (CohortGroupingType = {}));
export var CohortType;
(function (CohortType) {
    CohortType["Advanced"] = "ADVANCED";
    CohortType["BinBased"] = "BIN_BASED";
    CohortType["ColumnBased"] = "COLUMN_BASED";
    CohortType["GroupBased"] = "GROUP_BASED";
    CohortType["Simple"] = "SIMPLE";
})(CohortType || (CohortType = {}));
export var ColumnAggregationType;
(function (ColumnAggregationType) {
    ColumnAggregationType["Aggregate"] = "AGGREGATE";
    ColumnAggregationType["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    ColumnAggregationType["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    ColumnAggregationType["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    ColumnAggregationType["Average"] = "AVERAGE";
    ColumnAggregationType["Count"] = "COUNT";
    ColumnAggregationType["CountDistinct"] = "COUNT_DISTINCT";
    ColumnAggregationType["CumulativeAverage"] = "CUMULATIVE_AVERAGE";
    ColumnAggregationType["CumulativeCount"] = "CUMULATIVE_COUNT";
    ColumnAggregationType["CumulativeMax"] = "CUMULATIVE_MAX";
    ColumnAggregationType["CumulativeMin"] = "CUMULATIVE_MIN";
    ColumnAggregationType["CumulativeSum"] = "CUMULATIVE_SUM";
    ColumnAggregationType["Growth"] = "GROWTH";
    ColumnAggregationType["Max"] = "MAX";
    ColumnAggregationType["Median"] = "MEDIAN";
    ColumnAggregationType["Min"] = "MIN";
    ColumnAggregationType["MovingAverage"] = "MOVING_AVERAGE";
    ColumnAggregationType["MovingCount"] = "MOVING_COUNT";
    ColumnAggregationType["MovingMax"] = "MOVING_MAX";
    ColumnAggregationType["MovingMin"] = "MOVING_MIN";
    ColumnAggregationType["MovingSum"] = "MOVING_SUM";
    ColumnAggregationType["None"] = "NONE";
    ColumnAggregationType["Percentile"] = "PERCENTILE";
    ColumnAggregationType["Rank"] = "RANK";
    ColumnAggregationType["RankPercentile"] = "RANK_PERCENTILE";
    ColumnAggregationType["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    ColumnAggregationType["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    ColumnAggregationType["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    ColumnAggregationType["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    ColumnAggregationType["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    ColumnAggregationType["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    ColumnAggregationType["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    ColumnAggregationType["StdDeviation"] = "STD_DEVIATION";
    ColumnAggregationType["Sum"] = "SUM";
    ColumnAggregationType["TableAggr"] = "TABLE_AGGR";
    ColumnAggregationType["Variance"] = "VARIANCE";
})(ColumnAggregationType || (ColumnAggregationType = {}));
export var ColumnDataTypeEnum;
(function (ColumnDataTypeEnum) {
    ColumnDataTypeEnum["Bool"] = "BOOL";
    ColumnDataTypeEnum["Char"] = "CHAR";
    ColumnDataTypeEnum["Date"] = "DATE";
    ColumnDataTypeEnum["DateNum"] = "DATE_NUM";
    ColumnDataTypeEnum["DateNumAbsDay"] = "DATE_NUM_ABS_DAY";
    ColumnDataTypeEnum["DateNumAbsHour"] = "DATE_NUM_ABS_HOUR";
    ColumnDataTypeEnum["DateNumAbsMonth"] = "DATE_NUM_ABS_MONTH";
    ColumnDataTypeEnum["DateNumAbsQuarter"] = "DATE_NUM_ABS_QUARTER";
    ColumnDataTypeEnum["DateNumAbsWeek"] = "DATE_NUM_ABS_WEEK";
    ColumnDataTypeEnum["DateNumAbsYear"] = "DATE_NUM_ABS_YEAR";
    ColumnDataTypeEnum["DateNumDayInMonth"] = "DATE_NUM_DAY_IN_MONTH";
    ColumnDataTypeEnum["DateNumDayInQuarter"] = "DATE_NUM_DAY_IN_QUARTER";
    ColumnDataTypeEnum["DateNumDayInYear"] = "DATE_NUM_DAY_IN_YEAR";
    ColumnDataTypeEnum["DateNumDayOfWeek"] = "DATE_NUM_DAY_OF_WEEK";
    ColumnDataTypeEnum["DateNumDayOfWeekStr"] = "DATE_NUM_DAY_OF_WEEK_STR";
    ColumnDataTypeEnum["DateNumHourInDay"] = "DATE_NUM_HOUR_IN_DAY";
    ColumnDataTypeEnum["DateNumMonthInQuarter"] = "DATE_NUM_MONTH_IN_QUARTER";
    ColumnDataTypeEnum["DateNumMonthInYear"] = "DATE_NUM_MONTH_IN_YEAR";
    ColumnDataTypeEnum["DateNumQuarterInYear"] = "DATE_NUM_QUARTER_IN_YEAR";
    ColumnDataTypeEnum["DateNumSecInDay"] = "DATE_NUM_SEC_IN_DAY";
    ColumnDataTypeEnum["DateNumWeekInMonth"] = "DATE_NUM_WEEK_IN_MONTH";
    ColumnDataTypeEnum["DateNumWeekInQuarter"] = "DATE_NUM_WEEK_IN_QUARTER";
    ColumnDataTypeEnum["DateNumWeekInYear"] = "DATE_NUM_WEEK_IN_YEAR";
    ColumnDataTypeEnum["DateTime"] = "DATE_TIME";
    ColumnDataTypeEnum["Double"] = "DOUBLE";
    ColumnDataTypeEnum["Float"] = "FLOAT";
    ColumnDataTypeEnum["Int32"] = "INT32";
    ColumnDataTypeEnum["Int64"] = "INT64";
    ColumnDataTypeEnum["List"] = "LIST";
    ColumnDataTypeEnum["ListBool"] = "LIST_BOOL";
    ColumnDataTypeEnum["ListDate"] = "LIST_DATE";
    ColumnDataTypeEnum["ListDateTime"] = "LIST_DATE_TIME";
    ColumnDataTypeEnum["ListDouble"] = "LIST_DOUBLE";
    ColumnDataTypeEnum["ListInt"] = "LIST_INT";
    ColumnDataTypeEnum["ListString"] = "LIST_STRING";
    ColumnDataTypeEnum["ListTime"] = "LIST_TIME";
    ColumnDataTypeEnum["Time"] = "TIME";
    ColumnDataTypeEnum["Unknown"] = "UNKNOWN";
    ColumnDataTypeEnum["Varchar"] = "VARCHAR";
})(ColumnDataTypeEnum || (ColumnDataTypeEnum = {}));
export var ColumnProperty;
(function (ColumnProperty) {
    ColumnProperty["GrowthDimension"] = "GROWTH_DIMENSION";
    ColumnProperty["IsFormula"] = "IS_FORMULA";
    ColumnProperty["IsGrouping"] = "IS_GROUPING";
    ColumnProperty["IsOutput"] = "IS_OUTPUT";
    ColumnProperty["SortAscending"] = "SORT_ASCENDING";
    ColumnProperty["SortDescending"] = "SORT_DESCENDING";
})(ColumnProperty || (ColumnProperty = {}));
export var ColumnSortCategory;
(function (ColumnSortCategory) {
    ColumnSortCategory["Alpha"] = "ALPHA";
    ColumnSortCategory["Custom"] = "CUSTOM";
    ColumnSortCategory["Default"] = "DEFAULT";
    ColumnSortCategory["None"] = "NONE";
})(ColumnSortCategory || (ColumnSortCategory = {}));
export var ColumnSortConfigOptions;
(function (ColumnSortConfigOptions) {
    ColumnSortConfigOptions["Custom"] = "CUSTOM";
    ColumnSortConfigOptions["Default"] = "DEFAULT";
})(ColumnSortConfigOptions || (ColumnSortConfigOptions = {}));
export var ColumnTimeBucket;
(function (ColumnTimeBucket) {
    ColumnTimeBucket["Auto"] = "AUTO";
    ColumnTimeBucket["Daily"] = "DAILY";
    ColumnTimeBucket["DayOfMonth"] = "DAY_OF_MONTH";
    ColumnTimeBucket["DayOfQuarter"] = "DAY_OF_QUARTER";
    ColumnTimeBucket["DayOfWeek"] = "DAY_OF_WEEK";
    ColumnTimeBucket["DayOfYear"] = "DAY_OF_YEAR";
    ColumnTimeBucket["Hourly"] = "HOURLY";
    ColumnTimeBucket["HourOfDay"] = "HOUR_OF_DAY";
    ColumnTimeBucket["Monthly"] = "MONTHLY";
    ColumnTimeBucket["MonthOfQuarter"] = "MONTH_OF_QUARTER";
    ColumnTimeBucket["MonthOfYear"] = "MONTH_OF_YEAR";
    ColumnTimeBucket["NoBucket"] = "NO_BUCKET";
    ColumnTimeBucket["Quarterly"] = "QUARTERLY";
    ColumnTimeBucket["QuarterOfYear"] = "QUARTER_OF_YEAR";
    ColumnTimeBucket["Weekly"] = "WEEKLY";
    ColumnTimeBucket["WeekOfMonth"] = "WEEK_OF_MONTH";
    ColumnTimeBucket["WeekOfQuarter"] = "WEEK_OF_QUARTER";
    ColumnTimeBucket["WeekOfYear"] = "WEEK_OF_YEAR";
    ColumnTimeBucket["Yearly"] = "YEARLY";
})(ColumnTimeBucket || (ColumnTimeBucket = {}));
export var ColumnType;
(function (ColumnType) {
    ColumnType["Attribute"] = "ATTRIBUTE";
    ColumnType["Date"] = "DATE";
    ColumnType["Measure"] = "MEASURE";
})(ColumnType || (ColumnType = {}));
export var ColumnValueType;
(function (ColumnValueType) {
    ColumnValueType["Bool"] = "BOOL";
    ColumnValueType["Char"] = "CHAR";
    ColumnValueType["Date"] = "DATE";
    ColumnValueType["Double"] = "DOUBLE";
    ColumnValueType["Int"] = "INT";
    ColumnValueType["Unknown"] = "UNKNOWN";
})(ColumnValueType || (ColumnValueType = {}));
export var ComparisonOperatorType;
(function (ComparisonOperatorType) {
    ComparisonOperatorType["BeginsWith"] = "BEGINS_WITH";
    ComparisonOperatorType["Bw"] = "BW";
    ComparisonOperatorType["Contains"] = "CONTAINS";
    ComparisonOperatorType["EndsWith"] = "ENDS_WITH";
    ComparisonOperatorType["Eq"] = "EQ";
    ComparisonOperatorType["Ge"] = "GE";
    ComparisonOperatorType["Gt"] = "GT";
    ComparisonOperatorType["Le"] = "LE";
    ComparisonOperatorType["Lt"] = "LT";
    ComparisonOperatorType["Ne"] = "NE";
    ComparisonOperatorType["NotContains"] = "NOT_CONTAINS";
})(ComparisonOperatorType || (ComparisonOperatorType = {}));
export var ComparisonType;
(function (ComparisonType) {
    ComparisonType["Current"] = "CURRENT";
    ComparisonType["Previous"] = "PREVIOUS";
})(ComparisonType || (ComparisonType = {}));
export var ComponentType;
(function (ComponentType) {
    ComponentType["Group"] = "GROUP";
    ComponentType["Tile"] = "TILE";
})(ComponentType || (ComponentType = {}));
export var ConditionalFormattingComparisonTypes;
(function (ConditionalFormattingComparisonTypes) {
    ConditionalFormattingComparisonTypes["ColumnBased"] = "COLUMN_BASED";
    ConditionalFormattingComparisonTypes["ParameterBased"] = "PARAMETER_BASED";
    ConditionalFormattingComparisonTypes["ValueBased"] = "VALUE_BASED";
})(ConditionalFormattingComparisonTypes || (ConditionalFormattingComparisonTypes = {}));
export var ConnectionConfigType;
(function (ConnectionConfigType) {
    ConnectionConfigType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    ConnectionConfigType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    ConnectionConfigType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    ConnectionConfigType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    ConnectionConfigType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    ConnectionConfigType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    ConnectionConfigType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    ConnectionConfigType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    ConnectionConfigType["RdbmsDenodo"] = "RDBMS_DENODO";
    ConnectionConfigType["RdbmsDremio"] = "RDBMS_DREMIO";
    ConnectionConfigType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    ConnectionConfigType["RdbmsFalcon"] = "RDBMS_FALCON";
    ConnectionConfigType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    ConnectionConfigType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    ConnectionConfigType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    ConnectionConfigType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    ConnectionConfigType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    ConnectionConfigType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    ConnectionConfigType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    ConnectionConfigType["RdbmsLooker"] = "RDBMS_LOOKER";
    ConnectionConfigType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    ConnectionConfigType["RdbmsMode"] = "RDBMS_MODE";
    ConnectionConfigType["RdbmsMysql"] = "RDBMS_MYSQL";
    ConnectionConfigType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    ConnectionConfigType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    ConnectionConfigType["RdbmsPresto"] = "RDBMS_PRESTO";
    ConnectionConfigType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    ConnectionConfigType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    ConnectionConfigType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    ConnectionConfigType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    ConnectionConfigType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    ConnectionConfigType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    ConnectionConfigType["RdbmsTeradata"] = "RDBMS_TERADATA";
    ConnectionConfigType["RdbmsTrino"] = "RDBMS_TRINO";
})(ConnectionConfigType || (ConnectionConfigType = {}));
export var ConnectionRelationType;
(function (ConnectionRelationType) {
    ConnectionRelationType["Administrator"] = "ADMINISTRATOR";
    ConnectionRelationType["ConnectionOwner"] = "CONNECTION_OWNER";
    ConnectionRelationType["None"] = "NONE";
    ConnectionRelationType["SharedWithCurrentUser"] = "SHARED_WITH_CURRENT_USER";
})(ConnectionRelationType || (ConnectionRelationType = {}));
export var ConnectionTypeEnum;
(function (ConnectionTypeEnum) {
    ConnectionTypeEnum["DataSource"] = "DATA_SOURCE";
    ConnectionTypeEnum["LogicalColumn"] = "LOGICAL_COLUMN";
    ConnectionTypeEnum["LogicalTable"] = "LOGICAL_TABLE";
})(ConnectionTypeEnum || (ConnectionTypeEnum = {}));
export var ConnectorType;
(function (ConnectorType) {
    ConnectorType["Airbyte"] = "AIRBYTE";
    ConnectorType["Fivetran"] = "FIVETRAN";
    ConnectorType["Matillion"] = "MATILLION";
})(ConnectorType || (ConnectorType = {}));
export var CortexInsightStatus;
(function (CortexInsightStatus) {
    CortexInsightStatus["CortexAnalysisFailed"] = "CORTEX_ANALYSIS_FAILED";
    CortexInsightStatus["StatusCodeOk"] = "STATUS_CODE_OK";
})(CortexInsightStatus || (CortexInsightStatus = {}));
export var CurrencyFormatType;
(function (CurrencyFormatType) {
    CurrencyFormatType["Column"] = "COLUMN";
    CurrencyFormatType["IsoCode"] = "ISO_CODE";
    CurrencyFormatType["UserLocale"] = "USER_LOCALE";
})(CurrencyFormatType || (CurrencyFormatType = {}));
export var CurrencySetting;
(function (CurrencySetting) {
    CurrencySetting["FromColumn"] = "FROM_COLUMN";
    CurrencySetting["FromIsoCode"] = "FROM_ISO_CODE";
    CurrencySetting["FromUserLocale"] = "FROM_USER_LOCALE";
    CurrencySetting["None"] = "NONE";
})(CurrencySetting || (CurrencySetting = {}));
export var CurrentDataOptionsEnum;
(function (CurrentDataOptionsEnum) {
    CurrentDataOptionsEnum["CurrentOnly"] = "CURRENT_ONLY";
    CurrentDataOptionsEnum["Exclude"] = "EXCLUDE";
    CurrentDataOptionsEnum["Include"] = "INCLUDE";
})(CurrentDataOptionsEnum || (CurrentDataOptionsEnum = {}));
export var DataConnection;
(function (DataConnection) {
    DataConnection["AmazonRedshift"] = "AMAZON_REDSHIFT";
    DataConnection["AzureSynapse"] = "AZURE_SYNAPSE";
    DataConnection["Databricks"] = "DATABRICKS";
    DataConnection["Denodo"] = "DENODO";
    DataConnection["Dremio"] = "DREMIO";
    DataConnection["GoogleBigquery"] = "GOOGLE_BIGQUERY";
    DataConnection["OracleAdw"] = "ORACLE_ADW";
    DataConnection["SapHana"] = "SAP_HANA";
    DataConnection["Snowflake"] = "SNOWFLAKE";
    DataConnection["Starburst"] = "STARBURST";
    DataConnection["Teradata"] = "TERADATA";
})(DataConnection || (DataConnection = {}));
export var DataSourceOrigin;
(function (DataSourceOrigin) {
    DataSourceOrigin["Copilot"] = "COPILOT";
    DataSourceOrigin["Nls"] = "NLS";
    DataSourceOrigin["TrainSage"] = "TRAIN_SAGE";
    DataSourceOrigin["UnifiedSage"] = "UNIFIED_SAGE";
})(DataSourceOrigin || (DataSourceOrigin = {}));
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["Default"] = "DEFAULT";
    DataSourceType["FileCsv"] = "FILE_CSV";
    DataSourceType["Informatica"] = "INFORMATICA";
    DataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    DataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    DataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    DataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    DataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    DataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    DataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    DataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    DataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    DataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    DataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    DataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    DataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    DataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    DataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    DataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    DataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    DataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    DataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    DataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    DataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    DataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    DataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    DataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    DataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    DataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    DataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    DataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    DataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    DataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    DataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    DataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    DataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    DataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    DataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    DataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    DataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    DataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    DataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    DataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    DataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(DataSourceType || (DataSourceType = {}));
export var DateFilterType;
(function (DateFilterType) {
    DateFilterType["ExactDate"] = "EXACT_DATE";
    DateFilterType["ExactDateRange"] = "EXACT_DATE_RANGE";
    DateFilterType["ExactDateTime"] = "EXACT_DATE_TIME";
    DateFilterType["ExactTime"] = "EXACT_TIME";
    DateFilterType["LastNPeriod"] = "LAST_N_PERIOD";
    DateFilterType["LastPeriod"] = "LAST_PERIOD";
    DateFilterType["MonthOnly"] = "MONTH_ONLY";
    DateFilterType["MonthYear"] = "MONTH_YEAR";
    DateFilterType["NextNPeriod"] = "NEXT_N_PERIOD";
    DateFilterType["NextPeriod"] = "NEXT_PERIOD";
    DateFilterType["Now"] = "NOW";
    DateFilterType["NumDateFilters"] = "NUM_DATE_FILTERS";
    DateFilterType["NPeriodAgo"] = "N_PERIOD_AGO";
    DateFilterType["PeriodOnly"] = "PERIOD_ONLY";
    DateFilterType["PeriodToDate"] = "PERIOD_TO_DATE";
    DateFilterType["QuarterOnly"] = "QUARTER_ONLY";
    DateFilterType["QuarterYear"] = "QUARTER_YEAR";
    DateFilterType["ThisPeriod"] = "THIS_PERIOD";
    DateFilterType["Today"] = "TODAY";
    DateFilterType["Tomorrow"] = "TOMORROW";
    DateFilterType["WeekdayOnly"] = "WEEKDAY_ONLY";
    DateFilterType["YearOnly"] = "YEAR_ONLY";
    DateFilterType["Yesterday"] = "YESTERDAY";
})(DateFilterType || (DateFilterType = {}));
export var DatePeriod;
(function (DatePeriod) {
    DatePeriod["Day"] = "DAY";
    DatePeriod["Hour"] = "HOUR";
    DatePeriod["Minute"] = "MINUTE";
    DatePeriod["Month"] = "MONTH";
    DatePeriod["NumDatePeriods"] = "NUM_DATE_PERIODS";
    DatePeriod["Quarter"] = "QUARTER";
    DatePeriod["Second"] = "SECOND";
    DatePeriod["Week"] = "WEEK";
    DatePeriod["Year"] = "YEAR";
})(DatePeriod || (DatePeriod = {}));
export var DependencyListObjectType;
(function (DependencyListObjectType) {
    DependencyListObjectType["CustomChartConfigManifest"] = "CUSTOM_CHART_CONFIG_MANIFEST";
    DependencyListObjectType["DataSource"] = "DATA_SOURCE";
    DependencyListObjectType["File"] = "FILE";
    DependencyListObjectType["LogicalColumn"] = "LOGICAL_COLUMN";
    DependencyListObjectType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    DependencyListObjectType["LogicalTable"] = "LOGICAL_TABLE";
    DependencyListObjectType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    DependencyListObjectType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    DependencyListObjectType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    DependencyListObjectType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    DependencyListObjectType["RTemplate"] = "R_TEMPLATE";
    DependencyListObjectType["Tag"] = "TAG";
    DependencyListObjectType["User"] = "USER";
    DependencyListObjectType["UserGroup"] = "USER_GROUP";
})(DependencyListObjectType || (DependencyListObjectType = {}));
export var DependentObjectVersion;
(function (DependentObjectVersion) {
    DependentObjectVersion["V1"] = "V1";
    DependentObjectVersion["V2"] = "V2";
})(DependentObjectVersion || (DependentObjectVersion = {}));
export var DestinationOperationTypes;
(function (DestinationOperationTypes) {
    DestinationOperationTypes["Archive"] = "ARCHIVE";
    DestinationOperationTypes["Create"] = "CREATE";
    DestinationOperationTypes["Delete"] = "DELETE";
    DestinationOperationTypes["Insert"] = "INSERT";
    DestinationOperationTypes["Update"] = "UPDATE";
    DestinationOperationTypes["Upsert"] = "UPSERT";
})(DestinationOperationTypes || (DestinationOperationTypes = {}));
export var DestinationTypes;
(function (DestinationTypes) {
    DestinationTypes["Bigquery"] = "BIGQUERY";
    DestinationTypes["Gainsight"] = "GAINSIGHT";
    DestinationTypes["Googlesheets"] = "GOOGLESHEETS";
    DestinationTypes["Hubspot"] = "HUBSPOT";
    DestinationTypes["Mailchimp"] = "MAILCHIMP";
    DestinationTypes["Msexcel"] = "MSEXCEL";
    DestinationTypes["Msteams"] = "MSTEAMS";
    DestinationTypes["Redshift"] = "REDSHIFT";
    DestinationTypes["Salesforce"] = "SALESFORCE";
    DestinationTypes["Servicenow"] = "SERVICENOW";
    DestinationTypes["Slack"] = "SLACK";
    DestinationTypes["Snowflake"] = "SNOWFLAKE";
    DestinationTypes["Webex"] = "WEBEX";
    DestinationTypes["Zendesk"] = "ZENDESK";
    DestinationTypes["Zoho"] = "ZOHO";
})(DestinationTypes || (DestinationTypes = {}));
export var DisallowedAlertTypeErrorCode;
(function (DisallowedAlertTypeErrorCode) {
    DisallowedAlertTypeErrorCode["AlertAcrossAttributesFlagDisabled"] = "ALERT_ACROSS_ATTRIBUTES_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtChartLevel"] = "ANOMALY_DISABLED_AT_CHART_LEVEL";
    DisallowedAlertTypeErrorCode["AnomalyDisabledAtUserProfile"] = "ANOMALY_DISABLED_AT_USER_PROFILE";
    DisallowedAlertTypeErrorCode["AnomalyDisabledChartNonTimeSeries"] = "ANOMALY_DISABLED_CHART_NON_TIME_SERIES";
    DisallowedAlertTypeErrorCode["AnomalyDisabledFalconSource"] = "ANOMALY_DISABLED_FALCON_SOURCE";
    DisallowedAlertTypeErrorCode["AnomalyFlagDisabled"] = "ANOMALY_FLAG_DISABLED";
    DisallowedAlertTypeErrorCode["GrowthKeywordNotSupported"] = "GROWTH_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["GrowthOfKeywordNotSupported"] = "GROWTH_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["HourlyKpiNotSupported"] = "HOURLY_KPI_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["OfKeywordNotSupported"] = "OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["PercentageOfKeywordNotSupported"] = "PERCENTAGE_OF_KEYWORD_NOT_SUPPORTED";
    DisallowedAlertTypeErrorCode["UnexpectedError"] = "UNEXPECTED_ERROR";
    DisallowedAlertTypeErrorCode["UnsupportedFormula"] = "UNSUPPORTED_FORMULA";
    DisallowedAlertTypeErrorCode["VersusKeywordNotSupported"] = "VERSUS_KEYWORD_NOT_SUPPORTED";
})(DisallowedAlertTypeErrorCode || (DisallowedAlertTypeErrorCode = {}));
export var DisplayMode;
(function (DisplayMode) {
    DisplayMode["ChartMode"] = "CHART_MODE";
    DisplayMode["HeadlineMode"] = "HEADLINE_MODE";
    DisplayMode["RAnalysisMode"] = "R_ANALYSIS_MODE";
    DisplayMode["TableMode"] = "TABLE_MODE";
    DisplayMode["Undefined"] = "UNDEFINED";
})(DisplayMode || (DisplayMode = {}));
export var EDocFormatType;
(function (EDocFormatType) {
    EDocFormatType["Json"] = "JSON";
    EDocFormatType["Proto"] = "PROTO";
    EDocFormatType["Yaml"] = "YAML";
})(EDocFormatType || (EDocFormatType = {}));
export var EDocGenerationType;
(function (EDocGenerationType) {
    EDocGenerationType["Autogenerated"] = "AUTOGENERATED";
    EDocGenerationType["Default"] = "DEFAULT";
})(EDocGenerationType || (EDocGenerationType = {}));
export var EditType;
(function (EditType) {
    EditType["Editable"] = "EDITABLE";
    EditType["Hidden"] = "HIDDEN";
    EditType["MultiSelection"] = "MULTI_SELECTION";
    EditType["NonEditable"] = "NON_EDITABLE";
    EditType["Text"] = "TEXT";
})(EditType || (EditType = {}));
export var EmptyAnswerStateEnum;
(function (EmptyAnswerStateEnum) {
    EmptyAnswerStateEnum["AutogenAnswer"] = "AUTOGEN_ANSWER";
    EmptyAnswerStateEnum["Default"] = "DEFAULT";
    EmptyAnswerStateEnum["StartAaq"] = "START_AAQ";
    EmptyAnswerStateEnum["StartSearchAssist"] = "START_SEARCH_ASSIST";
})(EmptyAnswerStateEnum || (EmptyAnswerStateEnum = {}));
export var EventSchemaType;
(function (EventSchemaType) {
    EventSchemaType["Monitor"] = "MONITOR";
})(EventSchemaType || (EventSchemaType = {}));
export var ExplorationType;
(function (ExplorationType) {
    ExplorationType["Add"] = "ADD";
    ExplorationType["Compare"] = "COMPARE";
    ExplorationType["Filter"] = "FILTER";
    ExplorationType["Replace"] = "REPLACE";
})(ExplorationType || (ExplorationType = {}));
export var FalconDataType;
(function (FalconDataType) {
    FalconDataType["Bool"] = "BOOL";
    FalconDataType["Char"] = "CHAR";
    FalconDataType["Date"] = "DATE";
    FalconDataType["DateTime"] = "DATE_TIME";
    FalconDataType["Double"] = "DOUBLE";
    FalconDataType["Float"] = "FLOAT";
    FalconDataType["Int32"] = "INT32";
    FalconDataType["Int64"] = "INT64";
    FalconDataType["List"] = "LIST";
    FalconDataType["ListBool"] = "LIST_BOOL";
    FalconDataType["ListDate"] = "LIST_DATE";
    FalconDataType["ListDateTime"] = "LIST_DATE_TIME";
    FalconDataType["ListDouble"] = "LIST_DOUBLE";
    FalconDataType["ListInt"] = "LIST_INT";
    FalconDataType["ListString"] = "LIST_STRING";
    FalconDataType["ListTime"] = "LIST_TIME";
    FalconDataType["MaxType"] = "MAX_TYPE";
    FalconDataType["Time"] = "TIME";
    FalconDataType["Unknown"] = "UNKNOWN";
})(FalconDataType || (FalconDataType = {}));
export var FalconValueTypeEnum;
(function (FalconValueTypeEnum) {
    FalconValueTypeEnum["TypeBool"] = "TYPE_BOOL";
    FalconValueTypeEnum["TypeDouble"] = "TYPE_DOUBLE";
    FalconValueTypeEnum["TypeInt64"] = "TYPE_INT64";
    FalconValueTypeEnum["TypeNull"] = "TYPE_NULL";
    FalconValueTypeEnum["TypeString"] = "TYPE_STRING";
    FalconValueTypeEnum["TypeStringCase"] = "TYPE_STRING_CASE";
})(FalconValueTypeEnum || (FalconValueTypeEnum = {}));
export var FeedbackReason;
(function (FeedbackReason) {
    FeedbackReason["NotInterested"] = "NOT_INTERESTED";
    FeedbackReason["QuestionAnswerMismatch"] = "QUESTION_ANSWER_MISMATCH";
})(FeedbackReason || (FeedbackReason = {}));
export var FeedbackType;
(function (FeedbackType) {
    FeedbackType["AllAnomaliesObvious"] = "ALL_ANOMALIES_OBVIOUS";
    FeedbackType["AllChangesExpected"] = "ALL_CHANGES_EXPECTED";
    FeedbackType["AnomalousPointUninteresting"] = "ANOMALOUS_POINT_UNINTERESTING";
    FeedbackType["AttributeColumnUninteresting"] = "ATTRIBUTE_COLUMN_UNINTERESTING";
    FeedbackType["AttributeFilterCombinationUninteresting"] = "ATTRIBUTE_FILTER_COMBINATION_UNINTERESTING";
    FeedbackType["BetterDateBucket"] = "BETTER_DATE_BUCKET";
    FeedbackType["CorrelationObvious"] = "CORRELATION_OBVIOUS";
    FeedbackType["DataSourceUninteresting"] = "DATA_SOURCE_UNINTERESTING";
    FeedbackType["DiffExpected"] = "DIFF_EXPECTED";
    FeedbackType["DiffValueUninteresting"] = "DIFF_VALUE_UNINTERESTING";
    FeedbackType["FilterColumnUninteresting"] = "FILTER_COLUMN_UNINTERESTING";
    FeedbackType["MeasureColumnUninteresting"] = "MEASURE_COLUMN_UNINTERESTING";
    FeedbackType["MeasureFilterCombinationObvious"] = "MEASURE_FILTER_COMBINATION_OBVIOUS";
    FeedbackType["TrendBetterDateAttribute"] = "TREND_BETTER_DATE_ATTRIBUTE";
    FeedbackType["TrendObvious"] = "TREND_OBVIOUS";
})(FeedbackType || (FeedbackType = {}));
export var FilterProperty;
(function (FilterProperty) {
    FilterProperty["IncludeNull"] = "INCLUDE_NULL";
    FilterProperty["IsDateFilter"] = "IS_DATE_FILTER";
    FilterProperty["IsFormula"] = "IS_FORMULA";
    FilterProperty["IsInSubquery"] = "IS_IN_SUBQUERY";
})(FilterProperty || (FilterProperty = {}));
export var FilterTypes;
(function (FilterTypes) {
    FilterTypes["BeginsWith"] = "BEGINS_WITH";
    FilterTypes["Bw"] = "BW";
    FilterTypes["BwInc"] = "BW_INC";
    FilterTypes["BwIncMax"] = "BW_INC_MAX";
    FilterTypes["BwIncMin"] = "BW_INC_MIN";
    FilterTypes["Contains"] = "CONTAINS";
    FilterTypes["EndsWith"] = "ENDS_WITH";
    FilterTypes["Eq"] = "EQ";
    FilterTypes["Ge"] = "GE";
    FilterTypes["Gt"] = "GT";
    FilterTypes["In"] = "IN";
    FilterTypes["Le"] = "LE";
    FilterTypes["Like"] = "LIKE";
    FilterTypes["Lt"] = "LT";
    FilterTypes["Ne"] = "NE";
    FilterTypes["NotIn"] = "NOT_IN";
})(FilterTypes || (FilterTypes = {}));
export var FilterValueDataType;
(function (FilterValueDataType) {
    FilterValueDataType["Bool"] = "BOOL";
    FilterValueDataType["Char"] = "CHAR";
    FilterValueDataType["Date"] = "DATE";
    FilterValueDataType["Double"] = "DOUBLE";
    FilterValueDataType["Int"] = "INT";
    FilterValueDataType["Unknown"] = "UNKNOWN";
})(FilterValueDataType || (FilterValueDataType = {}));
export var FormatData;
(function (FormatData) {
    FormatData["Compact"] = "COMPACT";
    FormatData["Full"] = "FULL";
})(FormatData || (FormatData = {}));
export var FormatType;
(function (FormatType) {
    FormatType["Json"] = "JSON";
    FormatType["Yaml"] = "YAML";
})(FormatType || (FormatType = {}));
export var FrequencyGranularity;
(function (FrequencyGranularity) {
    FrequencyGranularity["Daily"] = "DAILY";
    FrequencyGranularity["EveryMinute"] = "EVERY_MINUTE";
    FrequencyGranularity["Hourly"] = "HOURLY";
    FrequencyGranularity["Monthly"] = "MONTHLY";
    FrequencyGranularity["Weekly"] = "WEEKLY";
})(FrequencyGranularity || (FrequencyGranularity = {}));
export var GeoConfigGeometryTypes;
(function (GeoConfigGeometryTypes) {
    GeoConfigGeometryTypes["Circle"] = "CIRCLE";
    GeoConfigGeometryTypes["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeoConfigGeometryTypes["LinearRing"] = "LINEAR_RING";
    GeoConfigGeometryTypes["LineString"] = "LINE_STRING";
    GeoConfigGeometryTypes["MultiLineString"] = "MULTI_LINE_STRING";
    GeoConfigGeometryTypes["MultiPoint"] = "MULTI_POINT";
    GeoConfigGeometryTypes["MultiPolygon"] = "MULTI_POLYGON";
    GeoConfigGeometryTypes["Point"] = "POINT";
    GeoConfigGeometryTypes["Polygon"] = "POLYGON";
})(GeoConfigGeometryTypes || (GeoConfigGeometryTypes = {}));
export var GeoConfigType;
(function (GeoConfigType) {
    GeoConfigType["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigType["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigType["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigType["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigType["Latitude"] = "LATITUDE";
    GeoConfigType["Longitude"] = "LONGITUDE";
    GeoConfigType["ZipCode"] = "ZIP_CODE";
})(GeoConfigType || (GeoConfigType = {}));
export var GeoConfigTypes;
(function (GeoConfigTypes) {
    GeoConfigTypes["AdminDiv_0"] = "ADMIN_DIV_0";
    GeoConfigTypes["AdminDiv_1"] = "ADMIN_DIV_1";
    GeoConfigTypes["AdminDiv_2"] = "ADMIN_DIV_2";
    GeoConfigTypes["CustomRegion"] = "CUSTOM_REGION";
    GeoConfigTypes["Latitude"] = "LATITUDE";
    GeoConfigTypes["Longitude"] = "LONGITUDE";
    GeoConfigTypes["None"] = "NONE";
    GeoConfigTypes["ZipCode"] = "ZIP_CODE";
})(GeoConfigTypes || (GeoConfigTypes = {}));
export var GeometryType;
(function (GeometryType) {
    GeometryType["Circle"] = "CIRCLE";
    GeometryType["GeometryCollection"] = "GEOMETRY_COLLECTION";
    GeometryType["LinearRing"] = "LINEAR_RING";
    GeometryType["LineString"] = "LINE_STRING";
    GeometryType["MultiLineString"] = "MULTI_LINE_STRING";
    GeometryType["MultiPoint"] = "MULTI_POINT";
    GeometryType["MultiPolygon"] = "MULTI_POLYGON";
    GeometryType["Point"] = "POINT";
    GeometryType["Polygon"] = "POLYGON";
})(GeometryType || (GeometryType = {}));
export var GitConfigsMappingStatus;
(function (GitConfigsMappingStatus) {
    GitConfigsMappingStatus["Mapped"] = "MAPPED";
    GitConfigsMappingStatus["Unmapped"] = "UNMAPPED";
})(GitConfigsMappingStatus || (GitConfigsMappingStatus = {}));
export var GitConfigsSortFieldName;
(function (GitConfigsSortFieldName) {
    GitConfigsSortFieldName["Name"] = "NAME";
    GitConfigsSortFieldName["Status"] = "STATUS";
})(GitConfigsSortFieldName || (GitConfigsSortFieldName = {}));
export var GitConfigsSortOrder;
(function (GitConfigsSortOrder) {
    GitConfigsSortOrder["Asc"] = "ASC";
    GitConfigsSortOrder["Desc"] = "DESC";
})(GitConfigsSortOrder || (GitConfigsSortOrder = {}));
export var GroupBrandColor;
(function (GroupBrandColor) {
    GroupBrandColor["GbcA"] = "GBC_A";
    GroupBrandColor["GbcB"] = "GBC_B";
    GroupBrandColor["GbcC"] = "GBC_C";
    GroupBrandColor["GbcD"] = "GBC_D";
    GroupBrandColor["GbcE"] = "GBC_E";
    GroupBrandColor["GbcF"] = "GBC_F";
    GroupBrandColor["GbcG"] = "GBC_G";
    GroupBrandColor["GbcH"] = "GBC_H";
    GroupBrandColor["GbcUnknown"] = "GBC_UNKNOWN";
})(GroupBrandColor || (GroupBrandColor = {}));
export var GroupColorShade;
(function (GroupColorShade) {
    GroupColorShade["GcsA"] = "GCS_A";
    GroupColorShade["GcsUnknown"] = "GCS_UNKNOWN";
})(GroupColorShade || (GroupColorShade = {}));
export var Groups__GroupType;
(function (Groups__GroupType) {
    Groups__GroupType["LdapGroup"] = "LDAP_GROUP";
    Groups__GroupType["LocalGroup"] = "LOCAL_GROUP";
    Groups__GroupType["TeamGroup"] = "TEAM_GROUP";
    Groups__GroupType["TenantGroup"] = "TENANT_GROUP";
})(Groups__GroupType || (Groups__GroupType = {}));
export var Groups__ParentType;
(function (Groups__ParentType) {
    Groups__ParentType["Group"] = "GROUP";
    Groups__ParentType["User"] = "USER";
})(Groups__ParentType || (Groups__ParentType = {}));
export var HandleMissingValues;
(function (HandleMissingValues) {
    HandleMissingValues["DontShow"] = "DONT_SHOW";
    HandleMissingValues["ShowAsZero"] = "SHOW_AS_ZERO";
    HandleMissingValues["ShowGap"] = "SHOW_GAP";
})(HandleMissingValues || (HandleMissingValues = {}));
export var HeadlineVizPropVersion;
(function (HeadlineVizPropVersion) {
    HeadlineVizPropVersion["PreV1"] = "PRE_V1";
    HeadlineVizPropVersion["V1"] = "V1";
})(HeadlineVizPropVersion || (HeadlineVizPropVersion = {}));
export var HomepageModule;
(function (HomepageModule) {
    HomepageModule["Announcement"] = "ANNOUNCEMENT";
    HomepageModule["Favorite"] = "FAVORITE";
    HomepageModule["Learning"] = "LEARNING";
    HomepageModule["MyLibrary"] = "MY_LIBRARY";
    HomepageModule["Search"] = "SEARCH";
    HomepageModule["Trending"] = "TRENDING";
    HomepageModule["Watchlist"] = "WATCHLIST";
})(HomepageModule || (HomepageModule = {}));
export var ImportEPackAction;
(function (ImportEPackAction) {
    ImportEPackAction["Create"] = "CREATE";
    ImportEPackAction["Update"] = "UPDATE";
})(ImportEPackAction || (ImportEPackAction = {}));
export var ImportEPackPolicy;
(function (ImportEPackPolicy) {
    ImportEPackPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportEPackPolicy["Partial"] = "PARTIAL";
    ImportEPackPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportEPackPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportEPackPolicy || (ImportEPackPolicy = {}));
export var ImportPolicy;
(function (ImportPolicy) {
    ImportPolicy["AllOrNone"] = "ALL_OR_NONE";
    ImportPolicy["Partial"] = "PARTIAL";
    ImportPolicy["PartialObject"] = "PARTIAL_OBJECT";
    ImportPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(ImportPolicy || (ImportPolicy = {}));
export var InferenceStatusEnum;
(function (InferenceStatusEnum) {
    InferenceStatusEnum["Done"] = "DONE";
    InferenceStatusEnum["Error"] = "ERROR";
    InferenceStatusEnum["Pending"] = "PENDING";
})(InferenceStatusEnum || (InferenceStatusEnum = {}));
export var IntegrationActionEnum;
(function (IntegrationActionEnum) {
    IntegrationActionEnum["Create"] = "CREATE";
    IntegrationActionEnum["Delete"] = "DELETE";
    IntegrationActionEnum["Edit"] = "EDIT";
})(IntegrationActionEnum || (IntegrationActionEnum = {}));
export var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["Cleanup"] = "CLEANUP";
    JobStatusEnum["Default"] = "DEFAULT";
    JobStatusEnum["Expired"] = "EXPIRED";
    JobStatusEnum["Paused"] = "PAUSED";
    JobStatusEnum["Scheduled"] = "SCHEDULED";
    JobStatusEnum["Stopped"] = "STOPPED";
})(JobStatusEnum || (JobStatusEnum = {}));
export var JoinType;
(function (JoinType) {
    JoinType["Cross"] = "CROSS";
    JoinType["FullOuter"] = "FULL_OUTER";
    JoinType["Inner"] = "INNER";
    JoinType["LeftOuter"] = "LEFT_OUTER";
    JoinType["RightOuter"] = "RIGHT_OUTER";
})(JoinType || (JoinType = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType["Pinboard"] = "PINBOARD";
    LayoutType["Visualization"] = "VISUALIZATION";
})(LayoutType || (LayoutType = {}));
export var LegendPositionOptions;
(function (LegendPositionOptions) {
    LegendPositionOptions["BottomLegend"] = "BOTTOM_LEGEND";
    LegendPositionOptions["LeftLegend"] = "LEFT_LEGEND";
    LegendPositionOptions["RightLegend"] = "RIGHT_LEGEND";
    LegendPositionOptions["TopLegend"] = "TOP_LEGEND";
})(LegendPositionOptions || (LegendPositionOptions = {}));
export var LessonAdviceType;
(function (LessonAdviceType) {
    LessonAdviceType["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    LessonAdviceType["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    LessonAdviceType["CustomCalendar"] = "CUSTOM_CALENDAR";
    LessonAdviceType["Done"] = "DONE";
    LessonAdviceType["ErrorRemove"] = "ERROR_REMOVE";
    LessonAdviceType["ForEach"] = "FOR_EACH";
    LessonAdviceType["Geofilter"] = "GEOFILTER";
    LessonAdviceType["GrowthOf"] = "GROWTH_OF";
    LessonAdviceType["Having"] = "HAVING";
    LessonAdviceType["InitialAttribute"] = "INITIAL_ATTRIBUTE";
    LessonAdviceType["InitialMeasure"] = "INITIAL_MEASURE";
    LessonAdviceType["InFilter"] = "IN_FILTER";
    LessonAdviceType["LessonNotPossible"] = "LESSON_NOT_POSSIBLE";
    LessonAdviceType["LessonNotStarted"] = "LESSON_NOT_STARTED";
    LessonAdviceType["MeasureColumn"] = "MEASURE_COLUMN";
    LessonAdviceType["PhraseDone"] = "PHRASE_DONE";
    LessonAdviceType["PositiveInt"] = "POSITIVE_INT";
    LessonAdviceType["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    LessonAdviceType["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    LessonAdviceType["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    LessonAdviceType["SortBy"] = "SORT_BY";
    LessonAdviceType["TimeBucket"] = "TIME_BUCKET";
    LessonAdviceType["TimeFilters"] = "TIME_FILTERS";
    LessonAdviceType["TopBottom"] = "TOP_BOTTOM";
    LessonAdviceType["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(LessonAdviceType || (LessonAdviceType = {}));
export var ListCategory;
(function (ListCategory) {
    ListCategory["All"] = "ALL";
    ListCategory["Favorite"] = "FAVORITE";
    ListCategory["My"] = "MY";
    ListCategory["NonFavorite"] = "NON_FAVORITE";
    ListCategory["Requested"] = "REQUESTED";
})(ListCategory || (ListCategory = {}));
export var ListType;
(function (ListType) {
    ListType["DataSource"] = "DATA_SOURCE";
    ListType["DbtConnection"] = "DBT_CONNECTION";
    ListType["File"] = "FILE";
    ListType["LogicalColumn"] = "LOGICAL_COLUMN";
    ListType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    ListType["LogicalTable"] = "LOGICAL_TABLE";
    ListType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ListType["PinboardAnswerSheet"] = "PINBOARD_ANSWER_SHEET";
    ListType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ListType["QuestionAnswerSheet"] = "QUESTION_ANSWER_SHEET";
    ListType["RTemplate"] = "R_TEMPLATE";
    ListType["Tag"] = "TAG";
    ListType["User"] = "USER";
    ListType["UserGroup"] = "USER_GROUP";
})(ListType || (ListType = {}));
export var LiveboardBorderType;
(function (LiveboardBorderType) {
    LiveboardBorderType["Curved"] = "CURVED";
    LiveboardBorderType["LiveboardBorderUnknown"] = "LIVEBOARD_BORDER_UNKNOWN";
    LiveboardBorderType["Sharp"] = "SHARP";
})(LiveboardBorderType || (LiveboardBorderType = {}));
export var LiveboardBrandColor;
(function (LiveboardBrandColor) {
    LiveboardBrandColor["LbcA"] = "LBC_A";
    LiveboardBrandColor["LbcB"] = "LBC_B";
    LiveboardBrandColor["LbcC"] = "LBC_C";
    LiveboardBrandColor["LbcD"] = "LBC_D";
    LiveboardBrandColor["LbcE"] = "LBC_E";
    LiveboardBrandColor["LbcF"] = "LBC_F";
    LiveboardBrandColor["LbcG"] = "LBC_G";
    LiveboardBrandColor["LbcH"] = "LBC_H";
    LiveboardBrandColor["LbcUnknown"] = "LBC_UNKNOWN";
})(LiveboardBrandColor || (LiveboardBrandColor = {}));
export var LiveboardDensityType;
(function (LiveboardDensityType) {
    LiveboardDensityType["LiveboardDensityUnknown"] = "LIVEBOARD_DENSITY_UNKNOWN";
    LiveboardDensityType["Loose"] = "LOOSE";
    LiveboardDensityType["Regular"] = "REGULAR";
    LiveboardDensityType["Tight"] = "TIGHT";
})(LiveboardDensityType || (LiveboardDensityType = {}));
export var LiveboardGutterType;
(function (LiveboardGutterType) {
    LiveboardGutterType["Guttered"] = "GUTTERED";
    LiveboardGutterType["Gutterless"] = "GUTTERLESS";
    LiveboardGutterType["LiveboardGutterUnknown"] = "LIVEBOARD_GUTTER_UNKNOWN";
})(LiveboardGutterType || (LiveboardGutterType = {}));
export var LogicalTableTypeEnum;
(function (LogicalTableTypeEnum) {
    LogicalTableTypeEnum["AggrWorksheet"] = "AGGR_WORKSHEET";
    LogicalTableTypeEnum["CalendarTable"] = "CALENDAR_TABLE";
    LogicalTableTypeEnum["DbView"] = "DB_VIEW";
    LogicalTableTypeEnum["MaterializedView"] = "MATERIALIZED_VIEW";
    LogicalTableTypeEnum["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    LogicalTableTypeEnum["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    LogicalTableTypeEnum["SqlView"] = "SQL_VIEW";
    LogicalTableTypeEnum["UserDefined"] = "USER_DEFINED";
    LogicalTableTypeEnum["Worksheet"] = "WORKSHEET";
})(LogicalTableTypeEnum || (LogicalTableTypeEnum = {}));
export var LogsValues;
(function (LogsValues) {
    LogsValues["SecurityLogs"] = "security_logs";
})(LogsValues || (LogsValues = {}));
export var MetadataType;
(function (MetadataType) {
    MetadataType["AggrWorksheet"] = "AGGR_WORKSHEET";
    MetadataType["DataSource"] = "DATA_SOURCE";
    MetadataType["DbView"] = "DB_VIEW";
    MetadataType["Filter"] = "FILTER";
    MetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    MetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    MetadataType["LogicalTable"] = "LOGICAL_TABLE";
    MetadataType["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    MetadataType["PersonalisedView"] = "PERSONALISED_VIEW";
    MetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    MetadataType["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    MetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    MetadataType["RelatedLink"] = "RELATED_LINK";
    MetadataType["ReportBook"] = "REPORT_BOOK";
    MetadataType["RowSecurity"] = "ROW_SECURITY";
    MetadataType["RTemplate"] = "R_TEMPLATE";
    MetadataType["TableFilter"] = "TABLE_FILTER";
    MetadataType["Tag"] = "TAG";
    MetadataType["User"] = "USER";
    MetadataType["UserData"] = "USER_DATA";
    MetadataType["UserDefined"] = "USER_DEFINED";
    MetadataType["UserGroup"] = "USER_GROUP";
    MetadataType["UserQuestion"] = "USER_QUESTION";
    MetadataType["UserRole"] = "USER_ROLE";
    MetadataType["Visualization"] = "VISUALIZATION";
    MetadataType["Worksheet"] = "WORKSHEET";
})(MetadataType || (MetadataType = {}));
export var Method;
(function (Method) {
    Method["Get"] = "GET";
    Method["Post"] = "POST";
})(Method || (Method = {}));
export var MonitorAlertType;
(function (MonitorAlertType) {
    MonitorAlertType["AnomalyBasedAlerts"] = "ANOMALY_BASED_ALERTS";
    MonitorAlertType["ScheduleBasedAlerts"] = "SCHEDULE_BASED_ALERTS";
    MonitorAlertType["ScheduleByAttributeBasedAlerts"] = "SCHEDULE_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["ThresholdBasedAlerts"] = "THRESHOLD_BASED_ALERTS";
    MonitorAlertType["ThresholdByAttributeBasedAlerts"] = "THRESHOLD_BY_ATTRIBUTE_BASED_ALERTS";
    MonitorAlertType["Unspecified"] = "UNSPECIFIED";
})(MonitorAlertType || (MonitorAlertType = {}));
export var MonitorRuleApiCode;
(function (MonitorRuleApiCode) {
    MonitorRuleApiCode["StatusCodeAlertAcrossAttributesDisabled"] = "STATUS_CODE_ALERT_ACROSS_ATTRIBUTES_DISABLED";
    MonitorRuleApiCode["StatusCodeAnomalyAlertDisabled"] = "STATUS_CODE_ANOMALY_ALERT_DISABLED";
    MonitorRuleApiCode["StatusCodeAutoCompleteFailure"] = "STATUS_CODE_AUTO_COMPLETE_FAILURE";
    MonitorRuleApiCode["StatusCodeCreatorNotSubscriber"] = "STATUS_CODE_CREATOR_NOT_SUBSCRIBER";
    MonitorRuleApiCode["StatusCodeDataFetchError"] = "STATUS_CODE_DATA_FETCH_ERROR";
    MonitorRuleApiCode["StatusCodeError"] = "STATUS_CODE_ERROR";
    MonitorRuleApiCode["StatusCodeHourlyKpiNotSupported"] = "STATUS_CODE_HOURLY_KPI_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeHtmlInAlertName"] = "STATUS_CODE_HTML_IN_ALERT_NAME";
    MonitorRuleApiCode["StatusCodeInsufficientDataError"] = "STATUS_CODE_INSUFFICIENT_DATA_ERROR";
    MonitorRuleApiCode["StatusCodeInvalidAttributeValueConfiguration"] = "STATUS_CODE_INVALID_ATTRIBUTE_VALUE_CONFIGURATION";
    MonitorRuleApiCode["StatusCodeInvalidRequest"] = "STATUS_CODE_INVALID_REQUEST";
    MonitorRuleApiCode["StatusCodeKeywordNotSupported"] = "STATUS_CODE_KEYWORD_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeMetricNotMonitorable"] = "STATUS_CODE_METRIC_NOT_MONITORABLE";
    MonitorRuleApiCode["StatusCodeMonitorableNotFound"] = "STATUS_CODE_MONITORABLE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeOk"] = "STATUS_CODE_OK";
    MonitorRuleApiCode["StatusCodePercentageChangeOnNonTimeseriesKpi"] = "STATUS_CODE_PERCENTAGE_CHANGE_ON_NON_TIMESERIES_KPI";
    MonitorRuleApiCode["StatusCodePermissionsNotFound"] = "STATUS_CODE_PERMISSIONS_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeRuleNotFound"] = "STATUS_CODE_RULE_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeTableIndependentAttributesNotSupported"] = "STATUS_CODE_TABLE_INDEPENDENT_ATTRIBUTES_NOT_SUPPORTED";
    MonitorRuleApiCode["StatusCodeTitleNotPlaintext"] = "STATUS_CODE_TITLE_NOT_PLAINTEXT";
    MonitorRuleApiCode["StatusCodeUnauthorized"] = "STATUS_CODE_UNAUTHORIZED";
    MonitorRuleApiCode["StatusCodeUnspecified"] = "STATUS_CODE_UNSPECIFIED";
    MonitorRuleApiCode["StatusCodeUnsupportedFormula"] = "STATUS_CODE_UNSUPPORTED_FORMULA";
    MonitorRuleApiCode["StatusCodeUnsupportedTimeBucket"] = "STATUS_CODE_UNSUPPORTED_TIME_BUCKET";
    MonitorRuleApiCode["StatusCodeUserAlreadySubscribed"] = "STATUS_CODE_USER_ALREADY_SUBSCRIBED";
    MonitorRuleApiCode["StatusCodeUserNotFound"] = "STATUS_CODE_USER_NOT_FOUND";
    MonitorRuleApiCode["StatusCodeUserNotSubscribed"] = "STATUS_CODE_USER_NOT_SUBSCRIBED";
})(MonitorRuleApiCode || (MonitorRuleApiCode = {}));
export var Month;
(function (Month) {
    Month["April"] = "APRIL";
    Month["August"] = "AUGUST";
    Month["December"] = "DECEMBER";
    Month["February"] = "FEBRUARY";
    Month["January"] = "JANUARY";
    Month["July"] = "JULY";
    Month["June"] = "JUNE";
    Month["March"] = "MARCH";
    Month["May"] = "MAY";
    Month["November"] = "NOVEMBER";
    Month["NumMonths"] = "NUM_MONTHS";
    Month["October"] = "OCTOBER";
    Month["September"] = "SEPTEMBER";
})(Month || (Month = {}));
export var NasStatus;
(function (NasStatus) {
    NasStatus["Configured"] = "CONFIGURED";
    NasStatus["Empty"] = "EMPTY";
    NasStatus["NotConfigured"] = "NOT_CONFIGURED";
})(NasStatus || (NasStatus = {}));
export var NegativeValueFormat;
(function (NegativeValueFormat) {
    NegativeValueFormat["BracesNodash"] = "BRACES_NODASH";
    NegativeValueFormat["PrefixDash"] = "PREFIX_DASH";
    NegativeValueFormat["SuffixDash"] = "SUFFIX_DASH";
})(NegativeValueFormat || (NegativeValueFormat = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Email"] = "EMAIL";
    NotificationChannel["Webhook"] = "WEBHOOK";
})(NotificationChannel || (NotificationChannel = {}));
export var ObjectDependency;
(function (ObjectDependency) {
    ObjectDependency["Column"] = "COLUMN";
    ObjectDependency["Dataobject"] = "DATAOBJECT";
    ObjectDependency["Join"] = "JOIN";
    ObjectDependency["Liveboard"] = "LIVEBOARD";
})(ObjectDependency || (ObjectDependency = {}));
export var ObjectType;
(function (ObjectType) {
    ObjectType["Answer"] = "ANSWER";
    ObjectType["Column"] = "COLUMN";
    ObjectType["Connection"] = "CONNECTION";
    ObjectType["Filter"] = "FILTER";
    ObjectType["Formula"] = "FORMULA";
    ObjectType["Insight"] = "INSIGHT";
    ObjectType["Pinboard"] = "PINBOARD";
    ObjectType["Relationship"] = "RELATIONSHIP";
    ObjectType["Table"] = "TABLE";
})(ObjectType || (ObjectType = {}));
export var Operators;
(function (Operators) {
    Operators["Contains"] = "CONTAINS";
    Operators["DoesNotContain"] = "DOES_NOT_CONTAIN";
    Operators["EndsWith"] = "ENDS_WITH";
    Operators["EqualTo"] = "EQUAL_TO";
    Operators["GreaterThan"] = "GREATER_THAN";
    Operators["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    Operators["Is"] = "IS";
    Operators["IsBetween"] = "IS_BETWEEN";
    Operators["IsEmpty"] = "IS_EMPTY";
    Operators["IsNot"] = "IS_NOT";
    Operators["IsNotEmpty"] = "IS_NOT_EMPTY";
    Operators["IsNotNull"] = "IS_NOT_NULL";
    Operators["IsNull"] = "IS_NULL";
    Operators["LessThan"] = "LESS_THAN";
    Operators["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    Operators["NotEqualTo"] = "NOT_EQUAL_TO";
    Operators["StartsWith"] = "STARTS_WITH";
})(Operators || (Operators = {}));
export var Orientation;
(function (Orientation) {
    Orientation["Landscape"] = "LANDSCAPE";
    Orientation["Portrait"] = "PORTRAIT";
})(Orientation || (Orientation = {}));
export var OutputType;
(function (OutputType) {
    OutputType["Csv"] = "CSV";
    OutputType["Pdf"] = "PDF";
    OutputType["Png"] = "PNG";
    OutputType["Xlsx"] = "XLSX";
})(OutputType || (OutputType = {}));
export var PageSize;
(function (PageSize) {
    PageSize["A4"] = "A4";
})(PageSize || (PageSize = {}));
export var ParameterOwnerType;
(function (ParameterOwnerType) {
    ParameterOwnerType["Answer"] = "ANSWER";
    ParameterOwnerType["Worksheet"] = "WORKSHEET";
})(ParameterOwnerType || (ParameterOwnerType = {}));
export var ParameterValueType;
(function (ParameterValueType) {
    ParameterValueType["Any"] = "ANY";
    ParameterValueType["List"] = "LIST";
    ParameterValueType["Range"] = "RANGE";
})(ParameterValueType || (ParameterValueType = {}));
export var Partner;
(function (Partner) {
    Partner["Redshift"] = "REDSHIFT";
})(Partner || (Partner = {}));
export var PeriodicScheduleType;
(function (PeriodicScheduleType) {
    PeriodicScheduleType["Cron"] = "CRON";
    PeriodicScheduleType["Default"] = "DEFAULT";
})(PeriodicScheduleType || (PeriodicScheduleType = {}));
export var Periodicity;
(function (Periodicity) {
    Periodicity["Default"] = "DEFAULT";
    Periodicity["OneTime"] = "ONE_TIME";
    Periodicity["Periodic"] = "PERIODIC";
})(Periodicity || (Periodicity = {}));
export var PermissionLevel;
(function (PermissionLevel) {
    PermissionLevel["PermissionLevelCannotSubscribe"] = "PERMISSION_LEVEL_CANNOT_SUBSCRIBE";
    PermissionLevel["PermissionLevelCanSubscribe"] = "PERMISSION_LEVEL_CAN_SUBSCRIBE";
    PermissionLevel["PermissionLevelPermissionsNeeded"] = "PERMISSION_LEVEL_PERMISSIONS_NEEDED";
    PermissionLevel["PermissionLevelUnspecified"] = "PERMISSION_LEVEL_UNSPECIFIED";
})(PermissionLevel || (PermissionLevel = {}));
export var PhraseType;
(function (PhraseType) {
    PhraseType["AggregatedAttributeValuePhrase"] = "AGGREGATED_ATTRIBUTE_VALUE_PHRASE";
    PhraseType["AggregatedColumnPhrase"] = "AGGREGATED_COLUMN_PHRASE";
    PhraseType["Begin"] = "BEGIN";
    PhraseType["CalendarPhrase"] = "CALENDAR_PHRASE";
    PhraseType["DelimiterPhrase"] = "DELIMITER_PHRASE";
    PhraseType["End"] = "END";
    PhraseType["FilteredCountPhrase"] = "FILTERED_COUNT_PHRASE";
    PhraseType["FilterPhrase"] = "FILTER_PHRASE";
    PhraseType["FormulaPhrase"] = "FORMULA_PHRASE";
    PhraseType["ForEachPhrase"] = "FOR_EACH_PHRASE";
    PhraseType["GeofilterPhrase"] = "GEOFILTER_PHRASE";
    PhraseType["GroupByColumnPhrase"] = "GROUP_BY_COLUMN_PHRASE";
    PhraseType["GrowthPhrase"] = "GROWTH_PHRASE";
    PhraseType["HavingPhrase"] = "HAVING_PHRASE";
    PhraseType["InFilterPhrase"] = "IN_FILTER_PHRASE";
    PhraseType["InFilterSubqueryPhrase"] = "IN_FILTER_SUBQUERY_PHRASE";
    PhraseType["OfFilterPhrase"] = "OF_FILTER_PHRASE";
    PhraseType["OfPhrase"] = "OF_PHRASE";
    PhraseType["OfSortByPhrase"] = "OF_SORT_BY_PHRASE";
    PhraseType["PercentageOfFilterPhrase"] = "PERCENTAGE_OF_FILTER_PHRASE";
    PhraseType["PercentageOfPhrase"] = "PERCENTAGE_OF_PHRASE";
    PhraseType["PercentageOfSortByPhrase"] = "PERCENTAGE_OF_SORT_BY_PHRASE";
    PhraseType["PivotPhrase"] = "PIVOT_PHRASE";
    PhraseType["ShowColumnPhrase"] = "SHOW_COLUMN_PHRASE";
    PhraseType["SkipTokenPhrase"] = "SKIP_TOKEN_PHRASE";
    PhraseType["SortByPhrase"] = "SORT_BY_PHRASE";
    PhraseType["StopWordPhrase"] = "STOP_WORD_PHRASE";
    PhraseType["TopBottomFilterPhrase"] = "TOP_BOTTOM_FILTER_PHRASE";
    PhraseType["TopBottomPhrase"] = "TOP_BOTTOM_PHRASE";
    PhraseType["UndefinedPhrase"] = "UNDEFINED_PHRASE";
    PhraseType["VersusPhrase"] = "VERSUS_PHRASE";
    PhraseType["VersusSubqueryPhrase"] = "VERSUS_SUBQUERY_PHRASE";
})(PhraseType || (PhraseType = {}));
export var PinboardContainerType;
(function (PinboardContainerType) {
    PinboardContainerType["ClusterViz"] = "CLUSTER_VIZ";
    PinboardContainerType["GenericViz"] = "GENERIC_VIZ";
    PinboardContainerType["Group"] = "GROUP";
    PinboardContainerType["NoteTile"] = "NOTE_TILE";
    PinboardContainerType["PinnedAnswer"] = "PINNED_ANSWER";
    PinboardContainerType["PinnedInsight"] = "PINNED_INSIGHT";
})(PinboardContainerType || (PinboardContainerType = {}));
export var PinboardContextType;
(function (PinboardContextType) {
    PinboardContextType["AdminPinboard"] = "ADMIN_PINBOARD";
    PinboardContextType["DownloadPinboard"] = "DOWNLOAD_PINBOARD";
    PinboardContextType["EmbedPinboard"] = "EMBED_PINBOARD";
    PinboardContextType["HomePinboard"] = "HOME_PINBOARD";
    PinboardContextType["InsightPinboard"] = "INSIGHT_PINBOARD";
    PinboardContextType["KpiMonitor"] = "KPI_MONITOR";
    PinboardContextType["LearnPinboard"] = "LEARN_PINBOARD";
    PinboardContextType["SavedPinboard"] = "SAVED_PINBOARD";
})(PinboardContextType || (PinboardContextType = {}));
export var PinboardModelVersion;
(function (PinboardModelVersion) {
    PinboardModelVersion["V1"] = "V1";
    PinboardModelVersion["V2"] = "V2";
})(PinboardModelVersion || (PinboardModelVersion = {}));
export var PolicyType;
(function (PolicyType) {
    PolicyType["NoPolicy"] = "NO_POLICY";
    PolicyType["Process"] = "PROCESS";
    PolicyType["Usergroups"] = "USERGROUPS";
})(PolicyType || (PolicyType = {}));
export var PrincipalGroupType;
(function (PrincipalGroupType) {
    PrincipalGroupType["LocalGroup"] = "LOCAL_GROUP";
    PrincipalGroupType["TenantGroup"] = "TENANT_GROUP";
})(PrincipalGroupType || (PrincipalGroupType = {}));
export var PrincipalType;
(function (PrincipalType) {
    PrincipalType["LdapUser"] = "LDAP_USER";
    PrincipalType["LocalUser"] = "LOCAL_USER";
    PrincipalType["OidcUser"] = "OIDC_USER";
    PrincipalType["SamlUser"] = "SAML_USER";
    PrincipalType["Unknown"] = "UNKNOWN";
})(PrincipalType || (PrincipalType = {}));
export var PrincipalVisibilityType;
(function (PrincipalVisibilityType) {
    PrincipalVisibilityType["Default"] = "DEFAULT";
    PrincipalVisibilityType["NonSharable"] = "NON_SHARABLE";
    PrincipalVisibilityType["Sharable"] = "SHARABLE";
})(PrincipalVisibilityType || (PrincipalVisibilityType = {}));
export var Privilages;
(function (Privilages) {
    Privilages["A3Analysis"] = "A3ANALYSIS";
    Privilages["Administration"] = "ADMINISTRATION";
    Privilages["ApplicationAdministration"] = "APPLICATION_ADMINISTRATION";
    Privilages["Authoring"] = "AUTHORING";
    Privilages["BackupAdministration"] = "BACKUP_ADMINISTRATION";
    Privilages["Bypassrls"] = "BYPASSRLS";
    Privilages["CanConfigureConnections"] = "CAN_CONFIGURE_CONNECTIONS";
    Privilages["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privilages["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privilages["Datadownloading"] = "DATADOWNLOADING";
    Privilages["Datamanagement"] = "DATAMANAGEMENT";
    Privilages["Developer"] = "DEVELOPER";
    Privilages["DisablePinboardCreation"] = "DISABLE_PINBOARD_CREATION";
    Privilages["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privilages["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privilages["Jobscheduling"] = "JOBSCHEDULING";
    Privilages["Ranalysis"] = "RANALYSIS";
    Privilages["Sharewithall"] = "SHAREWITHALL";
    Privilages["Systemmanagement"] = "SYSTEMMANAGEMENT";
    Privilages["SystemInfoAdministration"] = "SYSTEM_INFO_ADMINISTRATION";
    Privilages["Userdatauploading"] = "USERDATAUPLOADING";
    Privilages["UserAdministration"] = "USER_ADMINISTRATION";
})(Privilages || (Privilages = {}));
export var Privileges;
(function (Privileges) {
    Privileges["A3Analysis"] = "A3ANALYSIS";
    Privileges["Administration"] = "ADMINISTRATION";
    Privileges["AllowNonEmbedFullAppAccess"] = "ALLOW_NON_EMBED_FULL_APP_ACCESS";
    Privileges["Authoring"] = "AUTHORING";
    Privileges["Bypassrls"] = "BYPASSRLS";
    Privileges["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Privileges["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Privileges["Datadownloading"] = "DATADOWNLOADING";
    Privileges["Datamanagement"] = "DATAMANAGEMENT";
    Privileges["Developer"] = "DEVELOPER";
    Privileges["Experimentalfeatureprivilege"] = "EXPERIMENTALFEATUREPRIVILEGE";
    Privileges["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Privileges["Jobscheduling"] = "JOBSCHEDULING";
    Privileges["Ranalysis"] = "RANALYSIS";
    Privileges["Sharewithall"] = "SHAREWITHALL";
    Privileges["Syncmanagement"] = "SYNCMANAGEMENT";
    Privileges["Userdatauploading"] = "USERDATAUPLOADING";
    Privileges["Usermanagement"] = "USERMANAGEMENT";
    Privileges["UserAdministration"] = "USER_ADMINISTRATION";
})(Privileges || (Privileges = {}));
export var Processes;
(function (Processes) {
    Processes["RowCountStats"] = "ROW_COUNT_STATS";
    Processes["SageIndexing"] = "SAGE_INDEXING";
    Processes["SageSampling"] = "SAGE_SAMPLING";
})(Processes || (Processes = {}));
export var ProgressStatusCode;
(function (ProgressStatusCode) {
    ProgressStatusCode["Completed"] = "COMPLETED";
    ProgressStatusCode["Failed"] = "FAILED";
    ProgressStatusCode["InProgress"] = "IN_PROGRESS";
    ProgressStatusCode["InQueue"] = "IN_QUEUE";
})(ProgressStatusCode || (ProgressStatusCode = {}));
export var Quarter;
(function (Quarter) {
    Quarter["NumQuarters"] = "NUM_QUARTERS";
    Quarter["Q1"] = "Q1";
    Quarter["Q2"] = "Q2";
    Quarter["Q3"] = "Q3";
    Quarter["Q4"] = "Q4";
})(Quarter || (Quarter = {}));
export var QuerableDataSourceType;
(function (QuerableDataSourceType) {
    QuerableDataSourceType["Default"] = "DEFAULT";
    QuerableDataSourceType["FileCsv"] = "FILE_CSV";
    QuerableDataSourceType["Informatica"] = "INFORMATICA";
    QuerableDataSourceType["IpaasInformatica"] = "IPAAS_INFORMATICA";
    QuerableDataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    QuerableDataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    QuerableDataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    QuerableDataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    QuerableDataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    QuerableDataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    QuerableDataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    QuerableDataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    QuerableDataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    QuerableDataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    QuerableDataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    QuerableDataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    QuerableDataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    QuerableDataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    QuerableDataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    QuerableDataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    QuerableDataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    QuerableDataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    QuerableDataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    QuerableDataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    QuerableDataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    QuerableDataSourceType["RdbmsMarketo"] = "RDBMS_MARKETO";
    QuerableDataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    QuerableDataSourceType["RdbmsMode"] = "RDBMS_MODE";
    QuerableDataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    QuerableDataSourceType["RdbmsOracle"] = "RDBMS_ORACLE";
    QuerableDataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    QuerableDataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    QuerableDataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    QuerableDataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    QuerableDataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    QuerableDataSourceType["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    QuerableDataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    QuerableDataSourceType["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    QuerableDataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    QuerableDataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    QuerableDataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    QuerableDataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    QuerableDataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    QuerableDataSourceType["SaasSalesforce"] = "SAAS_SALESFORCE";
})(QuerableDataSourceType || (QuerableDataSourceType = {}));
export var QueryCompletionType;
(function (QueryCompletionType) {
    QueryCompletionType["NlCompletion"] = "NL_COMPLETION";
    QueryCompletionType["NlPrimingCompletion"] = "NL_PRIMING_COMPLETION";
    QueryCompletionType["PhraseHistoryOthers"] = "PHRASE_HISTORY_OTHERS";
    QueryCompletionType["PhraseHistorySelf"] = "PHRASE_HISTORY_SELF";
    QueryCompletionType["Rewrite"] = "REWRITE";
    QueryCompletionType["SearchHistoryOthers"] = "SEARCH_HISTORY_OTHERS";
    QueryCompletionType["SearchHistorySelf"] = "SEARCH_HISTORY_SELF";
    QueryCompletionType["Synonym"] = "SYNONYM";
    QueryCompletionType["Undefined"] = "UNDEFINED";
})(QueryCompletionType || (QueryCompletionType = {}));
export var QueryTemplateBoundStateType;
(function (QueryTemplateBoundStateType) {
    QueryTemplateBoundStateType["FilterColumn"] = "FILTER_COLUMN";
    QueryTemplateBoundStateType["FilterValue"] = "FILTER_VALUE";
})(QueryTemplateBoundStateType || (QueryTemplateBoundStateType = {}));
export var QueryTemplateType;
(function (QueryTemplateType) {
    QueryTemplateType["Attribute"] = "ATTRIBUTE";
    QueryTemplateType["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    QueryTemplateType["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    QueryTemplateType["CustomCalendar"] = "CUSTOM_CALENDAR";
    QueryTemplateType["ForEach"] = "FOR_EACH";
    QueryTemplateType["Geofilter"] = "GEOFILTER";
    QueryTemplateType["GrowthOf"] = "GROWTH_OF";
    QueryTemplateType["Having"] = "HAVING";
    QueryTemplateType["InFilter"] = "IN_FILTER";
    QueryTemplateType["Measure"] = "MEASURE";
    QueryTemplateType["MeasureColumn"] = "MEASURE_COLUMN";
    QueryTemplateType["NoSkill"] = "NO_SKILL";
    QueryTemplateType["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    QueryTemplateType["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    QueryTemplateType["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    QueryTemplateType["SortBy"] = "SORT_BY";
    QueryTemplateType["TimeBucket"] = "TIME_BUCKET";
    QueryTemplateType["TimeFilters"] = "TIME_FILTERS";
    QueryTemplateType["TopBottom"] = "TOP_BOTTOM";
    QueryTemplateType["Undefined"] = "UNDEFINED";
    QueryTemplateType["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(QueryTemplateType || (QueryTemplateType = {}));
export var QueryTransformType;
(function (QueryTransformType) {
    QueryTransformType["AddAttribute"] = "ADD_ATTRIBUTE";
    QueryTransformType["AddAutoResolvedDateBucketsToTokens"] = "ADD_AUTO_RESOLVED_DATE_BUCKETS_TO_TOKENS";
    QueryTransformType["AddColumn"] = "ADD_COLUMN";
    QueryTransformType["AddEmptyGroupBy"] = "ADD_EMPTY_GROUP_BY";
    QueryTransformType["AddFilter"] = "ADD_FILTER";
    QueryTransformType["AddHavingFilter"] = "ADD_HAVING_FILTER";
    QueryTransformType["AddInFilter"] = "ADD_IN_FILTER";
    QueryTransformType["AddMeasure"] = "ADD_MEASURE";
    QueryTransformType["AddPredicateFilter"] = "ADD_PREDICATE_FILTER";
    QueryTransformType["AddSortColumn"] = "ADD_SORT_COLUMN";
    QueryTransformType["AddTimeBucketQualifier"] = "ADD_TIME_BUCKET_QUALIFIER";
    QueryTransformType["AddVersus"] = "ADD_VERSUS";
    QueryTransformType["ChangeAggregation"] = "CHANGE_AGGREGATION";
    QueryTransformType["ChangeTimeBucket"] = "CHANGE_TIME_BUCKET";
    QueryTransformType["DeprecatedAddFormula"] = "DEPRECATED_ADD_FORMULA";
    QueryTransformType["DeprecatedAddTimeBucket"] = "DEPRECATED_ADD_TIME_BUCKET";
    QueryTransformType["DeprecatedRemoveFormula"] = "DEPRECATED_REMOVE_FORMULA";
    QueryTransformType["DeprecatedRemoveTimeBucket"] = "DEPRECATED_REMOVE_TIME_BUCKET";
    QueryTransformType["DrillDown"] = "DRILL_DOWN";
    QueryTransformType["EditFilter"] = "EDIT_FILTER";
    QueryTransformType["NumTransforms"] = "NUM_TRANSFORMS";
    QueryTransformType["PopulatePeriodToDateFiltersInTokens"] = "POPULATE_PERIOD_TO_DATE_FILTERS_IN_TOKENS";
    QueryTransformType["RemoveAllDateRangeFiltersForColumn"] = "REMOVE_ALL_DATE_RANGE_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllFiltersForColumn"] = "REMOVE_ALL_FILTERS_FOR_COLUMN";
    QueryTransformType["RemoveAllHavingFilters"] = "REMOVE_ALL_HAVING_FILTERS";
    QueryTransformType["RemoveAllHavingFiltersByAggregate"] = "REMOVE_ALL_HAVING_FILTERS_BY_AGGREGATE";
    QueryTransformType["RemoveAllHavingFiltersByColumn"] = "REMOVE_ALL_HAVING_FILTERS_BY_COLUMN";
    QueryTransformType["RemoveAllPhrasesByColumn"] = "REMOVE_ALL_PHRASES_BY_COLUMN";
    QueryTransformType["RemoveAllSortPhrases"] = "REMOVE_ALL_SORT_PHRASES";
    QueryTransformType["RemoveColumn"] = "REMOVE_COLUMN";
    QueryTransformType["RemoveFilter"] = "REMOVE_FILTER";
    QueryTransformType["RemoveHavingFilter"] = "REMOVE_HAVING_FILTER";
    QueryTransformType["RemoveInFilter"] = "REMOVE_IN_FILTER";
    QueryTransformType["RemoveNonFilterPhrases"] = "REMOVE_NON_FILTER_PHRASES";
    QueryTransformType["RemovePredicateFilter"] = "REMOVE_PREDICATE_FILTER";
    QueryTransformType["RemoveTimeBucketQualifier"] = "REMOVE_TIME_BUCKET_QUALIFIER";
    QueryTransformType["RemoveVersus"] = "REMOVE_VERSUS";
})(QueryTransformType || (QueryTransformType = {}));
export var ROutputTypeEnum;
(function (ROutputTypeEnum) {
    ROutputTypeEnum["Csv"] = "CSV";
    ROutputTypeEnum["Png"] = "PNG";
})(ROutputTypeEnum || (ROutputTypeEnum = {}));
export var ReceiverType;
(function (ReceiverType) {
    ReceiverType["Email"] = "EMAIL";
    ReceiverType["Group"] = "GROUP";
    ReceiverType["User"] = "USER";
})(ReceiverType || (ReceiverType = {}));
export var RecognizedTokenType;
(function (RecognizedTokenType) {
    RecognizedTokenType["Any"] = "ANY";
    RecognizedTokenType["Attribute"] = "ATTRIBUTE";
    RecognizedTokenType["Bool"] = "BOOL";
    RecognizedTokenType["Calendar"] = "CALENDAR";
    RecognizedTokenType["Constant"] = "CONSTANT";
    RecognizedTokenType["Date"] = "DATE";
    RecognizedTokenType["DateBucket"] = "DATE_BUCKET";
    RecognizedTokenType["Delimiter"] = "DELIMITER";
    RecognizedTokenType["Double"] = "DOUBLE";
    RecognizedTokenType["EndFsm"] = "END_FSM";
    RecognizedTokenType["Formula"] = "FORMULA";
    RecognizedTokenType["FunctionName"] = "FUNCTION_NAME";
    RecognizedTokenType["IncludeFsm"] = "INCLUDE_FSM";
    RecognizedTokenType["Integer"] = "INTEGER";
    RecognizedTokenType["Keyword"] = "KEYWORD";
    RecognizedTokenType["MaxType"] = "MAX_TYPE";
    RecognizedTokenType["Measure"] = "MEASURE";
    RecognizedTokenType["NamedPhrase"] = "NAMED_PHRASE";
    RecognizedTokenType["Operator"] = "OPERATOR";
    RecognizedTokenType["Parameter"] = "PARAMETER";
    RecognizedTokenType["PositiveInt"] = "POSITIVE_INT";
    RecognizedTokenType["PrefixValue"] = "PREFIX_VALUE";
    RecognizedTokenType["SkipToken"] = "SKIP_TOKEN";
    RecognizedTokenType["StopWord"] = "STOP_WORD";
    RecognizedTokenType["String"] = "STRING";
    RecognizedTokenType["SubstringValue"] = "SUBSTRING_VALUE";
    RecognizedTokenType["SuffixValue"] = "SUFFIX_VALUE";
    RecognizedTokenType["TemplateArg"] = "TEMPLATE_ARG";
    RecognizedTokenType["Time"] = "TIME";
    RecognizedTokenType["Unrecognized"] = "UNRECOGNIZED";
    RecognizedTokenType["Value"] = "VALUE";
    RecognizedTokenType["Year"] = "YEAR";
})(RecognizedTokenType || (RecognizedTokenType = {}));
export var RedshiftConnectionStatus;
(function (RedshiftConnectionStatus) {
    RedshiftConnectionStatus["Active"] = "Active";
    RedshiftConnectionStatus["ConnectionFailure"] = "ConnectionFailure";
    RedshiftConnectionStatus["Inactive"] = "Inactive";
    RedshiftConnectionStatus["RuntimeFailure"] = "RuntimeFailure";
})(RedshiftConnectionStatus || (RedshiftConnectionStatus = {}));
export var ReplaceableColumnType;
(function (ReplaceableColumnType) {
    ReplaceableColumnType["Attribute"] = "ATTRIBUTE";
    ReplaceableColumnType["DateBucket"] = "DATE_BUCKET";
    ReplaceableColumnType["DateColumn"] = "DATE_COLUMN";
    ReplaceableColumnType["Measure"] = "MEASURE";
})(ReplaceableColumnType || (ReplaceableColumnType = {}));
export var ReportFormat;
(function (ReportFormat) {
    ReportFormat["Csv"] = "CSV";
    ReportFormat["Pdf"] = "PDF";
    ReportFormat["Png"] = "PNG";
    ReportFormat["Xlsx"] = "XLSX";
})(ReportFormat || (ReportFormat = {}));
export var RevertPolicy;
(function (RevertPolicy) {
    RevertPolicy["AllOrNone"] = "ALL_OR_NONE";
    RevertPolicy["Partial"] = "PARTIAL";
    RevertPolicy["PartialObject"] = "PARTIAL_OBJECT";
})(RevertPolicy || (RevertPolicy = {}));
export var SfdcOperationTypes;
(function (SfdcOperationTypes) {
    SfdcOperationTypes["Insert"] = "INSERT";
    SfdcOperationTypes["Upsert"] = "UPSERT";
})(SfdcOperationTypes || (SfdcOperationTypes = {}));
export var SageColumnAggTypes;
(function (SageColumnAggTypes) {
    SageColumnAggTypes["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    SageColumnAggTypes["Average"] = "AVERAGE";
    SageColumnAggTypes["Count"] = "COUNT";
    SageColumnAggTypes["Max"] = "MAX";
    SageColumnAggTypes["Median"] = "MEDIAN";
    SageColumnAggTypes["Min"] = "MIN";
    SageColumnAggTypes["None"] = "NONE";
    SageColumnAggTypes["Percentile"] = "PERCENTILE";
    SageColumnAggTypes["Rank"] = "RANK";
    SageColumnAggTypes["RankPercentile"] = "RANK_PERCENTILE";
    SageColumnAggTypes["StdDeviation"] = "STD_DEVIATION";
    SageColumnAggTypes["Sum"] = "SUM";
    SageColumnAggTypes["UniqueCount"] = "UNIQUE_COUNT";
    SageColumnAggTypes["Variance"] = "VARIANCE";
})(SageColumnAggTypes || (SageColumnAggTypes = {}));
export var SageColumnType;
(function (SageColumnType) {
    SageColumnType["Attribute"] = "ATTRIBUTE";
    SageColumnType["Measure"] = "MEASURE";
    SageColumnType["Unknown"] = "UNKNOWN";
})(SageColumnType || (SageColumnType = {}));
export var SageCompareType;
(function (SageCompareType) {
    SageCompareType["BeginsWith"] = "BEGINS_WITH";
    SageCompareType["Bw"] = "BW";
    SageCompareType["BwInc"] = "BW_INC";
    SageCompareType["BwIncMax"] = "BW_INC_MAX";
    SageCompareType["BwIncMin"] = "BW_INC_MIN";
    SageCompareType["Contains"] = "CONTAINS";
    SageCompareType["EndsWith"] = "ENDS_WITH";
    SageCompareType["Eq"] = "EQ";
    SageCompareType["Ge"] = "GE";
    SageCompareType["Gt"] = "GT";
    SageCompareType["In"] = "IN";
    SageCompareType["Le"] = "LE";
    SageCompareType["Like"] = "LIKE";
    SageCompareType["Lt"] = "LT";
    SageCompareType["Ne"] = "NE";
    SageCompareType["NotIn"] = "NOT_IN";
})(SageCompareType || (SageCompareType = {}));
export var SageErrorCodeType;
(function (SageErrorCodeType) {
    SageErrorCodeType["AmbiguousToken"] = "AMBIGUOUS_TOKEN";
    SageErrorCodeType["BadRecognizedTokens"] = "BAD_RECOGNIZED_TOKENS";
    SageErrorCodeType["BadTokenSequence"] = "BAD_TOKEN_SEQUENCE";
    SageErrorCodeType["Cancelled"] = "CANCELLED";
    SageErrorCodeType["Failure"] = "FAILURE";
    SageErrorCodeType["ForbiddenWord"] = "FORBIDDEN_WORD";
    SageErrorCodeType["InconsistentJoinPath"] = "INCONSISTENT_JOIN_PATH";
    SageErrorCodeType["IncrementalRequestNotApplicable"] = "INCREMENTAL_REQUEST_NOT_APPLICABLE";
    SageErrorCodeType["InvalidColumn"] = "INVALID_COLUMN";
    SageErrorCodeType["InvalidJoinPath"] = "INVALID_JOIN_PATH";
    SageErrorCodeType["InvalidRequest"] = "INVALID_REQUEST";
    SageErrorCodeType["InvalidTable"] = "INVALID_TABLE";
    SageErrorCodeType["InvalidTransform"] = "INVALID_TRANSFORM";
    SageErrorCodeType["JoinPathAmbiguity"] = "JOIN_PATH_AMBIGUITY";
    SageErrorCodeType["LessonPlanUpgraded"] = "LESSON_PLAN_UPGRADED";
    SageErrorCodeType["LessonPlanUpgradeFailed"] = "LESSON_PLAN_UPGRADE_FAILED";
    SageErrorCodeType["LlmDisabled"] = "LLM_DISABLED";
    SageErrorCodeType["LlmFormat"] = "LLM_FORMAT";
    SageErrorCodeType["LlmNotEnoughQuestions"] = "LLM_NOT_ENOUGH_QUESTIONS";
    SageErrorCodeType["LlmNotFoundInPensieve"] = "LLM_NOT_FOUND_IN_PENSIEVE";
    SageErrorCodeType["LlmPensieveWriteError"] = "LLM_PENSIEVE_WRITE_ERROR";
    SageErrorCodeType["LlmUnavailable"] = "LLM_UNAVAILABLE";
    SageErrorCodeType["NestedAggrWarning"] = "NESTED_AGGR_WARNING";
    SageErrorCodeType["NestingGroupAggrNotAllowed"] = "NESTING_GROUP_AGGR_NOT_ALLOWED";
    SageErrorCodeType["NotFound"] = "NOT_FOUND";
    SageErrorCodeType["NotReady"] = "NOT_READY";
    SageErrorCodeType["NoJoinPath"] = "NO_JOIN_PATH";
    SageErrorCodeType["NoMatch"] = "NO_MATCH";
    SageErrorCodeType["PermissionDenied"] = "PERMISSION_DENIED";
    SageErrorCodeType["QueryTemplateToTemplateEntryMismatch"] = "QUERY_TEMPLATE_TO_TEMPLATE_ENTRY_MISMATCH";
    SageErrorCodeType["RelationshipGraphHasCycles"] = "RELATIONSHIP_GRAPH_HAS_CYCLES";
    SageErrorCodeType["RemoveFormulaDependencyFailure"] = "REMOVE_FORMULA_DEPENDENCY_FAILURE";
    SageErrorCodeType["Success"] = "SUCCESS";
    SageErrorCodeType["TimeOutError"] = "TIME_OUT_ERROR";
    SageErrorCodeType["UnknownUser"] = "UNKNOWN_USER";
    SageErrorCodeType["UnsupportedLanguage"] = "UNSUPPORTED_LANGUAGE";
    SageErrorCodeType["UserGroupMaskNotSet"] = "USER_GROUP_MASK_NOT_SET";
})(SageErrorCodeType || (SageErrorCodeType = {}));
export var SageFeatureFlag;
(function (SageFeatureFlag) {
    SageFeatureFlag["AutoResolveJoinAmbiguity"] = "AUTO_RESOLVE_JOIN_AMBIGUITY";
    SageFeatureFlag["DisableApproximateMatches"] = "DISABLE_APPROXIMATE_MATCHES";
    SageFeatureFlag["DisableDataBasedAutoBucketing"] = "DISABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["DisableFollowUpSuggestions"] = "DISABLE_FOLLOW_UP_SUGGESTIONS";
    SageFeatureFlag["DisableObjectSearch"] = "DISABLE_OBJECT_SEARCH";
    SageFeatureFlag["DisableSearchHistoryLookup"] = "DISABLE_SEARCH_HISTORY_LOOKUP";
    SageFeatureFlag["DisableTokenization"] = "DISABLE_TOKENIZATION";
    SageFeatureFlag["DisableUbr"] = "DISABLE_UBR";
    SageFeatureFlag["DisableUbrFeedbackLookup"] = "DISABLE_UBR_FEEDBACK_LOOKUP";
    SageFeatureFlag["EnableDataBasedAutoBucketing"] = "ENABLE_DATA_BASED_AUTO_BUCKETING";
    SageFeatureFlag["EnableNlpTokenizer"] = "ENABLE_NLP_TOKENIZER";
    SageFeatureFlag["EnableOutOfScopeMatches"] = "ENABLE_OUT_OF_SCOPE_MATCHES";
    SageFeatureFlag["EnableRequestProfiling"] = "ENABLE_REQUEST_PROFILING";
    SageFeatureFlag["EnableSearchHistory"] = "ENABLE_SEARCH_HISTORY";
    SageFeatureFlag["LookupEnlitePreferredColumns"] = "LOOKUP_ENLITE_PREFERRED_COLUMNS";
    SageFeatureFlag["LookupOnlyColumns"] = "LOOKUP_ONLY_COLUMNS";
    SageFeatureFlag["NumFeatureFlags"] = "NUM_FEATURE_FLAGS";
    SageFeatureFlag["ShowDebugInfo"] = "SHOW_DEBUG_INFO";
    SageFeatureFlag["SingleTokenCompletionsOnly"] = "SINGLE_TOKEN_COMPLETIONS_ONLY";
    SageFeatureFlag["UseWhiteSpaceInfo"] = "USE_WHITE_SPACE_INFO";
    SageFeatureFlag["WriteRequestSnapshot"] = "WRITE_REQUEST_SNAPSHOT";
})(SageFeatureFlag || (SageFeatureFlag = {}));
export var SageJoinType;
(function (SageJoinType) {
    SageJoinType["Cross"] = "CROSS";
    SageJoinType["FullOuter"] = "FULL_OUTER";
    SageJoinType["Inner"] = "INNER";
    SageJoinType["LeftOuter"] = "LEFT_OUTER";
    SageJoinType["RightOuter"] = "RIGHT_OUTER";
})(SageJoinType || (SageJoinType = {}));
export var SageQueryIssueSeverity;
(function (SageQueryIssueSeverity) {
    SageQueryIssueSeverity["Error"] = "ERROR";
    SageQueryIssueSeverity["Warning"] = "WARNING";
})(SageQueryIssueSeverity || (SageQueryIssueSeverity = {}));
export var SageQueryIssueType;
(function (SageQueryIssueType) {
    SageQueryIssueType["AutoDisambiguation"] = "AUTO_DISAMBIGUATION";
    SageQueryIssueType["JoinPathResolutionRequired"] = "JOIN_PATH_RESOLUTION_REQUIRED";
    SageQueryIssueType["OtherBackendIssue"] = "OTHER_BACKEND_ISSUE";
})(SageQueryIssueType || (SageQueryIssueType = {}));
export var SageRequestFlag;
(function (SageRequestFlag) {
    SageRequestFlag["DoBestEffortTokenization"] = "DoBestEffortTokenization";
    SageRequestFlag["ExactMatchCompletionsOnly"] = "ExactMatchCompletionsOnly";
})(SageRequestFlag || (SageRequestFlag = {}));
export var ScheduleOps;
(function (ScheduleOps) {
    ScheduleOps["Create"] = "CREATE";
    ScheduleOps["Delete"] = "DELETE";
    ScheduleOps["Update"] = "UPDATE";
})(ScheduleOps || (ScheduleOps = {}));
export var ScheduleRunState;
(function (ScheduleRunState) {
    ScheduleRunState["Deadline"] = "DEADLINE";
    ScheduleRunState["Default"] = "DEFAULT";
    ScheduleRunState["DoesNotExist"] = "DOES_NOT_EXIST";
    ScheduleRunState["Failed"] = "FAILED";
    ScheduleRunState["Running"] = "RUNNING";
    ScheduleRunState["Success"] = "SUCCESS";
})(ScheduleRunState || (ScheduleRunState = {}));
export var ScheduleTargetType;
(function (ScheduleTargetType) {
    ScheduleTargetType["Http"] = "HTTP";
    ScheduleTargetType["Queue"] = "QUEUE";
})(ScheduleTargetType || (ScheduleTargetType = {}));
export var ScheduleType;
(function (ScheduleType) {
    ScheduleType["OnetimeSchedule"] = "ONETIME_SCHEDULE";
    ScheduleType["RecurringSchedule"] = "RECURRING_SCHEDULE";
})(ScheduleType || (ScheduleType = {}));
export var SchemaVersion;
(function (SchemaVersion) {
    SchemaVersion["V1"] = "v1";
})(SchemaVersion || (SchemaVersion = {}));
export var SearchAssistVersion;
(function (SearchAssistVersion) {
    SearchAssistVersion["V1"] = "V1";
    SearchAssistVersion["V2"] = "V2";
})(SearchAssistVersion || (SearchAssistVersion = {}));
export var SearchCacheSchedulerRunType;
(function (SearchCacheSchedulerRunType) {
    SearchCacheSchedulerRunType["AdHoc"] = "AD_HOC";
    SearchCacheSchedulerRunType["Scheduled"] = "SCHEDULED";
})(SearchCacheSchedulerRunType || (SearchCacheSchedulerRunType = {}));
export var SearchCacheStatus;
(function (SearchCacheStatus) {
    SearchCacheStatus["Empty"] = "EMPTY";
    SearchCacheStatus["Error"] = "ERROR";
    SearchCacheStatus["Inprogress"] = "INPROGRESS";
    SearchCacheStatus["Queued"] = "QUEUED";
    SearchCacheStatus["Ready"] = "READY";
    SearchCacheStatus["Stale"] = "STALE";
    SearchCacheStatus["Unknown"] = "UNKNOWN";
})(SearchCacheStatus || (SearchCacheStatus = {}));
export var SearchMetadataType;
(function (SearchMetadataType) {
    SearchMetadataType["Answer"] = "ANSWER";
    SearchMetadataType["Connection"] = "CONNECTION";
    SearchMetadataType["InsightSpec"] = "INSIGHT_SPEC";
    SearchMetadataType["Liveboard"] = "LIVEBOARD";
    SearchMetadataType["LogicalColumn"] = "LOGICAL_COLUMN";
    SearchMetadataType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    SearchMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    SearchMetadataType["Tag"] = "TAG";
    SearchMetadataType["User"] = "USER";
    SearchMetadataType["UserGroup"] = "USER_GROUP";
})(SearchMetadataType || (SearchMetadataType = {}));
export var SecurityType;
(function (SecurityType) {
    SecurityType["Answer"] = "ANSWER";
    SecurityType["Column"] = "COLUMN";
    SecurityType["Dataobject"] = "DATAOBJECT";
    SecurityType["Liveboard"] = "LIVEBOARD";
})(SecurityType || (SecurityType = {}));
export var ShareMode;
(function (ShareMode) {
    ShareMode["Modify"] = "MODIFY";
    ShareMode["NoAccess"] = "NO_ACCESS";
    ShareMode["ReadOnly"] = "READ_ONLY";
})(ShareMode || (ShareMode = {}));
export var ShareType;
(function (ShareType) {
    ShareType["ReadOnly"] = "READ_ONLY";
})(ShareType || (ShareType = {}));
export var ShowPivotSummaryPrior;
(function (ShowPivotSummaryPrior) {
    ShowPivotSummaryPrior["Both"] = "BOTH";
    ShowPivotSummaryPrior["Columns"] = "COLUMNS";
    ShowPivotSummaryPrior["None"] = "NONE";
    ShowPivotSummaryPrior["Rows"] = "ROWS";
})(ShowPivotSummaryPrior || (ShowPivotSummaryPrior = {}));
export var SinglePointKpiStatus;
(function (SinglePointKpiStatus) {
    SinglePointKpiStatus["Complete"] = "COMPLETE";
    SinglePointKpiStatus["Done"] = "DONE";
    SinglePointKpiStatus["InProgress"] = "IN_PROGRESS";
})(SinglePointKpiStatus || (SinglePointKpiStatus = {}));
export var SnapshotStatus;
(function (SnapshotStatus) {
    SnapshotStatus["SnapshotCreateFailed"] = "SNAPSHOT_CREATE_FAILED";
    SnapshotStatus["SnapshotCreateFinished"] = "SNAPSHOT_CREATE_FINISHED";
    SnapshotStatus["SnapshotCreateStarted"] = "SNAPSHOT_CREATE_STARTED";
    SnapshotStatus["SnapshotDeleteFailed"] = "SNAPSHOT_DELETE_FAILED";
    SnapshotStatus["SnapshotDeleteScheduled"] = "SNAPSHOT_DELETE_SCHEDULED";
    SnapshotStatus["SnapshotNotFound"] = "SNAPSHOT_NOT_FOUND";
})(SnapshotStatus || (SnapshotStatus = {}));
export var SnapshotType;
(function (SnapshotType) {
    SnapshotType["Html"] = "HTML";
    SnapshotType["Jpeg"] = "JPEG";
    SnapshotType["Svg"] = "SVG";
})(SnapshotType || (SnapshotType = {}));
export var SortBy;
(function (SortBy) {
    SortBy["Author"] = "AUTHOR";
    SortBy["Created"] = "CREATED";
    SortBy["Default"] = "DEFAULT";
    SortBy["DisplayName"] = "DISPLAY_NAME";
    SortBy["LastAccessed"] = "LAST_ACCESSED";
    SortBy["Modified"] = "MODIFIED";
    SortBy["Name"] = "NAME";
    SortBy["None"] = "NONE";
    SortBy["RowCount"] = "ROW_COUNT";
    SortBy["Synced"] = "SYNCED";
    SortBy["UserState"] = "USER_STATE";
    SortBy["Views"] = "VIEWS";
})(SortBy || (SortBy = {}));
export var SortOptionFieldName;
(function (SortOptionFieldName) {
    SortOptionFieldName["Author"] = "AUTHOR";
    SortOptionFieldName["Created"] = "CREATED";
    SortOptionFieldName["DisplayName"] = "DISPLAY_NAME";
    SortOptionFieldName["Modified"] = "MODIFIED";
    SortOptionFieldName["Name"] = "NAME";
})(SortOptionFieldName || (SortOptionFieldName = {}));
export var SortOptionOrder;
(function (SortOptionOrder) {
    SortOptionOrder["Asc"] = "ASC";
    SortOptionOrder["Desc"] = "DESC";
})(SortOptionOrder || (SortOptionOrder = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Default"] = "DEFAULT";
    SortOrder["Desc"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SourceTypes;
(function (SourceTypes) {
    SourceTypes["Answer"] = "ANSWER";
    SourceTypes["Viz"] = "VIZ";
})(SourceTypes || (SourceTypes = {}));
export var SpotAppReviewStatus;
(function (SpotAppReviewStatus) {
    SpotAppReviewStatus["Published"] = "PUBLISHED";
    SpotAppReviewStatus["Rejected"] = "REJECTED";
    SpotAppReviewStatus["UnderReview"] = "UNDER_REVIEW";
})(SpotAppReviewStatus || (SpotAppReviewStatus = {}));
export var StateType;
(function (StateType) {
    StateType["Active"] = "ACTIVE";
    StateType["Expired"] = "EXPIRED";
    StateType["Inactive"] = "INACTIVE";
    StateType["Locked"] = "LOCKED";
    StateType["Pending"] = "PENDING";
})(StateType || (StateType = {}));
export var StyleConfigType;
(function (StyleConfigType) {
    StyleConfigType["All"] = "ALL";
    StyleConfigType["Group"] = "GROUP";
    StyleConfigType["Liveboard"] = "LIVEBOARD";
    StyleConfigType["Tile"] = "TILE";
})(StyleConfigType || (StyleConfigType = {}));
export var SubTypes;
(function (SubTypes) {
    SubTypes["AggrWorksheet"] = "AGGR_WORKSHEET";
    SubTypes["Dataset"] = "DATASET";
    SubTypes["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    SubTypes["SqlView"] = "SQL_VIEW";
    SubTypes["UserDefined"] = "USER_DEFINED";
    SubTypes["Worksheet"] = "WORKSHEET";
})(SubTypes || (SubTypes = {}));
export var SyncSourceTypes;
(function (SyncSourceTypes) {
    SyncSourceTypes["Answers"] = "Answers";
    SyncSourceTypes["Pinboard"] = "Pinboard";
    SyncSourceTypes["SqlView"] = "SqlView";
    SyncSourceTypes["View"] = "View";
})(SyncSourceTypes || (SyncSourceTypes = {}));
export var TableContentDensity;
(function (TableContentDensity) {
    TableContentDensity["Compact"] = "COMPACT";
    TableContentDensity["Regular"] = "REGULAR";
})(TableContentDensity || (TableContentDensity = {}));
export var TableTheme;
(function (TableTheme) {
    TableTheme["Outline"] = "OUTLINE";
    TableTheme["Row"] = "ROW";
    TableTheme["Zebra"] = "ZEBRA";
})(TableTheme || (TableTheme = {}));
export var TableType;
(function (TableType) {
    TableType["AggWorksheet"] = "AGG_WORKSHEET";
    TableType["BaseTable"] = "BASE_TABLE";
    TableType["QueryTable"] = "QUERY_TABLE";
    TableType["Unknown"] = "UNKNOWN";
    TableType["Worksheet"] = "WORKSHEET";
})(TableType || (TableType = {}));
export var TableVizPropVersion;
(function (TableVizPropVersion) {
    TableVizPropVersion["PreV1"] = "PRE_V1";
    TableVizPropVersion["V1"] = "V1";
})(TableVizPropVersion || (TableVizPropVersion = {}));
export var TemplateEntryType;
(function (TemplateEntryType) {
    TemplateEntryType["Text"] = "TEXT";
    TemplateEntryType["Token"] = "TOKEN";
})(TemplateEntryType || (TemplateEntryType = {}));
export var ThresholdComparator;
(function (ThresholdComparator) {
    ThresholdComparator["ComparatorEq"] = "COMPARATOR_EQ";
    ThresholdComparator["ComparatorGeq"] = "COMPARATOR_GEQ";
    ThresholdComparator["ComparatorGt"] = "COMPARATOR_GT";
    ThresholdComparator["ComparatorLeq"] = "COMPARATOR_LEQ";
    ThresholdComparator["ComparatorLt"] = "COMPARATOR_LT";
    ThresholdComparator["ComparatorNeq"] = "COMPARATOR_NEQ";
    ThresholdComparator["ComparatorUnspecified"] = "COMPARATOR_UNSPECIFIED";
})(ThresholdComparator || (ThresholdComparator = {}));
export var ThresholdPercentageChangeComparator;
(function (ThresholdPercentageChangeComparator) {
    ThresholdPercentageChangeComparator["PercentageChangeComparatorChangesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_CHANGES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorDecreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_DECREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorIncreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_INCREASES_BY";
    ThresholdPercentageChangeComparator["PercentageChangeComparatorUnspecified"] = "PERCENTAGE_CHANGE_COMPARATOR_UNSPECIFIED";
})(ThresholdPercentageChangeComparator || (ThresholdPercentageChangeComparator = {}));
export var TileBrandColor;
(function (TileBrandColor) {
    TileBrandColor["TbcA"] = "TBC_A";
    TileBrandColor["TbcB"] = "TBC_B";
    TileBrandColor["TbcC"] = "TBC_C";
    TileBrandColor["TbcD"] = "TBC_D";
    TileBrandColor["TbcE"] = "TBC_E";
    TileBrandColor["TbcF"] = "TBC_F";
    TileBrandColor["TbcG"] = "TBC_G";
    TileBrandColor["TbcH"] = "TBC_H";
    TileBrandColor["TbcI"] = "TBC_I";
    TileBrandColor["TbcJ"] = "TBC_J";
    TileBrandColor["TbcK"] = "TBC_K";
    TileBrandColor["TbcL"] = "TBC_L";
    TileBrandColor["TbcM"] = "TBC_M";
    TileBrandColor["TbcN"] = "TBC_N";
    TileBrandColor["TbcO"] = "TBC_O";
    TileBrandColor["TbcP"] = "TBC_P";
    TileBrandColor["TbcQ"] = "TBC_Q";
    TileBrandColor["TbcUnknown"] = "TBC_UNKNOWN";
})(TileBrandColor || (TileBrandColor = {}));
export var TileColorShade;
(function (TileColorShade) {
    TileColorShade["TcsA"] = "TCS_A";
    TileColorShade["TcsB"] = "TCS_B";
    TileColorShade["TcsUnknown"] = "TCS_UNKNOWN";
})(TileColorShade || (TileColorShade = {}));
export var TimeFrequency;
(function (TimeFrequency) {
    TimeFrequency["Daily"] = "DAILY";
    TimeFrequency["Hourly"] = "HOURLY";
    TimeFrequency["Monthly"] = "MONTHLY";
    TimeFrequency["None"] = "NONE";
    TimeFrequency["Quarterly"] = "QUARTERLY";
    TimeFrequency["Weekly"] = "WEEKLY";
    TimeFrequency["Yearly"] = "YEARLY";
})(TimeFrequency || (TimeFrequency = {}));
export var TrueFalse;
(function (TrueFalse) {
    TrueFalse["False"] = "False";
    TrueFalse["True"] = "True";
})(TrueFalse || (TrueFalse = {}));
export var TsObject;
(function (TsObject) {
    TsObject["Answer"] = "ANSWER";
    TsObject["Connection"] = "CONNECTION";
    TsObject["Dataobject"] = "DATAOBJECT";
    TsObject["Liveboard"] = "LIVEBOARD";
})(TsObject || (TsObject = {}));
export var TsObjectDetailGet;
(function (TsObjectDetailGet) {
    TsObjectDetailGet["Answer"] = "ANSWER";
    TsObjectDetailGet["Column"] = "COLUMN";
    TsObjectDetailGet["Connection"] = "CONNECTION";
    TsObjectDetailGet["Dataobject"] = "DATAOBJECT";
    TsObjectDetailGet["Join"] = "JOIN";
    TsObjectDetailGet["Liveboard"] = "LIVEBOARD";
    TsObjectDetailGet["Tag"] = "TAG";
    TsObjectDetailGet["User"] = "USER";
    TsObjectDetailGet["UserGroup"] = "USER_GROUP";
})(TsObjectDetailGet || (TsObjectDetailGet = {}));
export var TsObjectGet;
(function (TsObjectGet) {
    TsObjectGet["Answer"] = "ANSWER";
    TsObjectGet["ColumnAll"] = "COLUMN_ALL";
    TsObjectGet["ColumnCalendarTable"] = "COLUMN_CALENDAR_TABLE";
    TsObjectGet["ColumnTable"] = "COLUMN_TABLE";
    TsObjectGet["ColumnUserDefined"] = "COLUMN_USER_DEFINED";
    TsObjectGet["ColumnView"] = "COLUMN_VIEW";
    TsObjectGet["ColumnWorksheet"] = "COLUMN_WORKSHEET";
    TsObjectGet["Connection"] = "CONNECTION";
    TsObjectGet["DataobjectAll"] = "DATAOBJECT_ALL";
    TsObjectGet["DataobjectCalendarTable"] = "DATAOBJECT_CALENDAR_TABLE";
    TsObjectGet["DataobjectTable"] = "DATAOBJECT_TABLE";
    TsObjectGet["DataobjectUserDefined"] = "DATAOBJECT_USER_DEFINED";
    TsObjectGet["DataobjectView"] = "DATAOBJECT_VIEW";
    TsObjectGet["DataobjectWorksheet"] = "DATAOBJECT_WORKSHEET";
    TsObjectGet["Join"] = "JOIN";
    TsObjectGet["Liveboard"] = "LIVEBOARD";
    TsObjectGet["Tag"] = "TAG";
    TsObjectGet["User"] = "USER";
    TsObjectGet["UserGroup"] = "USER_GROUP";
})(TsObjectGet || (TsObjectGet = {}));
export var TupleType;
(function (TupleType) {
    TupleType["ChartAggregatedVal"] = "CHART_AGGREGATED_VAL";
    TupleType["Current"] = "CURRENT";
    TupleType["Custom"] = "CUSTOM";
    TupleType["LastAvailable"] = "LAST_AVAILABLE";
    TupleType["PreviousChartAggregatedVal"] = "PREVIOUS_CHART_AGGREGATED_VAL";
    TupleType["PrevAvailable"] = "PREV_AVAILABLE";
    TupleType["PrevDay"] = "PREV_DAY";
    TupleType["PrevHour"] = "PREV_HOUR";
    TupleType["PrevMonth"] = "PREV_MONTH";
    TupleType["PrevQuarter"] = "PREV_QUARTER";
    TupleType["PrevWeek"] = "PREV_WEEK";
    TupleType["PrevYear"] = "PREV_YEAR";
    TupleType["SinglePointKpiCurrent"] = "SINGLE_POINT_KPI_CURRENT";
    TupleType["SinglePointKpiPrevious"] = "SINGLE_POINT_KPI_PREVIOUS";
})(TupleType || (TupleType = {}));
export var Unit;
(function (Unit) {
    Unit["Auto"] = "AUTO";
    Unit["Billion"] = "BILLION";
    Unit["Million"] = "MILLION";
    Unit["None"] = "NONE";
    Unit["Thousands"] = "THOUSANDS";
    Unit["Trillion"] = "TRILLION";
})(Unit || (Unit = {}));
export var Users__AccountStatus;
(function (Users__AccountStatus) {
    Users__AccountStatus["Active"] = "ACTIVE";
    Users__AccountStatus["Expired"] = "EXPIRED";
    Users__AccountStatus["Inactive"] = "INACTIVE";
    Users__AccountStatus["Locked"] = "LOCKED";
    Users__AccountStatus["Pending"] = "PENDING";
})(Users__AccountStatus || (Users__AccountStatus = {}));
export var Users__AccountType;
(function (Users__AccountType) {
    Users__AccountType["LdapUser"] = "LDAP_USER";
    Users__AccountType["LocalUser"] = "LOCAL_USER";
    Users__AccountType["OidcUser"] = "OIDC_USER";
    Users__AccountType["RemoteUser"] = "REMOTE_USER";
    Users__AccountType["SamlUser"] = "SAML_USER";
})(Users__AccountType || (Users__AccountType = {}));
export var Users__FavoriteMetadata;
(function (Users__FavoriteMetadata) {
    Users__FavoriteMetadata["Answer"] = "ANSWER";
    Users__FavoriteMetadata["Connection"] = "CONNECTION";
    Users__FavoriteMetadata["Liveboard"] = "LIVEBOARD";
    Users__FavoriteMetadata["LogicalTable"] = "LOGICAL_TABLE";
})(Users__FavoriteMetadata || (Users__FavoriteMetadata = {}));
export var VcsCommitMetadataType;
(function (VcsCommitMetadataType) {
    VcsCommitMetadataType["Answer"] = "ANSWER";
    VcsCommitMetadataType["Liveboard"] = "LIVEBOARD";
    VcsCommitMetadataType["LogicalTable"] = "LOGICAL_TABLE";
})(VcsCommitMetadataType || (VcsCommitMetadataType = {}));
export var ValidEdocMetadataType;
(function (ValidEdocMetadataType) {
    ValidEdocMetadataType["ActionObject"] = "ACTION_OBJECT";
    ValidEdocMetadataType["Answer"] = "ANSWER";
    ValidEdocMetadataType["Cohort"] = "COHORT";
    ValidEdocMetadataType["Connection"] = "CONNECTION";
    ValidEdocMetadataType["Feedback"] = "FEEDBACK";
    ValidEdocMetadataType["Group"] = "GROUP";
    ValidEdocMetadataType["LogicalTable"] = "LOGICAL_TABLE";
    ValidEdocMetadataType["Model"] = "MODEL";
    ValidEdocMetadataType["MonitorAlerts"] = "MONITOR_ALERTS";
    ValidEdocMetadataType["Pinboard"] = "PINBOARD";
    ValidEdocMetadataType["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    ValidEdocMetadataType["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    ValidEdocMetadataType["Role"] = "ROLE";
    ValidEdocMetadataType["SqlView"] = "SQL_VIEW";
    ValidEdocMetadataType["Table"] = "TABLE";
    ValidEdocMetadataType["User"] = "USER";
    ValidEdocMetadataType["UserGroup"] = "USER_GROUP";
    ValidEdocMetadataType["View"] = "VIEW";
    ValidEdocMetadataType["Worksheet"] = "WORKSHEET";
})(ValidEdocMetadataType || (ValidEdocMetadataType = {}));
export var Vendor;
(function (Vendor) {
    Vendor["Datarobot"] = "DATAROBOT";
    Vendor["Thoughtspot"] = "THOUGHTSPOT";
})(Vendor || (Vendor = {}));
export var ViewType;
(function (ViewType) {
    ViewType["Default"] = "DEFAULT";
    ViewType["MonitorAlert"] = "MONITOR_ALERT";
})(ViewType || (ViewType = {}));
export var Visibility;
(function (Visibility) {
    Visibility["NonSharable"] = "NON_SHARABLE";
    Visibility["Sharable"] = "SHARABLE";
})(Visibility || (Visibility = {}));
export var VisualizationQueryStatus;
(function (VisualizationQueryStatus) {
    VisualizationQueryStatus["Completed"] = "COMPLETED";
    VisualizationQueryStatus["ExecutingQuery"] = "EXECUTING_QUERY";
    VisualizationQueryStatus["InPriorityQueue"] = "IN_PRIORITY_QUEUE";
    VisualizationQueryStatus["ProcessingResults"] = "PROCESSING_RESULTS";
    VisualizationQueryStatus["Unknown"] = "UNKNOWN";
    VisualizationQueryStatus["WaitingForConnection"] = "WAITING_FOR_CONNECTION";
})(VisualizationQueryStatus || (VisualizationQueryStatus = {}));
export var WebhookAuthType;
(function (WebhookAuthType) {
    WebhookAuthType["ApiKeyType"] = "API_KEY_TYPE";
    WebhookAuthType["NoAuthType"] = "NO_AUTH_TYPE";
    WebhookAuthType["OAuth2Type"] = "O_AUTH2_TYPE";
})(WebhookAuthType || (WebhookAuthType = {}));
export var WeekDay;
(function (WeekDay) {
    WeekDay["Friday"] = "FRIDAY";
    WeekDay["Monday"] = "MONDAY";
    WeekDay["NumWeekDays"] = "NUM_WEEK_DAYS";
    WeekDay["Saturday"] = "SATURDAY";
    WeekDay["Sunday"] = "SUNDAY";
    WeekDay["Thursday"] = "THURSDAY";
    WeekDay["Tuesday"] = "TUESDAY";
    WeekDay["Wednesday"] = "WEDNESDAY";
})(WeekDay || (WeekDay = {}));
export var WorksheetRequestType;
(function (WorksheetRequestType) {
    WorksheetRequestType["AcceptJoinRecommendationsTransform"] = "ACCEPT_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["AddColumnsFromDiffTablesTransformRequest"] = "ADD_COLUMNS_FROM_DIFF_TABLES_TRANSFORM_REQUEST";
    WorksheetRequestType["AddColumnsTransformRequest"] = "ADD_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["AddFilterTransformRequest"] = "ADD_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["AddSchemaTableTransformRequest"] = "ADD_SCHEMA_TABLE_TRANSFORM_REQUEST";
    WorksheetRequestType["ClearJoinRecommendationsTransform"] = "CLEAR_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["ColumnBulkEditTransform"] = "COLUMN_BULK_EDIT_TRANSFORM";
    WorksheetRequestType["ColumnCsvExportTransform"] = "COLUMN_CSV_EXPORT_TRANSFORM";
    WorksheetRequestType["ColumnCsvImportTransform"] = "COLUMN_CSV_IMPORT_TRANSFORM";
    WorksheetRequestType["ConvertGlobalToLocalJoinTransform"] = "CONVERT_GLOBAL_TO_LOCAL_JOIN_TRANSFORM";
    WorksheetRequestType["CreateSchemaJoinRequest"] = "CREATE_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["CreateWorksheetRequest"] = "CREATE_WORKSHEET_REQUEST";
    WorksheetRequestType["DeleteColumnsTransformRequest"] = "DELETE_COLUMNS_TRANSFORM_REQUEST";
    WorksheetRequestType["DeleteParameterTransformRequest"] = "DELETE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditFilterTransformRequest"] = "EDIT_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["EditSchemaGraphLayoutTransform"] = "EDIT_SCHEMA_GRAPH_LAYOUT_TRANSFORM";
    WorksheetRequestType["EditSchemaJoinRequest"] = "EDIT_SCHEMA_JOIN_REQUEST";
    WorksheetRequestType["GetFormulaMetadataRequest"] = "GET_FORMULA_METADATA_REQUEST";
    WorksheetRequestType["GetJoinRecommendationsTransform"] = "GET_JOIN_RECOMMENDATIONS_TRANSFORM";
    WorksheetRequestType["GetSchemaJoinDetailsRequest"] = "GET_SCHEMA_JOIN_DETAILS_REQUEST";
    WorksheetRequestType["InitAcSessionTransformRequest"] = "INIT_AC_SESSION_TRANSFORM_REQUEST";
    WorksheetRequestType["LoadWorksheetRequest"] = "LOAD_WORKSHEET_REQUEST";
    WorksheetRequestType["ParameterDependenciesRequest"] = "PARAMETER_DEPENDENCIES_REQUEST";
    WorksheetRequestType["RemoveFilterTransformRequest"] = "REMOVE_FILTER_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveFormulaTransformRequest"] = "REMOVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["RemoveSchemaJoinTransform"] = "REMOVE_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["RemoveSchemaTableTransform"] = "REMOVE_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["RenameSchemaTableTransform"] = "RENAME_SCHEMA_TABLE_TRANSFORM";
    WorksheetRequestType["SaveAsRequest"] = "SAVE_AS_REQUEST";
    WorksheetRequestType["SaveFormulaTransformRequest"] = "SAVE_FORMULA_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveParameterTransformRequest"] = "SAVE_PARAMETER_TRANSFORM_REQUEST";
    WorksheetRequestType["SaveWorksheetRequest"] = "SAVE_WORKSHEET_REQUEST";
    WorksheetRequestType["SelectSchemaJoinTransform"] = "SELECT_SCHEMA_JOIN_TRANSFORM";
    WorksheetRequestType["SetScopeTransformRequest"] = "SET_SCOPE_TRANSFORM_REQUEST";
    WorksheetRequestType["UpdateColumnPropertiesTransform"] = "UPDATE_COLUMN_PROPERTIES_TRANSFORM";
    WorksheetRequestType["UpdateWorksheetNameDescriptionRequest"] = "UPDATE_WORKSHEET_NAME_DESCRIPTION_REQUEST";
    WorksheetRequestType["UpdateWorksheetPropertiesRequest"] = "UPDATE_WORKSHEET_PROPERTIES_REQUEST";
})(WorksheetRequestType || (WorksheetRequestType = {}));
export var WorksheetVersion;
(function (WorksheetVersion) {
    WorksheetVersion["V1"] = "V1";
    WorksheetVersion["V2"] = "V2";
})(WorksheetVersion || (WorksheetVersion = {}));
export var A3_Analyzer_AnalysisBaseline;
(function (A3_Analyzer_AnalysisBaseline) {
    A3_Analyzer_AnalysisBaseline["Daily"] = "DAILY";
    A3_Analyzer_AnalysisBaseline["Quarerly"] = "QUARERLY";
    A3_Analyzer_AnalysisBaseline["Weekly"] = "WEEKLY";
    A3_Analyzer_AnalysisBaseline["Yearly"] = "YEARLY";
})(A3_Analyzer_AnalysisBaseline || (A3_Analyzer_AnalysisBaseline = {}));
export var A3_Analyzer_AnalysisType;
(function (A3_Analyzer_AnalysisType) {
    A3_Analyzer_AnalysisType["Comparative"] = "COMPARATIVE";
    A3_Analyzer_AnalysisType["SnapshotDiff"] = "SNAPSHOT_DIFF";
    A3_Analyzer_AnalysisType["Trend"] = "TREND";
})(A3_Analyzer_AnalysisType || (A3_Analyzer_AnalysisType = {}));
export var A3_Analyzer_AttributeOutput_AnalysisMethod;
(function (A3_Analyzer_AttributeOutput_AnalysisMethod) {
    A3_Analyzer_AttributeOutput_AnalysisMethod["Comparative"] = "COMPARATIVE";
    A3_Analyzer_AttributeOutput_AnalysisMethod["SnapshotDiff"] = "SNAPSHOT_DIFF";
    A3_Analyzer_AttributeOutput_AnalysisMethod["Trend"] = "TREND";
})(A3_Analyzer_AttributeOutput_AnalysisMethod || (A3_Analyzer_AttributeOutput_AnalysisMethod = {}));
export var A3_Analyzer_ComparativeAnalysisMode;
(function (A3_Analyzer_ComparativeAnalysisMode) {
    A3_Analyzer_ComparativeAnalysisMode["AutoAnalysis"] = "AUTO_ANALYSIS";
    A3_Analyzer_ComparativeAnalysisMode["CustomAnalysis"] = "CUSTOM_ANALYSIS";
    A3_Analyzer_ComparativeAnalysisMode["NoAnalysis"] = "NO_ANALYSIS";
})(A3_Analyzer_ComparativeAnalysisMode || (A3_Analyzer_ComparativeAnalysisMode = {}));
export var A3_Metric_Monitor_AlertType;
(function (A3_Metric_Monitor_AlertType) {
    A3_Metric_Monitor_AlertType["Anomaly"] = "Anomaly";
    A3_Metric_Monitor_AlertType["Scheduled"] = "Scheduled";
    A3_Metric_Monitor_AlertType["ScheduledByAttribute"] = "ScheduledByAttribute";
    A3_Metric_Monitor_AlertType["Threshold"] = "Threshold";
    A3_Metric_Monitor_AlertType["ThresholdByAttribute"] = "ThresholdByAttribute";
})(A3_Metric_Monitor_AlertType || (A3_Metric_Monitor_AlertType = {}));
export var A3_Metric_Monitor_ArithmeticOp;
(function (A3_Metric_Monitor_ArithmeticOp) {
    A3_Metric_Monitor_ArithmeticOp["ArithmeticOpAdd"] = "ARITHMETIC_OP_ADD";
    A3_Metric_Monitor_ArithmeticOp["ArithmeticOpDivide"] = "ARITHMETIC_OP_DIVIDE";
    A3_Metric_Monitor_ArithmeticOp["ArithmeticOpMultiply"] = "ARITHMETIC_OP_MULTIPLY";
    A3_Metric_Monitor_ArithmeticOp["ArithmeticOpSubtract"] = "ARITHMETIC_OP_SUBTRACT";
    A3_Metric_Monitor_ArithmeticOp["ArithmeticOpUnspecified"] = "ARITHMETIC_OP_UNSPECIFIED";
})(A3_Metric_Monitor_ArithmeticOp || (A3_Metric_Monitor_ArithmeticOp = {}));
export var A3_Metric_Monitor_BooleanOp;
(function (A3_Metric_Monitor_BooleanOp) {
    A3_Metric_Monitor_BooleanOp["BooleanOpAnd"] = "BOOLEAN_OP_AND";
    A3_Metric_Monitor_BooleanOp["BooleanOpOr"] = "BOOLEAN_OP_OR";
    A3_Metric_Monitor_BooleanOp["BooleanOpUnspecified"] = "BOOLEAN_OP_UNSPECIFIED";
})(A3_Metric_Monitor_BooleanOp || (A3_Metric_Monitor_BooleanOp = {}));
export var A3_Metric_Monitor_Comparator;
(function (A3_Metric_Monitor_Comparator) {
    A3_Metric_Monitor_Comparator["ComparatorEq"] = "COMPARATOR_EQ";
    A3_Metric_Monitor_Comparator["ComparatorGeq"] = "COMPARATOR_GEQ";
    A3_Metric_Monitor_Comparator["ComparatorGt"] = "COMPARATOR_GT";
    A3_Metric_Monitor_Comparator["ComparatorLeq"] = "COMPARATOR_LEQ";
    A3_Metric_Monitor_Comparator["ComparatorLt"] = "COMPARATOR_LT";
    A3_Metric_Monitor_Comparator["ComparatorNeq"] = "COMPARATOR_NEQ";
    A3_Metric_Monitor_Comparator["ComparatorUnspecified"] = "COMPARATOR_UNSPECIFIED";
})(A3_Metric_Monitor_Comparator || (A3_Metric_Monitor_Comparator = {}));
export var A3_Metric_Monitor_EventSchemaType;
(function (A3_Metric_Monitor_EventSchemaType) {
    A3_Metric_Monitor_EventSchemaType["Monitor"] = "MONITOR";
})(A3_Metric_Monitor_EventSchemaType || (A3_Metric_Monitor_EventSchemaType = {}));
export var A3_Metric_Monitor_FrequencySpec_FrequencyGranularity;
(function (A3_Metric_Monitor_FrequencySpec_FrequencyGranularity) {
    A3_Metric_Monitor_FrequencySpec_FrequencyGranularity["Daily"] = "DAILY";
    A3_Metric_Monitor_FrequencySpec_FrequencyGranularity["EveryMinute"] = "EVERY_MINUTE";
    A3_Metric_Monitor_FrequencySpec_FrequencyGranularity["Hourly"] = "HOURLY";
    A3_Metric_Monitor_FrequencySpec_FrequencyGranularity["Monthly"] = "MONTHLY";
    A3_Metric_Monitor_FrequencySpec_FrequencyGranularity["Weekly"] = "WEEKLY";
})(A3_Metric_Monitor_FrequencySpec_FrequencyGranularity || (A3_Metric_Monitor_FrequencySpec_FrequencyGranularity = {}));
export var A3_Metric_Monitor_NotificationChannel;
(function (A3_Metric_Monitor_NotificationChannel) {
    A3_Metric_Monitor_NotificationChannel["Email"] = "EMAIL";
    A3_Metric_Monitor_NotificationChannel["Webhook"] = "WEBHOOK";
})(A3_Metric_Monitor_NotificationChannel || (A3_Metric_Monitor_NotificationChannel = {}));
export var A3_Metric_Monitor_NotificationType;
(function (A3_Metric_Monitor_NotificationType) {
    A3_Metric_Monitor_NotificationType["AnomalyMetricUpdate"] = "ANOMALY_METRIC_UPDATE";
    A3_Metric_Monitor_NotificationType["AutomaticSelfSubscription"] = "AUTOMATIC_SELF_SUBSCRIPTION";
    A3_Metric_Monitor_NotificationType["Deletion"] = "DELETION";
    A3_Metric_Monitor_NotificationType["Failure"] = "FAILURE";
    A3_Metric_Monitor_NotificationType["ScheduledByAttribute"] = "SCHEDULED_BY_ATTRIBUTE";
    A3_Metric_Monitor_NotificationType["ScheduleMetricUpdate"] = "SCHEDULE_METRIC_UPDATE";
    A3_Metric_Monitor_NotificationType["SelfSubscription"] = "SELF_SUBSCRIPTION";
    A3_Metric_Monitor_NotificationType["Subscription"] = "SUBSCRIPTION";
    A3_Metric_Monitor_NotificationType["ThresholdByAttribute"] = "THRESHOLD_BY_ATTRIBUTE";
    A3_Metric_Monitor_NotificationType["ThresholdMetricUpdate"] = "THRESHOLD_METRIC_UPDATE";
    A3_Metric_Monitor_NotificationType["Updation"] = "UPDATION";
})(A3_Metric_Monitor_NotificationType || (A3_Metric_Monitor_NotificationType = {}));
export var A3_Metric_Monitor_PercentageChangeComparator;
(function (A3_Metric_Monitor_PercentageChangeComparator) {
    A3_Metric_Monitor_PercentageChangeComparator["PercentageChangeComparatorChangesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_CHANGES_BY";
    A3_Metric_Monitor_PercentageChangeComparator["PercentageChangeComparatorDecreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_DECREASES_BY";
    A3_Metric_Monitor_PercentageChangeComparator["PercentageChangeComparatorIncreasesBy"] = "PERCENTAGE_CHANGE_COMPARATOR_INCREASES_BY";
    A3_Metric_Monitor_PercentageChangeComparator["PercentageChangeComparatorUnspecified"] = "PERCENTAGE_CHANGE_COMPARATOR_UNSPECIFIED";
})(A3_Metric_Monitor_PercentageChangeComparator || (A3_Metric_Monitor_PercentageChangeComparator = {}));
export var A3_Metric_Monitor_SchemaVersion;
(function (A3_Metric_Monitor_SchemaVersion) {
    A3_Metric_Monitor_SchemaVersion["V1"] = "v1";
})(A3_Metric_Monitor_SchemaVersion || (A3_Metric_Monitor_SchemaVersion = {}));
export var A3_Metric_Monitor_UnaryFunction_Function;
(function (A3_Metric_Monitor_UnaryFunction_Function) {
    A3_Metric_Monitor_UnaryFunction_Function["FunctionAbs"] = "FUNCTION_ABS";
    A3_Metric_Monitor_UnaryFunction_Function["FunctionUnspecified"] = "FUNCTION_UNSPECIFIED";
})(A3_Metric_Monitor_UnaryFunction_Function || (A3_Metric_Monitor_UnaryFunction_Function = {}));
export var A3_Metric_Monitor_WebhookAuthType;
(function (A3_Metric_Monitor_WebhookAuthType) {
    A3_Metric_Monitor_WebhookAuthType["ApiKeyType"] = "API_KEY_TYPE";
    A3_Metric_Monitor_WebhookAuthType["NoAuthType"] = "NO_AUTH_TYPE";
    A3_Metric_Monitor_WebhookAuthType["OAuth2Type"] = "O_AUTH2_TYPE";
})(A3_Metric_Monitor_WebhookAuthType || (A3_Metric_Monitor_WebhookAuthType = {}));
export var A3_Status_Status_Code;
(function (A3_Status_Status_Code) {
    A3_Status_Status_Code["AlreadySubscribed"] = "ALREADY_SUBSCRIBED";
    A3_Status_Status_Code["Failed"] = "FAILED";
    A3_Status_Status_Code["InvalidParameters"] = "INVALID_PARAMETERS";
    A3_Status_Status_Code["InvalidPinboard"] = "INVALID_PINBOARD";
    A3_Status_Status_Code["InvalidSnapshot"] = "INVALID_SNAPSHOT";
    A3_Status_Status_Code["InvalidSnapshotQuery"] = "INVALID_SNAPSHOT_QUERY";
    A3_Status_Status_Code["InvalidSubscription"] = "INVALID_SUBSCRIPTION";
    A3_Status_Status_Code["InvalidVisualization"] = "INVALID_VISUALIZATION";
    A3_Status_Status_Code["NotEnoughSnapshots"] = "NOT_ENOUGH_SNAPSHOTS";
    A3_Status_Status_Code["NotImplemented"] = "NOT_IMPLEMENTED";
    A3_Status_Status_Code["NotReady"] = "NOT_READY";
    A3_Status_Status_Code["Ok"] = "OK";
    A3_Status_Status_Code["PersistentStoreError"] = "PERSISTENT_STORE_ERROR";
    A3_Status_Status_Code["SubscriptionLimitReachedPerUser"] = "SUBSCRIPTION_LIMIT_REACHED_PER_USER";
})(A3_Status_Status_Code || (A3_Status_Status_Code = {}));
export var A3_Subscription_NotificationType;
(function (A3_Subscription_NotificationType) {
    A3_Subscription_NotificationType["Email"] = "EMAIL";
    A3_Subscription_NotificationType["Log"] = "LOG";
})(A3_Subscription_NotificationType || (A3_Subscription_NotificationType = {}));
export var A3_Subscription_WatchState;
(function (A3_Subscription_WatchState) {
    A3_Subscription_WatchState["AnswerChange"] = "ANSWER_CHANGE";
    A3_Subscription_WatchState["AnswerDeleted"] = "ANSWER_DELETED";
    A3_Subscription_WatchState["CannotFollowMaxRows"] = "CANNOT_FOLLOW_MAX_ROWS";
    A3_Subscription_WatchState["Change"] = "CHANGE";
    A3_Subscription_WatchState["FirstDay"] = "FIRST_DAY";
    A3_Subscription_WatchState["NotYetExecuted"] = "NOT_YET_EXECUTED";
    A3_Subscription_WatchState["SnapshotMissed"] = "SNAPSHOT_MISSED";
    A3_Subscription_WatchState["StopExecution"] = "STOP_EXECUTION";
})(A3_Subscription_WatchState || (A3_Subscription_WatchState = {}));
export var Atlas_AiAnswerState;
(function (Atlas_AiAnswerState) {
    Atlas_AiAnswerState["Disabled"] = "DISABLED";
    Atlas_AiAnswerState["Enabled"] = "ENABLED";
    Atlas_AiAnswerState["NotSet"] = "NOT_SET";
})(Atlas_AiAnswerState || (Atlas_AiAnswerState = {}));
export var Atlas_ActionContext_E;
(function (Atlas_ActionContext_E) {
    Atlas_ActionContext_E["ContextMenu"] = "CONTEXT_MENU";
    Atlas_ActionContext_E["Menu"] = "MENU";
    Atlas_ActionContext_E["None"] = "NONE";
    Atlas_ActionContext_E["Primary"] = "PRIMARY";
})(Atlas_ActionContext_E || (Atlas_ActionContext_E = {}));
export var Atlas_ActionObjectApplicationType_E;
(function (Atlas_ActionObjectApplicationType_E) {
    Atlas_ActionObjectApplicationType_E["GoogleSheet"] = "GOOGLE_SHEET";
    Atlas_ActionObjectApplicationType_E["None"] = "NONE";
    Atlas_ActionObjectApplicationType_E["Salesforce"] = "SALESFORCE";
    Atlas_ActionObjectApplicationType_E["Slack"] = "SLACK";
})(Atlas_ActionObjectApplicationType_E || (Atlas_ActionObjectApplicationType_E = {}));
export var Atlas_AggregationType_E;
(function (Atlas_AggregationType_E) {
    Atlas_AggregationType_E["Aggregate"] = "AGGREGATE";
    Atlas_AggregationType_E["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    Atlas_AggregationType_E["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    Atlas_AggregationType_E["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    Atlas_AggregationType_E["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    Atlas_AggregationType_E["Average"] = "AVERAGE";
    Atlas_AggregationType_E["Count"] = "COUNT";
    Atlas_AggregationType_E["CountDistinct"] = "COUNT_DISTINCT";
    Atlas_AggregationType_E["CumulativeAverage"] = "CUMULATIVE_AVERAGE";
    Atlas_AggregationType_E["CumulativeCount"] = "CUMULATIVE_COUNT";
    Atlas_AggregationType_E["CumulativeMax"] = "CUMULATIVE_MAX";
    Atlas_AggregationType_E["CumulativeMin"] = "CUMULATIVE_MIN";
    Atlas_AggregationType_E["CumulativeSum"] = "CUMULATIVE_SUM";
    Atlas_AggregationType_E["Growth"] = "GROWTH";
    Atlas_AggregationType_E["Max"] = "MAX";
    Atlas_AggregationType_E["Median"] = "MEDIAN";
    Atlas_AggregationType_E["Min"] = "MIN";
    Atlas_AggregationType_E["MovingAverage"] = "MOVING_AVERAGE";
    Atlas_AggregationType_E["MovingCount"] = "MOVING_COUNT";
    Atlas_AggregationType_E["MovingMax"] = "MOVING_MAX";
    Atlas_AggregationType_E["MovingMin"] = "MOVING_MIN";
    Atlas_AggregationType_E["MovingSum"] = "MOVING_SUM";
    Atlas_AggregationType_E["None"] = "NONE";
    Atlas_AggregationType_E["Percentile"] = "PERCENTILE";
    Atlas_AggregationType_E["Rank"] = "RANK";
    Atlas_AggregationType_E["RankPercentile"] = "RANK_PERCENTILE";
    Atlas_AggregationType_E["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    Atlas_AggregationType_E["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    Atlas_AggregationType_E["StdDeviation"] = "STD_DEVIATION";
    Atlas_AggregationType_E["Sum"] = "SUM";
    Atlas_AggregationType_E["TableAggr"] = "TABLE_AGGR";
    Atlas_AggregationType_E["Variance"] = "VARIANCE";
})(Atlas_AggregationType_E || (Atlas_AggregationType_E = {}));
export var Atlas_AnswerSpecHeader_Type;
(function (Atlas_AnswerSpecHeader_Type) {
    Atlas_AnswerSpecHeader_Type["AskExpert"] = "ASK_EXPERT";
    Atlas_AnswerSpecHeader_Type["Autogenerated"] = "AUTOGENERATED";
    Atlas_AnswerSpecHeader_Type["Default"] = "DEFAULT";
    Atlas_AnswerSpecHeader_Type["SpotIq"] = "SPOT_IQ";
})(Atlas_AnswerSpecHeader_Type || (Atlas_AnswerSpecHeader_Type = {}));
export var Atlas_AnswerSpecHeader_VizType;
(function (Atlas_AnswerSpecHeader_VizType) {
    Atlas_AnswerSpecHeader_VizType["Chart"] = "CHART";
    Atlas_AnswerSpecHeader_VizType["Filter"] = "FILTER";
    Atlas_AnswerSpecHeader_VizType["Headline"] = "HEADLINE";
    Atlas_AnswerSpecHeader_VizType["RAnalysis"] = "R_ANALYSIS";
    Atlas_AnswerSpecHeader_VizType["Table"] = "TABLE";
})(Atlas_AnswerSpecHeader_VizType || (Atlas_AnswerSpecHeader_VizType = {}));
export var Atlas_AvailabilityContentType_E;
(function (Atlas_AvailabilityContentType_E) {
    Atlas_AvailabilityContentType_E["Answer"] = "ANSWER";
    Atlas_AvailabilityContentType_E["Global"] = "GLOBAL";
    Atlas_AvailabilityContentType_E["Pinboard"] = "PINBOARD";
})(Atlas_AvailabilityContentType_E || (Atlas_AvailabilityContentType_E = {}));
export var Atlas_ChartViz_Config_CustomChartManifest_ManifestVersion;
(function (Atlas_ChartViz_Config_CustomChartManifest_ManifestVersion) {
    Atlas_ChartViz_Config_CustomChartManifest_ManifestVersion["V1"] = "V1";
})(Atlas_ChartViz_Config_CustomChartManifest_ManifestVersion || (Atlas_ChartViz_Config_CustomChartManifest_ManifestVersion = {}));
export var Atlas_ColumnDataType_E;
(function (Atlas_ColumnDataType_E) {
    Atlas_ColumnDataType_E["Bool"] = "BOOL";
    Atlas_ColumnDataType_E["Char"] = "CHAR";
    Atlas_ColumnDataType_E["Date"] = "DATE";
    Atlas_ColumnDataType_E["DateNum"] = "DATE_NUM";
    Atlas_ColumnDataType_E["DateNumAbsDay"] = "DATE_NUM_ABS_DAY";
    Atlas_ColumnDataType_E["DateNumAbsHour"] = "DATE_NUM_ABS_HOUR";
    Atlas_ColumnDataType_E["DateNumAbsMonth"] = "DATE_NUM_ABS_MONTH";
    Atlas_ColumnDataType_E["DateNumAbsQuarter"] = "DATE_NUM_ABS_QUARTER";
    Atlas_ColumnDataType_E["DateNumAbsWeek"] = "DATE_NUM_ABS_WEEK";
    Atlas_ColumnDataType_E["DateNumAbsYear"] = "DATE_NUM_ABS_YEAR";
    Atlas_ColumnDataType_E["DateNumDayInMonth"] = "DATE_NUM_DAY_IN_MONTH";
    Atlas_ColumnDataType_E["DateNumDayInQuarter"] = "DATE_NUM_DAY_IN_QUARTER";
    Atlas_ColumnDataType_E["DateNumDayInYear"] = "DATE_NUM_DAY_IN_YEAR";
    Atlas_ColumnDataType_E["DateNumDayOfWeek"] = "DATE_NUM_DAY_OF_WEEK";
    Atlas_ColumnDataType_E["DateNumHourInDay"] = "DATE_NUM_HOUR_IN_DAY";
    Atlas_ColumnDataType_E["DateNumMonthInQuarter"] = "DATE_NUM_MONTH_IN_QUARTER";
    Atlas_ColumnDataType_E["DateNumMonthInYear"] = "DATE_NUM_MONTH_IN_YEAR";
    Atlas_ColumnDataType_E["DateNumQuarterInYear"] = "DATE_NUM_QUARTER_IN_YEAR";
    Atlas_ColumnDataType_E["DateNumSecInDay"] = "DATE_NUM_SEC_IN_DAY";
    Atlas_ColumnDataType_E["DateNumWeekInMonth"] = "DATE_NUM_WEEK_IN_MONTH";
    Atlas_ColumnDataType_E["DateNumWeekInQuarter"] = "DATE_NUM_WEEK_IN_QUARTER";
    Atlas_ColumnDataType_E["DateNumWeekInYear"] = "DATE_NUM_WEEK_IN_YEAR";
    Atlas_ColumnDataType_E["DateTime"] = "DATE_TIME";
    Atlas_ColumnDataType_E["Double"] = "DOUBLE";
    Atlas_ColumnDataType_E["Float"] = "FLOAT";
    Atlas_ColumnDataType_E["Int32"] = "INT32";
    Atlas_ColumnDataType_E["Int64"] = "INT64";
    Atlas_ColumnDataType_E["List"] = "LIST";
    Atlas_ColumnDataType_E["ListBool"] = "LIST_BOOL";
    Atlas_ColumnDataType_E["ListDate"] = "LIST_DATE";
    Atlas_ColumnDataType_E["ListDateTime"] = "LIST_DATE_TIME";
    Atlas_ColumnDataType_E["ListDouble"] = "LIST_DOUBLE";
    Atlas_ColumnDataType_E["ListInt"] = "LIST_INT";
    Atlas_ColumnDataType_E["ListString"] = "LIST_STRING";
    Atlas_ColumnDataType_E["ListTime"] = "LIST_TIME";
    Atlas_ColumnDataType_E["Time"] = "TIME";
    Atlas_ColumnDataType_E["Unknown"] = "UNKNOWN";
    Atlas_ColumnDataType_E["Varchar"] = "VARCHAR";
})(Atlas_ColumnDataType_E || (Atlas_ColumnDataType_E = {}));
export var Atlas_ColumnFormat_Type;
(function (Atlas_ColumnFormat_Type) {
    Atlas_ColumnFormat_Type["None"] = "NONE";
    Atlas_ColumnFormat_Type["Percentage"] = "PERCENTAGE";
})(Atlas_ColumnFormat_Type || (Atlas_ColumnFormat_Type = {}));
export var Atlas_ColumnGroupType_E;
(function (Atlas_ColumnGroupType_E) {
    Atlas_ColumnGroupType_E["DataPanel"] = "DATA_PANEL";
})(Atlas_ColumnGroupType_E || (Atlas_ColumnGroupType_E = {}));
export var Atlas_ColumnIndexType_E;
(function (Atlas_ColumnIndexType_E) {
    Atlas_ColumnIndexType_E["Default"] = "DEFAULT";
    Atlas_ColumnIndexType_E["DontIndex"] = "DONT_INDEX";
    Atlas_ColumnIndexType_E["PrefixAndSubstring"] = "PREFIX_AND_SUBSTRING";
    Atlas_ColumnIndexType_E["PrefixAndWordSubstring"] = "PREFIX_AND_WORD_SUBSTRING";
    Atlas_ColumnIndexType_E["PrefixOnly"] = "PREFIX_ONLY";
})(Atlas_ColumnIndexType_E || (Atlas_ColumnIndexType_E = {}));
export var Atlas_ColumnType_E;
(function (Atlas_ColumnType_E) {
    Atlas_ColumnType_E["Attribute"] = "ATTRIBUTE";
    Atlas_ColumnType_E["Measure"] = "MEASURE";
    Atlas_ColumnType_E["Unknown"] = "UNKNOWN";
})(Atlas_ColumnType_E || (Atlas_ColumnType_E = {}));
export var Atlas_ColumnValueCasing_E;
(function (Atlas_ColumnValueCasing_E) {
    Atlas_ColumnValueCasing_E["AllLowercase"] = "ALL_LOWERCASE";
    Atlas_ColumnValueCasing_E["AllUppercase"] = "ALL_UPPERCASE";
    Atlas_ColumnValueCasing_E["Default"] = "DEFAULT";
    Atlas_ColumnValueCasing_E["Mixed"] = "MIXED";
    Atlas_ColumnValueCasing_E["NonString"] = "NON_STRING";
    Atlas_ColumnValueCasing_E["Unknown"] = "UNKNOWN";
})(Atlas_ColumnValueCasing_E || (Atlas_ColumnValueCasing_E = {}));
export var Atlas_Comment_CommentableType;
(function (Atlas_Comment_CommentableType) {
    Atlas_Comment_CommentableType["PinboardSheet"] = "PINBOARD_SHEET";
})(Atlas_Comment_CommentableType || (Atlas_Comment_CommentableType = {}));
export var Atlas_CompareTypeProto_E;
(function (Atlas_CompareTypeProto_E) {
    Atlas_CompareTypeProto_E["BeginsWith"] = "BEGINS_WITH";
    Atlas_CompareTypeProto_E["Bw"] = "BW";
    Atlas_CompareTypeProto_E["BwInc"] = "BW_INC";
    Atlas_CompareTypeProto_E["BwIncMax"] = "BW_INC_MAX";
    Atlas_CompareTypeProto_E["BwIncMin"] = "BW_INC_MIN";
    Atlas_CompareTypeProto_E["Contains"] = "CONTAINS";
    Atlas_CompareTypeProto_E["EndsWith"] = "ENDS_WITH";
    Atlas_CompareTypeProto_E["Eq"] = "EQ";
    Atlas_CompareTypeProto_E["Ge"] = "GE";
    Atlas_CompareTypeProto_E["Gt"] = "GT";
    Atlas_CompareTypeProto_E["In"] = "IN";
    Atlas_CompareTypeProto_E["Le"] = "LE";
    Atlas_CompareTypeProto_E["Like"] = "LIKE";
    Atlas_CompareTypeProto_E["Lt"] = "LT";
    Atlas_CompareTypeProto_E["Ne"] = "NE";
    Atlas_CompareTypeProto_E["NotIn"] = "NOT_IN";
})(Atlas_CompareTypeProto_E || (Atlas_CompareTypeProto_E = {}));
export var Atlas_ContainerSpecHeader_Type;
(function (Atlas_ContainerSpecHeader_Type) {
    Atlas_ContainerSpecHeader_Type["ClusterViz"] = "CLUSTER_VIZ";
    Atlas_ContainerSpecHeader_Type["GenericViz"] = "GENERIC_VIZ";
    Atlas_ContainerSpecHeader_Type["Group"] = "GROUP";
    Atlas_ContainerSpecHeader_Type["NoteTile"] = "NOTE_TILE";
    Atlas_ContainerSpecHeader_Type["PinnedAnswer"] = "PINNED_ANSWER";
    Atlas_ContainerSpecHeader_Type["PinnedInsight"] = "PINNED_INSIGHT";
})(Atlas_ContainerSpecHeader_Type || (Atlas_ContainerSpecHeader_Type = {}));
export var Atlas_CurrencyFormat_Type;
(function (Atlas_CurrencyFormat_Type) {
    Atlas_CurrencyFormat_Type["Column"] = "COLUMN";
    Atlas_CurrencyFormat_Type["IsoCode"] = "ISO_CODE";
    Atlas_CurrencyFormat_Type["UserLocale"] = "USER_LOCALE";
})(Atlas_CurrencyFormat_Type || (Atlas_CurrencyFormat_Type = {}));
export var Atlas_CustomCalendarColumnType_E;
(function (Atlas_CustomCalendarColumnType_E) {
    Atlas_CustomCalendarColumnType_E["EndOfDateBucket"] = "END_OF_DATE_BUCKET";
    Atlas_CustomCalendarColumnType_E["FormattedDateBucketString"] = "FORMATTED_DATE_BUCKET_STRING";
})(Atlas_CustomCalendarColumnType_E || (Atlas_CustomCalendarColumnType_E = {}));
export var Atlas_DataFormat_E;
(function (Atlas_DataFormat_E) {
    Atlas_DataFormat_E["Csv"] = "CSV";
    Atlas_DataFormat_E["Pdf"] = "PDF";
    Atlas_DataFormat_E["Xlxs"] = "XLXS";
})(Atlas_DataFormat_E || (Atlas_DataFormat_E = {}));
export var Atlas_DataLoadStatisticsContent_LoadStatus;
(function (Atlas_DataLoadStatisticsContent_LoadStatus) {
    Atlas_DataLoadStatisticsContent_LoadStatus["Failed"] = "FAILED";
    Atlas_DataLoadStatisticsContent_LoadStatus["Inprogress"] = "INPROGRESS";
    Atlas_DataLoadStatisticsContent_LoadStatus["Queued"] = "QUEUED";
    Atlas_DataLoadStatisticsContent_LoadStatus["Scheduled"] = "SCHEDULED";
    Atlas_DataLoadStatisticsContent_LoadStatus["Success"] = "SUCCESS";
    Atlas_DataLoadStatisticsContent_LoadStatus["Unknown"] = "UNKNOWN";
})(Atlas_DataLoadStatisticsContent_LoadStatus || (Atlas_DataLoadStatisticsContent_LoadStatus = {}));
export var Atlas_DataSource_AuthenticationType;
(function (Atlas_DataSource_AuthenticationType) {
    Atlas_DataSource_AuthenticationType["Extoauth"] = "EXTOAUTH";
    Atlas_DataSource_AuthenticationType["ExtoauthWithPkce"] = "EXTOAUTH_WITH_PKCE";
    Atlas_DataSource_AuthenticationType["Iam"] = "IAM";
    Atlas_DataSource_AuthenticationType["KeyPair"] = "KEY_PAIR";
    Atlas_DataSource_AuthenticationType["Oauth"] = "OAUTH";
    Atlas_DataSource_AuthenticationType["OauthWithPez"] = "OAUTH_WITH_PEZ";
    Atlas_DataSource_AuthenticationType["OauthWithPkce"] = "OAUTH_WITH_PKCE";
    Atlas_DataSource_AuthenticationType["OauthWithServicePrincipal"] = "OAUTH_WITH_SERVICE_PRINCIPAL";
    Atlas_DataSource_AuthenticationType["PersonalAccessToken"] = "PERSONAL_ACCESS_TOKEN";
    Atlas_DataSource_AuthenticationType["ServiceAccount"] = "SERVICE_ACCOUNT";
})(Atlas_DataSource_AuthenticationType || (Atlas_DataSource_AuthenticationType = {}));
export var Atlas_DataSource_Type;
(function (Atlas_DataSource_Type) {
    Atlas_DataSource_Type["Default"] = "DEFAULT";
    Atlas_DataSource_Type["FileCsv"] = "FILE_CSV";
    Atlas_DataSource_Type["Informatica"] = "INFORMATICA";
    Atlas_DataSource_Type["IpaasInformatica"] = "IPAAS_INFORMATICA";
    Atlas_DataSource_Type["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    Atlas_DataSource_Type["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    Atlas_DataSource_Type["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    Atlas_DataSource_Type["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    Atlas_DataSource_Type["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    Atlas_DataSource_Type["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    Atlas_DataSource_Type["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    Atlas_DataSource_Type["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    Atlas_DataSource_Type["RdbmsDenodo"] = "RDBMS_DENODO";
    Atlas_DataSource_Type["RdbmsDremio"] = "RDBMS_DREMIO";
    Atlas_DataSource_Type["RdbmsDrSum"] = "RDBMS_DR_SUM";
    Atlas_DataSource_Type["RdbmsFalcon"] = "RDBMS_FALCON";
    Atlas_DataSource_Type["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    Atlas_DataSource_Type["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    Atlas_DataSource_Type["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    Atlas_DataSource_Type["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    Atlas_DataSource_Type["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    Atlas_DataSource_Type["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    Atlas_DataSource_Type["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    Atlas_DataSource_Type["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    Atlas_DataSource_Type["RdbmsLooker"] = "RDBMS_LOOKER";
    Atlas_DataSource_Type["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    Atlas_DataSource_Type["RdbmsMarketo"] = "RDBMS_MARKETO";
    Atlas_DataSource_Type["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    Atlas_DataSource_Type["RdbmsMode"] = "RDBMS_MODE";
    Atlas_DataSource_Type["RdbmsMysql"] = "RDBMS_MYSQL";
    Atlas_DataSource_Type["RdbmsOracle"] = "RDBMS_ORACLE";
    Atlas_DataSource_Type["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    Atlas_DataSource_Type["RdbmsPostgres"] = "RDBMS_POSTGRES";
    Atlas_DataSource_Type["RdbmsPresto"] = "RDBMS_PRESTO";
    Atlas_DataSource_Type["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    Atlas_DataSource_Type["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    Atlas_DataSource_Type["RdbmsSalesforce"] = "RDBMS_SALESFORCE";
    Atlas_DataSource_Type["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    Atlas_DataSource_Type["RdbmsServiceNow"] = "RDBMS_SERVICE_NOW";
    Atlas_DataSource_Type["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    Atlas_DataSource_Type["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    Atlas_DataSource_Type["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    Atlas_DataSource_Type["RdbmsTeradata"] = "RDBMS_TERADATA";
    Atlas_DataSource_Type["RdbmsTrino"] = "RDBMS_TRINO";
    Atlas_DataSource_Type["SaasSalesforce"] = "SAAS_SALESFORCE";
})(Atlas_DataSource_Type || (Atlas_DataSource_Type = {}));
export var Atlas_DefaultSortProperty_E;
(function (Atlas_DefaultSortProperty_E) {
    Atlas_DefaultSortProperty_E["Disable"] = "DISABLE";
    Atlas_DefaultSortProperty_E["Enable"] = "ENABLE";
})(Atlas_DefaultSortProperty_E || (Atlas_DefaultSortProperty_E = {}));
export var Atlas_EdgeDefinition_Constraint;
(function (Atlas_EdgeDefinition_Constraint) {
    Atlas_EdgeDefinition_Constraint["CascadeDelete"] = "CASCADE_DELETE";
    Atlas_EdgeDefinition_Constraint["References"] = "REFERENCES";
    Atlas_EdgeDefinition_Constraint["RestrictDelete"] = "RESTRICT_DELETE";
})(Atlas_EdgeDefinition_Constraint || (Atlas_EdgeDefinition_Constraint = {}));
export var Atlas_EdgeSortOrder;
(function (Atlas_EdgeSortOrder) {
    Atlas_EdgeSortOrder["CreatedMs"] = "CREATED_MS";
    Atlas_EdgeSortOrder["FavoritedIndex"] = "FAVORITED_INDEX";
    Atlas_EdgeSortOrder["Index"] = "INDEX";
})(Atlas_EdgeSortOrder || (Atlas_EdgeSortOrder = {}));
export var Atlas_EntityCategory_E;
(function (Atlas_EntityCategory_E) {
    Atlas_EntityCategory_E["Default"] = "DEFAULT";
    Atlas_EntityCategory_E["Money"] = "MONEY";
    Atlas_EntityCategory_E["NumTypes"] = "NUM_TYPES";
    Atlas_EntityCategory_E["Person"] = "PERSON";
    Atlas_EntityCategory_E["Place"] = "PLACE";
    Atlas_EntityCategory_E["Product"] = "PRODUCT";
    Atlas_EntityCategory_E["Time"] = "TIME";
})(Atlas_EntityCategory_E || (Atlas_EntityCategory_E = {}));
export var Atlas_ExpressionNode_Arithmetic_LogicalOp;
(function (Atlas_ExpressionNode_Arithmetic_LogicalOp) {
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsDate"] = "ABS_DATE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsDateAsEpoch"] = "ABS_DATE_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsDay"] = "ABS_DAY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsDayAsEpoch"] = "ABS_DAY_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsHour"] = "ABS_HOUR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsHourAsEpoch"] = "ABS_HOUR_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsMinute"] = "ABS_MINUTE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsMinuteAsEpoch"] = "ABS_MINUTE_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsMonth"] = "ABS_MONTH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsMonthAsEpoch"] = "ABS_MONTH_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsMonthEndExAsEpoch"] = "ABS_MONTH_END_EX_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsQuarter"] = "ABS_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsQuarterAsEpoch"] = "ABS_QUARTER_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsQuarterEndExAsEpoch"] = "ABS_QUARTER_END_EX_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsWeek"] = "ABS_WEEK";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsWeekAsEpoch"] = "ABS_WEEK_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsWeekEndExAsEpoch"] = "ABS_WEEK_END_EX_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsYear"] = "ABS_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsYearAsEpoch"] = "ABS_YEAR_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsYearEndExAsEpoch"] = "ABS_YEAR_END_EX_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["AbsYearNumber"] = "ABS_YEAR_NUMBER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["BeginsWith"] = "BEGINS_WITH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayInMonth"] = "DAY_IN_MONTH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayInQuarter"] = "DAY_IN_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayInYear"] = "DAY_IN_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfMonth"] = "DAY_OF_MONTH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfQuarter"] = "DAY_OF_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfWeek"] = "DAY_OF_WEEK";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfWeekNum"] = "DAY_OF_WEEK_NUM";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfWeekStr"] = "DAY_OF_WEEK_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["DayOfYear"] = "DAY_OF_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Diff"] = "DIFF";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Div"] = "DIV";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["EndsWith"] = "ENDS_WITH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Exp"] = "EXP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["FirstValue"] = "FIRST_VALUE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["FirstValueInPeriod"] = "FIRST_VALUE_IN_PERIOD";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["GroupAggregateIf"] = "GROUP_AGGREGATE_IF";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["HourOfDay"] = "HOUR_OF_DAY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["LastValue"] = "LAST_VALUE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["LastValueInPeriod"] = "LAST_VALUE_IN_PERIOD";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Mod"] = "MOD";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["MonthInQuarter"] = "MONTH_IN_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["MonthInYear"] = "MONTH_IN_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["MonthOfQuarter"] = "MONTH_OF_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["MonthOfYear"] = "MONTH_OF_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Mult"] = "MULT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["None"] = "NONE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAbs"] = "OP_ABS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAbsQuarterAsEpoch"] = "OP_ABS_QUARTER_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAbsYearAsEpoch"] = "OP_ABS_YEAR_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAcos"] = "OP_ACOS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAnd"] = "OP_AND";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpApproxSetCardinality"] = "OP_APPROX_SET_CARDINALITY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAsin"] = "OP_ASIN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAtan"] = "OP_ATAN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpAtan2"] = "OP_ATAN2";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpBeginsWith"] = "OP_BEGINS_WITH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpBeginsWithNocase"] = "OP_BEGINS_WITH_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpCeil"] = "OP_CEIL";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpContainerSize"] = "OP_CONTAINER_SIZE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpContains"] = "OP_CONTAINS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpContainsNocase"] = "OP_CONTAINS_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertBoolNumeric"] = "OP_CONVERT_BOOL_NUMERIC";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertBoolString"] = "OP_CONVERT_BOOL_STRING";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertDateString"] = "OP_CONVERT_DATE_STRING";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertDoubleString"] = "OP_CONVERT_DOUBLE_STRING";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertFloatInteger"] = "OP_CONVERT_FLOAT_INTEGER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertInt64String"] = "OP_CONVERT_INT64_STRING";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertNumericBool"] = "OP_CONVERT_NUMERIC_BOOL";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertStringBool"] = "OP_CONVERT_STRING_BOOL";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertStringDouble"] = "OP_CONVERT_STRING_DOUBLE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpConvertStringInt64"] = "OP_CONVERT_STRING_INT64";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpCos"] = "OP_COS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpCube"] = "OP_CUBE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpCuberoot"] = "OP_CUBEROOT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateAddDays"] = "OP_DATE_ADD_DAYS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateAddMonths"] = "OP_DATE_ADD_MONTHS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateAddWeeks"] = "OP_DATE_ADD_WEEKS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateAddYears"] = "OP_DATE_ADD_YEARS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateDiffDays"] = "OP_DATE_DIFF_DAYS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateParse"] = "OP_DATE_PARSE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateTimeAddMinutes"] = "OP_DATE_TIME_ADD_MINUTES";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDateTimeAddSeconds"] = "OP_DATE_TIME_ADD_SECONDS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpDayOfWeekStr"] = "OP_DAY_OF_WEEK_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEditDistance"] = "OP_EDIT_DISTANCE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEditDistanceWithCap"] = "OP_EDIT_DISTANCE_WITH_CAP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEndsWith"] = "OP_ENDS_WITH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEndsWithNocase"] = "OP_ENDS_WITH_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEquals"] = "OP_EQUALS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpEqualsNocase"] = "OP_EQUALS_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpExp2"] = "OP_EXP2";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpFiscalYearNumber"] = "OP_FISCAL_YEAR_NUMBER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpFloor"] = "OP_FLOOR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpGreaterEquals"] = "OP_GREATER_EQUALS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpGreaterEqualsNocase"] = "OP_GREATER_EQUALS_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpGreaterThan"] = "OP_GREATER_THAN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpGreaterThanNocase"] = "OP_GREATER_THAN_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpGreatest"] = "OP_GREATEST";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpHourInDay"] = "OP_HOUR_IN_DAY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpIf"] = "OP_IF";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpIfNull"] = "OP_IF_NULL";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpIn"] = "OP_IN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpIsNull"] = "OP_IS_NULL";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpIsWeekend"] = "OP_IS_WEEKEND";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLeast"] = "OP_LEAST";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLeft"] = "OP_LEFT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLesserEquals"] = "OP_LESSER_EQUALS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLesserEqualsNocase"] = "OP_LESSER_EQUALS_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLessThan"] = "OP_LESS_THAN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLessThanNocase"] = "OP_LESS_THAN_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLike"] = "OP_LIKE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpList"] = "OP_LIST";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpListDiff"] = "OP_LIST_DIFF";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpListUnion"] = "OP_LIST_UNION";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLn"] = "OP_LN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLog2"] = "OP_LOG2";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpLog10"] = "OP_LOG10";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpMonthlyStr"] = "OP_MONTHLY_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpMonthInYearStr"] = "OP_MONTH_IN_YEAR_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpNegate"] = "OP_NEGATE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpNot"] = "OP_NOT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpNotEquals"] = "OP_NOT_EQUALS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpNotEqualsNocase"] = "OP_NOT_EQUALS_NOCASE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpNow"] = "OP_NOW";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpOr"] = "OP_OR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpPow"] = "OP_POW";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpQuarterlyStr"] = "OP_QUARTERLY_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpQuarterInYear"] = "OP_QUARTER_IN_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpQuarterInYearStr"] = "OP_QUARTER_IN_YEAR_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpQueryFilters"] = "OP_QUERY_FILTERS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpQueryGroups"] = "OP_QUERY_GROUPS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpRandom"] = "OP_RANDOM";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpRight"] = "OP_RIGHT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpRound"] = "OP_ROUND";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSecondInDay"] = "OP_SECOND_IN_DAY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSign"] = "OP_SIGN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSin"] = "OP_SIN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSoundsLike"] = "OP_SOUNDS_LIKE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSpellsLike"] = "OP_SPELLS_LIKE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSphericalDistance"] = "OP_SPHERICAL_DISTANCE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSqrt"] = "OP_SQRT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSquare"] = "OP_SQUARE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpStrcat"] = "OP_STRCAT";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpStringMatchScore"] = "OP_STRING_MATCH_SCORE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpStrlen"] = "OP_STRLEN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpStrpos"] = "OP_STRPOS";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpSubstr"] = "OP_SUBSTR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpTan"] = "OP_TAN";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpTimePart"] = "OP_TIME_PART";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpToday"] = "OP_TODAY";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpYearlyStr"] = "OP_YEARLY_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["OpYearStr"] = "OP_YEAR_STR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["PinnedMeasure"] = "PINNED_MEASURE";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["PinnedMeasureIf"] = "PINNED_MEASURE_IF";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["QuarterInYear"] = "QUARTER_IN_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["QuarterOfYear"] = "QUARTER_OF_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlBooleanOp"] = "SQL_BOOLEAN_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlDateOp"] = "SQL_DATE_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlDateTimeOp"] = "SQL_DATE_TIME_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlDoubleOp"] = "SQL_DOUBLE_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlIntOp"] = "SQL_INT_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlStringOp"] = "SQL_STRING_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["SqlTimeOp"] = "SQL_TIME_OP";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["Sum"] = "SUM";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekInMonth"] = "WEEK_IN_MONTH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekInQuarter"] = "WEEK_IN_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekInYear"] = "WEEK_IN_YEAR";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekInYearAsEpoch"] = "WEEK_IN_YEAR_AS_EPOCH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekInYearIso"] = "WEEK_IN_YEAR_ISO";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekOfMonth"] = "WEEK_OF_MONTH";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekOfQuarter"] = "WEEK_OF_QUARTER";
    Atlas_ExpressionNode_Arithmetic_LogicalOp["WeekOfYearIso"] = "WEEK_OF_YEAR_ISO";
})(Atlas_ExpressionNode_Arithmetic_LogicalOp || (Atlas_ExpressionNode_Arithmetic_LogicalOp = {}));
export var Atlas_ExpressionNode_Type;
(function (Atlas_ExpressionNode_Type) {
    Atlas_ExpressionNode_Type["AggregateNode"] = "AGGREGATE_NODE";
    Atlas_ExpressionNode_Type["ArithmeticNode"] = "ARITHMETIC_NODE";
    Atlas_ExpressionNode_Type["ConstantNode"] = "CONSTANT_NODE";
    Atlas_ExpressionNode_Type["PinnedMeasureNode"] = "PINNED_MEASURE_NODE";
    Atlas_ExpressionNode_Type["ReferenceNode"] = "REFERENCE_NODE";
    Atlas_ExpressionNode_Type["VariableNode"] = "VARIABLE_NODE";
    Atlas_ExpressionNode_Type["WindowingNode"] = "WINDOWING_NODE";
})(Atlas_ExpressionNode_Type || (Atlas_ExpressionNode_Type = {}));
export var Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type;
(function (Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type) {
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type["CurrentRow"] = "CURRENT_ROW";
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type["Following"] = "FOLLOWING";
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type["Preceding"] = "PRECEDING";
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type["UnboundedFollowing"] = "UNBOUNDED_FOLLOWING";
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type["UnboundedPreceding"] = "UNBOUNDED_PRECEDING";
})(Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type || (Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Point_Type = {}));
export var Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type;
(function (Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type) {
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type["Range"] = "RANGE";
    Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type["Row"] = "ROW";
})(Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type || (Atlas_ExpressionNode_Windowing_PartitionOverDefinition_PartitionWindow_Type = {}));
export var Atlas_ExpressionVersion_E;
(function (Atlas_ExpressionVersion_E) {
    Atlas_ExpressionVersion_E["MaxVersion"] = "MAX_VERSION";
    Atlas_ExpressionVersion_E["V1"] = "V1";
    Atlas_ExpressionVersion_E["V2"] = "V2";
})(Atlas_ExpressionVersion_E || (Atlas_ExpressionVersion_E = {}));
export var Atlas_FileContent_StorageType;
(function (Atlas_FileContent_StorageType) {
    Atlas_FileContent_StorageType["Hdfs"] = "HDFS";
    Atlas_FileContent_StorageType["S3"] = "S3";
    Atlas_FileContent_StorageType["Unknown"] = "UNKNOWN";
})(Atlas_FileContent_StorageType || (Atlas_FileContent_StorageType = {}));
export var Atlas_FileHeader_Type;
(function (Atlas_FileHeader_Type) {
    Atlas_FileHeader_Type["File"] = "FILE";
    Atlas_FileHeader_Type["GeoCustomRegion"] = "GEO_CUSTOM_REGION";
    Atlas_FileHeader_Type["Json"] = "JSON";
    Atlas_FileHeader_Type["None"] = "NONE";
    Atlas_FileHeader_Type["NoteTileFile"] = "NOTE_TILE_FILE";
    Atlas_FileHeader_Type["Thumbnail"] = "THUMBNAIL";
    Atlas_FileHeader_Type["UserProfile"] = "USER_PROFILE";
})(Atlas_FileHeader_Type || (Atlas_FileHeader_Type = {}));
export var Atlas_FilterHeader_Type;
(function (Atlas_FilterHeader_Type) {
    Atlas_FilterHeader_Type["Compound"] = "COMPOUND";
    Atlas_FilterHeader_Type["Simple"] = "SIMPLE";
})(Atlas_FilterHeader_Type || (Atlas_FilterHeader_Type = {}));
export var Atlas_GeoConfigProto_Type;
(function (Atlas_GeoConfigProto_Type) {
    Atlas_GeoConfigProto_Type["AdminDiv_0"] = "ADMIN_DIV_0";
    Atlas_GeoConfigProto_Type["AdminDiv_1"] = "ADMIN_DIV_1";
    Atlas_GeoConfigProto_Type["AdminDiv_2"] = "ADMIN_DIV_2";
    Atlas_GeoConfigProto_Type["CustomRegion"] = "CUSTOM_REGION";
    Atlas_GeoConfigProto_Type["Latitude"] = "LATITUDE";
    Atlas_GeoConfigProto_Type["Longitude"] = "LONGITUDE";
    Atlas_GeoConfigProto_Type["ZipCode"] = "ZIP_CODE";
})(Atlas_GeoConfigProto_Type || (Atlas_GeoConfigProto_Type = {}));
export var Atlas_GeoType_E;
(function (Atlas_GeoType_E) {
    Atlas_GeoType_E["AreaCode"] = "AREA_CODE";
    Atlas_GeoType_E["CbsaMsa"] = "CBSA_MSA";
    Atlas_GeoType_E["City"] = "CITY";
    Atlas_GeoType_E["CongressionalDistrict"] = "CONGRESSIONAL_DISTRICT";
    Atlas_GeoType_E["CountryRegion"] = "COUNTRY_REGION";
    Atlas_GeoType_E["County"] = "COUNTY";
    Atlas_GeoType_E["Latitude"] = "LATITUDE";
    Atlas_GeoType_E["Longitude"] = "LONGITUDE";
    Atlas_GeoType_E["None"] = "NONE";
    Atlas_GeoType_E["StateProvince"] = "STATE_PROVINCE";
    Atlas_GeoType_E["ZipCode"] = "ZIP_CODE";
})(Atlas_GeoType_E || (Atlas_GeoType_E = {}));
export var Atlas_GrowthDimensionType_E;
(function (Atlas_GrowthDimensionType_E) {
    Atlas_GrowthDimensionType_E["TimeBucket"] = "TIME_BUCKET";
    Atlas_GrowthDimensionType_E["TimeBucketOutput"] = "TIME_BUCKET_OUTPUT";
    Atlas_GrowthDimensionType_E["TimeComparison"] = "TIME_COMPARISON";
})(Atlas_GrowthDimensionType_E || (Atlas_GrowthDimensionType_E = {}));
export var Atlas_HeadlineViz_TemplateType;
(function (Atlas_HeadlineViz_TemplateType) {
    Atlas_HeadlineViz_TemplateType["TemplateAttributeColumn"] = "TEMPLATE_ATTRIBUTE_COLUMN";
    Atlas_HeadlineViz_TemplateType["TemplateMeasureColumn"] = "TEMPLATE_MEASURE_COLUMN";
})(Atlas_HeadlineViz_TemplateType || (Atlas_HeadlineViz_TemplateType = {}));
export var Atlas_JoinType_E;
(function (Atlas_JoinType_E) {
    Atlas_JoinType_E["Cross"] = "CROSS";
    Atlas_JoinType_E["Inner"] = "INNER";
    Atlas_JoinType_E["Left"] = "LEFT";
    Atlas_JoinType_E["Outer"] = "OUTER";
    Atlas_JoinType_E["Right"] = "RIGHT";
})(Atlas_JoinType_E || (Atlas_JoinType_E = {}));
export var Atlas_LogicalColumnHeader_OptionalType;
(function (Atlas_LogicalColumnHeader_OptionalType) {
    Atlas_LogicalColumnHeader_OptionalType["Formula"] = "FORMULA";
})(Atlas_LogicalColumnHeader_OptionalType || (Atlas_LogicalColumnHeader_OptionalType = {}));
export var Atlas_LogicalColumnHeader_Type;
(function (Atlas_LogicalColumnHeader_Type) {
    Atlas_LogicalColumnHeader_Type["ColumnDerived"] = "COLUMN_DERIVED";
    Atlas_LogicalColumnHeader_Type["ColumnOneToOne"] = "COLUMN_ONE_TO_ONE";
    Atlas_LogicalColumnHeader_Type["ColumnSql"] = "COLUMN_SQL";
    Atlas_LogicalColumnHeader_Type["ColumnUnknown"] = "COLUMN_UNKNOWN";
})(Atlas_LogicalColumnHeader_Type || (Atlas_LogicalColumnHeader_Type = {}));
export var Atlas_LogicalRelationshipHeader_Type;
(function (Atlas_LogicalRelationshipHeader_Type) {
    Atlas_LogicalRelationshipHeader_Type["ForeignKey"] = "FOREIGN_KEY";
    Atlas_LogicalRelationshipHeader_Type["Generic"] = "GENERIC";
    Atlas_LogicalRelationshipHeader_Type["UserDefined"] = "USER_DEFINED";
})(Atlas_LogicalRelationshipHeader_Type || (Atlas_LogicalRelationshipHeader_Type = {}));
export var Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus;
(function (Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus) {
    Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus["Failed"] = "FAILED";
    Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus["Succeeded"] = "SUCCEEDED";
    Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus["Synching"] = "SYNCHING";
})(Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus || (Atlas_LogicalTableContent_MaterializedViewInfo_ExternalMaterializedViewInfo_SyncStatus = {}));
export var Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType;
(function (Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType) {
    Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType["TsEmaildomain"] = "TS_EMAILDOMAIN";
    Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType["TsGroups"] = "TS_GROUPS";
    Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType["TsGroupsInt"] = "TS_GROUPS_INT";
    Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType["TsOrg"] = "TS_ORG";
    Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType["TsUsername"] = "TS_USERNAME";
})(Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType || (Atlas_LogicalTableContent_MultiTenantCustomCalendarInfo_RlsVariableType = {}));
export var Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type;
(function (Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type) {
    Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type["Manually"] = "MANUALLY";
    Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type["Scheduled"] = "SCHEDULED";
    Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type["Unknown"] = "UNKNOWN";
    Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type["Unsynced"] = "UNSYNCED";
})(Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type || (Atlas_LogicalTableContent_TableMappingInfo_CachingInfo_Type = {}));
export var Atlas_LogicalTableContent_TableMappingInfo_TableType;
(function (Atlas_LogicalTableContent_TableMappingInfo_TableType) {
    Atlas_LogicalTableContent_TableMappingInfo_TableType["Table"] = "TABLE";
    Atlas_LogicalTableContent_TableMappingInfo_TableType["View"] = "VIEW";
})(Atlas_LogicalTableContent_TableMappingInfo_TableType || (Atlas_LogicalTableContent_TableMappingInfo_TableType = {}));
export var Atlas_LogicalTableHeader_GenerationType;
(function (Atlas_LogicalTableHeader_GenerationType) {
    Atlas_LogicalTableHeader_GenerationType["Autogenerated"] = "AUTOGENERATED";
    Atlas_LogicalTableHeader_GenerationType["Default"] = "DEFAULT";
})(Atlas_LogicalTableHeader_GenerationType || (Atlas_LogicalTableHeader_GenerationType = {}));
export var Atlas_LogicalTableHeader_Type;
(function (Atlas_LogicalTableHeader_Type) {
    Atlas_LogicalTableHeader_Type["AggrWorksheetTable"] = "AGGR_WORKSHEET_TABLE";
    Atlas_LogicalTableHeader_Type["CalendarTable"] = "CALENDAR_TABLE";
    Atlas_LogicalTableHeader_Type["DbViewTable"] = "DB_VIEW_TABLE";
    Atlas_LogicalTableHeader_Type["MaterializedViewTable"] = "MATERIALIZED_VIEW_TABLE";
    Atlas_LogicalTableHeader_Type["OneToOneTable"] = "ONE_TO_ONE_TABLE";
    Atlas_LogicalTableHeader_Type["PrivateWorksheetTable"] = "PRIVATE_WORKSHEET_TABLE";
    Atlas_LogicalTableHeader_Type["SqlView"] = "SQL_VIEW";
    Atlas_LogicalTableHeader_Type["UserDefinedTable"] = "USER_DEFINED_TABLE";
    Atlas_LogicalTableHeader_Type["WorksheetTable"] = "WORKSHEET_TABLE";
})(Atlas_LogicalTableHeader_Type || (Atlas_LogicalTableHeader_Type = {}));
export var Atlas_PersonalisedViewHeader_Type;
(function (Atlas_PersonalisedViewHeader_Type) {
    Atlas_PersonalisedViewHeader_Type["Default"] = "DEFAULT";
    Atlas_PersonalisedViewHeader_Type["MonitorAlert"] = "MONITOR_ALERT";
})(Atlas_PersonalisedViewHeader_Type || (Atlas_PersonalisedViewHeader_Type = {}));
export var Atlas_PinboardSheetContent_Type;
(function (Atlas_PinboardSheetContent_Type) {
    Atlas_PinboardSheetContent_Type["Insight"] = "INSIGHT";
    Atlas_PinboardSheetContent_Type["Pinboard"] = "PINBOARD";
})(Atlas_PinboardSheetContent_Type || (Atlas_PinboardSheetContent_Type = {}));
export var Atlas_PinboardSpecHeader_ModelVersion;
(function (Atlas_PinboardSpecHeader_ModelVersion) {
    Atlas_PinboardSpecHeader_ModelVersion["V1"] = "V1";
    Atlas_PinboardSpecHeader_ModelVersion["V2"] = "V2";
})(Atlas_PinboardSpecHeader_ModelVersion || (Atlas_PinboardSpecHeader_ModelVersion = {}));
export var Atlas_PinboardSpecHeader_Type;
(function (Atlas_PinboardSpecHeader_Type) {
    Atlas_PinboardSpecHeader_Type["Insight"] = "INSIGHT";
    Atlas_PinboardSpecHeader_Type["Pinboard"] = "PINBOARD";
})(Atlas_PinboardSpecHeader_Type || (Atlas_PinboardSpecHeader_Type = {}));
export var Atlas_PrincipalVisibility_Type;
(function (Atlas_PrincipalVisibility_Type) {
    Atlas_PrincipalVisibility_Type["Default"] = "DEFAULT";
    Atlas_PrincipalVisibility_Type["NonSharable"] = "NON_SHARABLE";
})(Atlas_PrincipalVisibility_Type || (Atlas_PrincipalVisibility_Type = {}));
export var Atlas_Privilege_E;
(function (Atlas_Privilege_E) {
    Atlas_Privilege_E["A3Analysis"] = "A3_ANALYSIS";
    Atlas_Privilege_E["Administration"] = "ADMINISTRATION";
    Atlas_Privilege_E["AllowNonEmbedFullAppAccess"] = "ALLOW_NON_EMBED_FULL_APP_ACCESS";
    Atlas_Privilege_E["ApplicationAdministration"] = "APPLICATION_ADMINISTRATION";
    Atlas_Privilege_E["AuthenticationAdministration"] = "AUTHENTICATION_ADMINISTRATION";
    Atlas_Privilege_E["Authoring"] = "AUTHORING";
    Atlas_Privilege_E["BackupAdministration"] = "BACKUP_ADMINISTRATION";
    Atlas_Privilege_E["BillingInfoAdministration"] = "BILLING_INFO_ADMINISTRATION";
    Atlas_Privilege_E["Bypassrls"] = "BYPASSRLS";
    Atlas_Privilege_E["CanAccessAnalystStudio"] = "CAN_ACCESS_ANALYST_STUDIO";
    Atlas_Privilege_E["CanConfigureConnections"] = "CAN_CONFIGURE_CONNECTIONS";
    Atlas_Privilege_E["CanCreateCatalog"] = "CAN_CREATE_CATALOG";
    Atlas_Privilege_E["CanCreateOrEditConnections"] = "CAN_CREATE_OR_EDIT_CONNECTIONS";
    Atlas_Privilege_E["CanManageAnalystStudio"] = "CAN_MANAGE_ANALYST_STUDIO";
    Atlas_Privilege_E["CanManageCustomCalendar"] = "CAN_MANAGE_CUSTOM_CALENDAR";
    Atlas_Privilege_E["CanManageUserSecurityParameters"] = "CAN_MANAGE_USER_SECURITY_PARAMETERS";
    Atlas_Privilege_E["CanManageVersionControl"] = "CAN_MANAGE_VERSION_CONTROL";
    Atlas_Privilege_E["CanManageWorksheetViewsTables"] = "CAN_MANAGE_WORKSHEET_VIEWS_TABLES";
    Atlas_Privilege_E["CanSetupVersionControl"] = "CAN_SETUP_VERSION_CONTROL";
    Atlas_Privilege_E["ControlTrustedAuth"] = "CONTROL_TRUSTED_AUTH";
    Atlas_Privilege_E["DataDownloading"] = "DATA_DOWNLOADING";
    Atlas_Privilege_E["DataManagement"] = "DATA_MANAGEMENT";
    Atlas_Privilege_E["DeveloperPrivilege"] = "DEVELOPER_PRIVILEGE";
    Atlas_Privilege_E["DisablePinboardCreation"] = "DISABLE_PINBOARD_CREATION";
    Atlas_Privilege_E["EnableSpotappCreation"] = "ENABLE_SPOTAPP_CREATION";
    Atlas_Privilege_E["ExperimentalFeaturePrivilege"] = "EXPERIMENTAL_FEATURE_PRIVILEGE";
    Atlas_Privilege_E["GroupAdministration"] = "GROUP_ADMINISTRATION";
    Atlas_Privilege_E["JobScheduling"] = "JOB_SCHEDULING";
    Atlas_Privilege_E["LiveboardVerifier"] = "LIVEBOARD_VERIFIER";
    Atlas_Privilege_E["LogicalModeling"] = "LOGICAL_MODELING";
    Atlas_Privilege_E["OrgAdminstration"] = "ORG_ADMINSTRATION";
    Atlas_Privilege_E["PreviewDocumentSearch"] = "PREVIEW_DOCUMENT_SEARCH";
    Atlas_Privilege_E["PreviewThoughtspotSage"] = "PREVIEW_THOUGHTSPOT_SAGE";
    Atlas_Privilege_E["RoleAdministration"] = "ROLE_ADMINISTRATION";
    Atlas_Privilege_E["RAnalysis"] = "R_ANALYSIS";
    Atlas_Privilege_E["SecurityManagement"] = "SECURITY_MANAGEMENT";
    Atlas_Privilege_E["ShareWithAll"] = "SHARE_WITH_ALL";
    Atlas_Privilege_E["SyncManagement"] = "SYNC_MANAGEMENT";
    Atlas_Privilege_E["SystemInfoAdministration"] = "SYSTEM_INFO_ADMINISTRATION";
    Atlas_Privilege_E["SystemManagement"] = "SYSTEM_MANAGEMENT";
    Atlas_Privilege_E["TagManagement"] = "TAG_MANAGEMENT";
    Atlas_Privilege_E["ThirdpartyAnalysis"] = "THIRDPARTY_ANALYSIS";
    Atlas_Privilege_E["Unknown"] = "UNKNOWN";
    Atlas_Privilege_E["UserAdministration"] = "USER_ADMINISTRATION";
    Atlas_Privilege_E["UserDataUploading"] = "USER_DATA_UPLOADING";
    Atlas_Privilege_E["UserManagement"] = "USER_MANAGEMENT";
})(Atlas_Privilege_E || (Atlas_Privilege_E = {}));
export var Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket;
(function (Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket) {
    Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket["Day"] = "DAY";
    Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket["Month"] = "MONTH";
    Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket["Quarter"] = "QUARTER";
    Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket["Week"] = "WEEK";
    Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket["Year"] = "YEAR";
})(Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket || (Atlas_QueryConstraints_Constraint_DateRangeCondition_Bucket = {}));
export var Atlas_SheetLayout_Mode;
(function (Atlas_SheetLayout_Mode) {
    Atlas_SheetLayout_Mode["Auto"] = "AUTO";
    Atlas_SheetLayout_Mode["Custom"] = "CUSTOM";
})(Atlas_SheetLayout_Mode || (Atlas_SheetLayout_Mode = {}));
export var Atlas_SheetLayout_Tile_Size;
(function (Atlas_SheetLayout_Tile_Size) {
    Atlas_SheetLayout_Tile_Size["Default"] = "DEFAULT";
    Atlas_SheetLayout_Tile_Size["ExtraLarge"] = "EXTRA_LARGE";
    Atlas_SheetLayout_Tile_Size["ExtraSmall"] = "EXTRA_SMALL";
    Atlas_SheetLayout_Tile_Size["Large"] = "LARGE";
    Atlas_SheetLayout_Tile_Size["LargeSmall"] = "LARGE_SMALL";
    Atlas_SheetLayout_Tile_Size["Medium"] = "MEDIUM";
    Atlas_SheetLayout_Tile_Size["MediumSmall"] = "MEDIUM_SMALL";
    Atlas_SheetLayout_Tile_Size["Small"] = "SMALL";
})(Atlas_SheetLayout_Tile_Size || (Atlas_SheetLayout_Tile_Size = {}));
export var Atlas_StatusProperty_E;
(function (Atlas_StatusProperty_E) {
    Atlas_StatusProperty_E["Disable"] = "DISABLE";
    Atlas_StatusProperty_E["Enable"] = "ENABLE";
})(Atlas_StatusProperty_E || (Atlas_StatusProperty_E = {}));
export var Atlas_Storable_Type;
(function (Atlas_Storable_Type) {
    Atlas_Storable_Type["Edge"] = "EDGE";
    Atlas_Storable_Type["Node"] = "NODE";
    Atlas_Storable_Type["NodeContent"] = "NODE_CONTENT";
    Atlas_Storable_Type["NodeHeader"] = "NODE_HEADER";
})(Atlas_Storable_Type || (Atlas_Storable_Type = {}));
export var Atlas_SynonymType_E;
(function (Atlas_SynonymType_E) {
    Atlas_SynonymType_E["AutoGenerated"] = "AUTO_GENERATED";
    Atlas_SynonymType_E["Unknown"] = "UNKNOWN";
    Atlas_SynonymType_E["UserDefined"] = "USER_DEFINED";
})(Atlas_SynonymType_E || (Atlas_SynonymType_E = {}));
export var Atlas_TsePipelineInstanceContentStatus_E;
(function (Atlas_TsePipelineInstanceContentStatus_E) {
    Atlas_TsePipelineInstanceContentStatus_E["Failed"] = "FAILED";
    Atlas_TsePipelineInstanceContentStatus_E["Initialized"] = "INITIALIZED";
    Atlas_TsePipelineInstanceContentStatus_E["Success"] = "SUCCESS";
})(Atlas_TsePipelineInstanceContentStatus_E || (Atlas_TsePipelineInstanceContentStatus_E = {}));
export var Atlas_TsePipelineInstanceContentType_E;
(function (Atlas_TsePipelineInstanceContentType_E) {
    Atlas_TsePipelineInstanceContentType_E["Instant"] = "INSTANT";
    Atlas_TsePipelineInstanceContentType_E["Scheduled"] = "SCHEDULED";
})(Atlas_TsePipelineInstanceContentType_E || (Atlas_TsePipelineInstanceContentType_E = {}));
export var Atlas_TableFilterHeader_Type;
(function (Atlas_TableFilterHeader_Type) {
    Atlas_TableFilterHeader_Type["DataFilter"] = "DATA_FILTER";
    Atlas_TableFilterHeader_Type["RowSecurityFilter"] = "ROW_SECURITY_FILTER";
})(Atlas_TableFilterHeader_Type || (Atlas_TableFilterHeader_Type = {}));
export var Atlas_TemplateVariableHeader_Type;
(function (Atlas_TemplateVariableHeader_Type) {
    Atlas_TemplateVariableHeader_Type["ConnectionProperty"] = "CONNECTION_PROPERTY";
    Atlas_TemplateVariableHeader_Type["ConnectionPropertyPerPrincipal"] = "CONNECTION_PROPERTY_PER_PRINCIPAL";
    Atlas_TemplateVariableHeader_Type["TableMapping"] = "TABLE_MAPPING";
    Atlas_TemplateVariableHeader_Type["Tml"] = "TML";
    Atlas_TemplateVariableHeader_Type["Translation"] = "TRANSLATION";
})(Atlas_TemplateVariableHeader_Type || (Atlas_TemplateVariableHeader_Type = {}));
export var Atlas_UpgradeId_E;
(function (Atlas_UpgradeId_E) {
    Atlas_UpgradeId_E["AggrWorksheetsUpgrade"] = "AGGR_WORKSHEETS_UPGRADE";
    Atlas_UpgradeId_E["AnswersUpgrade"] = "ANSWERS_UPGRADE";
    Atlas_UpgradeId_E["AtlasStorageUpgradeHandler"] = "ATLAS_STORAGE_UPGRADE_HANDLER";
    Atlas_UpgradeId_E["BaseUpgrade"] = "BASE_UPGRADE";
    Atlas_UpgradeId_E["MapboxTokenRotationHandler"] = "MAPBOX_TOKEN_ROTATION_HANDLER";
    Atlas_UpgradeId_E["MiscHandler"] = "MISC_HANDLER";
    Atlas_UpgradeId_E["PinboardsUpgrade"] = "PINBOARDS_UPGRADE";
    Atlas_UpgradeId_E["ScheduledJobsUpgradeHandler"] = "SCHEDULED_JOBS_UPGRADE_HANDLER";
    Atlas_UpgradeId_E["TableFiltersUpgrade"] = "TABLE_FILTERS_UPGRADE";
    Atlas_UpgradeId_E["TestUpgrade_1"] = "TEST_UPGRADE_1";
    Atlas_UpgradeId_E["TestUpgrade_2"] = "TEST_UPGRADE_2";
    Atlas_UpgradeId_E["TestUpgrade_3"] = "TEST_UPGRADE_3";
    Atlas_UpgradeId_E["ViewsUpgradeHandler"] = "VIEWS_UPGRADE_HANDLER";
    Atlas_UpgradeId_E["WorksheetsUpgrade"] = "WORKSHEETS_UPGRADE";
})(Atlas_UpgradeId_E || (Atlas_UpgradeId_E = {}));
export var Atlas_UserActivityContent_DigestFrequency;
(function (Atlas_UserActivityContent_DigestFrequency) {
    Atlas_UserActivityContent_DigestFrequency["Monthly"] = "MONTHLY";
    Atlas_UserActivityContent_DigestFrequency["Never"] = "NEVER";
    Atlas_UserActivityContent_DigestFrequency["Quarterly"] = "QUARTERLY";
    Atlas_UserActivityContent_DigestFrequency["Weekly"] = "WEEKLY";
})(Atlas_UserActivityContent_DigestFrequency || (Atlas_UserActivityContent_DigestFrequency = {}));
export var Atlas_UserActivityContent_HomepageModuleEntity_ModuleType;
(function (Atlas_UserActivityContent_HomepageModuleEntity_ModuleType) {
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["Favorite"] = "FAVORITE";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["Learning"] = "LEARNING";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["MyLibrary"] = "MY_LIBRARY";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["Search"] = "SEARCH";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["TestModule"] = "TEST_MODULE";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["Trending"] = "TRENDING";
    Atlas_UserActivityContent_HomepageModuleEntity_ModuleType["Watchlist"] = "WATCHLIST";
})(Atlas_UserActivityContent_HomepageModuleEntity_ModuleType || (Atlas_UserActivityContent_HomepageModuleEntity_ModuleType = {}));
export var Atlas_UserActivityContent_PrioritizedVisualization_ObjectType;
(function (Atlas_UserActivityContent_PrioritizedVisualization_ObjectType) {
    Atlas_UserActivityContent_PrioritizedVisualization_ObjectType["Answer"] = "ANSWER";
    Atlas_UserActivityContent_PrioritizedVisualization_ObjectType["Pinboard"] = "PINBOARD";
})(Atlas_UserActivityContent_PrioritizedVisualization_ObjectType || (Atlas_UserActivityContent_PrioritizedVisualization_ObjectType = {}));
export var Atlas_UserActivityContent_PrioritizedVisualization_Type;
(function (Atlas_UserActivityContent_PrioritizedVisualization_Type) {
    Atlas_UserActivityContent_PrioritizedVisualization_Type["Chart"] = "CHART";
    Atlas_UserActivityContent_PrioritizedVisualization_Type["Default"] = "DEFAULT";
    Atlas_UserActivityContent_PrioritizedVisualization_Type["Headline"] = "HEADLINE";
})(Atlas_UserActivityContent_PrioritizedVisualization_Type || (Atlas_UserActivityContent_PrioritizedVisualization_Type = {}));
export var Atlas_UserActivityEvent_Type;
(function (Atlas_UserActivityEvent_Type) {
    Atlas_UserActivityEvent_Type["AddFilter"] = "ADD_FILTER";
    Atlas_UserActivityEvent_Type["AddFormula"] = "ADD_FORMULA";
    Atlas_UserActivityEvent_Type["AddKeyword"] = "ADD_KEYWORD";
    Atlas_UserActivityEvent_Type["JoinTables"] = "JOIN_TABLES";
    Atlas_UserActivityEvent_Type["PinAnswer"] = "PIN_ANSWER";
    Atlas_UserActivityEvent_Type["SaveAnswer"] = "SAVE_ANSWER";
    Atlas_UserActivityEvent_Type["SavePinboard"] = "SAVE_PINBOARD";
})(Atlas_UserActivityEvent_Type || (Atlas_UserActivityEvent_Type = {}));
export var Atlas_UserAuthInfoHeader_ClientCredentials_Type;
(function (Atlas_UserAuthInfoHeader_ClientCredentials_Type) {
    Atlas_UserAuthInfoHeader_ClientCredentials_Type["Web"] = "WEB";
})(Atlas_UserAuthInfoHeader_ClientCredentials_Type || (Atlas_UserAuthInfoHeader_ClientCredentials_Type = {}));
export var Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType;
(function (Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType) {
    Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType["Full"] = "FULL";
    Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType["ReportBookView"] = "REPORT_BOOK_VIEW";
})(Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType || (Atlas_UserAuthInfoHeader_ShortLivedToken_AccessType = {}));
export var Atlas_UserAuthInfoHeader_Type;
(function (Atlas_UserAuthInfoHeader_Type) {
    Atlas_UserAuthInfoHeader_Type["ClientCredentials"] = "CLIENT_CREDENTIALS";
    Atlas_UserAuthInfoHeader_Type["EncryptedPassword"] = "ENCRYPTED_PASSWORD";
    Atlas_UserAuthInfoHeader_Type["ShortLivedToken"] = "SHORT_LIVED_TOKEN";
})(Atlas_UserAuthInfoHeader_Type || (Atlas_UserAuthInfoHeader_Type = {}));
export var Atlas_UserGroupHeader_Type;
(function (Atlas_UserGroupHeader_Type) {
    Atlas_UserGroupHeader_Type["AdminGroup"] = "ADMIN_GROUP";
    Atlas_UserGroupHeader_Type["AllUserGroup"] = "ALL_USER_GROUP";
    Atlas_UserGroupHeader_Type["LdapGroup"] = "LDAP_GROUP";
    Atlas_UserGroupHeader_Type["LocalGroup"] = "LOCAL_GROUP";
    Atlas_UserGroupHeader_Type["SystemGroup"] = "SYSTEM_GROUP";
    Atlas_UserGroupHeader_Type["TeamGroup"] = "TEAM_GROUP";
    Atlas_UserGroupHeader_Type["TenantGroup"] = "TENANT_GROUP";
    Atlas_UserGroupHeader_Type["Unknown"] = "UNKNOWN";
})(Atlas_UserGroupHeader_Type || (Atlas_UserGroupHeader_Type = {}));
export var Atlas_UserHeader_State;
(function (Atlas_UserHeader_State) {
    Atlas_UserHeader_State["Active"] = "ACTIVE";
    Atlas_UserHeader_State["Expired"] = "EXPIRED";
    Atlas_UserHeader_State["Inactive"] = "INACTIVE";
    Atlas_UserHeader_State["Locked"] = "LOCKED";
    Atlas_UserHeader_State["Pending"] = "PENDING";
    Atlas_UserHeader_State["Suspended"] = "SUSPENDED";
})(Atlas_UserHeader_State || (Atlas_UserHeader_State = {}));
export var Atlas_UserHeader_Type;
(function (Atlas_UserHeader_Type) {
    Atlas_UserHeader_Type["AdminUser"] = "ADMIN_USER";
    Atlas_UserHeader_Type["LdapUser"] = "LDAP_USER";
    Atlas_UserHeader_Type["LocalUser"] = "LOCAL_USER";
    Atlas_UserHeader_Type["OidcUser"] = "OIDC_USER";
    Atlas_UserHeader_Type["RemoteUser"] = "REMOTE_USER";
    Atlas_UserHeader_Type["SamlUser"] = "SAML_USER";
    Atlas_UserHeader_Type["SuperUser"] = "SUPER_USER";
    Atlas_UserHeader_Type["SystemUser"] = "SYSTEM_USER";
    Atlas_UserHeader_Type["Unknown"] = "UNKNOWN";
})(Atlas_UserHeader_Type || (Atlas_UserHeader_Type = {}));
export var Atlas_UserQuestionHeader_Status;
(function (Atlas_UserQuestionHeader_Status) {
    Atlas_UserQuestionHeader_Status["Resolved"] = "RESOLVED";
    Atlas_UserQuestionHeader_Status["Unresolved"] = "UNRESOLVED";
})(Atlas_UserQuestionHeader_Status || (Atlas_UserQuestionHeader_Status = {}));
export var Atlas_Variable_Type;
(function (Atlas_Variable_Type) {
    Atlas_Variable_Type["Global"] = "GLOBAL";
    Atlas_Variable_Type["System"] = "SYSTEM";
})(Atlas_Variable_Type || (Atlas_Variable_Type = {}));
export var Atlas_VisualizationColumn_Sort_Order;
(function (Atlas_VisualizationColumn_Sort_Order) {
    Atlas_VisualizationColumn_Sort_Order["SortAscending"] = "SORT_ASCENDING";
    Atlas_VisualizationColumn_Sort_Order["SortDescending"] = "SORT_DESCENDING";
})(Atlas_VisualizationColumn_Sort_Order || (Atlas_VisualizationColumn_Sort_Order = {}));
export var Atlas_VisualizationHeader_Type;
(function (Atlas_VisualizationHeader_Type) {
    Atlas_VisualizationHeader_Type["ChartViz"] = "CHART_VIZ";
    Atlas_VisualizationHeader_Type["ClusterViz"] = "CLUSTER_VIZ";
    Atlas_VisualizationHeader_Type["FilterViz"] = "FILTER_VIZ";
    Atlas_VisualizationHeader_Type["GenericViz"] = "GENERIC_VIZ";
    Atlas_VisualizationHeader_Type["HeadlineViz"] = "HEADLINE_VIZ";
    Atlas_VisualizationHeader_Type["PinboardViz"] = "PINBOARD_VIZ";
    Atlas_VisualizationHeader_Type["RAnalysisViz"] = "R_ANALYSIS_VIZ";
    Atlas_VisualizationHeader_Type["TableViz"] = "TABLE_VIZ";
})(Atlas_VisualizationHeader_Type || (Atlas_VisualizationHeader_Type = {}));
export var Atlas_WorksheetType_E;
(function (Atlas_WorksheetType_E) {
    Atlas_WorksheetType_E["Container"] = "CONTAINER";
    Atlas_WorksheetType_E["View"] = "VIEW";
})(Atlas_WorksheetType_E || (Atlas_WorksheetType_E = {}));
export var Atlas_WorksheetVersion_E;
(function (Atlas_WorksheetVersion_E) {
    Atlas_WorksheetVersion_E["V1"] = "V1";
    Atlas_WorksheetVersion_E["V2"] = "V2";
})(Atlas_WorksheetVersion_E || (Atlas_WorksheetVersion_E = {}));
export var Bach_AiContext_Source_E;
(function (Bach_AiContext_Source_E) {
    Bach_AiContext_Source_E["Copilot"] = "COPILOT";
    Bach_AiContext_Source_E["Nls"] = "NLS";
})(Bach_AiContext_Source_E || (Bach_AiContext_Source_E = {}));
export var Bach_BachRequest_RequestClass_E;
(function (Bach_BachRequest_RequestClass_E) {
    Bach_BachRequest_RequestClass_E["Answer"] = "ANSWER";
    Bach_BachRequest_RequestClass_E["LogicalTable"] = "LOGICAL_TABLE";
    Bach_BachRequest_RequestClass_E["SqlAnswer"] = "SQL_ANSWER";
    Bach_BachRequest_RequestClass_E["UnaggregatedAnswer"] = "UNAGGREGATED_ANSWER";
    Bach_BachRequest_RequestClass_E["UniversalSearch"] = "UNIVERSAL_SEARCH";
    Bach_BachRequest_RequestClass_E["VizSnapshot"] = "VIZ_SNAPSHOT";
    Bach_BachRequest_RequestClass_E["Worksheet"] = "WORKSHEET";
})(Bach_BachRequest_RequestClass_E || (Bach_BachRequest_RequestClass_E = {}));
export var Bach_ObjectType_E;
(function (Bach_ObjectType_E) {
    Bach_ObjectType_E["Answer"] = "ANSWER";
    Bach_ObjectType_E["Column"] = "COLUMN";
    Bach_ObjectType_E["Connection"] = "CONNECTION";
    Bach_ObjectType_E["Filter"] = "FILTER";
    Bach_ObjectType_E["Formula"] = "FORMULA";
    Bach_ObjectType_E["Insight"] = "INSIGHT";
    Bach_ObjectType_E["Pinboard"] = "PINBOARD";
    Bach_ObjectType_E["Relationship"] = "RELATIONSHIP";
    Bach_ObjectType_E["Table"] = "TABLE";
})(Bach_ObjectType_E || (Bach_ObjectType_E = {}));
export var Bach_Status_Class_E;
(function (Bach_Status_Class_E) {
    Bach_Status_Class_E["Error"] = "ERROR";
    Bach_Status_Class_E["Ok"] = "OK";
    Bach_Status_Class_E["PartiallyExecuted"] = "PARTIALLY_EXECUTED";
})(Bach_Status_Class_E || (Bach_Status_Class_E = {}));
export var Bach_Status_ErrorDetail_Source_E;
(function (Bach_Status_ErrorDetail_Source_E) {
    Bach_Status_ErrorDetail_Source_E["Callosum"] = "CALLOSUM";
    Bach_Status_ErrorDetail_Source_E["Sage"] = "SAGE";
})(Bach_Status_ErrorDetail_Source_E || (Bach_Status_ErrorDetail_Source_E = {}));
export var Bach_Value_Type;
(function (Bach_Value_Type) {
    Bach_Value_Type["Bool"] = "BOOL";
    Bach_Value_Type["Char"] = "CHAR";
    Bach_Value_Type["Date"] = "DATE";
    Bach_Value_Type["Double"] = "DOUBLE";
    Bach_Value_Type["Int"] = "INT";
    Bach_Value_Type["Unknown"] = "UNKNOWN";
})(Bach_Value_Type || (Bach_Value_Type = {}));
export var Bach_Answer_AnswerContext_E;
(function (Bach_Answer_AnswerContext_E) {
    Bach_Answer_AnswerContext_E["ChangeAnalysis"] = "CHANGE_ANALYSIS";
    Bach_Answer_AnswerContext_E["CohortAnswer"] = "COHORT_ANSWER";
    Bach_Answer_AnswerContext_E["DownloadAnswer"] = "DOWNLOAD_ANSWER";
    Bach_Answer_AnswerContext_E["EditPinboardViz"] = "EDIT_PINBOARD_VIZ";
    Bach_Answer_AnswerContext_E["ExploreAnswer"] = "EXPLORE_ANSWER";
    Bach_Answer_AnswerContext_E["KpiMonitor"] = "KPI_MONITOR";
    Bach_Answer_AnswerContext_E["NewAnswer"] = "NEW_ANSWER";
    Bach_Answer_AnswerContext_E["PinboardViz"] = "PINBOARD_VIZ";
    Bach_Answer_AnswerContext_E["SavedAnswer"] = "SAVED_ANSWER";
    Bach_Answer_AnswerContext_E["SpotterNewAnswer"] = "SPOTTER_NEW_ANSWER";
    Bach_Answer_AnswerContext_E["SpotIq"] = "SPOT_IQ";
    Bach_Answer_AnswerContext_E["UnaggregatedAnswer"] = "UNAGGREGATED_ANSWER";
    Bach_Answer_AnswerContext_E["View"] = "VIEW";
})(Bach_Answer_AnswerContext_E || (Bach_Answer_AnswerContext_E = {}));
export var Bach_Answer_AnswerRequest_Type;
(function (Bach_Answer_AnswerRequest_Type) {
    Bach_Answer_AnswerRequest_Type["A3AnalysisSubmission"] = "A3_ANALYSIS_SUBMISSION";
    Bach_Answer_AnswerRequest_Type["A3AnalysisSync"] = "A3_ANALYSIS_SYNC";
    Bach_Answer_AnswerRequest_Type["A3AnalysisSyncFlex"] = "A3_ANALYSIS_SYNC_FLEX";
    Bach_Answer_AnswerRequest_Type["AddColumn"] = "ADD_COLUMN";
    Bach_Answer_AnswerRequest_Type["AddFilter"] = "ADD_FILTER";
    Bach_Answer_AnswerRequest_Type["AddFormula"] = "ADD_FORMULA";
    Bach_Answer_AnswerRequest_Type["AddVizToPinboard"] = "ADD_VIZ_TO_PINBOARD";
    Bach_Answer_AnswerRequest_Type["ApplyExploreSuggestion"] = "APPLY_EXPLORE_SUGGESTION";
    Bach_Answer_AnswerRequest_Type["AskExpert"] = "ASK_EXPERT";
    Bach_Answer_AnswerRequest_Type["ClearAnswer"] = "CLEAR_ANSWER";
    Bach_Answer_AnswerRequest_Type["CopyAnswer"] = "COPY_ANSWER";
    Bach_Answer_AnswerRequest_Type["CreateAnswer"] = "CREATE_ANSWER";
    Bach_Answer_AnswerRequest_Type["CreateWhatIfRequest"] = "CREATE_WHAT_IF_REQUEST";
    Bach_Answer_AnswerRequest_Type["DrillDown"] = "DRILL_DOWN";
    Bach_Answer_AnswerRequest_Type["FormulaSearch"] = "FORMULA_SEARCH";
    Bach_Answer_AnswerRequest_Type["GetA3AnalysisColumns"] = "GET_A3_ANALYSIS_COLUMNS";
    Bach_Answer_AnswerRequest_Type["GetAcContext"] = "GET_AC_CONTEXT";
    Bach_Answer_AnswerRequest_Type["GetAnswerFromTokens"] = "GET_ANSWER_FROM_TOKENS";
    Bach_Answer_AnswerRequest_Type["GetAnswerModel"] = "GET_ANSWER_MODEL";
    Bach_Answer_AnswerRequest_Type["GetAnswerSpec"] = "GET_ANSWER_SPEC";
    Bach_Answer_AnswerRequest_Type["GetCohortDependencies"] = "GET_COHORT_DEPENDENCIES";
    Bach_Answer_AnswerRequest_Type["GetCohortDetails"] = "GET_COHORT_DETAILS";
    Bach_Answer_AnswerRequest_Type["GetColumnValues"] = "GET_COLUMN_VALUES";
    Bach_Answer_AnswerRequest_Type["GetDataSources"] = "GET_DATA_SOURCES";
    Bach_Answer_AnswerRequest_Type["GetDateFilterPreview"] = "GET_DATE_FILTER_PREVIEW";
    Bach_Answer_AnswerRequest_Type["GetDrillDownColumns"] = "GET_DRILL_DOWN_COLUMNS";
    Bach_Answer_AnswerRequest_Type["GetExploreSuggestions"] = "GET_EXPLORE_SUGGESTIONS";
    Bach_Answer_AnswerRequest_Type["GetFormulaMetadata"] = "GET_FORMULA_METADATA";
    Bach_Answer_AnswerRequest_Type["GetInsightData"] = "GET_INSIGHT_DATA";
    Bach_Answer_AnswerRequest_Type["GetInScopeParameters"] = "GET_IN_SCOPE_PARAMETERS";
    Bach_Answer_AnswerRequest_Type["GetNaturalLanguageQuery"] = "GET_NATURAL_LANGUAGE_QUERY";
    Bach_Answer_AnswerRequest_Type["GetParameterDependencies"] = "GET_PARAMETER_DEPENDENCIES";
    Bach_Answer_AnswerRequest_Type["GetPermissions"] = "GET_PERMISSIONS";
    Bach_Answer_AnswerRequest_Type["GetQueryParameters"] = "GET_QUERY_PARAMETERS";
    Bach_Answer_AnswerRequest_Type["GetQueryViewerSpec"] = "GET_QUERY_VIEWER_SPEC";
    Bach_Answer_AnswerRequest_Type["GetRelatedInsights"] = "GET_RELATED_INSIGHTS";
    Bach_Answer_AnswerRequest_Type["GetSageToSqlQuery"] = "GET_SAGE_TO_SQL_QUERY";
    Bach_Answer_AnswerRequest_Type["GetTml"] = "GET_TML";
    Bach_Answer_AnswerRequest_Type["GetTokens"] = "GET_TOKENS";
    Bach_Answer_AnswerRequest_Type["GetUnaggregatedAnswer"] = "GET_UNAGGREGATED_ANSWER";
    Bach_Answer_AnswerRequest_Type["GetVizData"] = "GET_VIZ_DATA";
    Bach_Answer_AnswerRequest_Type["IncludeOrExcludeValues"] = "INCLUDE_OR_EXCLUDE_VALUES";
    Bach_Answer_AnswerRequest_Type["LoadAnswer"] = "LOAD_ANSWER";
    Bach_Answer_AnswerRequest_Type["RefreshAnswer"] = "REFRESH_ANSWER";
    Bach_Answer_AnswerRequest_Type["RemoveCohort"] = "REMOVE_COHORT";
    Bach_Answer_AnswerRequest_Type["RemoveColumn"] = "REMOVE_COLUMN";
    Bach_Answer_AnswerRequest_Type["RemoveFilter"] = "REMOVE_FILTER";
    Bach_Answer_AnswerRequest_Type["RemoveFormula"] = "REMOVE_FORMULA";
    Bach_Answer_AnswerRequest_Type["RemoveParameter"] = "REMOVE_PARAMETER";
    Bach_Answer_AnswerRequest_Type["RemoveParameterOverrideValue"] = "REMOVE_PARAMETER_OVERRIDE_VALUE";
    Bach_Answer_AnswerRequest_Type["SaveAnswer"] = "SAVE_ANSWER";
    Bach_Answer_AnswerRequest_Type["SaveAsView"] = "SAVE_AS_VIEW";
    Bach_Answer_AnswerRequest_Type["SaveCohort"] = "SAVE_COHORT";
    Bach_Answer_AnswerRequest_Type["SaveFormula"] = "SAVE_FORMULA";
    Bach_Answer_AnswerRequest_Type["SaveParameter"] = "SAVE_PARAMETER";
    Bach_Answer_AnswerRequest_Type["Search"] = "SEARCH";
    Bach_Answer_AnswerRequest_Type["SetAcContext"] = "SET_AC_CONTEXT";
    Bach_Answer_AnswerRequest_Type["SetCcaColumnConfig"] = "SET_CCA_COLUMN_CONFIG";
    Bach_Answer_AnswerRequest_Type["SetParameterOverrideValue"] = "SET_PARAMETER_OVERRIDE_VALUE";
    Bach_Answer_AnswerRequest_Type["SetReportBook"] = "SET_REPORT_BOOK";
    Bach_Answer_AnswerRequest_Type["UpdateAnswerClientState"] = "UPDATE_ANSWER_CLIENT_STATE";
    Bach_Answer_AnswerRequest_Type["UpdateAnswerColumnClientState"] = "UPDATE_ANSWER_COLUMN_CLIENT_STATE";
    Bach_Answer_AnswerRequest_Type["UpdateAnswerProperties"] = "UPDATE_ANSWER_PROPERTIES";
    Bach_Answer_AnswerRequest_Type["UpdateChartClientState"] = "UPDATE_CHART_CLIENT_STATE";
    Bach_Answer_AnswerRequest_Type["UpdateChartConfig"] = "UPDATE_CHART_CONFIG";
    Bach_Answer_AnswerRequest_Type["UpdateColumn"] = "UPDATE_COLUMN";
    Bach_Answer_AnswerRequest_Type["UpdateCustomVisualProps"] = "UPDATE_CUSTOM_VISUAL_PROPS";
    Bach_Answer_AnswerRequest_Type["UpdateFilter"] = "UPDATE_FILTER";
    Bach_Answer_AnswerRequest_Type["UpdateFilterLayout"] = "UPDATE_FILTER_LAYOUT";
    Bach_Answer_AnswerRequest_Type["UpdateFormula"] = "UPDATE_FORMULA";
    Bach_Answer_AnswerRequest_Type["UpdateHeadlineAggregation"] = "UPDATE_HEADLINE_AGGREGATION";
    Bach_Answer_AnswerRequest_Type["UpdateHeadlineColumns"] = "UPDATE_HEADLINE_COLUMNS";
    Bach_Answer_AnswerRequest_Type["UpdateSelectedSources"] = "UPDATE_SELECTED_SOURCES";
    Bach_Answer_AnswerRequest_Type["UpdateSort"] = "UPDATE_SORT";
    Bach_Answer_AnswerRequest_Type["UpdateView"] = "UPDATE_VIEW";
    Bach_Answer_AnswerRequest_Type["UpdateVizClientState"] = "UPDATE_VIZ_CLIENT_STATE";
})(Bach_Answer_AnswerRequest_Type || (Bach_Answer_AnswerRequest_Type = {}));
export var Bach_Answer_DataRequestParams_DataSourceType;
(function (Bach_Answer_DataRequestParams_DataSourceType) {
    Bach_Answer_DataRequestParams_DataSourceType["Default"] = "DEFAULT";
    Bach_Answer_DataRequestParams_DataSourceType["Falcon"] = "FALCON";
    Bach_Answer_DataRequestParams_DataSourceType["Live"] = "LIVE";
})(Bach_Answer_DataRequestParams_DataSourceType || (Bach_Answer_DataRequestParams_DataSourceType = {}));
export var Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType;
(function (Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType) {
    Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType["Current"] = "CURRENT";
    Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType["Previous"] = "PREVIOUS";
})(Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType || (Bach_Answer_DataRequestParams_SinglePointKpiParams_ComparisonType = {}));
export var Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type;
(function (Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type) {
    Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type["Attribute"] = "ATTRIBUTE";
    Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type["Measure"] = "MEASURE";
})(Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type || (Bach_Answer_GetA3AnalysisColumnsResponse_Column_Type = {}));
export var Bach_Answer_IncludeOrExcludeValuesRequest_Type;
(function (Bach_Answer_IncludeOrExcludeValuesRequest_Type) {
    Bach_Answer_IncludeOrExcludeValuesRequest_Type["Exclude"] = "EXCLUDE";
    Bach_Answer_IncludeOrExcludeValuesRequest_Type["OnlyInclude"] = "ONLY_INCLUDE";
})(Bach_Answer_IncludeOrExcludeValuesRequest_Type || (Bach_Answer_IncludeOrExcludeValuesRequest_Type = {}));
export var Bach_Answer_InsightData_InferenceStatus_Status;
(function (Bach_Answer_InsightData_InferenceStatus_Status) {
    Bach_Answer_InsightData_InferenceStatus_Status["Done"] = "DONE";
    Bach_Answer_InsightData_InferenceStatus_Status["Error"] = "ERROR";
    Bach_Answer_InsightData_InferenceStatus_Status["Pending"] = "PENDING";
})(Bach_Answer_InsightData_InferenceStatus_Status || (Bach_Answer_InsightData_InferenceStatus_Status = {}));
export var Bach_Answer_KpiTuple_TupleType;
(function (Bach_Answer_KpiTuple_TupleType) {
    Bach_Answer_KpiTuple_TupleType["ChartAggregatedVal"] = "CHART_AGGREGATED_VAL";
    Bach_Answer_KpiTuple_TupleType["Current"] = "CURRENT";
    Bach_Answer_KpiTuple_TupleType["Custom"] = "CUSTOM";
    Bach_Answer_KpiTuple_TupleType["LastAvailable"] = "LAST_AVAILABLE";
    Bach_Answer_KpiTuple_TupleType["PreviousChartAggregatedVal"] = "PREVIOUS_CHART_AGGREGATED_VAL";
    Bach_Answer_KpiTuple_TupleType["PrevAvailable"] = "PREV_AVAILABLE";
    Bach_Answer_KpiTuple_TupleType["PrevDay"] = "PREV_DAY";
    Bach_Answer_KpiTuple_TupleType["PrevHour"] = "PREV_HOUR";
    Bach_Answer_KpiTuple_TupleType["PrevMonth"] = "PREV_MONTH";
    Bach_Answer_KpiTuple_TupleType["PrevQuarter"] = "PREV_QUARTER";
    Bach_Answer_KpiTuple_TupleType["PrevWeek"] = "PREV_WEEK";
    Bach_Answer_KpiTuple_TupleType["PrevYear"] = "PREV_YEAR";
    Bach_Answer_KpiTuple_TupleType["SinglePointKpiCurrent"] = "SINGLE_POINT_KPI_CURRENT";
    Bach_Answer_KpiTuple_TupleType["SinglePointKpiPrevious"] = "SINGLE_POINT_KPI_PREVIOUS";
})(Bach_Answer_KpiTuple_TupleType || (Bach_Answer_KpiTuple_TupleType = {}));
export var Bach_Answer_SortType_E;
(function (Bach_Answer_SortType_E) {
    Bach_Answer_SortType_E["Ascending"] = "ASCENDING";
    Bach_Answer_SortType_E["Descending"] = "DESCENDING";
    Bach_Answer_SortType_E["Unknown"] = "UNKNOWN";
})(Bach_Answer_SortType_E || (Bach_Answer_SortType_E = {}));
export var Bach_Answer_Visualization_Type;
(function (Bach_Answer_Visualization_Type) {
    Bach_Answer_Visualization_Type["Chart"] = "CHART";
    Bach_Answer_Visualization_Type["Headline"] = "HEADLINE";
    Bach_Answer_Visualization_Type["RAnalysis"] = "R_ANALYSIS";
    Bach_Answer_Visualization_Type["Table"] = "TABLE";
})(Bach_Answer_Visualization_Type || (Bach_Answer_Visualization_Type = {}));
export var Blink_NumberFormatConfig_FormatConfig_CategoryType;
(function (Blink_NumberFormatConfig_FormatConfig_CategoryType) {
    Blink_NumberFormatConfig_FormatConfig_CategoryType["Currency"] = "CURRENCY";
    Blink_NumberFormatConfig_FormatConfig_CategoryType["Custom"] = "CUSTOM";
    Blink_NumberFormatConfig_FormatConfig_CategoryType["Number"] = "NUMBER";
    Blink_NumberFormatConfig_FormatConfig_CategoryType["Percentage"] = "PERCENTAGE";
})(Blink_NumberFormatConfig_FormatConfig_CategoryType || (Blink_NumberFormatConfig_FormatConfig_CategoryType = {}));
export var Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat;
(function (Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat) {
    Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat["BracesNodash"] = "BRACES_NODASH";
    Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat["PrefixDash"] = "PREFIX_DASH";
    Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat["SuffixDash"] = "SUFFIX_DASH";
})(Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat || (Blink_NumberFormatConfig_FormatConfig_NegativeValueFormat = {}));
export var Blink_NumberFormatConfig_FormatConfig_Unit;
(function (Blink_NumberFormatConfig_FormatConfig_Unit) {
    Blink_NumberFormatConfig_FormatConfig_Unit["Auto"] = "AUTO";
    Blink_NumberFormatConfig_FormatConfig_Unit["Billion"] = "BILLION";
    Blink_NumberFormatConfig_FormatConfig_Unit["Million"] = "MILLION";
    Blink_NumberFormatConfig_FormatConfig_Unit["None"] = "NONE";
    Blink_NumberFormatConfig_FormatConfig_Unit["Thousands"] = "THOUSANDS";
    Blink_NumberFormatConfig_FormatConfig_Unit["Trillion"] = "TRILLION";
})(Blink_NumberFormatConfig_FormatConfig_Unit || (Blink_NumberFormatConfig_FormatConfig_Unit = {}));
export var Callosum_ActionOnAnalysesRequest_Action;
(function (Callosum_ActionOnAnalysesRequest_Action) {
    Callosum_ActionOnAnalysesRequest_Action["Delete"] = "DELETE";
    Callosum_ActionOnAnalysesRequest_Action["Save"] = "SAVE";
})(Callosum_ActionOnAnalysesRequest_Action || (Callosum_ActionOnAnalysesRequest_Action = {}));
export var Callosum_ActionOnAnalysesResponse_Status;
(function (Callosum_ActionOnAnalysesResponse_Status) {
    Callosum_ActionOnAnalysesResponse_Status["Done"] = "DONE";
    Callosum_ActionOnAnalysesResponse_Status["Failed"] = "FAILED";
})(Callosum_ActionOnAnalysesResponse_Status || (Callosum_ActionOnAnalysesResponse_Status = {}));
export var Callosum_AggregateFunctionTypeEnumProto_E;
(function (Callosum_AggregateFunctionTypeEnumProto_E) {
    Callosum_AggregateFunctionTypeEnumProto_E["Aggregate"] = "AGGREGATE";
    Callosum_AggregateFunctionTypeEnumProto_E["AggrDistinct"] = "AGGR_DISTINCT";
    Callosum_AggregateFunctionTypeEnumProto_E["ApproxAggrDistinct"] = "APPROX_AGGR_DISTINCT";
    Callosum_AggregateFunctionTypeEnumProto_E["ApproxAggrDistinctMerge"] = "APPROX_AGGR_DISTINCT_MERGE";
    Callosum_AggregateFunctionTypeEnumProto_E["ApproxCountDistinct"] = "APPROX_COUNT_DISTINCT";
    Callosum_AggregateFunctionTypeEnumProto_E["Average"] = "AVERAGE";
    Callosum_AggregateFunctionTypeEnumProto_E["Count"] = "COUNT";
    Callosum_AggregateFunctionTypeEnumProto_E["CountDistinct"] = "COUNT_DISTINCT";
    Callosum_AggregateFunctionTypeEnumProto_E["Growth"] = "GROWTH";
    Callosum_AggregateFunctionTypeEnumProto_E["Max"] = "MAX";
    Callosum_AggregateFunctionTypeEnumProto_E["Median"] = "MEDIAN";
    Callosum_AggregateFunctionTypeEnumProto_E["Min"] = "MIN";
    Callosum_AggregateFunctionTypeEnumProto_E["None"] = "NONE";
    Callosum_AggregateFunctionTypeEnumProto_E["Percentile"] = "PERCENTILE";
    Callosum_AggregateFunctionTypeEnumProto_E["Rank"] = "RANK";
    Callosum_AggregateFunctionTypeEnumProto_E["RankPercentile"] = "RANK_PERCENTILE";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlBoolAggregateOp"] = "SQL_BOOL_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlDateAggregateOp"] = "SQL_DATE_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlDateTimeAggregateOp"] = "SQL_DATE_TIME_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlDoubleAggregateOp"] = "SQL_DOUBLE_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlIntAggregateOp"] = "SQL_INT_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlStringAggregateOp"] = "SQL_STRING_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["SqlTimeAggregateOp"] = "SQL_TIME_AGGREGATE_OP";
    Callosum_AggregateFunctionTypeEnumProto_E["StdDeviation"] = "STD_DEVIATION";
    Callosum_AggregateFunctionTypeEnumProto_E["Sum"] = "SUM";
    Callosum_AggregateFunctionTypeEnumProto_E["TableAggr"] = "TABLE_AGGR";
    Callosum_AggregateFunctionTypeEnumProto_E["Variance"] = "VARIANCE";
})(Callosum_AggregateFunctionTypeEnumProto_E || (Callosum_AggregateFunctionTypeEnumProto_E = {}));
export var Callosum_AggregationType_E;
(function (Callosum_AggregationType_E) {
    Callosum_AggregationType_E["Average"] = "AVERAGE";
    Callosum_AggregationType_E["Count"] = "COUNT";
    Callosum_AggregationType_E["Max"] = "MAX";
    Callosum_AggregationType_E["Min"] = "MIN";
    Callosum_AggregationType_E["None"] = "NONE";
    Callosum_AggregationType_E["StdDeviation"] = "STD_DEVIATION";
    Callosum_AggregationType_E["Sum"] = "SUM";
    Callosum_AggregationType_E["UniqueCount"] = "UNIQUE_COUNT";
    Callosum_AggregationType_E["Variance"] = "VARIANCE";
})(Callosum_AggregationType_E || (Callosum_AggregationType_E = {}));
export var Callosum_AnalysisJobRunsResponse_Status;
(function (Callosum_AnalysisJobRunsResponse_Status) {
    Callosum_AnalysisJobRunsResponse_Status["Default"] = "DEFAULT";
    Callosum_AnalysisJobRunsResponse_Status["Done"] = "DONE";
    Callosum_AnalysisJobRunsResponse_Status["Failed"] = "FAILED";
    Callosum_AnalysisJobRunsResponse_Status["NoInterestingInsights"] = "NO_INTERESTING_INSIGHTS";
    Callosum_AnalysisJobRunsResponse_Status["ResultExpired"] = "RESULT_EXPIRED";
    Callosum_AnalysisJobRunsResponse_Status["Running"] = "RUNNING";
})(Callosum_AnalysisJobRunsResponse_Status || (Callosum_AnalysisJobRunsResponse_Status = {}));
export var Callosum_AnalysisState;
(function (Callosum_AnalysisState) {
    Callosum_AnalysisState["Completed"] = "COMPLETED";
    Callosum_AnalysisState["Failed"] = "FAILED";
    Callosum_AnalysisState["NoInsights"] = "NO_INSIGHTS";
    Callosum_AnalysisState["Paused"] = "PAUSED";
    Callosum_AnalysisState["Running"] = "RUNNING";
    Callosum_AnalysisState["Scheduled"] = "SCHEDULED";
})(Callosum_AnalysisState || (Callosum_AnalysisState = {}));
export var Callosum_ClientPlatformType_E;
(function (Callosum_ClientPlatformType_E) {
    Callosum_ClientPlatformType_E["Android"] = "ANDROID";
    Callosum_ClientPlatformType_E["BrowserChrome"] = "BROWSER_CHROME";
    Callosum_ClientPlatformType_E["BrowserEdge"] = "BROWSER_EDGE";
    Callosum_ClientPlatformType_E["BrowserSafari"] = "BROWSER_SAFARI";
    Callosum_ClientPlatformType_E["Ios"] = "IOS";
    Callosum_ClientPlatformType_E["Macos"] = "MACOS";
    Callosum_ClientPlatformType_E["Windows"] = "WINDOWS";
})(Callosum_ClientPlatformType_E || (Callosum_ClientPlatformType_E = {}));
export var Callosum_ClientType_E;
(function (Callosum_ClientType_E) {
    Callosum_ClientType_E["Blink"] = "BLINK";
    Callosum_ClientType_E["BlinkV2"] = "BLINK_V2";
    Callosum_ClientType_E["FullEmbed"] = "FULL_EMBED";
    Callosum_ClientType_E["Mobile"] = "MOBILE";
    Callosum_ClientType_E["PublicApiDirect"] = "PUBLIC_API_DIRECT";
})(Callosum_ClientType_E || (Callosum_ClientType_E = {}));
export var Callosum_CohortConfig_Version;
(function (Callosum_CohortConfig_Version) {
    Callosum_CohortConfig_Version["V1"] = "V1";
})(Callosum_CohortConfig_Version || (Callosum_CohortConfig_Version = {}));
export var Callosum_CohortGroupingType_E;
(function (Callosum_CohortGroupingType_E) {
    Callosum_CohortGroupingType_E["BinBased"] = "BIN_BASED";
    Callosum_CohortGroupingType_E["ColumnBased"] = "COLUMN_BASED";
    Callosum_CohortGroupingType_E["GroupBased"] = "GROUP_BASED";
})(Callosum_CohortGroupingType_E || (Callosum_CohortGroupingType_E = {}));
export var Callosum_CohortType_E;
(function (Callosum_CohortType_E) {
    Callosum_CohortType_E["Advanced"] = "ADVANCED";
    Callosum_CohortType_E["BinBased"] = "BIN_BASED";
    Callosum_CohortType_E["ColumnBased"] = "COLUMN_BASED";
    Callosum_CohortType_E["GroupBased"] = "GROUP_BASED";
    Callosum_CohortType_E["Simple"] = "SIMPLE";
})(Callosum_CohortType_E || (Callosum_CohortType_E = {}));
export var Callosum_ColumnDataTypeEnumProto_E;
(function (Callosum_ColumnDataTypeEnumProto_E) {
    Callosum_ColumnDataTypeEnumProto_E["Bool"] = "BOOL";
    Callosum_ColumnDataTypeEnumProto_E["Char"] = "CHAR";
    Callosum_ColumnDataTypeEnumProto_E["Date"] = "DATE";
    Callosum_ColumnDataTypeEnumProto_E["DateNum"] = "DATE_NUM";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsDay"] = "DATE_NUM_ABS_DAY";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsHour"] = "DATE_NUM_ABS_HOUR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsMonth"] = "DATE_NUM_ABS_MONTH";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsQuarter"] = "DATE_NUM_ABS_QUARTER";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsWeek"] = "DATE_NUM_ABS_WEEK";
    Callosum_ColumnDataTypeEnumProto_E["DateNumAbsYear"] = "DATE_NUM_ABS_YEAR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumDayInMonth"] = "DATE_NUM_DAY_IN_MONTH";
    Callosum_ColumnDataTypeEnumProto_E["DateNumDayInQuarter"] = "DATE_NUM_DAY_IN_QUARTER";
    Callosum_ColumnDataTypeEnumProto_E["DateNumDayInYear"] = "DATE_NUM_DAY_IN_YEAR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumDayOfWeek"] = "DATE_NUM_DAY_OF_WEEK";
    Callosum_ColumnDataTypeEnumProto_E["DateNumDayOfWeekStr"] = "DATE_NUM_DAY_OF_WEEK_STR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumHourInDay"] = "DATE_NUM_HOUR_IN_DAY";
    Callosum_ColumnDataTypeEnumProto_E["DateNumMonthInQuarter"] = "DATE_NUM_MONTH_IN_QUARTER";
    Callosum_ColumnDataTypeEnumProto_E["DateNumMonthInYear"] = "DATE_NUM_MONTH_IN_YEAR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumQuarterInYear"] = "DATE_NUM_QUARTER_IN_YEAR";
    Callosum_ColumnDataTypeEnumProto_E["DateNumSecInDay"] = "DATE_NUM_SEC_IN_DAY";
    Callosum_ColumnDataTypeEnumProto_E["DateNumWeekInMonth"] = "DATE_NUM_WEEK_IN_MONTH";
    Callosum_ColumnDataTypeEnumProto_E["DateNumWeekInQuarter"] = "DATE_NUM_WEEK_IN_QUARTER";
    Callosum_ColumnDataTypeEnumProto_E["DateNumWeekInYear"] = "DATE_NUM_WEEK_IN_YEAR";
    Callosum_ColumnDataTypeEnumProto_E["DateTime"] = "DATE_TIME";
    Callosum_ColumnDataTypeEnumProto_E["Double"] = "DOUBLE";
    Callosum_ColumnDataTypeEnumProto_E["Float"] = "FLOAT";
    Callosum_ColumnDataTypeEnumProto_E["Int32"] = "INT32";
    Callosum_ColumnDataTypeEnumProto_E["Int64"] = "INT64";
    Callosum_ColumnDataTypeEnumProto_E["List"] = "LIST";
    Callosum_ColumnDataTypeEnumProto_E["ListBool"] = "LIST_BOOL";
    Callosum_ColumnDataTypeEnumProto_E["ListDate"] = "LIST_DATE";
    Callosum_ColumnDataTypeEnumProto_E["ListDateTime"] = "LIST_DATE_TIME";
    Callosum_ColumnDataTypeEnumProto_E["ListDouble"] = "LIST_DOUBLE";
    Callosum_ColumnDataTypeEnumProto_E["ListInt"] = "LIST_INT";
    Callosum_ColumnDataTypeEnumProto_E["ListString"] = "LIST_STRING";
    Callosum_ColumnDataTypeEnumProto_E["ListTime"] = "LIST_TIME";
    Callosum_ColumnDataTypeEnumProto_E["Time"] = "TIME";
    Callosum_ColumnDataTypeEnumProto_E["Unknown"] = "UNKNOWN";
    Callosum_ColumnDataTypeEnumProto_E["Varchar"] = "VARCHAR";
})(Callosum_ColumnDataTypeEnumProto_E || (Callosum_ColumnDataTypeEnumProto_E = {}));
export var Callosum_ColumnSpotiqPreferenceProto_E;
(function (Callosum_ColumnSpotiqPreferenceProto_E) {
    Callosum_ColumnSpotiqPreferenceProto_E["Default"] = "DEFAULT";
    Callosum_ColumnSpotiqPreferenceProto_E["Exclude"] = "EXCLUDE";
})(Callosum_ColumnSpotiqPreferenceProto_E || (Callosum_ColumnSpotiqPreferenceProto_E = {}));
export var Callosum_ColumnType_E;
(function (Callosum_ColumnType_E) {
    Callosum_ColumnType_E["Attribute"] = "ATTRIBUTE";
    Callosum_ColumnType_E["Measure"] = "MEASURE";
    Callosum_ColumnType_E["Unknown"] = "UNKNOWN";
})(Callosum_ColumnType_E || (Callosum_ColumnType_E = {}));
export var Callosum_ComparisonOperator_E;
(function (Callosum_ComparisonOperator_E) {
    Callosum_ComparisonOperator_E["BeginsWith"] = "BEGINS_WITH";
    Callosum_ComparisonOperator_E["Bw"] = "BW";
    Callosum_ComparisonOperator_E["Contains"] = "CONTAINS";
    Callosum_ComparisonOperator_E["EndsWith"] = "ENDS_WITH";
    Callosum_ComparisonOperator_E["Eq"] = "EQ";
    Callosum_ComparisonOperator_E["Ge"] = "GE";
    Callosum_ComparisonOperator_E["Gt"] = "GT";
    Callosum_ComparisonOperator_E["Le"] = "LE";
    Callosum_ComparisonOperator_E["Lt"] = "LT";
    Callosum_ComparisonOperator_E["Ne"] = "NE";
    Callosum_ComparisonOperator_E["NotContains"] = "NOT_CONTAINS";
})(Callosum_ComparisonOperator_E || (Callosum_ComparisonOperator_E = {}));
export var Callosum_ConditionCombineType_E;
(function (Callosum_ConditionCombineType_E) {
    Callosum_ConditionCombineType_E["All"] = "ALL";
    Callosum_ConditionCombineType_E["Any"] = "ANY";
})(Callosum_ConditionCombineType_E || (Callosum_ConditionCombineType_E = {}));
export var Callosum_ConditionalFormatMetric_BackgroundFormatTypes;
(function (Callosum_ConditionalFormatMetric_BackgroundFormatTypes) {
    Callosum_ConditionalFormatMetric_BackgroundFormatTypes["Gradient"] = "GRADIENT";
    Callosum_ConditionalFormatMetric_BackgroundFormatTypes["Solid"] = "SOLID";
})(Callosum_ConditionalFormatMetric_BackgroundFormatTypes || (Callosum_ConditionalFormatMetric_BackgroundFormatTypes = {}));
export var Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes;
(function (Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes) {
    Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes["ColumnBased"] = "COLUMN_BASED";
    Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes["ParameterBased"] = "PARAMETER_BASED";
    Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes["ValueBased"] = "VALUE_BASED";
})(Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes || (Callosum_ConditionalFormatMetric_ConditionalFormattingComparisonTypes = {}));
export var Callosum_ConditionalFormatMetric_Operators;
(function (Callosum_ConditionalFormatMetric_Operators) {
    Callosum_ConditionalFormatMetric_Operators["Contains"] = "CONTAINS";
    Callosum_ConditionalFormatMetric_Operators["DoesNotContain"] = "DOES_NOT_CONTAIN";
    Callosum_ConditionalFormatMetric_Operators["EndsWith"] = "ENDS_WITH";
    Callosum_ConditionalFormatMetric_Operators["EqualTo"] = "EQUAL_TO";
    Callosum_ConditionalFormatMetric_Operators["GreaterThan"] = "GREATER_THAN";
    Callosum_ConditionalFormatMetric_Operators["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    Callosum_ConditionalFormatMetric_Operators["Is"] = "IS";
    Callosum_ConditionalFormatMetric_Operators["IsBetween"] = "IS_BETWEEN";
    Callosum_ConditionalFormatMetric_Operators["IsEmpty"] = "IS_EMPTY";
    Callosum_ConditionalFormatMetric_Operators["IsNot"] = "IS_NOT";
    Callosum_ConditionalFormatMetric_Operators["IsNotEmpty"] = "IS_NOT_EMPTY";
    Callosum_ConditionalFormatMetric_Operators["IsNotNull"] = "IS_NOT_NULL";
    Callosum_ConditionalFormatMetric_Operators["IsNull"] = "IS_NULL";
    Callosum_ConditionalFormatMetric_Operators["LessThan"] = "LESS_THAN";
    Callosum_ConditionalFormatMetric_Operators["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    Callosum_ConditionalFormatMetric_Operators["NotEqualTo"] = "NOT_EQUAL_TO";
    Callosum_ConditionalFormatMetric_Operators["StartsWith"] = "STARTS_WITH";
})(Callosum_ConditionalFormatMetric_Operators || (Callosum_ConditionalFormatMetric_Operators = {}));
export var Callosum_DisplayMode;
(function (Callosum_DisplayMode) {
    Callosum_DisplayMode["ChartMode"] = "CHART_MODE";
    Callosum_DisplayMode["RAnalysisMode"] = "R_ANALYSIS_MODE";
    Callosum_DisplayMode["TableMode"] = "TABLE_MODE";
    Callosum_DisplayMode["Undefined"] = "UNDEFINED";
})(Callosum_DisplayMode || (Callosum_DisplayMode = {}));
export var Callosum_DisplayNameLastUpdatedBy_E;
(function (Callosum_DisplayNameLastUpdatedBy_E) {
    Callosum_DisplayNameLastUpdatedBy_E["Admin"] = "ADMIN";
    Callosum_DisplayNameLastUpdatedBy_E["Auto"] = "AUTO";
    Callosum_DisplayNameLastUpdatedBy_E["User"] = "USER";
})(Callosum_DisplayNameLastUpdatedBy_E || (Callosum_DisplayNameLastUpdatedBy_E = {}));
export var Callosum_ExpressionProto_ColumnType;
(function (Callosum_ExpressionProto_ColumnType) {
    Callosum_ExpressionProto_ColumnType["LogicalColumn"] = "LOGICAL_COLUMN";
    Callosum_ExpressionProto_ColumnType["None"] = "NONE";
    Callosum_ExpressionProto_ColumnType["VizColumn"] = "VIZ_COLUMN";
})(Callosum_ExpressionProto_ColumnType || (Callosum_ExpressionProto_ColumnType = {}));
export var Callosum_GeoConfigProto_Type;
(function (Callosum_GeoConfigProto_Type) {
    Callosum_GeoConfigProto_Type["AdminDiv_0"] = "ADMIN_DIV_0";
    Callosum_GeoConfigProto_Type["AdminDiv_1"] = "ADMIN_DIV_1";
    Callosum_GeoConfigProto_Type["AdminDiv_2"] = "ADMIN_DIV_2";
    Callosum_GeoConfigProto_Type["CustomRegion"] = "CUSTOM_REGION";
    Callosum_GeoConfigProto_Type["Latitude"] = "LATITUDE";
    Callosum_GeoConfigProto_Type["Longitude"] = "LONGITUDE";
    Callosum_GeoConfigProto_Type["ZipCode"] = "ZIP_CODE";
})(Callosum_GeoConfigProto_Type || (Callosum_GeoConfigProto_Type = {}));
export var Callosum_GeoTypeEnumProto_E;
(function (Callosum_GeoTypeEnumProto_E) {
    Callosum_GeoTypeEnumProto_E["AreaCode"] = "AREA_CODE";
    Callosum_GeoTypeEnumProto_E["CbsaMsa"] = "CBSA_MSA";
    Callosum_GeoTypeEnumProto_E["City"] = "CITY";
    Callosum_GeoTypeEnumProto_E["CongressionalDistrict"] = "CONGRESSIONAL_DISTRICT";
    Callosum_GeoTypeEnumProto_E["CountryRegion"] = "COUNTRY_REGION";
    Callosum_GeoTypeEnumProto_E["County"] = "COUNTY";
    Callosum_GeoTypeEnumProto_E["Latitude"] = "LATITUDE";
    Callosum_GeoTypeEnumProto_E["Longitude"] = "LONGITUDE";
    Callosum_GeoTypeEnumProto_E["None"] = "NONE";
    Callosum_GeoTypeEnumProto_E["StateProvince"] = "STATE_PROVINCE";
    Callosum_GeoTypeEnumProto_E["ZipCode"] = "ZIP_CODE";
})(Callosum_GeoTypeEnumProto_E || (Callosum_GeoTypeEnumProto_E = {}));
export var Callosum_GetDmQueryForMetricRequest_ObjectType;
(function (Callosum_GetDmQueryForMetricRequest_ObjectType) {
    Callosum_GetDmQueryForMetricRequest_ObjectType["ObjectTypeAcContext"] = "OBJECT_TYPE_AC_CONTEXT";
    Callosum_GetDmQueryForMetricRequest_ObjectType["ObjectTypeAnswer"] = "OBJECT_TYPE_ANSWER";
    Callosum_GetDmQueryForMetricRequest_ObjectType["ObjectTypePinboard"] = "OBJECT_TYPE_PINBOARD";
    Callosum_GetDmQueryForMetricRequest_ObjectType["ObjectTypeUnspecified"] = "OBJECT_TYPE_UNSPECIFIED";
})(Callosum_GetDmQueryForMetricRequest_ObjectType || (Callosum_GetDmQueryForMetricRequest_ObjectType = {}));
export var Callosum_ListAnalysesRequest_SortBy;
(function (Callosum_ListAnalysesRequest_SortBy) {
    Callosum_ListAnalysesRequest_SortBy["ExpiresIn"] = "EXPIRES_IN";
    Callosum_ListAnalysesRequest_SortBy["LastAnalyzed"] = "LAST_ANALYZED";
    Callosum_ListAnalysesRequest_SortBy["Name"] = "NAME";
    Callosum_ListAnalysesRequest_SortBy["Status"] = "STATUS";
    Callosum_ListAnalysesRequest_SortBy["TriggeredBy"] = "TRIGGERED_BY";
})(Callosum_ListAnalysesRequest_SortBy || (Callosum_ListAnalysesRequest_SortBy = {}));
export var Callosum_LogicalColumnProto_ColumnTypeEnumProto;
(function (Callosum_LogicalColumnProto_ColumnTypeEnumProto) {
    Callosum_LogicalColumnProto_ColumnTypeEnumProto["Attribute"] = "ATTRIBUTE";
    Callosum_LogicalColumnProto_ColumnTypeEnumProto["Measure"] = "MEASURE";
    Callosum_LogicalColumnProto_ColumnTypeEnumProto["Unknown"] = "UNKNOWN";
})(Callosum_LogicalColumnProto_ColumnTypeEnumProto || (Callosum_LogicalColumnProto_ColumnTypeEnumProto = {}));
export var Callosum_LogicalRelationshipJoinTypeEnumProto_E;
(function (Callosum_LogicalRelationshipJoinTypeEnumProto_E) {
    Callosum_LogicalRelationshipJoinTypeEnumProto_E["Inner"] = "INNER";
    Callosum_LogicalRelationshipJoinTypeEnumProto_E["LeftOuter"] = "LEFT_OUTER";
    Callosum_LogicalRelationshipJoinTypeEnumProto_E["Outer"] = "OUTER";
    Callosum_LogicalRelationshipJoinTypeEnumProto_E["RightOuter"] = "RIGHT_OUTER";
})(Callosum_LogicalRelationshipJoinTypeEnumProto_E || (Callosum_LogicalRelationshipJoinTypeEnumProto_E = {}));
export var Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto;
(function (Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto) {
    Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto["Generic"] = "GENERIC";
    Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto["PkFk"] = "PK_FK";
    Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto["UserDefined"] = "USER_DEFINED";
})(Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto || (Callosum_LogicalRelationshipProto_LogicalRelationshipTypeEnumProto = {}));
export var Callosum_LogicalTableTypeEnumProto_E;
(function (Callosum_LogicalTableTypeEnumProto_E) {
    Callosum_LogicalTableTypeEnumProto_E["AggrWorksheet"] = "AGGR_WORKSHEET";
    Callosum_LogicalTableTypeEnumProto_E["CalendarTable"] = "CALENDAR_TABLE";
    Callosum_LogicalTableTypeEnumProto_E["DbView"] = "DB_VIEW";
    Callosum_LogicalTableTypeEnumProto_E["MaterializedView"] = "MATERIALIZED_VIEW";
    Callosum_LogicalTableTypeEnumProto_E["OneToOneLogical"] = "ONE_TO_ONE_LOGICAL";
    Callosum_LogicalTableTypeEnumProto_E["PrivateWorksheet"] = "PRIVATE_WORKSHEET";
    Callosum_LogicalTableTypeEnumProto_E["SqlView"] = "SQL_VIEW";
    Callosum_LogicalTableTypeEnumProto_E["UserDefined"] = "USER_DEFINED";
    Callosum_LogicalTableTypeEnumProto_E["Worksheet"] = "WORKSHEET";
})(Callosum_LogicalTableTypeEnumProto_E || (Callosum_LogicalTableTypeEnumProto_E = {}));
export var Callosum_LogicalTableType_E;
(function (Callosum_LogicalTableType_E) {
    Callosum_LogicalTableType_E["OneToOne"] = "ONE_TO_ONE";
    Callosum_LogicalTableType_E["UserTable"] = "USER_TABLE";
    Callosum_LogicalTableType_E["Worksheet"] = "WORKSHEET";
})(Callosum_LogicalTableType_E || (Callosum_LogicalTableType_E = {}));
export var Callosum_MetricDefinitionProto_Action;
(function (Callosum_MetricDefinitionProto_Action) {
    Callosum_MetricDefinitionProto_Action["Alert"] = "ALERT";
    Callosum_MetricDefinitionProto_Action["Email"] = "EMAIL";
    Callosum_MetricDefinitionProto_Action["None"] = "NONE";
})(Callosum_MetricDefinitionProto_Action || (Callosum_MetricDefinitionProto_Action = {}));
export var Callosum_ObjectType_E;
(function (Callosum_ObjectType_E) {
    Callosum_ObjectType_E["Answer"] = "ANSWER";
    Callosum_ObjectType_E["Column"] = "COLUMN";
    Callosum_ObjectType_E["Filter"] = "FILTER";
    Callosum_ObjectType_E["Pinboard"] = "PINBOARD";
    Callosum_ObjectType_E["Relationship"] = "RELATIONSHIP";
    Callosum_ObjectType_E["Table"] = "TABLE";
    Callosum_ObjectType_E["User"] = "USER";
    Callosum_ObjectType_E["UserGroup"] = "USER_GROUP";
})(Callosum_ObjectType_E || (Callosum_ObjectType_E = {}));
export var Callosum_PurchaseOption_E;
(function (Callosum_PurchaseOption_E) {
    Callosum_PurchaseOption_E["BuyNow"] = "BUY_NOW";
    Callosum_PurchaseOption_E["ContactSales"] = "CONTACT_SALES";
    Callosum_PurchaseOption_E["None"] = "NONE";
})(Callosum_PurchaseOption_E || (Callosum_PurchaseOption_E = {}));
export var Callosum_QueryWarningType;
(function (Callosum_QueryWarningType) {
    Callosum_QueryWarningType["MultiplePreferredRoot"] = "MULTIPLE_PREFERRED_ROOT";
})(Callosum_QueryWarningType || (Callosum_QueryWarningType = {}));
export var Callosum_RequestType_E;
(function (Callosum_RequestType_E) {
    Callosum_RequestType_E["AnswerAddNewFilter"] = "ANSWER_ADD_NEW_FILTER";
    Callosum_RequestType_E["AnswerHelpRequested"] = "ANSWER_HELP_REQUESTED";
    Callosum_RequestType_E["AnswerPinboardContext"] = "ANSWER_PINBOARD_CONTEXT";
    Callosum_RequestType_E["AnswerSaved"] = "ANSWER_SAVED";
    Callosum_RequestType_E["AnswerUnsaved"] = "ANSWER_UNSAVED";
    Callosum_RequestType_E["AnswerUpgrade"] = "ANSWER_UPGRADE";
    Callosum_RequestType_E["AnswerView"] = "ANSWER_VIEW";
    Callosum_RequestType_E["AnswerViewList"] = "ANSWER_VIEW_LIST";
    Callosum_RequestType_E["AnswerViewSave"] = "ANSWER_VIEW_SAVE";
    Callosum_RequestType_E["AnswerVizContextView"] = "ANSWER_VIZ_CONTEXT_VIEW";
    Callosum_RequestType_E["DataChartConfig"] = "DATA_CHART_CONFIG";
    Callosum_RequestType_E["DataExport"] = "DATA_EXPORT";
    Callosum_RequestType_E["DataShowUnderlyingRow"] = "DATA_SHOW_UNDERLYING_ROW";
    Callosum_RequestType_E["DataShowUnderlyingViz"] = "DATA_SHOW_UNDERLYING_VIZ";
    Callosum_RequestType_E["PinboardAdminView"] = "PINBOARD_ADMIN_VIEW";
    Callosum_RequestType_E["PinboardAdHoc"] = "PINBOARD_AD_HOC";
    Callosum_RequestType_E["PinboardEmbedView"] = "PINBOARD_EMBED_VIEW";
    Callosum_RequestType_E["PinboardFilter"] = "PINBOARD_FILTER";
    Callosum_RequestType_E["PinboardHomepageView"] = "PINBOARD_HOMEPAGE_VIEW";
    Callosum_RequestType_E["PinboardInsightView"] = "PINBOARD_INSIGHT_VIEW";
    Callosum_RequestType_E["PinboardLearnView"] = "PINBOARD_LEARN_VIEW";
    Callosum_RequestType_E["PinboardPrintFilter"] = "PINBOARD_PRINT_FILTER";
    Callosum_RequestType_E["PinboardPrintView"] = "PINBOARD_PRINT_VIEW";
    Callosum_RequestType_E["PinboardTspublicNoRuntimeFilter"] = "PINBOARD_TSPUBLIC_NO_RUNTIME_FILTER";
    Callosum_RequestType_E["PinboardTspublicRuntimeFilter"] = "PINBOARD_TSPUBLIC_RUNTIME_FILTER";
    Callosum_RequestType_E["PinboardView"] = "PINBOARD_VIEW";
    Callosum_RequestType_E["TspublicDataExport"] = "TSPUBLIC_DATA_EXPORT";
    Callosum_RequestType_E["Unknown"] = "UNKNOWN";
    Callosum_RequestType_E["ViewAnswerView"] = "VIEW_ANSWER_VIEW";
})(Callosum_RequestType_E || (Callosum_RequestType_E = {}));
export var Callosum_SearchFilterProto_BoolFilterValue_E;
(function (Callosum_SearchFilterProto_BoolFilterValue_E) {
    Callosum_SearchFilterProto_BoolFilterValue_E["FalseValue"] = "FALSE_VALUE";
    Callosum_SearchFilterProto_BoolFilterValue_E["Ignore"] = "IGNORE";
    Callosum_SearchFilterProto_BoolFilterValue_E["TrueValue"] = "TRUE_VALUE";
})(Callosum_SearchFilterProto_BoolFilterValue_E || (Callosum_SearchFilterProto_BoolFilterValue_E = {}));
export var Callosum_SearchFilterProto_RequestStatus_E;
(function (Callosum_SearchFilterProto_RequestStatus_E) {
    Callosum_SearchFilterProto_RequestStatus_E["All"] = "ALL";
    Callosum_SearchFilterProto_RequestStatus_E["Resolved"] = "RESOLVED";
    Callosum_SearchFilterProto_RequestStatus_E["Unresolved"] = "UNRESOLVED";
})(Callosum_SearchFilterProto_RequestStatus_E || (Callosum_SearchFilterProto_RequestStatus_E = {}));
export var Callosum_StatusProto_Code;
(function (Callosum_StatusProto_Code) {
    Callosum_StatusProto_Code["Error"] = "ERROR";
    Callosum_StatusProto_Code["Ok"] = "OK";
    Callosum_StatusProto_Code["Warning"] = "WARNING";
})(Callosum_StatusProto_Code || (Callosum_StatusProto_Code = {}));
export var Callosum_SubscriptionStatus_E;
(function (Callosum_SubscriptionStatus_E) {
    Callosum_SubscriptionStatus_E["Active"] = "ACTIVE";
    Callosum_SubscriptionStatus_E["Canceled"] = "CANCELED";
    Callosum_SubscriptionStatus_E["Incomplete"] = "INCOMPLETE";
    Callosum_SubscriptionStatus_E["IncompleteExpired"] = "INCOMPLETE_EXPIRED";
    Callosum_SubscriptionStatus_E["PastDue"] = "PAST_DUE";
    Callosum_SubscriptionStatus_E["Trialing"] = "TRIALING";
    Callosum_SubscriptionStatus_E["Unpaid"] = "UNPAID";
})(Callosum_SubscriptionStatus_E || (Callosum_SubscriptionStatus_E = {}));
export var Callosum_SubscriptionTier_E;
(function (Callosum_SubscriptionTier_E) {
    Callosum_SubscriptionTier_E["PlanA"] = "PLAN_A";
    Callosum_SubscriptionTier_E["PlanB"] = "PLAN_B";
    Callosum_SubscriptionTier_E["PlanC"] = "PLAN_C";
})(Callosum_SubscriptionTier_E || (Callosum_SubscriptionTier_E = {}));
export var Callosum_SubscriptionType_E;
(function (Callosum_SubscriptionType_E) {
    Callosum_SubscriptionType_E["DeveloperEdition"] = "DEVELOPER_EDITION";
    Callosum_SubscriptionType_E["FreeTrial"] = "FREE_TRIAL";
    Callosum_SubscriptionType_E["TeamsEdition"] = "TEAMS_EDITION";
})(Callosum_SubscriptionType_E || (Callosum_SubscriptionType_E = {}));
export var Callosum_UserAccountSource_E;
(function (Callosum_UserAccountSource_E) {
    Callosum_UserAccountSource_E["AwsMarketplaceDatabricksConsumptionSpotapp"] = "AWS_MARKETPLACE_DATABRICKS_CONSUMPTION_SPOTAPP";
    Callosum_UserAccountSource_E["AwsMarketplaceRedshiftConsumptionSpotapp"] = "AWS_MARKETPLACE_REDSHIFT_CONSUMPTION_SPOTAPP";
    Callosum_UserAccountSource_E["AwsMarketplaceSnowflakeConsumptionSpotapp"] = "AWS_MARKETPLACE_SNOWFLAKE_CONSUMPTION_SPOTAPP";
    Callosum_UserAccountSource_E["DatabricksPartnerConnect"] = "DATABRICKS_PARTNER_CONNECT";
    Callosum_UserAccountSource_E["FreeTrial"] = "FREE_TRIAL";
    Callosum_UserAccountSource_E["Internal"] = "INTERNAL";
    Callosum_UserAccountSource_E["RedshiftPartnerConnect"] = "REDSHIFT_PARTNER_CONNECT";
    Callosum_UserAccountSource_E["SnowflakePartnerConnect"] = "SNOWFLAKE_PARTNER_CONNECT";
})(Callosum_UserAccountSource_E || (Callosum_UserAccountSource_E = {}));
export var Callosum_UserPersona_E;
(function (Callosum_UserPersona_E) {
    Callosum_UserPersona_E["Analyst"] = "ANALYST";
    Callosum_UserPersona_E["BusinessUser"] = "BUSINESS_USER";
})(Callosum_UserPersona_E || (Callosum_UserPersona_E = {}));
export var Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto;
(function (Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto) {
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedArea"] = "ADVANCED_AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedBar"] = "ADVANCED_BAR";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedColumn"] = "ADVANCED_COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedLine"] = "ADVANCED_LINE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedPivotTable"] = "ADVANCED_PIVOT_TABLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedStackedArea"] = "ADVANCED_STACKED_AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedStackedBar"] = "ADVANCED_STACKED_BAR";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["AdvancedStackedColumn"] = "ADVANCED_STACKED_COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Area"] = "AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Bar"] = "BAR";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Bubble"] = "BUBBLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Candlestick"] = "CANDLESTICK";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Column"] = "COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["CustomChart"] = "CUSTOM_CHART";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Funnel"] = "FUNNEL";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoArea"] = "GEO_AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoBubble"] = "GEO_BUBBLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoEarthArea"] = "GEO_EARTH_AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoEarthBar"] = "GEO_EARTH_BAR";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoEarthBubble"] = "GEO_EARTH_BUBBLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoEarthGraph"] = "GEO_EARTH_GRAPH";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoEarthHeatmap"] = "GEO_EARTH_HEATMAP";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GeoHeatmap"] = "GEO_HEATMAP";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["GridTable"] = "GRID_TABLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Heatmap"] = "HEATMAP";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Kpi"] = "KPI";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Line"] = "LINE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["LineColumn"] = "LINE_COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["LineStackedColumn"] = "LINE_STACKED_COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["MuzeStudio"] = "MUZE_STUDIO";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["None"] = "NONE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Pareto"] = "PARETO";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Pie"] = "PIE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["PivotTable"] = "PIVOT_TABLE";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Sankey"] = "SANKEY";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Scatter"] = "SCATTER";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["SpiderWeb"] = "SPIDER_WEB";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["StackedArea"] = "STACKED_AREA";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["StackedBar"] = "STACKED_BAR";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["StackedColumn"] = "STACKED_COLUMN";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Treemap"] = "TREEMAP";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["Waterfall"] = "WATERFALL";
    Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto["WhiskerScatter"] = "WHISKER_SCATTER";
})(Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto || (Callosum_VisualizationProto_ChartVisualizationContentProto_ChartTypeEnumProto = {}));
export var Callosum_VisualizationProto_VisualizationTypeEnumProto;
(function (Callosum_VisualizationProto_VisualizationTypeEnumProto) {
    Callosum_VisualizationProto_VisualizationTypeEnumProto["Chart"] = "CHART";
    Callosum_VisualizationProto_VisualizationTypeEnumProto["Headline"] = "HEADLINE";
    Callosum_VisualizationProto_VisualizationTypeEnumProto["Image"] = "IMAGE";
    Callosum_VisualizationProto_VisualizationTypeEnumProto["RAnalysis"] = "R_ANALYSIS";
    Callosum_VisualizationProto_VisualizationTypeEnumProto["Table"] = "TABLE";
})(Callosum_VisualizationProto_VisualizationTypeEnumProto || (Callosum_VisualizationProto_VisualizationTypeEnumProto = {}));
export var Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion;
(function (Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion) {
    Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion["PreV1"] = "PRE_V1";
    Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion["V1"] = "V1";
})(Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion || (Callosum_VizPropProto_AnswerColumnFormatProto_AnswerColumnPropVersion = {}));
export var Callosum_VizPropProto_AxisTypes;
(function (Callosum_VizPropProto_AxisTypes) {
    Callosum_VizPropProto_AxisTypes["Color"] = "COLOR";
    Callosum_VizPropProto_AxisTypes["X"] = "X";
    Callosum_VizPropProto_AxisTypes["Y"] = "Y";
})(Callosum_VizPropProto_AxisTypes || (Callosum_VizPropProto_AxisTypes = {}));
export var Callosum_VizPropProto_ChartResponsiveLayout;
(function (Callosum_VizPropProto_ChartResponsiveLayout) {
    Callosum_VizPropProto_ChartResponsiveLayout["AutoOff"] = "AUTO_OFF";
    Callosum_VizPropProto_ChartResponsiveLayout["AutoOn"] = "AUTO_ON";
    Callosum_VizPropProto_ChartResponsiveLayout["UserPreferredOff"] = "USER_PREFERRED_OFF";
    Callosum_VizPropProto_ChartResponsiveLayout["UserPreferredOn"] = "USER_PREFERRED_ON";
})(Callosum_VizPropProto_ChartResponsiveLayout || (Callosum_VizPropProto_ChartResponsiveLayout = {}));
export var Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion;
(function (Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion) {
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V2"] = "V2";
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V2Dot1"] = "V2DOT1";
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V3"] = "V3";
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V4"] = "V4";
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V4Dot1"] = "V4DOT1";
    Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion["V4Dot2"] = "V4DOT2";
})(Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion || (Callosum_VizPropProto_ChartVizPropProto_ChartVizPropVersion = {}));
export var Callosum_VizPropProto_ColumnSortConfigOptions;
(function (Callosum_VizPropProto_ColumnSortConfigOptions) {
    Callosum_VizPropProto_ColumnSortConfigOptions["Custom"] = "CUSTOM";
    Callosum_VizPropProto_ColumnSortConfigOptions["Default"] = "DEFAULT";
})(Callosum_VizPropProto_ColumnSortConfigOptions || (Callosum_VizPropProto_ColumnSortConfigOptions = {}));
export var Callosum_VizPropProto_HandleMissingValues;
(function (Callosum_VizPropProto_HandleMissingValues) {
    Callosum_VizPropProto_HandleMissingValues["DontShow"] = "DONT_SHOW";
    Callosum_VizPropProto_HandleMissingValues["ShowAsZero"] = "SHOW_AS_ZERO";
    Callosum_VizPropProto_HandleMissingValues["ShowGap"] = "SHOW_GAP";
})(Callosum_VizPropProto_HandleMissingValues || (Callosum_VizPropProto_HandleMissingValues = {}));
export var Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion;
(function (Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion) {
    Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion["PreV1"] = "PRE_V1";
    Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion["V1"] = "V1";
})(Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion || (Callosum_VizPropProto_HeadlineVizPropProto_HeadlineVizPropVersion = {}));
export var Callosum_VizPropProto_LegendPositionOptions;
(function (Callosum_VizPropProto_LegendPositionOptions) {
    Callosum_VizPropProto_LegendPositionOptions["BottomLegend"] = "BOTTOM_LEGEND";
    Callosum_VizPropProto_LegendPositionOptions["LeftLegend"] = "LEFT_LEGEND";
    Callosum_VizPropProto_LegendPositionOptions["RightLegend"] = "RIGHT_LEGEND";
    Callosum_VizPropProto_LegendPositionOptions["TopLegend"] = "TOP_LEGEND";
})(Callosum_VizPropProto_LegendPositionOptions || (Callosum_VizPropProto_LegendPositionOptions = {}));
export var Callosum_VizPropProto_ShowPivotSummaryPrior;
(function (Callosum_VizPropProto_ShowPivotSummaryPrior) {
    Callosum_VizPropProto_ShowPivotSummaryPrior["Both"] = "BOTH";
    Callosum_VizPropProto_ShowPivotSummaryPrior["Columns"] = "COLUMNS";
    Callosum_VizPropProto_ShowPivotSummaryPrior["None"] = "NONE";
    Callosum_VizPropProto_ShowPivotSummaryPrior["Rows"] = "ROWS";
})(Callosum_VizPropProto_ShowPivotSummaryPrior || (Callosum_VizPropProto_ShowPivotSummaryPrior = {}));
export var Callosum_VizPropProto_TableContentDensity;
(function (Callosum_VizPropProto_TableContentDensity) {
    Callosum_VizPropProto_TableContentDensity["Compact"] = "COMPACT";
    Callosum_VizPropProto_TableContentDensity["Regular"] = "REGULAR";
})(Callosum_VizPropProto_TableContentDensity || (Callosum_VizPropProto_TableContentDensity = {}));
export var Callosum_VizPropProto_TableTheme;
(function (Callosum_VizPropProto_TableTheme) {
    Callosum_VizPropProto_TableTheme["Outline"] = "OUTLINE";
    Callosum_VizPropProto_TableTheme["Row"] = "ROW";
    Callosum_VizPropProto_TableTheme["Zebra"] = "ZEBRA";
})(Callosum_VizPropProto_TableTheme || (Callosum_VizPropProto_TableTheme = {}));
export var Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion;
(function (Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion) {
    Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion["PreV1"] = "PRE_V1";
    Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion["V1"] = "V1";
})(Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion || (Callosum_VizPropProto_TableVizPropProto_TableVizPropVersion = {}));
export var Callosum_WorksheetTypeEnumProto_E;
(function (Callosum_WorksheetTypeEnumProto_E) {
    Callosum_WorksheetTypeEnumProto_E["Container"] = "CONTAINER";
    Callosum_WorksheetTypeEnumProto_E["View"] = "VIEW";
})(Callosum_WorksheetTypeEnumProto_E || (Callosum_WorksheetTypeEnumProto_E = {}));
export var Common_ErrorCode;
(function (Common_ErrorCode) {
    Common_ErrorCode["Aborted"] = "ABORTED";
    Common_ErrorCode["AdmissionControlCancelled"] = "ADMISSION_CONTROL_CANCELLED";
    Common_ErrorCode["AdmissionControlRejected"] = "ADMISSION_CONTROL_REJECTED";
    Common_ErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    Common_ErrorCode["AlterTableFailed"] = "ALTER_TABLE_FAILED";
    Common_ErrorCode["AuthenticationFailed"] = "AUTHENTICATION_FAILED";
    Common_ErrorCode["Busy"] = "BUSY";
    Common_ErrorCode["Cancelled"] = "CANCELLED";
    Common_ErrorCode["CmdNotFound"] = "CMD_NOT_FOUND";
    Common_ErrorCode["ConnectionAuthFailed"] = "CONNECTION_AUTH_FAILED";
    Common_ErrorCode["ConnectionFailed"] = "CONNECTION_FAILED";
    Common_ErrorCode["DataNotFound"] = "DATA_NOT_FOUND";
    Common_ErrorCode["DataNotIndexed"] = "DATA_NOT_INDEXED";
    Common_ErrorCode["DbQueryFlagOff"] = "DB_QUERY_FLAG_OFF";
    Common_ErrorCode["DependentsFound"] = "DEPENDENTS_FOUND";
    Common_ErrorCode["DmEmptyResponse"] = "DM_EMPTY_RESPONSE";
    Common_ErrorCode["FalconResponseError"] = "FALCON_RESPONSE_ERROR";
    Common_ErrorCode["FetchAcContextFailed"] = "FETCH_AC_CONTEXT_FAILED";
    Common_ErrorCode["GetA3CallosumConfigFailed"] = "GET_A3_CALLOSUM_CONFIG_FAILED";
    Common_ErrorCode["GetDataManagerQueryFailed"] = "GET_DATA_MANAGER_QUERY_FAILED";
    Common_ErrorCode["GetDbqueryFalconRequestFailed"] = "GET_DBQUERY_FALCON_REQUEST_FAILED";
    Common_ErrorCode["GetFrmtDateBucketFailed"] = "GET_FRMT_DATE_BUCKET_FAILED";
    Common_ErrorCode["GetMonitorConfigFailed"] = "GET_MONITOR_CONFIG_FAILED";
    Common_ErrorCode["GetRelatedColumnsFailed"] = "GET_RELATED_COLUMNS_FAILED";
    Common_ErrorCode["HdfsError"] = "HDFS_ERROR";
    Common_ErrorCode["Internal"] = "INTERNAL";
    Common_ErrorCode["InvalidArgument"] = "INVALID_ARGUMENT";
    Common_ErrorCode["InvalidJoinPath"] = "INVALID_JOIN_PATH";
    Common_ErrorCode["InvalidResponse"] = "INVALID_RESPONSE";
    Common_ErrorCode["InvalidTableGraph"] = "INVALID_TABLE_GRAPH";
    Common_ErrorCode["LessonPlanUpgraded"] = "LESSON_PLAN_UPGRADED";
    Common_ErrorCode["LessonPlanUpgradeFailed"] = "LESSON_PLAN_UPGRADE_FAILED";
    Common_ErrorCode["LoadFailed"] = "LOAD_FAILED";
    Common_ErrorCode["LoadFailedExistsLoadCycleConflicts"] = "LOAD_FAILED_EXISTS_LOAD_CYCLE_CONFLICTS";
    Common_ErrorCode["MaterializationCheckpointError"] = "MATERIALIZATION_CHECKPOINT_ERROR";
    Common_ErrorCode["MaterializationConfigError"] = "MATERIALIZATION_CONFIG_ERROR";
    Common_ErrorCode["MaterializationInternalError"] = "MATERIALIZATION_INTERNAL_ERROR";
    Common_ErrorCode["MaterializationWorkerConnectionFailure"] = "MATERIALIZATION_WORKER_CONNECTION_FAILURE";
    Common_ErrorCode["MissingTenantId"] = "MISSING_TENANT_ID";
    Common_ErrorCode["NestedAggrWarning"] = "NESTED_AGGR_WARNING";
    Common_ErrorCode["NestingGroupAggrNotAllowed"] = "NESTING_GROUP_AGGR_NOT_ALLOWED";
    Common_ErrorCode["NonAttributeColumnType"] = "NON_ATTRIBUTE_COLUMN_TYPE";
    Common_ErrorCode["NotFound"] = "NOT_FOUND";
    Common_ErrorCode["NotImplemented"] = "NOT_IMPLEMENTED";
    Common_ErrorCode["NotReady"] = "NOT_READY";
    Common_ErrorCode["Ok"] = "OK";
    Common_ErrorCode["OneOffFailed"] = "ONE_OFF_FAILED";
    Common_ErrorCode["OrionError"] = "ORION_ERROR";
    Common_ErrorCode["PercentileQueryExceedsMaxInputRows"] = "PERCENTILE_QUERY_EXCEEDS_MAX_INPUT_ROWS";
    Common_ErrorCode["PermissionDenied"] = "PERMISSION_DENIED";
    Common_ErrorCode["PermissionDeniedInaccessibleToOrg"] = "PERMISSION_DENIED_INACCESSIBLE_TO_ORG";
    Common_ErrorCode["PersistentFsError"] = "PERSISTENT_FS_ERROR";
    Common_ErrorCode["RemoveFormulaDependencyFailure"] = "REMOVE_FORMULA_DEPENDENCY_FAILURE";
    Common_ErrorCode["ResourceExceeded"] = "RESOURCE_EXCEEDED";
    Common_ErrorCode["RpcFailed"] = "RPC_FAILED";
    Common_ErrorCode["SageAcUtilFailed"] = "SAGE_AC_UTIL_FAILED";
    Common_ErrorCode["SerializationError"] = "SERIALIZATION_ERROR";
    Common_ErrorCode["SpotiqChangeAnalysisHasCompositeAggregation"] = "SPOTIQ_CHANGE_ANALYSIS_HAS_COMPOSITE_AGGREGATION";
    Common_ErrorCode["SpotiqChangeAnalysisHasGrowth"] = "SPOTIQ_CHANGE_ANALYSIS_HAS_GROWTH";
    Common_ErrorCode["SpotiqChangeAnalysisHasWindowing"] = "SPOTIQ_CHANGE_ANALYSIS_HAS_WINDOWING";
    Common_ErrorCode["SpotiqChangeAnalysisNoMeasure"] = "SPOTIQ_CHANGE_ANALYSIS_NO_MEASURE";
    Common_ErrorCode["SpotiqChangeAnalysisPinnedMeasure"] = "SPOTIQ_CHANGE_ANALYSIS_PINNED_MEASURE";
    Common_ErrorCode["SpotiqChangeAnalysisUnknownError"] = "SPOTIQ_CHANGE_ANALYSIS_UNKNOWN_ERROR";
    Common_ErrorCode["SpotiqHasVersus"] = "SPOTIQ_HAS_VERSUS";
    Common_ErrorCode["SpotiqNoSuggestedColumns"] = "SPOTIQ_NO_SUGGESTED_COLUMNS";
    Common_ErrorCode["TableAbsentOnCdw"] = "TABLE_ABSENT_ON_CDW";
    Common_ErrorCode["TableNotReady"] = "TABLE_NOT_READY";
    Common_ErrorCode["TableOffline"] = "TABLE_OFFLINE";
    Common_ErrorCode["Timeout"] = "TIMEOUT";
    Common_ErrorCode["Unknown"] = "UNKNOWN";
    Common_ErrorCode["Unreachable"] = "UNREACHABLE";
    Common_ErrorCode["ZookeeperError"] = "ZOOKEEPER_ERROR";
})(Common_ErrorCode || (Common_ErrorCode = {}));
export var Common_FormatingType_E;
(function (Common_FormatingType_E) {
    Common_FormatingType_E["DateFormatPattern"] = "DATE_FORMAT_PATTERN";
    Common_FormatingType_E["DateTimeFormatPattern"] = "DATE_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["DayInMonthFormatPattern"] = "DAY_IN_MONTH_FORMAT_PATTERN";
    Common_FormatingType_E["DayInQtrFormatPattern"] = "DAY_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["DayInYearFormatPattern"] = "DAY_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["DayOfWeekFormatPattern"] = "DAY_OF_WEEK_FORMAT_PATTERN";
    Common_FormatingType_E["HourDateFormatPattern"] = "HOUR_DATE_FORMAT_PATTERN";
    Common_FormatingType_E["HourTimeFormatPattern"] = "HOUR_TIME_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInQtrFormatPattern"] = "MONTH_IN_QTR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthInYearFormatPattern"] = "MONTH_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["MonthYearFormatPattern"] = "MONTH_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["NoFormating"] = "NO_FORMATING";
    Common_FormatingType_E["NumberFormatPattern"] = "NUMBER_FORMAT_PATTERN";
    Common_FormatingType_E["QtrInYearFormatPattern"] = "QTR_IN_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["QtrYearFormatPattern"] = "QTR_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["TimeFormatPattern"] = "TIME_FORMAT_PATTERN";
    Common_FormatingType_E["WeekYearFormatPattern"] = "WEEK_YEAR_FORMAT_PATTERN";
    Common_FormatingType_E["YearFormatPattern"] = "YEAR_FORMAT_PATTERN";
})(Common_FormatingType_E || (Common_FormatingType_E = {}));
export var Common_GeometryTypeEnumProto_E;
(function (Common_GeometryTypeEnumProto_E) {
    Common_GeometryTypeEnumProto_E["Circle"] = "CIRCLE";
    Common_GeometryTypeEnumProto_E["GeometryCollection"] = "GEOMETRY_COLLECTION";
    Common_GeometryTypeEnumProto_E["LinearRing"] = "LINEAR_RING";
    Common_GeometryTypeEnumProto_E["LineString"] = "LINE_STRING";
    Common_GeometryTypeEnumProto_E["MultiLineString"] = "MULTI_LINE_STRING";
    Common_GeometryTypeEnumProto_E["MultiPoint"] = "MULTI_POINT";
    Common_GeometryTypeEnumProto_E["MultiPolygon"] = "MULTI_POLYGON";
    Common_GeometryTypeEnumProto_E["Point"] = "POINT";
    Common_GeometryTypeEnumProto_E["Polygon"] = "POLYGON";
})(Common_GeometryTypeEnumProto_E || (Common_GeometryTypeEnumProto_E = {}));
export var Common_MetricValue_MetricType;
(function (Common_MetricValue_MetricType) {
    Common_MetricValue_MetricType["Average"] = "AVERAGE";
    Common_MetricValue_MetricType["Counter"] = "COUNTER";
    Common_MetricValue_MetricType["Distribution"] = "DISTRIBUTION";
    Common_MetricValue_MetricType["Quantile"] = "QUANTILE";
    Common_MetricValue_MetricType["Value"] = "VALUE";
})(Common_MetricValue_MetricType || (Common_MetricValue_MetricType = {}));
export var Common_MetricValue_MetricUnit;
(function (Common_MetricValue_MetricUnit) {
    Common_MetricValue_MetricUnit["Mb"] = "MB";
    Common_MetricValue_MetricUnit["MicroSecond"] = "MICRO_SECOND";
    Common_MetricValue_MetricUnit["MilliSecond"] = "MILLI_SECOND";
    Common_MetricValue_MetricUnit["Second"] = "SECOND";
    Common_MetricValue_MetricUnit["Unknown"] = "UNKNOWN";
})(Common_MetricValue_MetricUnit || (Common_MetricValue_MetricUnit = {}));
export var Common_Metric_Kind;
(function (Common_Metric_Kind) {
    Common_Metric_Kind["Cumulative"] = "CUMULATIVE";
    Common_Metric_Kind["Delta"] = "DELTA";
    Common_Metric_Kind["Gauge"] = "GAUGE";
    Common_Metric_Kind["UnknownKind"] = "UNKNOWN_KIND";
})(Common_Metric_Kind || (Common_Metric_Kind = {}));
export var Common_Metric_Unit;
(function (Common_Metric_Unit) {
    Common_Metric_Unit["Bytes"] = "BYTES";
    Common_Metric_Unit["GigaBytes"] = "GIGA_BYTES";
    Common_Metric_Unit["Hours"] = "HOURS";
    Common_Metric_Unit["KiloBytes"] = "KILO_BYTES";
    Common_Metric_Unit["MegaBytes"] = "MEGA_BYTES";
    Common_Metric_Unit["MicroSeconds"] = "MICRO_SECONDS";
    Common_Metric_Unit["MilliSeconds"] = "MILLI_SECONDS";
    Common_Metric_Unit["Minutes"] = "MINUTES";
    Common_Metric_Unit["NanoSeconds"] = "NANO_SECONDS";
    Common_Metric_Unit["Seconds"] = "SECONDS";
    Common_Metric_Unit["Unknown"] = "UNKNOWN";
})(Common_Metric_Unit || (Common_Metric_Unit = {}));
export var Common_Metric_ValueType;
(function (Common_Metric_ValueType) {
    Common_Metric_ValueType["BoolValue"] = "BOOL_VALUE";
    Common_Metric_ValueType["DistributionValue"] = "DISTRIBUTION_VALUE";
    Common_Metric_ValueType["DoubleValue"] = "DOUBLE_VALUE";
    Common_Metric_ValueType["IntegerValue"] = "INTEGER_VALUE";
    Common_Metric_ValueType["StringValue"] = "STRING_VALUE";
})(Common_Metric_ValueType || (Common_Metric_ValueType = {}));
export var Common_ProductInfo_ProductType;
(function (Common_ProductInfo_ProductType) {
    Common_ProductInfo_ProductType["Enterprise"] = "ENTERPRISE";
    Common_ProductInfo_ProductType["FreeTrial"] = "FREE_TRIAL";
    Common_ProductInfo_ProductType["Pro"] = "PRO";
    Common_ProductInfo_ProductType["Team"] = "TEAM";
    Common_ProductInfo_ProductType["TrialTeam"] = "TRIAL_TEAM";
    Common_ProductInfo_ProductType["Tsa"] = "TSA";
    Common_ProductInfo_ProductType["TsaEnterprise"] = "TSA_ENTERPRISE";
    Common_ProductInfo_ProductType["TsaEssentials"] = "TSA_ESSENTIALS";
    Common_ProductInfo_ProductType["TsaPro"] = "TSA_PRO";
    Common_ProductInfo_ProductType["Tse"] = "TSE";
    Common_ProductInfo_ProductType["TseBuild"] = "TSE_BUILD";
    Common_ProductInfo_ProductType["TseDeveloper"] = "TSE_DEVELOPER";
    Common_ProductInfo_ProductType["TseEnterprise"] = "TSE_ENTERPRISE";
    Common_ProductInfo_ProductType["TseEssentials"] = "TSE_ESSENTIALS";
    Common_ProductInfo_ProductType["TsePro"] = "TSE_PRO";
})(Common_ProductInfo_ProductType || (Common_ProductInfo_ProductType = {}));
export var Common_ValueProto_Type;
(function (Common_ValueProto_Type) {
    Common_ValueProto_Type["TypeBool"] = "TYPE_BOOL";
    Common_ValueProto_Type["TypeDouble"] = "TYPE_DOUBLE";
    Common_ValueProto_Type["TypeInt64"] = "TYPE_INT64";
    Common_ValueProto_Type["TypeNull"] = "TYPE_NULL";
    Common_ValueProto_Type["TypeString"] = "TYPE_STRING";
    Common_ValueProto_Type["TypeUint64"] = "TYPE_UINT64";
    Common_ValueProto_Type["TypeVariable"] = "TYPE_VARIABLE";
})(Common_ValueProto_Type || (Common_ValueProto_Type = {}));
export var Convassist_AnswerAction;
(function (Convassist_AnswerAction) {
    Convassist_AnswerAction["AnswerEdited"] = "ANSWER_EDITED";
    Convassist_AnswerAction["ChartSwitch"] = "CHART_SWITCH";
    Convassist_AnswerAction["DrillDown"] = "DRILL_DOWN";
    Convassist_AnswerAction["Redo"] = "REDO";
    Convassist_AnswerAction["Reset"] = "RESET";
    Convassist_AnswerAction["Undo"] = "UNDO";
})(Convassist_AnswerAction || (Convassist_AnswerAction = {}));
export var Convassist_ErrorCode;
(function (Convassist_ErrorCode) {
    Convassist_ErrorCode["Aborted"] = "ABORTED";
    Convassist_ErrorCode["AlreadyExists"] = "ALREADY_EXISTS";
    Convassist_ErrorCode["AuthenticationFailed"] = "AUTHENTICATION_FAILED";
    Convassist_ErrorCode["BadRequest"] = "BAD_REQUEST";
    Convassist_ErrorCode["Busy"] = "BUSY";
    Convassist_ErrorCode["Cancelled"] = "CANCELLED";
    Convassist_ErrorCode["ConversationNotFound"] = "CONVERSATION_NOT_FOUND";
    Convassist_ErrorCode["CreateAnswerSpecFailed"] = "CREATE_ANSWER_SPEC_FAILED";
    Convassist_ErrorCode["FindToolFailed"] = "FIND_TOOL_FAILED";
    Convassist_ErrorCode["InitialQuestionNotPresent"] = "INITIAL_QUESTION_NOT_PRESENT";
    Convassist_ErrorCode["InitialSqlGenFailed"] = "INITIAL_SQL_GEN_FAILED";
    Convassist_ErrorCode["Internal"] = "INTERNAL";
    Convassist_ErrorCode["InvalidArgument"] = "INVALID_ARGUMENT";
    Convassist_ErrorCode["InvalidObjectType"] = "INVALID_OBJECT_TYPE";
    Convassist_ErrorCode["InvalidResponse"] = "INVALID_RESPONSE";
    Convassist_ErrorCode["InvalidUser"] = "INVALID_USER";
    Convassist_ErrorCode["LlmSqlParseFailed"] = "LLM_SQL_PARSE_FAILED";
    Convassist_ErrorCode["NlpServiceError"] = "NLP_SERVICE_ERROR";
    Convassist_ErrorCode["NotFound"] = "NOT_FOUND";
    Convassist_ErrorCode["NotImplemented"] = "NOT_IMPLEMENTED";
    Convassist_ErrorCode["NotReady"] = "NOT_READY";
    Convassist_ErrorCode["NoAiAnsGenPrivilege"] = "NO_AI_ANS_GEN_PRIVILEGE";
    Convassist_ErrorCode["NoPhrasesInSqlToTml"] = "NO_PHRASES_IN_SQL_TO_TML";
    Convassist_ErrorCode["Ok"] = "OK";
    Convassist_ErrorCode["PermissionDenied"] = "PERMISSION_DENIED";
    Convassist_ErrorCode["RateLimitExceeded"] = "RATE_LIMIT_EXCEEDED";
    Convassist_ErrorCode["ReadMetadataFailed"] = "READ_METADATA_FAILED";
    Convassist_ErrorCode["RequiredFieldMissing"] = "REQUIRED_FIELD_MISSING";
    Convassist_ErrorCode["ResourceExceeded"] = "RESOURCE_EXCEEDED";
    Convassist_ErrorCode["RpcFailed"] = "RPC_FAILED";
    Convassist_ErrorCode["SerializationError"] = "SERIALIZATION_ERROR";
    Convassist_ErrorCode["Timeout"] = "TIMEOUT";
    Convassist_ErrorCode["TmlSanitizationFailed"] = "TML_SANITIZATION_FAILED";
    Convassist_ErrorCode["ToolError"] = "TOOL_ERROR";
    Convassist_ErrorCode["Unknown"] = "UNKNOWN";
    Convassist_ErrorCode["WorksheetAiDisabled"] = "WORKSHEET_AI_DISABLED";
    Convassist_ErrorCode["WorksheetIdMissing"] = "WORKSHEET_ID_MISSING";
})(Convassist_ErrorCode || (Convassist_ErrorCode = {}));
export var Convassist_FeedbackType;
(function (Convassist_FeedbackType) {
    Convassist_FeedbackType["DownVote"] = "DOWN_VOTE";
    Convassist_FeedbackType["UpVote"] = "UP_VOTE";
})(Convassist_FeedbackType || (Convassist_FeedbackType = {}));
export var Convassist_GetQuerySuggestionsRequest_SuggestionContextType;
(function (Convassist_GetQuerySuggestionsRequest_SuggestionContextType) {
    Convassist_GetQuerySuggestionsRequest_SuggestionContextType["TsAnswer"] = "TS_ANSWER";
    Convassist_GetQuerySuggestionsRequest_SuggestionContextType["TsWorksheet"] = "TS_WORKSHEET";
})(Convassist_GetQuerySuggestionsRequest_SuggestionContextType || (Convassist_GetQuerySuggestionsRequest_SuggestionContextType = {}));
export var Convassist_MessageType;
(function (Convassist_MessageType) {
    Convassist_MessageType["AsstResponse"] = "ASST_RESPONSE";
    Convassist_MessageType["DisambCommand"] = "DISAMB_COMMAND";
    Convassist_MessageType["DisambResponse"] = "DISAMB_RESPONSE";
    Convassist_MessageType["Error"] = "ERROR";
    Convassist_MessageType["StatusUpdate"] = "STATUS_UPDATE";
    Convassist_MessageType["UpdateMessage"] = "UPDATE_MESSAGE";
    Convassist_MessageType["UserCommand"] = "USER_COMMAND";
})(Convassist_MessageType || (Convassist_MessageType = {}));
export var Convassist_QuerySuggestion_Source;
(function (Convassist_QuerySuggestion_Source) {
    Convassist_QuerySuggestion_Source["ExploreSuggestions"] = "EXPLORE_SUGGESTIONS";
    Convassist_QuerySuggestion_Source["NlsFeedback"] = "NLS_FEEDBACK";
    Convassist_QuerySuggestion_Source["SuggestedQuestionBank"] = "SUGGESTED_QUESTION_BANK";
})(Convassist_QuerySuggestion_Source || (Convassist_QuerySuggestion_Source = {}));
export var Convassist_SendErrorMessageRequest_Source;
(function (Convassist_SendErrorMessageRequest_Source) {
    Convassist_SendErrorMessageRequest_Source["Ui"] = "UI";
})(Convassist_SendErrorMessageRequest_Source || (Convassist_SendErrorMessageRequest_Source = {}));
export var Convassist_Tool;
(function (Convassist_Tool) {
    Convassist_Tool["Ca"] = "CA";
    Convassist_Tool["DecomposeQuery"] = "DECOMPOSE_QUERY";
    Convassist_Tool["FetchData"] = "FETCH_DATA";
    Convassist_Tool["SuggestDataSource"] = "SUGGEST_DATA_SOURCE";
    Convassist_Tool["TsNls"] = "TS_NLS";
})(Convassist_Tool || (Convassist_Tool = {}));
export var Convassist_Context_InitialContextType;
(function (Convassist_Context_InitialContextType) {
    Convassist_Context_InitialContextType["TsAnswer"] = "TS_ANSWER";
    Convassist_Context_InitialContextType["TsWorksheet"] = "TS_WORKSHEET";
})(Convassist_Context_InitialContextType || (Convassist_Context_InitialContextType = {}));
export var Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType;
(function (Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType) {
    Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType["Answer"] = "ANSWER";
    Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType["Spotiq"] = "SPOTIQ";
})(Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType || (Convassist_Decompose_Query_Tool_DecomposeQueryToolAsstRespData_ResponseType = {}));
export var Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType;
(function (Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType) {
    Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType["Answer"] = "ANSWER";
    Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType["TextResponse"] = "TEXT_RESPONSE";
    Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType["TextWithAnswer"] = "TEXT_WITH_ANSWER";
})(Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType || (Convassist_Nls_Tool_NlsToolAsstRespData_ResponseType = {}));
export var Convassist_Nls_Tool_QuestionType;
(function (Convassist_Nls_Tool_QuestionType) {
    Convassist_Nls_Tool_QuestionType["AnswerSpecGeneration"] = "ANSWER_SPEC_GENERATION";
    Convassist_Nls_Tool_QuestionType["DataLiteracy"] = "DATA_LITERACY";
    Convassist_Nls_Tool_QuestionType["Unknown"] = "UNKNOWN";
})(Convassist_Nls_Tool_QuestionType || (Convassist_Nls_Tool_QuestionType = {}));
export var Core__Purpose;
(function (Core__Purpose) {
    Core__Purpose["Execution"] = "EXECUTION";
    Core__Purpose["Security"] = "SECURITY";
})(Core__Purpose || (Core__Purpose = {}));
export var Cortex_AnalysisInfo_AnalysisType;
(function (Cortex_AnalysisInfo_AnalysisType) {
    Cortex_AnalysisInfo_AnalysisType["Forecast"] = "FORECAST";
    Cortex_AnalysisInfo_AnalysisType["KeyDrivers"] = "KEY_DRIVERS";
    Cortex_AnalysisInfo_AnalysisType["KpiAnomalyDetection"] = "KPI_ANOMALY_DETECTION";
    Cortex_AnalysisInfo_AnalysisType["WhatIf"] = "WHAT_IF";
})(Cortex_AnalysisInfo_AnalysisType || (Cortex_AnalysisInfo_AnalysisType = {}));
export var Cortex_CortexEventStatus_ProcessingStatus;
(function (Cortex_CortexEventStatus_ProcessingStatus) {
    Cortex_CortexEventStatus_ProcessingStatus["Done"] = "DONE";
    Cortex_CortexEventStatus_ProcessingStatus["Error"] = "ERROR";
})(Cortex_CortexEventStatus_ProcessingStatus || (Cortex_CortexEventStatus_ProcessingStatus = {}));
export var Cortex_InferenceRequestV2_RequestMode;
(function (Cortex_InferenceRequestV2_RequestMode) {
    Cortex_InferenceRequestV2_RequestMode["AsyncInfer"] = "ASYNC_INFER";
    Cortex_InferenceRequestV2_RequestMode["AsyncTrain"] = "ASYNC_TRAIN";
    Cortex_InferenceRequestV2_RequestMode["AsyncTrainInfer"] = "ASYNC_TRAIN_INFER";
    Cortex_InferenceRequestV2_RequestMode["Benchmark"] = "BENCHMARK";
    Cortex_InferenceRequestV2_RequestMode["Fetch"] = "FETCH";
    Cortex_InferenceRequestV2_RequestMode["SyncDelete"] = "SYNC_DELETE";
    Cortex_InferenceRequestV2_RequestMode["SyncInfer"] = "SYNC_INFER";
    Cortex_InferenceRequestV2_RequestMode["SyncTrainInfer"] = "SYNC_TRAIN_INFER";
})(Cortex_InferenceRequestV2_RequestMode || (Cortex_InferenceRequestV2_RequestMode = {}));
export var Cortex_InferenceRequest_Type;
(function (Cortex_InferenceRequest_Type) {
    Cortex_InferenceRequest_Type["AsyncTrain"] = "ASYNC_TRAIN";
    Cortex_InferenceRequest_Type["InferOnly"] = "INFER_ONLY";
    Cortex_InferenceRequest_Type["SyncTrain"] = "SYNC_TRAIN";
})(Cortex_InferenceRequest_Type || (Cortex_InferenceRequest_Type = {}));
export var Cortex_IntegrationAction;
(function (Cortex_IntegrationAction) {
    Cortex_IntegrationAction["Create"] = "CREATE";
    Cortex_IntegrationAction["Delete"] = "DELETE";
    Cortex_IntegrationAction["Edit"] = "EDIT";
})(Cortex_IntegrationAction || (Cortex_IntegrationAction = {}));
export var Cortex_Matrix_TimeFrequency;
(function (Cortex_Matrix_TimeFrequency) {
    Cortex_Matrix_TimeFrequency["Daily"] = "DAILY";
    Cortex_Matrix_TimeFrequency["Hourly"] = "HOURLY";
    Cortex_Matrix_TimeFrequency["Monthly"] = "MONTHLY";
    Cortex_Matrix_TimeFrequency["None"] = "NONE";
    Cortex_Matrix_TimeFrequency["Quarterly"] = "QUARTERLY";
    Cortex_Matrix_TimeFrequency["Weekly"] = "WEEKLY";
    Cortex_Matrix_TimeFrequency["Yearly"] = "YEARLY";
})(Cortex_Matrix_TimeFrequency || (Cortex_Matrix_TimeFrequency = {}));
export var Cortex_SourceInfo_Source;
(function (Cortex_SourceInfo_Source) {
    Cortex_SourceInfo_Source["Answer"] = "ANSWER";
    Cortex_SourceInfo_Source["Liveboard"] = "LIVEBOARD";
    Cortex_SourceInfo_Source["LiveboardAnswer"] = "LIVEBOARD_ANSWER";
    Cortex_SourceInfo_Source["Unknown"] = "UNKNOWN";
})(Cortex_SourceInfo_Source || (Cortex_SourceInfo_Source = {}));
export var Cortex_VendorInfo_Vendor;
(function (Cortex_VendorInfo_Vendor) {
    Cortex_VendorInfo_Vendor["Datarobot"] = "DATAROBOT";
    Cortex_VendorInfo_Vendor["Thoughtspot"] = "THOUGHTSPOT";
})(Cortex_VendorInfo_Vendor || (Cortex_VendorInfo_Vendor = {}));
export var Datamanager_DmStatusResponse_DmRequestStatus;
(function (Datamanager_DmStatusResponse_DmRequestStatus) {
    Datamanager_DmStatusResponse_DmRequestStatus["Completed"] = "COMPLETED";
    Datamanager_DmStatusResponse_DmRequestStatus["ExecutingQuery"] = "EXECUTING_QUERY";
    Datamanager_DmStatusResponse_DmRequestStatus["InPriorityQueue"] = "IN_PRIORITY_QUEUE";
    Datamanager_DmStatusResponse_DmRequestStatus["ProcessingResults"] = "PROCESSING_RESULTS";
    Datamanager_DmStatusResponse_DmRequestStatus["Unknown"] = "UNKNOWN";
    Datamanager_DmStatusResponse_DmRequestStatus["WaitingForConnection"] = "WAITING_FOR_CONNECTION";
})(Datamanager_DmStatusResponse_DmRequestStatus || (Datamanager_DmStatusResponse_DmRequestStatus = {}));
export var Datamanager_DataSourceType;
(function (Datamanager_DataSourceType) {
    Datamanager_DataSourceType["Falcon"] = "FALCON";
    Datamanager_DataSourceType["RdbmsAmazonAthena"] = "RDBMS_AMAZON_ATHENA";
    Datamanager_DataSourceType["RdbmsAmazonAuroraMysql"] = "RDBMS_AMAZON_AURORA_MYSQL";
    Datamanager_DataSourceType["RdbmsAmazonAuroraPostgresql"] = "RDBMS_AMAZON_AURORA_POSTGRESQL";
    Datamanager_DataSourceType["RdbmsAmazonRdsMysql"] = "RDBMS_AMAZON_RDS_MYSQL";
    Datamanager_DataSourceType["RdbmsAmazonRdsPostgresql"] = "RDBMS_AMAZON_RDS_POSTGRESQL";
    Datamanager_DataSourceType["RdbmsAzureSqlDatawarehouse"] = "RDBMS_AZURE_SQL_DATAWAREHOUSE";
    Datamanager_DataSourceType["RdbmsClickhouse"] = "RDBMS_CLICKHOUSE";
    Datamanager_DataSourceType["RdbmsDatabricks"] = "RDBMS_DATABRICKS";
    Datamanager_DataSourceType["RdbmsDenodo"] = "RDBMS_DENODO";
    Datamanager_DataSourceType["RdbmsDremio"] = "RDBMS_DREMIO";
    Datamanager_DataSourceType["RdbmsDrSum"] = "RDBMS_DR_SUM";
    Datamanager_DataSourceType["RdbmsFalcon"] = "RDBMS_FALCON";
    Datamanager_DataSourceType["RdbmsFalconOnprem"] = "RDBMS_FALCON_ONPREM";
    Datamanager_DataSourceType["RdbmsGcpAlloydbPostgresql"] = "RDBMS_GCP_ALLOYDB_POSTGRESQL";
    Datamanager_DataSourceType["RdbmsGcpBigquery"] = "RDBMS_GCP_BIGQUERY";
    Datamanager_DataSourceType["RdbmsGcpMysql"] = "RDBMS_GCP_MYSQL";
    Datamanager_DataSourceType["RdbmsGcpPostgresql"] = "RDBMS_GCP_POSTGRESQL";
    Datamanager_DataSourceType["RdbmsGcpSqlserver"] = "RDBMS_GCP_SQLSERVER";
    Datamanager_DataSourceType["RdbmsGenericJdbc"] = "RDBMS_GENERIC_JDBC";
    Datamanager_DataSourceType["RdbmsGoogleSheets"] = "RDBMS_GOOGLE_SHEETS";
    Datamanager_DataSourceType["RdbmsLooker"] = "RDBMS_LOOKER";
    Datamanager_DataSourceType["RdbmsLookerMl"] = "RDBMS_LOOKER_ML";
    Datamanager_DataSourceType["RdbmsMockDatabase"] = "RDBMS_MOCK_DATABASE";
    Datamanager_DataSourceType["RdbmsMode"] = "RDBMS_MODE";
    Datamanager_DataSourceType["RdbmsMysql"] = "RDBMS_MYSQL";
    Datamanager_DataSourceType["RdbmsOracleAdw"] = "RDBMS_ORACLE_ADW";
    Datamanager_DataSourceType["RdbmsPostgres"] = "RDBMS_POSTGRES";
    Datamanager_DataSourceType["RdbmsPresto"] = "RDBMS_PRESTO";
    Datamanager_DataSourceType["RdbmsPrestoJdbc"] = "RDBMS_PRESTO_JDBC";
    Datamanager_DataSourceType["RdbmsRedshift"] = "RDBMS_REDSHIFT";
    Datamanager_DataSourceType["RdbmsSapHana"] = "RDBMS_SAP_HANA";
    Datamanager_DataSourceType["RdbmsSinglestore"] = "RDBMS_SINGLESTORE";
    Datamanager_DataSourceType["RdbmsSnowflake"] = "RDBMS_SNOWFLAKE";
    Datamanager_DataSourceType["RdbmsSqlserver"] = "RDBMS_SQLSERVER";
    Datamanager_DataSourceType["RdbmsTeradata"] = "RDBMS_TERADATA";
    Datamanager_DataSourceType["RdbmsTrino"] = "RDBMS_TRINO";
    Datamanager_DataSourceType["Unknown"] = "UNKNOWN";
})(Datamanager_DataSourceType || (Datamanager_DataSourceType = {}));
export var Datamanager_ExternalQueryRequestV2_QueryPriority;
(function (Datamanager_ExternalQueryRequestV2_QueryPriority) {
    Datamanager_ExternalQueryRequestV2_QueryPriority["High"] = "HIGH";
    Datamanager_ExternalQueryRequestV2_QueryPriority["Low"] = "LOW";
    Datamanager_ExternalQueryRequestV2_QueryPriority["Medium"] = "MEDIUM";
})(Datamanager_ExternalQueryRequestV2_QueryPriority || (Datamanager_ExternalQueryRequestV2_QueryPriority = {}));
export var Datamanager_ExternalQueryStats_Result_QueryStatus;
(function (Datamanager_ExternalQueryStats_Result_QueryStatus) {
    Datamanager_ExternalQueryStats_Result_QueryStatus["Error"] = "ERROR";
    Datamanager_ExternalQueryStats_Result_QueryStatus["Ok"] = "OK";
    Datamanager_ExternalQueryStats_Result_QueryStatus["Timeout"] = "TIMEOUT";
})(Datamanager_ExternalQueryStats_Result_QueryStatus || (Datamanager_ExternalQueryStats_Result_QueryStatus = {}));
export var Datamanager_LoadTableRequest_RequestType;
(function (Datamanager_LoadTableRequest_RequestType) {
    Datamanager_LoadTableRequest_RequestType["CsvUpload"] = "CSV_UPLOAD";
    Datamanager_LoadTableRequest_RequestType["CustomCal"] = "CUSTOM_CAL";
    Datamanager_LoadTableRequest_RequestType["UnknownRequestType"] = "UNKNOWN_REQUEST_TYPE";
})(Datamanager_LoadTableRequest_RequestType || (Datamanager_LoadTableRequest_RequestType = {}));
export var Datamanager_QueryTrigger_E;
(function (Datamanager_QueryTrigger_E) {
    Datamanager_QueryTrigger_E["AnswerEdit"] = "ANSWER_EDIT";
    Datamanager_QueryTrigger_E["AnswerView"] = "ANSWER_VIEW";
    Datamanager_QueryTrigger_E["Apis"] = "APIS";
    Datamanager_QueryTrigger_E["Caffeine"] = "CAFFEINE";
    Datamanager_QueryTrigger_E["CdwConnection"] = "CDW_CONNECTION";
    Datamanager_QueryTrigger_E["Cortex"] = "CORTEX";
    Datamanager_QueryTrigger_E["CustomCalendar"] = "CUSTOM_CALENDAR";
    Datamanager_QueryTrigger_E["DataWorkspaceQuery"] = "DATA_WORKSPACE_QUERY";
    Datamanager_QueryTrigger_E["DataWorkspaceSample"] = "DATA_WORKSPACE_SAMPLE";
    Datamanager_QueryTrigger_E["Dbt"] = "DBT";
    Datamanager_QueryTrigger_E["Download"] = "DOWNLOAD";
    Datamanager_QueryTrigger_E["DrillDown"] = "DRILL_DOWN";
    Datamanager_QueryTrigger_E["Explore"] = "EXPLORE";
    Datamanager_QueryTrigger_E["GetFilterValues"] = "GET_FILTER_VALUES";
    Datamanager_QueryTrigger_E["KpiMonitor"] = "KPI_MONITOR";
    Datamanager_QueryTrigger_E["LiveboardEdit"] = "LIVEBOARD_EDIT";
    Datamanager_QueryTrigger_E["LiveboardView"] = "LIVEBOARD_VIEW";
    Datamanager_QueryTrigger_E["Mobile"] = "MOBILE";
    Datamanager_QueryTrigger_E["Reportbook"] = "REPORTBOOK";
    Datamanager_QueryTrigger_E["RowCountStats"] = "ROW_COUNT_STATS";
    Datamanager_QueryTrigger_E["SageIndexing"] = "SAGE_INDEXING";
    Datamanager_QueryTrigger_E["SageSampling"] = "SAGE_SAMPLING";
    Datamanager_QueryTrigger_E["ScheduledPinboards"] = "SCHEDULED_PINBOARDS";
    Datamanager_QueryTrigger_E["SearchData"] = "SEARCH_DATA";
    Datamanager_QueryTrigger_E["SeedQuestions"] = "SEED_QUESTIONS";
    Datamanager_QueryTrigger_E["SpotiqAutoAnalyze"] = "SPOTIQ_AUTO_ANALYZE";
    Datamanager_QueryTrigger_E["Spotter"] = "SPOTTER";
    Datamanager_QueryTrigger_E["SpotApps"] = "SPOT_APPS";
    Datamanager_QueryTrigger_E["SqlEditor"] = "SQL_EDITOR";
    Datamanager_QueryTrigger_E["TsSync"] = "TS_SYNC";
    Datamanager_QueryTrigger_E["UnderlyingData"] = "UNDERLYING_DATA";
    Datamanager_QueryTrigger_E["Unknown"] = "UNKNOWN";
})(Datamanager_QueryTrigger_E || (Datamanager_QueryTrigger_E = {}));
export var Datamanager_TableMetadata_ColumnMetadata_Constraint;
(function (Datamanager_TableMetadata_ColumnMetadata_Constraint) {
    Datamanager_TableMetadata_ColumnMetadata_Constraint["Primary"] = "PRIMARY";
    Datamanager_TableMetadata_ColumnMetadata_Constraint["UnknownConstraint"] = "UNKNOWN_CONSTRAINT";
})(Datamanager_TableMetadata_ColumnMetadata_Constraint || (Datamanager_TableMetadata_ColumnMetadata_Constraint = {}));
export var Datamanager_TableMetadata_ColumnMetadata_DataType;
(function (Datamanager_TableMetadata_ColumnMetadata_DataType) {
    Datamanager_TableMetadata_ColumnMetadata_DataType["Bool"] = "BOOL";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Date"] = "DATE";
    Datamanager_TableMetadata_ColumnMetadata_DataType["DateTime"] = "DATE_TIME";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Double"] = "DOUBLE";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Float"] = "FLOAT";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Int32"] = "INT32";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Int64"] = "INT64";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Time"] = "TIME";
    Datamanager_TableMetadata_ColumnMetadata_DataType["UnknownDataType"] = "UNKNOWN_DATA_TYPE";
    Datamanager_TableMetadata_ColumnMetadata_DataType["Varchar"] = "VARCHAR";
})(Datamanager_TableMetadata_ColumnMetadata_DataType || (Datamanager_TableMetadata_ColumnMetadata_DataType = {}));
export var Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format;
(function (Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format) {
    Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format["Ddmmyyyy"] = "DDMMYYYY";
    Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format["Epoch"] = "EPOCH";
    Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format["Mmddyyyy"] = "MMDDYYYY";
    Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format["UnknownFormat"] = "UNKNOWN_FORMAT";
    Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format["Yyyymmdd"] = "YYYYMMDD";
})(Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format || (Datamanager_TableMetadata_ColumnMetadata_DateFormat_Format = {}));
export var Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType;
(function (Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType) {
    Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType["FilterColumn"] = "FILTER_COLUMN";
    Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType["GrowthColumn"] = "GROWTH_COLUMN";
    Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType["SageColumn"] = "SAGE_COLUMN";
    Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType["VizSpecificColumn"] = "VIZ_SPECIFIC_COLUMN";
})(Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType || (Entitylib_AnswerSpecProto_AnswerColumnProto_BaseColumnType = {}));
export var Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type;
(function (Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type) {
    Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type["Currency"] = "CURRENCY";
    Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type["None"] = "NONE";
    Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type["Percentage"] = "PERCENTAGE";
})(Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type || (Entitylib_AnswerSpecProto_AnswerColumnProto_ColumnFormat_Type = {}));
export var Entitylib_AnswerSpecProto_Type;
(function (Entitylib_AnswerSpecProto_Type) {
    Entitylib_AnswerSpecProto_Type["AskExpert"] = "ASK_EXPERT";
    Entitylib_AnswerSpecProto_Type["Autogenerated"] = "AUTOGENERATED";
    Entitylib_AnswerSpecProto_Type["Default"] = "DEFAULT";
    Entitylib_AnswerSpecProto_Type["SpotIq"] = "SPOT_IQ";
})(Entitylib_AnswerSpecProto_Type || (Entitylib_AnswerSpecProto_Type = {}));
export var Entitylib_ChartVizProto_ChartSpecificColumn_Type;
(function (Entitylib_ChartVizProto_ChartSpecificColumn_Type) {
    Entitylib_ChartVizProto_ChartSpecificColumn_Type["MeasureNames"] = "MEASURE_NAMES";
    Entitylib_ChartVizProto_ChartSpecificColumn_Type["MeasureValues"] = "MEASURE_VALUES";
    Entitylib_ChartVizProto_ChartSpecificColumn_Type["Undefined"] = "UNDEFINED";
})(Entitylib_ChartVizProto_ChartSpecificColumn_Type || (Entitylib_ChartVizProto_ChartSpecificColumn_Type = {}));
export var Entitylib_Chip_ChipType;
(function (Entitylib_Chip_ChipType) {
    Entitylib_Chip_ChipType["Filter"] = "FILTER";
    Entitylib_Chip_ChipType["Parameter"] = "PARAMETER";
})(Entitylib_Chip_ChipType || (Entitylib_Chip_ChipType = {}));
export var Entitylib_VizSpecProto_Type;
(function (Entitylib_VizSpecProto_Type) {
    Entitylib_VizSpecProto_Type["Chart"] = "CHART";
    Entitylib_VizSpecProto_Type["Filter"] = "FILTER";
    Entitylib_VizSpecProto_Type["Headline"] = "HEADLINE";
    Entitylib_VizSpecProto_Type["RAnalysis"] = "R_ANALYSIS";
    Entitylib_VizSpecProto_Type["Table"] = "TABLE";
})(Entitylib_VizSpecProto_Type || (Entitylib_VizSpecProto_Type = {}));
export var Eureka_AccessCode;
(function (Eureka_AccessCode) {
    Eureka_AccessCode["NoAccess"] = "NO_ACCESS";
    Eureka_AccessCode["Read"] = "READ";
    Eureka_AccessCode["Write"] = "WRITE";
})(Eureka_AccessCode || (Eureka_AccessCode = {}));
export var Eureka_AiAnswerState;
(function (Eureka_AiAnswerState) {
    Eureka_AiAnswerState["Error"] = "ERROR";
    Eureka_AiAnswerState["Expanded"] = "EXPANDED";
    Eureka_AiAnswerState["Minimized"] = "MINIMIZED";
    Eureka_AiAnswerState["Warning"] = "WARNING";
})(Eureka_AiAnswerState || (Eureka_AiAnswerState = {}));
export var Eureka_AmbiguityType;
(function (Eureka_AmbiguityType) {
    Eureka_AmbiguityType["ColumnSelection"] = "COLUMN_SELECTION";
    Eureka_AmbiguityType["KeywordSelection"] = "KEYWORD_SELECTION";
    Eureka_AmbiguityType["OperatorSelection"] = "OPERATOR_SELECTION";
    Eureka_AmbiguityType["Unknown"] = "UNKNOWN";
    Eureka_AmbiguityType["ValueSelection"] = "VALUE_SELECTION";
})(Eureka_AmbiguityType || (Eureka_AmbiguityType = {}));
export var Eureka_CoachingSource;
(function (Eureka_CoachingSource) {
    Eureka_CoachingSource["CoachingHomepage"] = "COACHING_HOMEPAGE";
    Eureka_CoachingSource["ConvassistMessage"] = "CONVASSIST_MESSAGE";
    Eureka_CoachingSource["ConvexMessage"] = "CONVEX_MESSAGE";
})(Eureka_CoachingSource || (Eureka_CoachingSource = {}));
export var Eureka_CompleteInfo_Type;
(function (Eureka_CompleteInfo_Type) {
    Eureka_CompleteInfo_Type["Any"] = "ANY";
    Eureka_CompleteInfo_Type["Column"] = "COLUMN";
    Eureka_CompleteInfo_Type["Object"] = "OBJECT";
    Eureka_CompleteInfo_Type["Query"] = "QUERY";
    Eureka_CompleteInfo_Type["Sticker"] = "STICKER";
    Eureka_CompleteInfo_Type["User"] = "USER";
    Eureka_CompleteInfo_Type["Value"] = "VALUE";
})(Eureka_CompleteInfo_Type || (Eureka_CompleteInfo_Type = {}));
export var Eureka_CompleteObjectResult_Type;
(function (Eureka_CompleteObjectResult_Type) {
    Eureka_CompleteObjectResult_Type["Answer"] = "ANSWER";
    Eureka_CompleteObjectResult_Type["Pinboard"] = "PINBOARD";
    Eureka_CompleteObjectResult_Type["Visualization"] = "VISUALIZATION";
})(Eureka_CompleteObjectResult_Type || (Eureka_CompleteObjectResult_Type = {}));
export var Eureka_CompleteQueryResult_Type;
(function (Eureka_CompleteQueryResult_Type) {
    Eureka_CompleteQueryResult_Type["Content"] = "CONTENT";
    Eureka_CompleteQueryResult_Type["Popular"] = "POPULAR";
    Eureka_CompleteQueryResult_Type["Recent"] = "RECENT";
})(Eureka_CompleteQueryResult_Type || (Eureka_CompleteQueryResult_Type = {}));
export var Eureka_CompleteRequest_AutoCompleteVersion;
(function (Eureka_CompleteRequest_AutoCompleteVersion) {
    Eureka_CompleteRequest_AutoCompleteVersion["AutocompleteVersionAbsent"] = "AUTOCOMPLETE_VERSION_ABSENT";
    Eureka_CompleteRequest_AutoCompleteVersion["ObjectSuggestions"] = "OBJECT_SUGGESTIONS";
    Eureka_CompleteRequest_AutoCompleteVersion["Production"] = "PRODUCTION";
    Eureka_CompleteRequest_AutoCompleteVersion["QuerySuggestionsV1"] = "QUERY_SUGGESTIONS_V1";
    Eureka_CompleteRequest_AutoCompleteVersion["QuerySuggestionsV2"] = "QUERY_SUGGESTIONS_V2";
})(Eureka_CompleteRequest_AutoCompleteVersion || (Eureka_CompleteRequest_AutoCompleteVersion = {}));
export var Eureka_ContextType;
(function (Eureka_ContextType) {
    Eureka_ContextType["TsAnswer"] = "TS_ANSWER";
    Eureka_ContextType["TsLb"] = "TS_LB";
    Eureka_ContextType["TsWorksheet"] = "TS_WORKSHEET";
})(Eureka_ContextType || (Eureka_ContextType = {}));
export var Eureka_DataStatsResponse_StatsType;
(function (Eureka_DataStatsResponse_StatsType) {
    Eureka_DataStatsResponse_StatsType["Cardinality"] = "CARDINALITY";
    Eureka_DataStatsResponse_StatsType["Max"] = "MAX";
    Eureka_DataStatsResponse_StatsType["Min"] = "MIN";
    Eureka_DataStatsResponse_StatsType["MostFrequentInData"] = "MOST_FREQUENT_IN_DATA";
})(Eureka_DataStatsResponse_StatsType || (Eureka_DataStatsResponse_StatsType = {}));
export var Eureka_EurekaSearchToken_Type;
(function (Eureka_EurekaSearchToken_Type) {
    Eureka_EurekaSearchToken_Type["Column"] = "COLUMN";
    Eureka_EurekaSearchToken_Type["Object"] = "OBJECT";
    Eureka_EurekaSearchToken_Type["Sticker"] = "STICKER";
    Eureka_EurekaSearchToken_Type["Unrecognized"] = "UNRECOGNIZED";
    Eureka_EurekaSearchToken_Type["User"] = "USER";
    Eureka_EurekaSearchToken_Type["Value"] = "VALUE";
})(Eureka_EurekaSearchToken_Type || (Eureka_EurekaSearchToken_Type = {}));
export var Eureka_FacetType;
(function (Eureka_FacetType) {
    Eureka_FacetType["AuthorGuid"] = "AUTHOR_GUID";
    Eureka_FacetType["AuthorInfo"] = "AUTHOR_INFO";
    Eureka_FacetType["IsVerified"] = "IS_VERIFIED";
    Eureka_FacetType["LastModifiedUserFacet"] = "LAST_MODIFIED_USER_FACET";
    Eureka_FacetType["ObjectType"] = "OBJECT_TYPE";
    Eureka_FacetType["ObjectTypeFacet"] = "OBJECT_TYPE_FACET";
    Eureka_FacetType["Stickers"] = "STICKERS";
    Eureka_FacetType["StickerGuid"] = "STICKER_GUID";
    Eureka_FacetType["Worksheets"] = "WORKSHEETS";
    Eureka_FacetType["WorksheetName"] = "WORKSHEET_NAME";
})(Eureka_FacetType || (Eureka_FacetType = {}));
export var Eureka_FeedbackScope;
(function (Eureka_FeedbackScope) {
    Eureka_FeedbackScope["Global"] = "GLOBAL";
    Eureka_FeedbackScope["SystemGenerated"] = "SYSTEM_GENERATED";
    Eureka_FeedbackScope["WorksheetUser"] = "WORKSHEET_USER";
})(Eureka_FeedbackScope || (Eureka_FeedbackScope = {}));
export var Eureka_FeedbackScopePolicy;
(function (Eureka_FeedbackScopePolicy) {
    Eureka_FeedbackScopePolicy["TsadminFeedbackGlobalByDefault"] = "TSADMIN_FEEDBACK_GLOBAL_BY_DEFAULT";
    Eureka_FeedbackScopePolicy["WorksheetEditorFeedbackGlobalByDefault"] = "WORKSHEET_EDITOR_FEEDBACK_GLOBAL_BY_DEFAULT";
})(Eureka_FeedbackScopePolicy || (Eureka_FeedbackScopePolicy = {}));
export var Eureka_Feedback_Type;
(function (Eureka_Feedback_Type) {
    Eureka_Feedback_Type["All"] = "ALL";
    Eureka_Feedback_Type["Fragment"] = "FRAGMENT";
    Eureka_Feedback_Type["Query"] = "QUERY";
})(Eureka_Feedback_Type || (Eureka_Feedback_Type = {}));
export var Eureka_FragmentPayload_FragmentType;
(function (Eureka_FragmentPayload_FragmentType) {
    Eureka_FragmentPayload_FragmentType["BusinessTerm"] = "BUSINESS_TERM";
    Eureka_FragmentPayload_FragmentType["Fragment"] = "FRAGMENT";
    Eureka_FragmentPayload_FragmentType["Synonym"] = "SYNONYM";
})(Eureka_FragmentPayload_FragmentType || (Eureka_FragmentPayload_FragmentType = {}));
export var Eureka_GetFeedbackFieldEntriesRequest_Field;
(function (Eureka_GetFeedbackFieldEntriesRequest_Field) {
    Eureka_GetFeedbackFieldEntriesRequest_Field["EditedBy"] = "EDITED_BY";
    Eureka_GetFeedbackFieldEntriesRequest_Field["FeedbackProvider"] = "FEEDBACK_PROVIDER";
    Eureka_GetFeedbackFieldEntriesRequest_Field["Worksheet"] = "WORKSHEET";
})(Eureka_GetFeedbackFieldEntriesRequest_Field || (Eureka_GetFeedbackFieldEntriesRequest_Field = {}));
export var Eureka_GetNlQueryFeedbackRequest_GroupBy;
(function (Eureka_GetNlQueryFeedbackRequest_GroupBy) {
    Eureka_GetNlQueryFeedbackRequest_GroupBy["ByFragment"] = "BY_FRAGMENT";
    Eureka_GetNlQueryFeedbackRequest_GroupBy["None"] = "NONE";
})(Eureka_GetNlQueryFeedbackRequest_GroupBy || (Eureka_GetNlQueryFeedbackRequest_GroupBy = {}));
export var Eureka_GetNlQueryFeedbackRequest_Type;
(function (Eureka_GetNlQueryFeedbackRequest_Type) {
    Eureka_GetNlQueryFeedbackRequest_Type["Both"] = "BOTH";
    Eureka_GetNlQueryFeedbackRequest_Type["Fragment"] = "FRAGMENT";
    Eureka_GetNlQueryFeedbackRequest_Type["Query"] = "QUERY";
})(Eureka_GetNlQueryFeedbackRequest_Type || (Eureka_GetNlQueryFeedbackRequest_Type = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field["EditedById"] = "EDITED_BY_ID";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field["FeedbackProviderId"] = "FEEDBACK_PROVIDER_ID";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field["Rating"] = "RATING";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field["Scope"] = "SCOPE";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field["WorksheetId"] = "WORKSHEET_ID";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field || (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Field = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating["DownVoted"] = "DOWN_VOTED";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating["UpVoted"] = "UP_VOTED";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating || (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Rating = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope["Global"] = "GLOBAL";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope["SystemGenerated"] = "SYSTEM_GENERATED";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope["WorksheetUser"] = "WORKSHEET_USER";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope || (Eureka_GetPaginatedNlQueryFeedbackRequest_Filter_Scope = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["ChartType"] = "CHART_TYPE";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["ModifiedAt"] = "MODIFIED_AT";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["NlQuery"] = "NL_QUERY";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["ParentQuery"] = "PARENT_QUERY";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["Rating"] = "RATING";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["SageTokensUsed"] = "SAGE_TOKENS_USED";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["Scope"] = "SCOPE";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field["Worksheet"] = "WORKSHEET";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field || (Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Field = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order["Asc"] = "ASC";
    Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order["Desc"] = "DESC";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order || (Eureka_GetPaginatedNlQueryFeedbackRequest_SortBy_Order = {}));
export var Eureka_GetPaginatedNlQueryFeedbackRequest_Type;
(function (Eureka_GetPaginatedNlQueryFeedbackRequest_Type) {
    Eureka_GetPaginatedNlQueryFeedbackRequest_Type["All"] = "ALL";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Type["Fragment"] = "FRAGMENT";
    Eureka_GetPaginatedNlQueryFeedbackRequest_Type["Query"] = "QUERY";
})(Eureka_GetPaginatedNlQueryFeedbackRequest_Type || (Eureka_GetPaginatedNlQueryFeedbackRequest_Type = {}));
export var Eureka_GetQuestionFragmentsResponse_ErrorCode;
(function (Eureka_GetQuestionFragmentsResponse_ErrorCode) {
    Eureka_GetQuestionFragmentsResponse_ErrorCode["FragmentRedundant"] = "FRAGMENT_REDUNDANT";
    Eureka_GetQuestionFragmentsResponse_ErrorCode["NlpException"] = "NLP_EXCEPTION";
    Eureka_GetQuestionFragmentsResponse_ErrorCode["Success"] = "SUCCESS";
})(Eureka_GetQuestionFragmentsResponse_ErrorCode || (Eureka_GetQuestionFragmentsResponse_ErrorCode = {}));
export var Eureka_ImpressionSearchRequest_EventType;
(function (Eureka_ImpressionSearchRequest_EventType) {
    Eureka_ImpressionSearchRequest_EventType["OpenAnswer"] = "OPEN_ANSWER";
    Eureka_ImpressionSearchRequest_EventType["OpenPinboard"] = "OPEN_PINBOARD";
})(Eureka_ImpressionSearchRequest_EventType || (Eureka_ImpressionSearchRequest_EventType = {}));
export var Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType;
(function (Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType) {
    Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType["Answer"] = "ANSWER";
    Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType["Pinboard"] = "PINBOARD";
    Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType["Visualization"] = "VISUALIZATION";
})(Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType || (Eureka_MatchCriteria_ObjectTypeCriterion_ObjectType = {}));
export var Eureka_ModificationType;
(function (Eureka_ModificationType) {
    Eureka_ModificationType["Add"] = "ADD";
    Eureka_ModificationType["Delete"] = "DELETE";
    Eureka_ModificationType["Replace"] = "REPLACE";
})(Eureka_ModificationType || (Eureka_ModificationType = {}));
export var Eureka_NlHandlerVersion;
(function (Eureka_NlHandlerVersion) {
    Eureka_NlHandlerVersion["Latest"] = "LATEST";
    Eureka_NlHandlerVersion["Stable"] = "STABLE";
    Eureka_NlHandlerVersion["Tslm"] = "TSLM";
})(Eureka_NlHandlerVersion || (Eureka_NlHandlerVersion = {}));
export var Eureka_NlsRequest_ConversationContext_Role;
(function (Eureka_NlsRequest_ConversationContext_Role) {
    Eureka_NlsRequest_ConversationContext_Role["Assistant"] = "ASSISTANT";
    Eureka_NlsRequest_ConversationContext_Role["System"] = "SYSTEM";
    Eureka_NlsRequest_ConversationContext_Role["User"] = "USER";
})(Eureka_NlsRequest_ConversationContext_Role || (Eureka_NlsRequest_ConversationContext_Role = {}));
export var Eureka_ParentType;
(function (Eureka_ParentType) {
    Eureka_ParentType["Answer"] = "ANSWER";
    Eureka_ParentType["Pinboard"] = "PINBOARD";
})(Eureka_ParentType || (Eureka_ParentType = {}));
export var Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation;
(function (Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation) {
    Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation["DeleteFeedback"] = "DELETE_FEEDBACK";
    Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation["UpdateFeedbackScope"] = "UPDATE_FEEDBACK_SCOPE";
})(Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation || (Eureka_PutNlQueryFeedbackRequest_BulkOperation_Operation = {}));
export var Eureka_Result_ResultType;
(function (Eureka_Result_ResultType) {
    Eureka_Result_ResultType["AnswerResult"] = "ANSWER_RESULT";
    Eureka_Result_ResultType["PinboardResult"] = "PINBOARD_RESULT";
    Eureka_Result_ResultType["PinboardVizResult"] = "PINBOARD_VIZ_RESULT";
})(Eureka_Result_ResultType || (Eureka_Result_ResultType = {}));
export var Eureka_SageQuerySuggestion_QueryIntentType;
(function (Eureka_SageQuerySuggestion_QueryIntentType) {
    Eureka_SageQuerySuggestion_QueryIntentType["IsDataExplanation"] = "IS_DATA_EXPLANATION";
    Eureka_SageQuerySuggestion_QueryIntentType["IsSpotIq"] = "IS_SPOT_IQ";
    Eureka_SageQuerySuggestion_QueryIntentType["IsUnrelated"] = "IS_UNRELATED";
    Eureka_SageQuerySuggestion_QueryIntentType["IsVisualization"] = "IS_VISUALIZATION";
})(Eureka_SageQuerySuggestion_QueryIntentType || (Eureka_SageQuerySuggestion_QueryIntentType = {}));
export var Eureka_SearchRequest_SearchResultOption;
(function (Eureka_SearchRequest_SearchResultOption) {
    Eureka_SearchRequest_SearchResultOption["AiAnswer"] = "AI_ANSWER";
    Eureka_SearchRequest_SearchResultOption["Both"] = "BOTH";
    Eureka_SearchRequest_SearchResultOption["SearchResults"] = "SEARCH_RESULTS";
})(Eureka_SearchRequest_SearchResultOption || (Eureka_SearchRequest_SearchResultOption = {}));
export var Eureka_SearchRequest_SearcherVersion;
(function (Eureka_SearchRequest_SearcherVersion) {
    Eureka_SearchRequest_SearcherVersion["HierarchicalScore"] = "HIERARCHICAL_SCORE";
    Eureka_SearchRequest_SearcherVersion["Production"] = "PRODUCTION";
    Eureka_SearchRequest_SearcherVersion["QueryBuilderV2"] = "QUERY_BUILDER_V2";
    Eureka_SearchRequest_SearcherVersion["SearcherVersionAbsent"] = "SEARCHER_VERSION_ABSENT";
    Eureka_SearchRequest_SearcherVersion["UseCaseBasedQueryBuilder"] = "USE_CASE_BASED_QUERY_BUILDER";
})(Eureka_SearchRequest_SearcherVersion || (Eureka_SearchRequest_SearcherVersion = {}));
export var Eureka_SearchRequest_SortOnType;
(function (Eureka_SearchRequest_SortOnType) {
    Eureka_SearchRequest_SortOnType["CreatedMs"] = "CREATED_MS";
    Eureka_SearchRequest_SortOnType["ImpressionsOverall"] = "IMPRESSIONS_OVERALL";
    Eureka_SearchRequest_SortOnType["ModifiedMs"] = "MODIFIED_MS";
    Eureka_SearchRequest_SortOnType["Score"] = "SCORE";
})(Eureka_SearchRequest_SortOnType || (Eureka_SearchRequest_SortOnType = {}));
export var Eureka_SearchRequest_SortOrder;
(function (Eureka_SearchRequest_SortOrder) {
    Eureka_SearchRequest_SortOrder["Ascending"] = "ASCENDING";
    Eureka_SearchRequest_SortOrder["Descending"] = "DESCENDING";
})(Eureka_SearchRequest_SortOrder || (Eureka_SearchRequest_SortOrder = {}));
export var Eureka_SearchRequest_Source;
(function (Eureka_SearchRequest_Source) {
    Eureka_SearchRequest_Source["QuerySuggestion"] = "QUERY_SUGGESTION";
    Eureka_SearchRequest_Source["Typed"] = "TYPED";
})(Eureka_SearchRequest_Source || (Eureka_SearchRequest_Source = {}));
export var Eureka_SearchResultRelevanceFeedback_Rating;
(function (Eureka_SearchResultRelevanceFeedback_Rating) {
    Eureka_SearchResultRelevanceFeedback_Rating["HighlyRelevant"] = "HIGHLY_RELEVANT";
    Eureka_SearchResultRelevanceFeedback_Rating["Irrelevant"] = "IRRELEVANT";
    Eureka_SearchResultRelevanceFeedback_Rating["SlightlyRelevant"] = "SLIGHTLY_RELEVANT";
    Eureka_SearchResultRelevanceFeedback_Rating["Unspecified"] = "UNSPECIFIED";
})(Eureka_SearchResultRelevanceFeedback_Rating || (Eureka_SearchResultRelevanceFeedback_Rating = {}));
export var Eureka_Skill;
(function (Eureka_Skill) {
    Eureka_Skill["Cca"] = "CCA";
    Eureka_Skill["Nls"] = "NLS";
    Eureka_Skill["SkillUnspecified"] = "SKILL_UNSPECIFIED";
    Eureka_Skill["Why"] = "WHY";
})(Eureka_Skill || (Eureka_Skill = {}));
export var Eureka_WarningType;
(function (Eureka_WarningType) {
    Eureka_WarningType["ChartIntentApplied"] = "CHART_INTENT_APPLIED";
    Eureka_WarningType["ChartIntentDetected"] = "CHART_INTENT_DETECTED";
    Eureka_WarningType["ColumnChangedValueHeuristicApplied"] = "COLUMN_CHANGED_VALUE_HEURISTIC_APPLIED";
    Eureka_WarningType["ContainsHeuristicApplied"] = "CONTAINS_HEURISTIC_APPLIED";
    Eureka_WarningType["EmptyInputToTml"] = "EMPTY_INPUT_TO_TML";
    Eureka_WarningType["NoInitialQuesInCtx"] = "NO_INITIAL_QUES_IN_CTX";
    Eureka_WarningType["NoMatchValueHeuristicApplied"] = "NO_MATCH_VALUE_HEURISTIC_APPLIED";
    Eureka_WarningType["PartialTmlConversion"] = "PARTIAL_TML_CONVERSION";
    Eureka_WarningType["PartialTmlSanitization"] = "PARTIAL_TML_SANITIZATION";
    Eureka_WarningType["RandomColSelection"] = "RANDOM_COL_SELECTION";
    Eureka_WarningType["ReplaceValueHeuristicApplied"] = "REPLACE_VALUE_HEURISTIC_APPLIED";
    Eureka_WarningType["SampleValueMissing"] = "SAMPLE_VALUE_MISSING";
    Eureka_WarningType["TotalTmlSanitization"] = "TOTAL_TML_SANITIZATION";
})(Eureka_WarningType || (Eureka_WarningType = {}));
export var Eureka_Agent_ResolveTokenRequest_ResolveType;
(function (Eureka_Agent_ResolveTokenRequest_ResolveType) {
    Eureka_Agent_ResolveTokenRequest_ResolveType["AddSynonym"] = "ADD_SYNONYM";
    Eureka_Agent_ResolveTokenRequest_ResolveType["Ignore"] = "IGNORE";
})(Eureka_Agent_ResolveTokenRequest_ResolveType || (Eureka_Agent_ResolveTokenRequest_ResolveType = {}));
export var Eureka_Agent_ResolveTokenResponse_Status;
(function (Eureka_Agent_ResolveTokenResponse_Status) {
    Eureka_Agent_ResolveTokenResponse_Status["Failed"] = "FAILED";
    Eureka_Agent_ResolveTokenResponse_Status["Received"] = "RECEIVED";
})(Eureka_Agent_ResolveTokenResponse_Status || (Eureka_Agent_ResolveTokenResponse_Status = {}));
export var Eureka_Agent_SynonymInfo_ResolutionType;
(function (Eureka_Agent_SynonymInfo_ResolutionType) {
    Eureka_Agent_SynonymInfo_ResolutionType["Ignored"] = "IGNORED";
    Eureka_Agent_SynonymInfo_ResolutionType["Queued"] = "QUEUED";
    Eureka_Agent_SynonymInfo_ResolutionType["Resolved"] = "RESOLVED";
    Eureka_Agent_SynonymInfo_ResolutionType["Unresolved"] = "UNRESOLVED";
})(Eureka_Agent_SynonymInfo_ResolutionType || (Eureka_Agent_SynonymInfo_ResolutionType = {}));
export var Eureka_Agent_TokenType;
(function (Eureka_Agent_TokenType) {
    Eureka_Agent_TokenType["Resolved"] = "RESOLVED";
    Eureka_Agent_TokenType["Unresolved"] = "UNRESOLVED";
})(Eureka_Agent_TokenType || (Eureka_Agent_TokenType = {}));
export var Eureka_Agent_Transaction_ActionType;
(function (Eureka_Agent_Transaction_ActionType) {
    Eureka_Agent_Transaction_ActionType["ResolveToken"] = "RESOLVE_TOKEN";
})(Eureka_Agent_Transaction_ActionType || (Eureka_Agent_Transaction_ActionType = {}));
export var Eureka_Agent_Transaction_Status;
(function (Eureka_Agent_Transaction_Status) {
    Eureka_Agent_Transaction_Status["Done"] = "DONE";
    Eureka_Agent_Transaction_Status["Failed"] = "FAILED";
    Eureka_Agent_Transaction_Status["NotQueued"] = "NOT_QUEUED";
    Eureka_Agent_Transaction_Status["Queued"] = "QUEUED";
})(Eureka_Agent_Transaction_Status || (Eureka_Agent_Transaction_Status = {}));
export var Eureka_Common_PermissionsType;
(function (Eureka_Common_PermissionsType) {
    Eureka_Common_PermissionsType["D13YPermissionsExplicit"] = "D13Y_PERMISSIONS_EXPLICIT";
    Eureka_Common_PermissionsType["PermissionExplicit"] = "PERMISSION_EXPLICIT";
    Eureka_Common_PermissionsType["PermissionFlattened"] = "PERMISSION_FLATTENED";
    Eureka_Common_PermissionsType["PermissionUnspecified"] = "PERMISSION_UNSPECIFIED";
})(Eureka_Common_PermissionsType || (Eureka_Common_PermissionsType = {}));
export var Eureka_Dataindexer_ContextType;
(function (Eureka_Dataindexer_ContextType) {
    Eureka_Dataindexer_ContextType["Answer"] = "ANSWER";
    Eureka_Dataindexer_ContextType["ContextTypeUnknown"] = "CONTEXT_TYPE_UNKNOWN";
    Eureka_Dataindexer_ContextType["Conversation"] = "CONVERSATION";
    Eureka_Dataindexer_ContextType["Liveboard"] = "LIVEBOARD";
    Eureka_Dataindexer_ContextType["Org"] = "ORG";
    Eureka_Dataindexer_ContextType["Tag"] = "TAG";
    Eureka_Dataindexer_ContextType["User"] = "USER";
    Eureka_Dataindexer_ContextType["UserGroup"] = "USER_GROUP";
    Eureka_Dataindexer_ContextType["Worksheet"] = "WORKSHEET";
})(Eureka_Dataindexer_ContextType || (Eureka_Dataindexer_ContextType = {}));
export var Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field;
(function (Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field) {
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field["CreatedBy"] = "CREATED_BY";
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field["ModifiedBy"] = "MODIFIED_BY";
})(Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field || (Eureka_Dataindexer_GeneratedMemorySourcesRequest_Filter_Field = {}));
export var Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field;
(function (Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field) {
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field["CreatedAt"] = "CREATED_AT";
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field["ModifiedAt"] = "MODIFIED_AT";
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field["SourceName"] = "SOURCE_NAME";
})(Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field || (Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Field = {}));
export var Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order;
(function (Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order) {
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order["Asc"] = "ASC";
    Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order["Desc"] = "DESC";
})(Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order || (Eureka_Dataindexer_GeneratedMemorySourcesRequest_SortBy_Order = {}));
export var Eureka_Dataindexer_MemoryInfraErrorCode;
(function (Eureka_Dataindexer_MemoryInfraErrorCode) {
    Eureka_Dataindexer_MemoryInfraErrorCode["GrpcCallError"] = "GRPC_CALL_ERROR";
    Eureka_Dataindexer_MemoryInfraErrorCode["GrpcConnectionError"] = "GRPC_CONNECTION_ERROR";
    Eureka_Dataindexer_MemoryInfraErrorCode["InvalidRequest"] = "INVALID_REQUEST";
    Eureka_Dataindexer_MemoryInfraErrorCode["Success"] = "SUCCESS";
    Eureka_Dataindexer_MemoryInfraErrorCode["UnknownError"] = "UNKNOWN_ERROR";
})(Eureka_Dataindexer_MemoryInfraErrorCode || (Eureka_Dataindexer_MemoryInfraErrorCode = {}));
export var Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus;
(function (Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus) {
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["Cancelled"] = "CANCELLED";
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["Completed"] = "COMPLETED";
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["Failed"] = "FAILED";
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["InProgress"] = "IN_PROGRESS";
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["Queued"] = "QUEUED";
    Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus["Unknown"] = "UNKNOWN";
})(Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus || (Eureka_Dataindexer_MemorySourceGenerateStatus_MemoryGenerationStatus = {}));
export var Eureka_Dataindexer_MemorySourceType;
(function (Eureka_Dataindexer_MemorySourceType) {
    Eureka_Dataindexer_MemorySourceType["TypeLiveboard"] = "TYPE_LIVEBOARD";
    Eureka_Dataindexer_MemorySourceType["TypeWorksheet"] = "TYPE_WORKSHEET";
})(Eureka_Dataindexer_MemorySourceType || (Eureka_Dataindexer_MemorySourceType = {}));
export var Eureka_Dataindexer_MemoryStatus;
(function (Eureka_Dataindexer_MemoryStatus) {
    Eureka_Dataindexer_MemoryStatus["MemoryCreated"] = "MEMORY_CREATED";
    Eureka_Dataindexer_MemoryStatus["MemoryNotCreated"] = "MEMORY_NOT_CREATED";
    Eureka_Dataindexer_MemoryStatus["Unknown"] = "UNKNOWN";
})(Eureka_Dataindexer_MemoryStatus || (Eureka_Dataindexer_MemoryStatus = {}));
export var Eureka_Dataindexer_MemoryType;
(function (Eureka_Dataindexer_MemoryType) {
    Eureka_Dataindexer_MemoryType["Facts"] = "FACTS";
    Eureka_Dataindexer_MemoryType["Instructions"] = "INSTRUCTIONS";
    Eureka_Dataindexer_MemoryType["MemoryTypeUnknown"] = "MEMORY_TYPE_UNKNOWN";
    Eureka_Dataindexer_MemoryType["Recipes"] = "RECIPES";
    Eureka_Dataindexer_MemoryType["Rules"] = "RULES";
})(Eureka_Dataindexer_MemoryType || (Eureka_Dataindexer_MemoryType = {}));
export var Eureka_Docsearcher_DocSearchRequest_SortOnType;
(function (Eureka_Docsearcher_DocSearchRequest_SortOnType) {
    Eureka_Docsearcher_DocSearchRequest_SortOnType["ModifiedMs"] = "MODIFIED_MS";
    Eureka_Docsearcher_DocSearchRequest_SortOnType["Score"] = "SCORE";
})(Eureka_Docsearcher_DocSearchRequest_SortOnType || (Eureka_Docsearcher_DocSearchRequest_SortOnType = {}));
export var Eureka_Docsearcher_DocSearchRequest_SortOrder;
(function (Eureka_Docsearcher_DocSearchRequest_SortOrder) {
    Eureka_Docsearcher_DocSearchRequest_SortOrder["Ascending"] = "ASCENDING";
    Eureka_Docsearcher_DocSearchRequest_SortOrder["Descending"] = "DESCENDING";
})(Eureka_Docsearcher_DocSearchRequest_SortOrder || (Eureka_Docsearcher_DocSearchRequest_SortOrder = {}));
export var Eureka_Metadata_ChatMetaType;
(function (Eureka_Metadata_ChatMetaType) {
    Eureka_Metadata_ChatMetaType["ChatName"] = "CHAT_NAME";
    Eureka_Metadata_ChatMetaType["Questions"] = "QUESTIONS";
})(Eureka_Metadata_ChatMetaType || (Eureka_Metadata_ChatMetaType = {}));
export var Eureka_Metadata_ColumnMetadata_ColumnType;
(function (Eureka_Metadata_ColumnMetadata_ColumnType) {
    Eureka_Metadata_ColumnMetadata_ColumnType["Attribute"] = "ATTRIBUTE";
    Eureka_Metadata_ColumnMetadata_ColumnType["Cohort"] = "COHORT";
    Eureka_Metadata_ColumnMetadata_ColumnType["Formula"] = "FORMULA";
    Eureka_Metadata_ColumnMetadata_ColumnType["Measure"] = "MEASURE";
    Eureka_Metadata_ColumnMetadata_ColumnType["Unknown"] = "UNKNOWN";
})(Eureka_Metadata_ColumnMetadata_ColumnType || (Eureka_Metadata_ColumnMetadata_ColumnType = {}));
export var Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType;
(function (Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType) {
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType["Attribute"] = "ATTRIBUTE";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType["Cohort"] = "COHORT";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType["Formula"] = "FORMULA";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType["Measure"] = "MEASURE";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType["Unknown"] = "UNKNOWN";
})(Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType || (Eureka_Metadata_GenerateSeedQuestionsRequest_Column_ColumnType = {}));
export var Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType;
(function (Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType) {
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType["Date"] = "DATE";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType["DateTime"] = "DATE_TIME";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType["Number"] = "NUMBER";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType["String"] = "STRING";
    Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType["Time"] = "TIME";
})(Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType || (Eureka_Metadata_GenerateSeedQuestionsRequest_Column_DataType = {}));
export var Eureka_Metadata_QuestionType;
(function (Eureka_Metadata_QuestionType) {
    Eureka_Metadata_QuestionType["AnswerGeneratedQuestion"] = "ANSWER_GENERATED_QUESTION";
    Eureka_Metadata_QuestionType["SeedQuestion"] = "SEED_QUESTION";
})(Eureka_Metadata_QuestionType || (Eureka_Metadata_QuestionType = {}));
export var Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType;
(function (Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType) {
    Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType["All"] = "ALL";
    Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType["Table"] = "TABLE";
    Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType["Worksheet"] = "WORKSHEET";
})(Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType || (Eureka_Metadata_UpdateModelRequest_ColumnProperty_IndexProperty_LogicalTableType = {}));
export var Eureka_Metadata_UpdateModelResponse_StatusCode;
(function (Eureka_Metadata_UpdateModelResponse_StatusCode) {
    Eureka_Metadata_UpdateModelResponse_StatusCode["AllTableColumnsFailure"] = "ALL_TABLE_COLUMNS_FAILURE";
    Eureka_Metadata_UpdateModelResponse_StatusCode["PartialTableColumnsFailure"] = "PARTIAL_TABLE_COLUMNS_FAILURE";
    Eureka_Metadata_UpdateModelResponse_StatusCode["Success"] = "SUCCESS";
    Eureka_Metadata_UpdateModelResponse_StatusCode["UnknownFailure"] = "UNKNOWN_FAILURE";
})(Eureka_Metadata_UpdateModelResponse_StatusCode || (Eureka_Metadata_UpdateModelResponse_StatusCode = {}));
export var Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType;
(function (Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType) {
    Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType["ColumnChange"] = "COLUMN_CHANGE";
    Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType["Contains"] = "CONTAINS";
    Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType["ExactMatch"] = "EXACT_MATCH";
    Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType["NoMatch"] = "NO_MATCH";
    Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType["Replace"] = "REPLACE";
})(Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType || (Eureka_Metadata_ValueHeuristicsResponse_ValueHeuristicType = {}));
export var Eureka_Metadata_WsSageIssuesRequest_IssueType;
(function (Eureka_Metadata_WsSageIssuesRequest_IssueType) {
    Eureka_Metadata_WsSageIssuesRequest_IssueType["All"] = "ALL";
    Eureka_Metadata_WsSageIssuesRequest_IssueType["ColumnNameAndDataType"] = "COLUMN_NAME_AND_DATA_TYPE";
    Eureka_Metadata_WsSageIssuesRequest_IssueType["ColumnType"] = "COLUMN_TYPE";
    Eureka_Metadata_WsSageIssuesRequest_IssueType["Indexing"] = "INDEXING";
})(Eureka_Metadata_WsSageIssuesRequest_IssueType || (Eureka_Metadata_WsSageIssuesRequest_IssueType = {}));
export var Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType;
(function (Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType) {
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["AttributeSetAsMeasure"] = "ATTRIBUTE_SET_AS_MEASURE";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["ColumnNameWithInvalidAggregation"] = "COLUMN_NAME_WITH_INVALID_AGGREGATION";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["ColumnNameWithInvalidCharacters"] = "COLUMN_NAME_WITH_INVALID_CHARACTERS";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["ColumnNameWithInvalidColumnType"] = "COLUMN_NAME_WITH_INVALID_COLUMN_TYPE";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["ColumnNameWithInvalidLength"] = "COLUMN_NAME_WITH_INVALID_LENGTH";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["ColumnValuesDatatypeMismatch"] = "COLUMN_VALUES_DATATYPE_MISMATCH";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["TableColumnWithDontIndexStatus"] = "TABLE_COLUMN_WITH_DONT_INDEX_STATUS";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["WorksheetColumnNotIndexedAndValueQueried"] = "WORKSHEET_COLUMN_NOT_INDEXED_AND_VALUE_QUERIED";
    Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType["WorksheetColumnSuggestValueDisabled"] = "WORKSHEET_COLUMN_SUGGEST_VALUE_DISABLED";
})(Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType || (Eureka_Metadata_WsSageIssuesResponse_ColumnIssueType = {}));
export var Export_Service_ObjectType;
(function (Export_Service_ObjectType) {
    Export_Service_ObjectType["Answer"] = "ANSWER";
    Export_Service_ObjectType["Pinboard"] = "PINBOARD";
})(Export_Service_ObjectType || (Export_Service_ObjectType = {}));
export var Export_Service_Orientation;
(function (Export_Service_Orientation) {
    Export_Service_Orientation["Landscape"] = "LANDSCAPE";
    Export_Service_Orientation["Portrait"] = "PORTRAIT";
})(Export_Service_Orientation || (Export_Service_Orientation = {}));
export var Export_Service_OutputType;
(function (Export_Service_OutputType) {
    Export_Service_OutputType["Csv"] = "CSV";
    Export_Service_OutputType["Pdf"] = "PDF";
    Export_Service_OutputType["Png"] = "PNG";
    Export_Service_OutputType["Xlsx"] = "XLSX";
})(Export_Service_OutputType || (Export_Service_OutputType = {}));
export var Export_Service_PageSize;
(function (Export_Service_PageSize) {
    Export_Service_PageSize["A4"] = "A4";
})(Export_Service_PageSize || (Export_Service_PageSize = {}));
export var Export_Service_PinboardParams_LayoutType;
(function (Export_Service_PinboardParams_LayoutType) {
    Export_Service_PinboardParams_LayoutType["Pinboard"] = "PINBOARD";
    Export_Service_PinboardParams_LayoutType["Visualization"] = "VISUALIZATION";
})(Export_Service_PinboardParams_LayoutType || (Export_Service_PinboardParams_LayoutType = {}));
export var Export_Service_RequestType;
(function (Export_Service_RequestType) {
    Export_Service_RequestType["Download"] = "DOWNLOAD";
    Export_Service_RequestType["Schedule"] = "SCHEDULE";
})(Export_Service_RequestType || (Export_Service_RequestType = {}));
export var Falcon_AggregateOp_E;
(function (Falcon_AggregateOp_E) {
    Falcon_AggregateOp_E["AggrApproxCountDistinct"] = "AGGR_APPROX_COUNT_DISTINCT";
    Falcon_AggregateOp_E["AggrApproxDistinct"] = "AGGR_APPROX_DISTINCT";
    Falcon_AggregateOp_E["AggrApproxDistinctMerge"] = "AGGR_APPROX_DISTINCT_MERGE";
    Falcon_AggregateOp_E["AggrAverage"] = "AGGR_AVERAGE";
    Falcon_AggregateOp_E["AggrCountDistinct"] = "AGGR_COUNT_DISTINCT";
    Falcon_AggregateOp_E["AggrCountDistinctNonNull"] = "AGGR_COUNT_DISTINCT_NON_NULL";
    Falcon_AggregateOp_E["AggrCountDistinctV1"] = "AGGR_COUNT_DISTINCT_V1";
    Falcon_AggregateOp_E["AggrCountNonNull"] = "AGGR_COUNT_NON_NULL";
    Falcon_AggregateOp_E["AggrCountWithNull"] = "AGGR_COUNT_WITH_NULL";
    Falcon_AggregateOp_E["AggrDenseRank"] = "AGGR_DENSE_RANK";
    Falcon_AggregateOp_E["AggrDistinct"] = "AGGR_DISTINCT";
    Falcon_AggregateOp_E["AggrDistinctNonNull"] = "AGGR_DISTINCT_NON_NULL";
    Falcon_AggregateOp_E["AggrGrowth"] = "AGGR_GROWTH";
    Falcon_AggregateOp_E["AggrMax"] = "AGGR_MAX";
    Falcon_AggregateOp_E["AggrMedian"] = "AGGR_MEDIAN";
    Falcon_AggregateOp_E["AggrMin"] = "AGGR_MIN";
    Falcon_AggregateOp_E["AggrNone"] = "AGGR_NONE";
    Falcon_AggregateOp_E["AggrNtile"] = "AGGR_NTILE";
    Falcon_AggregateOp_E["AggrPercentileContWithinGroup"] = "AGGR_PERCENTILE_CONT_WITHIN_GROUP";
    Falcon_AggregateOp_E["AggrPercentileDiscWithinGroup"] = "AGGR_PERCENTILE_DISC_WITHIN_GROUP";
    Falcon_AggregateOp_E["AggrPercentRank"] = "AGGR_PERCENT_RANK";
    Falcon_AggregateOp_E["AggrRank"] = "AGGR_RANK";
    Falcon_AggregateOp_E["AggrRankPercentile"] = "AGGR_RANK_PERCENTILE";
    Falcon_AggregateOp_E["AggrRowNumber"] = "AGGR_ROW_NUMBER";
    Falcon_AggregateOp_E["AggrStdev"] = "AGGR_STDEV";
    Falcon_AggregateOp_E["AggrSum"] = "AGGR_SUM";
    Falcon_AggregateOp_E["AggrValueBreak"] = "AGGR_VALUE_BREAK";
    Falcon_AggregateOp_E["AggrVariance"] = "AGGR_VARIANCE";
    Falcon_AggregateOp_E["Avg"] = "AVG";
    Falcon_AggregateOp_E["Count"] = "COUNT";
    Falcon_AggregateOp_E["CountDistinct"] = "COUNT_DISTINCT";
    Falcon_AggregateOp_E["CountNonNull"] = "COUNT_NON_NULL";
    Falcon_AggregateOp_E["CountWithNull"] = "COUNT_WITH_NULL";
    Falcon_AggregateOp_E["Growth"] = "GROWTH";
    Falcon_AggregateOp_E["Max"] = "MAX";
    Falcon_AggregateOp_E["Median"] = "MEDIAN";
    Falcon_AggregateOp_E["Min"] = "MIN";
    Falcon_AggregateOp_E["None"] = "NONE";
    Falcon_AggregateOp_E["SqlBoolAggregate"] = "SQL_BOOL_AGGREGATE";
    Falcon_AggregateOp_E["SqlDateAggregate"] = "SQL_DATE_AGGREGATE";
    Falcon_AggregateOp_E["SqlDateTimeAggregate"] = "SQL_DATE_TIME_AGGREGATE";
    Falcon_AggregateOp_E["SqlDoubleAggregate"] = "SQL_DOUBLE_AGGREGATE";
    Falcon_AggregateOp_E["SqlIntAggregate"] = "SQL_INT_AGGREGATE";
    Falcon_AggregateOp_E["SqlStringAggregate"] = "SQL_STRING_AGGREGATE";
    Falcon_AggregateOp_E["SqlTimeAggregate"] = "SQL_TIME_AGGREGATE";
    Falcon_AggregateOp_E["Stdev"] = "STDEV";
    Falcon_AggregateOp_E["Sum"] = "SUM";
    Falcon_AggregateOp_E["Variance"] = "VARIANCE";
})(Falcon_AggregateOp_E || (Falcon_AggregateOp_E = {}));
export var Falcon_ColumnSchemaProto_ContainerType;
(function (Falcon_ColumnSchemaProto_ContainerType) {
    Falcon_ColumnSchemaProto_ContainerType["ContainerNone"] = "CONTAINER_NONE";
    Falcon_ColumnSchemaProto_ContainerType["ContainerSet"] = "CONTAINER_SET";
})(Falcon_ColumnSchemaProto_ContainerType || (Falcon_ColumnSchemaProto_ContainerType = {}));
export var Falcon_ColumnSchemaProto_DataType;
(function (Falcon_ColumnSchemaProto_DataType) {
    Falcon_ColumnSchemaProto_DataType["TypeBool"] = "TYPE_BOOL";
    Falcon_ColumnSchemaProto_DataType["TypeDouble"] = "TYPE_DOUBLE";
    Falcon_ColumnSchemaProto_DataType["TypeFixedChar"] = "TYPE_FIXED_CHAR";
    Falcon_ColumnSchemaProto_DataType["TypeFloat"] = "TYPE_FLOAT";
    Falcon_ColumnSchemaProto_DataType["TypeInt8"] = "TYPE_INT8";
    Falcon_ColumnSchemaProto_DataType["TypeInt16"] = "TYPE_INT16";
    Falcon_ColumnSchemaProto_DataType["TypeInt32"] = "TYPE_INT32";
    Falcon_ColumnSchemaProto_DataType["TypeInt64"] = "TYPE_INT64";
    Falcon_ColumnSchemaProto_DataType["TypeVarChar"] = "TYPE_VAR_CHAR";
})(Falcon_ColumnSchemaProto_DataType || (Falcon_ColumnSchemaProto_DataType = {}));
export var Falcon_ColumnSchemaProto_DateTimeType;
(function (Falcon_ColumnSchemaProto_DateTimeType) {
    Falcon_ColumnSchemaProto_DateTimeType["TypeDate"] = "TYPE_DATE";
    Falcon_ColumnSchemaProto_DateTimeType["TypeDateTime"] = "TYPE_DATE_TIME";
    Falcon_ColumnSchemaProto_DateTimeType["TypeNotDate"] = "TYPE_NOT_DATE";
    Falcon_ColumnSchemaProto_DateTimeType["TypeTime"] = "TYPE_TIME";
})(Falcon_ColumnSchemaProto_DateTimeType || (Falcon_ColumnSchemaProto_DateTimeType = {}));
export var Falcon_CompressionScheme_E;
(function (Falcon_CompressionScheme_E) {
    Falcon_CompressionScheme_E["Auto"] = "AUTO";
    Falcon_CompressionScheme_E["Disabled"] = "DISABLED";
    Falcon_CompressionScheme_E["Lz4"] = "LZ4";
    Falcon_CompressionScheme_E["None"] = "NONE";
    Falcon_CompressionScheme_E["Rle"] = "RLE";
})(Falcon_CompressionScheme_E || (Falcon_CompressionScheme_E = {}));
export var Falcon_DdlOperation_Type;
(function (Falcon_DdlOperation_Type) {
    Falcon_DdlOperation_Type["AddColocation"] = "ADD_COLOCATION";
    Falcon_DdlOperation_Type["AddPrimaryKey"] = "ADD_PRIMARY_KEY";
    Falcon_DdlOperation_Type["AddRelationship"] = "ADD_RELATIONSHIP";
    Falcon_DdlOperation_Type["CompactAllTables"] = "COMPACT_ALL_TABLES";
    Falcon_DdlOperation_Type["CompactTable"] = "COMPACT_TABLE";
    Falcon_DdlOperation_Type["CreateDatabase"] = "CREATE_DATABASE";
    Falcon_DdlOperation_Type["CreateMaterializedView"] = "CREATE_MATERIALIZED_VIEW";
    Falcon_DdlOperation_Type["CreateTable"] = "CREATE_TABLE";
    Falcon_DdlOperation_Type["CreateUserSchema"] = "CREATE_USER_SCHEMA";
    Falcon_DdlOperation_Type["CreateView"] = "CREATE_VIEW";
    Falcon_DdlOperation_Type["DeleteMaterializedView"] = "DELETE_MATERIALIZED_VIEW";
    Falcon_DdlOperation_Type["DropColocation"] = "DROP_COLOCATION";
    Falcon_DdlOperation_Type["DropDatabase"] = "DROP_DATABASE";
    Falcon_DdlOperation_Type["DropPrimaryKey"] = "DROP_PRIMARY_KEY";
    Falcon_DdlOperation_Type["DropRelationship"] = "DROP_RELATIONSHIP";
    Falcon_DdlOperation_Type["DropTable"] = "DROP_TABLE";
    Falcon_DdlOperation_Type["DropUpdateTask"] = "DROP_UPDATE_TASK";
    Falcon_DdlOperation_Type["DropUserSchema"] = "DROP_USER_SCHEMA";
    Falcon_DdlOperation_Type["DropView"] = "DROP_VIEW";
    Falcon_DdlOperation_Type["GetInputRowSize"] = "GET_INPUT_ROW_SIZE";
    Falcon_DdlOperation_Type["GetStatistics"] = "GET_STATISTICS";
    Falcon_DdlOperation_Type["ModifyLoadPriority"] = "MODIFY_LOAD_PRIORITY";
    Falcon_DdlOperation_Type["RemoveLoadPriority"] = "REMOVE_LOAD_PRIORITY";
    Falcon_DdlOperation_Type["ScriptObject"] = "SCRIPT_OBJECT";
    Falcon_DdlOperation_Type["SelectIntoTable"] = "SELECT_INTO_TABLE";
    Falcon_DdlOperation_Type["SetCompression"] = "SET_COMPRESSION";
    Falcon_DdlOperation_Type["SetTableNumCopies"] = "SET_TABLE_NUM_COPIES";
    Falcon_DdlOperation_Type["SetTableOffline"] = "SET_TABLE_OFFLINE";
    Falcon_DdlOperation_Type["SetTableOnline"] = "SET_TABLE_ONLINE";
    Falcon_DdlOperation_Type["SetTableType"] = "SET_TABLE_TYPE";
    Falcon_DdlOperation_Type["ShowObject"] = "SHOW_OBJECT";
    Falcon_DdlOperation_Type["TruncateTable"] = "TRUNCATE_TABLE";
    Falcon_DdlOperation_Type["UpdateColumns"] = "UPDATE_COLUMNS";
    Falcon_DdlOperation_Type["UpdatePermission"] = "UPDATE_PERMISSION";
    Falcon_DdlOperation_Type["UseDatabase"] = "USE_DATABASE";
})(Falcon_DdlOperation_Type || (Falcon_DdlOperation_Type = {}));
export var Falcon_DmlOperation_Type;
(function (Falcon_DmlOperation_Type) {
    Falcon_DmlOperation_Type["OpDelete"] = "OP_DELETE";
    Falcon_DmlOperation_Type["OpInsert"] = "OP_INSERT";
    Falcon_DmlOperation_Type["OpSchemaUpdate"] = "OP_SCHEMA_UPDATE";
    Falcon_DmlOperation_Type["OpUpdate"] = "OP_UPDATE";
})(Falcon_DmlOperation_Type || (Falcon_DmlOperation_Type = {}));
export var Falcon_DataType_E;
(function (Falcon_DataType_E) {
    Falcon_DataType_E["Bool"] = "BOOL";
    Falcon_DataType_E["ByteArray"] = "BYTE_ARRAY";
    Falcon_DataType_E["Char"] = "CHAR";
    Falcon_DataType_E["Date"] = "DATE";
    Falcon_DataType_E["DateTime"] = "DATE_TIME";
    Falcon_DataType_E["Double"] = "DOUBLE";
    Falcon_DataType_E["Float"] = "FLOAT";
    Falcon_DataType_E["Int32"] = "INT32";
    Falcon_DataType_E["Int64"] = "INT64";
    Falcon_DataType_E["List"] = "LIST";
    Falcon_DataType_E["ListBool"] = "LIST_BOOL";
    Falcon_DataType_E["ListDate"] = "LIST_DATE";
    Falcon_DataType_E["ListDateTime"] = "LIST_DATE_TIME";
    Falcon_DataType_E["ListDouble"] = "LIST_DOUBLE";
    Falcon_DataType_E["ListInt"] = "LIST_INT";
    Falcon_DataType_E["ListString"] = "LIST_STRING";
    Falcon_DataType_E["ListTime"] = "LIST_TIME";
    Falcon_DataType_E["MaxType"] = "MAX_TYPE";
    Falcon_DataType_E["Time"] = "TIME";
    Falcon_DataType_E["Unknown"] = "UNKNOWN";
})(Falcon_DataType_E || (Falcon_DataType_E = {}));
export var Falcon_ExpressionOp_E;
(function (Falcon_ExpressionOp_E) {
    Falcon_ExpressionOp_E["AbsDay"] = "ABS_DAY";
    Falcon_ExpressionOp_E["AbsDayAsEpoch"] = "ABS_DAY_AS_EPOCH";
    Falcon_ExpressionOp_E["AbsHour"] = "ABS_HOUR";
    Falcon_ExpressionOp_E["AbsHourAsEpoch"] = "ABS_HOUR_AS_EPOCH";
    Falcon_ExpressionOp_E["AbsMonth"] = "ABS_MONTH";
    Falcon_ExpressionOp_E["AbsMonthAsEpoch"] = "ABS_MONTH_AS_EPOCH";
    Falcon_ExpressionOp_E["AbsQuarter"] = "ABS_QUARTER";
    Falcon_ExpressionOp_E["AbsQuarterAsEpoch"] = "ABS_QUARTER_AS_EPOCH";
    Falcon_ExpressionOp_E["AbsWeek"] = "ABS_WEEK";
    Falcon_ExpressionOp_E["AbsYear"] = "ABS_YEAR";
    Falcon_ExpressionOp_E["AbsYearAsEpoch"] = "ABS_YEAR_AS_EPOCH";
    Falcon_ExpressionOp_E["DayInMonth"] = "DAY_IN_MONTH";
    Falcon_ExpressionOp_E["DayInQuarter"] = "DAY_IN_QUARTER";
    Falcon_ExpressionOp_E["DayInYear"] = "DAY_IN_YEAR";
    Falcon_ExpressionOp_E["DayOfWeek"] = "DAY_OF_WEEK";
    Falcon_ExpressionOp_E["DayStartEpoch"] = "DAY_START_EPOCH";
    Falcon_ExpressionOp_E["Diff"] = "DIFF";
    Falcon_ExpressionOp_E["Div"] = "DIV";
    Falcon_ExpressionOp_E["Exp"] = "EXP";
    Falcon_ExpressionOp_E["HourStartEpoch"] = "HOUR_START_EPOCH";
    Falcon_ExpressionOp_E["Mod"] = "MOD";
    Falcon_ExpressionOp_E["MonthInQuarter"] = "MONTH_IN_QUARTER";
    Falcon_ExpressionOp_E["MonthInYear"] = "MONTH_IN_YEAR";
    Falcon_ExpressionOp_E["MonthStartEpoch"] = "MONTH_START_EPOCH";
    Falcon_ExpressionOp_E["Mult"] = "MULT";
    Falcon_ExpressionOp_E["None"] = "NONE";
    Falcon_ExpressionOp_E["OpAbs"] = "OP_ABS";
    Falcon_ExpressionOp_E["OpAbsDay"] = "OP_ABS_DAY";
    Falcon_ExpressionOp_E["OpAbsHour"] = "OP_ABS_HOUR";
    Falcon_ExpressionOp_E["OpAbsMinute"] = "OP_ABS_MINUTE";
    Falcon_ExpressionOp_E["OpAbsMonth"] = "OP_ABS_MONTH";
    Falcon_ExpressionOp_E["OpAbsQuarter"] = "OP_ABS_QUARTER";
    Falcon_ExpressionOp_E["OpAbsWeek"] = "OP_ABS_WEEK";
    Falcon_ExpressionOp_E["OpAbsYear"] = "OP_ABS_YEAR";
    Falcon_ExpressionOp_E["OpAcos"] = "OP_ACOS";
    Falcon_ExpressionOp_E["OpAnd"] = "OP_AND";
    Falcon_ExpressionOp_E["OpApproxSetCardinality"] = "OP_APPROX_SET_CARDINALITY";
    Falcon_ExpressionOp_E["OpAsin"] = "OP_ASIN";
    Falcon_ExpressionOp_E["OpAtan"] = "OP_ATAN";
    Falcon_ExpressionOp_E["OpAtan2"] = "OP_ATAN2";
    Falcon_ExpressionOp_E["OpBeginsWith"] = "OP_BEGINS_WITH";
    Falcon_ExpressionOp_E["OpBeginsWithNocase"] = "OP_BEGINS_WITH_NOCASE";
    Falcon_ExpressionOp_E["OpCeil"] = "OP_CEIL";
    Falcon_ExpressionOp_E["OpCombineHash"] = "OP_COMBINE_HASH";
    Falcon_ExpressionOp_E["OpContainerSize"] = "OP_CONTAINER_SIZE";
    Falcon_ExpressionOp_E["OpContains"] = "OP_CONTAINS";
    Falcon_ExpressionOp_E["OpContainsNocase"] = "OP_CONTAINS_NOCASE";
    Falcon_ExpressionOp_E["OpConvertBoolNumeric"] = "OP_CONVERT_BOOL_NUMERIC";
    Falcon_ExpressionOp_E["OpConvertBoolString"] = "OP_CONVERT_BOOL_STRING";
    Falcon_ExpressionOp_E["OpConvertDateString"] = "OP_CONVERT_DATE_STRING";
    Falcon_ExpressionOp_E["OpConvertDoubleString"] = "OP_CONVERT_DOUBLE_STRING";
    Falcon_ExpressionOp_E["OpConvertFloatInteger"] = "OP_CONVERT_FLOAT_INTEGER";
    Falcon_ExpressionOp_E["OpConvertInt64String"] = "OP_CONVERT_INT64_STRING";
    Falcon_ExpressionOp_E["OpConvertIntegerDouble"] = "OP_CONVERT_INTEGER_DOUBLE";
    Falcon_ExpressionOp_E["OpConvertNumericBool"] = "OP_CONVERT_NUMERIC_BOOL";
    Falcon_ExpressionOp_E["OpConvertStringBool"] = "OP_CONVERT_STRING_BOOL";
    Falcon_ExpressionOp_E["OpConvertStringDouble"] = "OP_CONVERT_STRING_DOUBLE";
    Falcon_ExpressionOp_E["OpConvertStringFloat"] = "OP_CONVERT_STRING_FLOAT";
    Falcon_ExpressionOp_E["OpConvertStringInt64"] = "OP_CONVERT_STRING_INT64";
    Falcon_ExpressionOp_E["OpCos"] = "OP_COS";
    Falcon_ExpressionOp_E["OpCube"] = "OP_CUBE";
    Falcon_ExpressionOp_E["OpCuberoot"] = "OP_CUBEROOT";
    Falcon_ExpressionOp_E["OpDateAddDays"] = "OP_DATE_ADD_DAYS";
    Falcon_ExpressionOp_E["OpDateAddMonths"] = "OP_DATE_ADD_MONTHS";
    Falcon_ExpressionOp_E["OpDateAddWeeks"] = "OP_DATE_ADD_WEEKS";
    Falcon_ExpressionOp_E["OpDateAddYears"] = "OP_DATE_ADD_YEARS";
    Falcon_ExpressionOp_E["OpDateDiffDays"] = "OP_DATE_DIFF_DAYS";
    Falcon_ExpressionOp_E["OpDateParse"] = "OP_DATE_PARSE";
    Falcon_ExpressionOp_E["OpDateTimeAddMinutes"] = "OP_DATE_TIME_ADD_MINUTES";
    Falcon_ExpressionOp_E["OpDateTimeAddSeconds"] = "OP_DATE_TIME_ADD_SECONDS";
    Falcon_ExpressionOp_E["OpDayInMonth"] = "OP_DAY_IN_MONTH";
    Falcon_ExpressionOp_E["OpDayInQuarter"] = "OP_DAY_IN_QUARTER";
    Falcon_ExpressionOp_E["OpDayInYear"] = "OP_DAY_IN_YEAR";
    Falcon_ExpressionOp_E["OpDayOfWeek"] = "OP_DAY_OF_WEEK";
    Falcon_ExpressionOp_E["OpDayOfWeekStr"] = "OP_DAY_OF_WEEK_STR";
    Falcon_ExpressionOp_E["OpDayStartEpoch"] = "OP_DAY_START_EPOCH";
    Falcon_ExpressionOp_E["OpDivide"] = "OP_DIVIDE";
    Falcon_ExpressionOp_E["OpEditDistance"] = "OP_EDIT_DISTANCE";
    Falcon_ExpressionOp_E["OpEditDistanceWithCap"] = "OP_EDIT_DISTANCE_WITH_CAP";
    Falcon_ExpressionOp_E["OpEndsWith"] = "OP_ENDS_WITH";
    Falcon_ExpressionOp_E["OpEndsWithNocase"] = "OP_ENDS_WITH_NOCASE";
    Falcon_ExpressionOp_E["OpEquals"] = "OP_EQUALS";
    Falcon_ExpressionOp_E["OpEqualsNocase"] = "OP_EQUALS_NOCASE";
    Falcon_ExpressionOp_E["OpExp"] = "OP_EXP";
    Falcon_ExpressionOp_E["OpExp2"] = "OP_EXP2";
    Falcon_ExpressionOp_E["OpFloor"] = "OP_FLOOR";
    Falcon_ExpressionOp_E["OpGreaterEquals"] = "OP_GREATER_EQUALS";
    Falcon_ExpressionOp_E["OpGreaterEqualsNocase"] = "OP_GREATER_EQUALS_NOCASE";
    Falcon_ExpressionOp_E["OpGreaterThan"] = "OP_GREATER_THAN";
    Falcon_ExpressionOp_E["OpGreaterThanNocase"] = "OP_GREATER_THAN_NOCASE";
    Falcon_ExpressionOp_E["OpGreatest"] = "OP_GREATEST";
    Falcon_ExpressionOp_E["OpHash"] = "OP_HASH";
    Falcon_ExpressionOp_E["OpHourInDay"] = "OP_HOUR_IN_DAY";
    Falcon_ExpressionOp_E["OpHourStartEpoch"] = "OP_HOUR_START_EPOCH";
    Falcon_ExpressionOp_E["OpIdentity"] = "OP_IDENTITY";
    Falcon_ExpressionOp_E["OpIf"] = "OP_IF";
    Falcon_ExpressionOp_E["OpIfNull"] = "OP_IF_NULL";
    Falcon_ExpressionOp_E["OpIn"] = "OP_IN";
    Falcon_ExpressionOp_E["OpIsNull"] = "OP_IS_NULL";
    Falcon_ExpressionOp_E["OpIsWeekend"] = "OP_IS_WEEKEND";
    Falcon_ExpressionOp_E["OpLeast"] = "OP_LEAST";
    Falcon_ExpressionOp_E["OpLeft"] = "OP_LEFT";
    Falcon_ExpressionOp_E["OpLesserEquals"] = "OP_LESSER_EQUALS";
    Falcon_ExpressionOp_E["OpLesserEqualsNocase"] = "OP_LESSER_EQUALS_NOCASE";
    Falcon_ExpressionOp_E["OpLessThan"] = "OP_LESS_THAN";
    Falcon_ExpressionOp_E["OpLessThanNocase"] = "OP_LESS_THAN_NOCASE";
    Falcon_ExpressionOp_E["OpLike"] = "OP_LIKE";
    Falcon_ExpressionOp_E["OpLn"] = "OP_LN";
    Falcon_ExpressionOp_E["OpLog2"] = "OP_LOG2";
    Falcon_ExpressionOp_E["OpLog10"] = "OP_LOG10";
    Falcon_ExpressionOp_E["OpMinus"] = "OP_MINUS";
    Falcon_ExpressionOp_E["OpMinuteStartEpoch"] = "OP_MINUTE_START_EPOCH";
    Falcon_ExpressionOp_E["OpMod"] = "OP_MOD";
    Falcon_ExpressionOp_E["OpMonthInQuarter"] = "OP_MONTH_IN_QUARTER";
    Falcon_ExpressionOp_E["OpMonthInYear"] = "OP_MONTH_IN_YEAR";
    Falcon_ExpressionOp_E["OpMonthInYearStr"] = "OP_MONTH_IN_YEAR_STR";
    Falcon_ExpressionOp_E["OpMonthStartEpoch"] = "OP_MONTH_START_EPOCH";
    Falcon_ExpressionOp_E["OpMultiply"] = "OP_MULTIPLY";
    Falcon_ExpressionOp_E["OpNegate"] = "OP_NEGATE";
    Falcon_ExpressionOp_E["OpNone"] = "OP_NONE";
    Falcon_ExpressionOp_E["OpNormalizeString"] = "OP_NORMALIZE_STRING";
    Falcon_ExpressionOp_E["OpNormalizeStringPreserveCase"] = "OP_NORMALIZE_STRING_PRESERVE_CASE";
    Falcon_ExpressionOp_E["OpNot"] = "OP_NOT";
    Falcon_ExpressionOp_E["OpNotEquals"] = "OP_NOT_EQUALS";
    Falcon_ExpressionOp_E["OpNotEqualsNocase"] = "OP_NOT_EQUALS_NOCASE";
    Falcon_ExpressionOp_E["OpNow"] = "OP_NOW";
    Falcon_ExpressionOp_E["OpNumOps"] = "OP_NUM_OPS";
    Falcon_ExpressionOp_E["OpOr"] = "OP_OR";
    Falcon_ExpressionOp_E["OpPlus"] = "OP_PLUS";
    Falcon_ExpressionOp_E["OpPow"] = "OP_POW";
    Falcon_ExpressionOp_E["OpQuarterInYear"] = "OP_QUARTER_IN_YEAR";
    Falcon_ExpressionOp_E["OpQuarterStartEpoch"] = "OP_QUARTER_START_EPOCH";
    Falcon_ExpressionOp_E["OpRandom"] = "OP_RANDOM";
    Falcon_ExpressionOp_E["OpRight"] = "OP_RIGHT";
    Falcon_ExpressionOp_E["OpRound"] = "OP_ROUND";
    Falcon_ExpressionOp_E["OpSecondInDay"] = "OP_SECOND_IN_DAY";
    Falcon_ExpressionOp_E["OpSign"] = "OP_SIGN";
    Falcon_ExpressionOp_E["OpSin"] = "OP_SIN";
    Falcon_ExpressionOp_E["OpSoundsLike"] = "OP_SOUNDS_LIKE";
    Falcon_ExpressionOp_E["OpSpellsLike"] = "OP_SPELLS_LIKE";
    Falcon_ExpressionOp_E["OpSphericalDistance"] = "OP_SPHERICAL_DISTANCE";
    Falcon_ExpressionOp_E["OpSqrt"] = "OP_SQRT";
    Falcon_ExpressionOp_E["OpSquare"] = "OP_SQUARE";
    Falcon_ExpressionOp_E["OpStrcat"] = "OP_STRCAT";
    Falcon_ExpressionOp_E["OpStringMatchScore"] = "OP_STRING_MATCH_SCORE";
    Falcon_ExpressionOp_E["OpStrlen"] = "OP_STRLEN";
    Falcon_ExpressionOp_E["OpStrpos"] = "OP_STRPOS";
    Falcon_ExpressionOp_E["OpSubstr"] = "OP_SUBSTR";
    Falcon_ExpressionOp_E["OpTan"] = "OP_TAN";
    Falcon_ExpressionOp_E["OpTimePart"] = "OP_TIME_PART";
    Falcon_ExpressionOp_E["OpToday"] = "OP_TODAY";
    Falcon_ExpressionOp_E["OpUtf8Left"] = "OP_UTF8_LEFT";
    Falcon_ExpressionOp_E["OpUtf8Right"] = "OP_UTF8_RIGHT";
    Falcon_ExpressionOp_E["OpUtf8Strlen"] = "OP_UTF8_STRLEN";
    Falcon_ExpressionOp_E["OpUtf8Strpos"] = "OP_UTF8_STRPOS";
    Falcon_ExpressionOp_E["OpUtf8Substr"] = "OP_UTF8_SUBSTR";
    Falcon_ExpressionOp_E["OpWeekInMonth"] = "OP_WEEK_IN_MONTH";
    Falcon_ExpressionOp_E["OpWeekInMonthAsEpoch"] = "OP_WEEK_IN_MONTH_AS_EPOCH";
    Falcon_ExpressionOp_E["OpWeekInQuarter"] = "OP_WEEK_IN_QUARTER";
    Falcon_ExpressionOp_E["OpWeekInQuarterAsEpoch"] = "OP_WEEK_IN_QUARTER_AS_EPOCH";
    Falcon_ExpressionOp_E["OpWeekInYear"] = "OP_WEEK_IN_YEAR";
    Falcon_ExpressionOp_E["OpWeekInYearAsEpoch"] = "OP_WEEK_IN_YEAR_AS_EPOCH";
    Falcon_ExpressionOp_E["OpWeekInYearIso"] = "OP_WEEK_IN_YEAR_ISO";
    Falcon_ExpressionOp_E["OpWeekStartEpoch"] = "OP_WEEK_START_EPOCH";
    Falcon_ExpressionOp_E["OpYearStartEpoch"] = "OP_YEAR_START_EPOCH";
    Falcon_ExpressionOp_E["QuarterInYear"] = "QUARTER_IN_YEAR";
    Falcon_ExpressionOp_E["QuarterStartEpoch"] = "QUARTER_START_EPOCH";
    Falcon_ExpressionOp_E["Sum"] = "SUM";
    Falcon_ExpressionOp_E["WeekInMonth"] = "WEEK_IN_MONTH";
    Falcon_ExpressionOp_E["WeekInMonthAsEpoch"] = "WEEK_IN_MONTH_AS_EPOCH";
    Falcon_ExpressionOp_E["WeekInQuarter"] = "WEEK_IN_QUARTER";
    Falcon_ExpressionOp_E["WeekInQuarterAsEpoch"] = "WEEK_IN_QUARTER_AS_EPOCH";
    Falcon_ExpressionOp_E["WeekInYear"] = "WEEK_IN_YEAR";
    Falcon_ExpressionOp_E["WeekInYearAsEpoch"] = "WEEK_IN_YEAR_AS_EPOCH";
    Falcon_ExpressionOp_E["WeekStartEpoch"] = "WEEK_START_EPOCH";
    Falcon_ExpressionOp_E["YearStartEpoch"] = "YEAR_START_EPOCH";
})(Falcon_ExpressionOp_E || (Falcon_ExpressionOp_E = {}));
export var Falcon_FalconQuery_From_Join_Type;
(function (Falcon_FalconQuery_From_Join_Type) {
    Falcon_FalconQuery_From_Join_Type["Cross"] = "CROSS";
    Falcon_FalconQuery_From_Join_Type["FullOuter"] = "FULL_OUTER";
    Falcon_FalconQuery_From_Join_Type["Inner"] = "INNER";
    Falcon_FalconQuery_From_Join_Type["Left"] = "LEFT";
    Falcon_FalconQuery_From_Join_Type["Right"] = "RIGHT";
})(Falcon_FalconQuery_From_Join_Type || (Falcon_FalconQuery_From_Join_Type = {}));
export var Falcon_FalconQuery_ResponseSpec_Type;
(function (Falcon_FalconQuery_ResponseSpec_Type) {
    Falcon_FalconQuery_ResponseSpec_Type["FalconResponse"] = "FALCON_RESPONSE";
    Falcon_FalconQuery_ResponseSpec_Type["FalconTable"] = "FALCON_TABLE";
    Falcon_FalconQuery_ResponseSpec_Type["IntoCsv"] = "INTO_CSV";
    Falcon_FalconQuery_ResponseSpec_Type["NoResult"] = "NO_RESULT";
    Falcon_FalconQuery_ResponseSpec_Type["QuerySignatureOnly"] = "QUERY_SIGNATURE_ONLY";
    Falcon_FalconQuery_ResponseSpec_Type["SerializedDictionary"] = "SERIALIZED_DICTIONARY";
    Falcon_FalconQuery_ResponseSpec_Type["SerializedTable"] = "SERIALIZED_TABLE";
    Falcon_FalconQuery_ResponseSpec_Type["SerializedTableProto"] = "SERIALIZED_TABLE_PROTO";
})(Falcon_FalconQuery_ResponseSpec_Type || (Falcon_FalconQuery_ResponseSpec_Type = {}));
export var Falcon_FalconQuery_TableSpec_TableType;
(function (Falcon_FalconQuery_TableSpec_TableType) {
    Falcon_FalconQuery_TableSpec_TableType["DeprecatedDimension"] = "DEPRECATED_DIMENSION";
    Falcon_FalconQuery_TableSpec_TableType["DeprecatedFact"] = "DEPRECATED_FACT";
    Falcon_FalconQuery_TableSpec_TableType["DeprecatedUnknown"] = "DEPRECATED_UNKNOWN";
    Falcon_FalconQuery_TableSpec_TableType["Query"] = "QUERY";
    Falcon_FalconQuery_TableSpec_TableType["Table"] = "TABLE";
})(Falcon_FalconQuery_TableSpec_TableType || (Falcon_FalconQuery_TableSpec_TableType = {}));
export var Falcon_GetInputRowSizeRequest_Type;
(function (Falcon_GetInputRowSizeRequest_Type) {
    Falcon_GetInputRowSizeRequest_Type["Database"] = "DATABASE";
    Falcon_GetInputRowSizeRequest_Type["Server"] = "SERVER";
    Falcon_GetInputRowSizeRequest_Type["Table"] = "TABLE";
    Falcon_GetInputRowSizeRequest_Type["UserSchema"] = "USER_SCHEMA";
})(Falcon_GetInputRowSizeRequest_Type || (Falcon_GetInputRowSizeRequest_Type = {}));
export var Falcon_GetStatisticsRequest_Type;
(function (Falcon_GetStatisticsRequest_Type) {
    Falcon_GetStatisticsRequest_Type["Database"] = "DATABASE";
    Falcon_GetStatisticsRequest_Type["Server"] = "SERVER";
    Falcon_GetStatisticsRequest_Type["Table"] = "TABLE";
    Falcon_GetStatisticsRequest_Type["UserSchema"] = "USER_SCHEMA";
})(Falcon_GetStatisticsRequest_Type || (Falcon_GetStatisticsRequest_Type = {}));
export var Falcon_GetTableRequest_StorageType;
(function (Falcon_GetTableRequest_StorageType) {
    Falcon_GetTableRequest_StorageType["Hdd"] = "HDD";
    Falcon_GetTableRequest_StorageType["Memory"] = "MEMORY";
})(Falcon_GetTableRequest_StorageType || (Falcon_GetTableRequest_StorageType = {}));
export var Falcon_MapReduceConfigProto_Type;
(function (Falcon_MapReduceConfigProto_Type) {
    Falcon_MapReduceConfigProto_Type["CumulativeSum"] = "CUMULATIVE_SUM";
    Falcon_MapReduceConfigProto_Type["Npath"] = "NPATH";
})(Falcon_MapReduceConfigProto_Type || (Falcon_MapReduceConfigProto_Type = {}));
export var Falcon_NamedTableSet_Label;
(function (Falcon_NamedTableSet_Label) {
    Falcon_NamedTableSet_Label["FalconLoaded"] = "FALCON_LOADED";
    Falcon_NamedTableSet_Label["FalconServing"] = "FALCON_SERVING";
    Falcon_NamedTableSet_Label["SageBuilding"] = "SAGE_BUILDING";
    Falcon_NamedTableSet_Label["SageServing"] = "SAGE_SERVING";
})(Falcon_NamedTableSet_Label || (Falcon_NamedTableSet_Label = {}));
export var Falcon_PartitionWindow_PointType;
(function (Falcon_PartitionWindow_PointType) {
    Falcon_PartitionWindow_PointType["CurrentRow"] = "CURRENT_ROW";
    Falcon_PartitionWindow_PointType["Following"] = "FOLLOWING";
    Falcon_PartitionWindow_PointType["Preceding"] = "PRECEDING";
    Falcon_PartitionWindow_PointType["UnboundedFollowing"] = "UNBOUNDED_FOLLOWING";
    Falcon_PartitionWindow_PointType["UnboundedPreceding"] = "UNBOUNDED_PRECEDING";
})(Falcon_PartitionWindow_PointType || (Falcon_PartitionWindow_PointType = {}));
export var Falcon_PartitionWindow_WindowType;
(function (Falcon_PartitionWindow_WindowType) {
    Falcon_PartitionWindow_WindowType["Range"] = "RANGE";
    Falcon_PartitionWindow_WindowType["Row"] = "ROW";
})(Falcon_PartitionWindow_WindowType || (Falcon_PartitionWindow_WindowType = {}));
export var Falcon_Permission_AccessLevel;
(function (Falcon_Permission_AccessLevel) {
    Falcon_Permission_AccessLevel["DataWrite"] = "DATA_WRITE";
    Falcon_Permission_AccessLevel["NoAccess"] = "NO_ACCESS";
    Falcon_Permission_AccessLevel["Owner"] = "OWNER";
    Falcon_Permission_AccessLevel["Read"] = "READ";
    Falcon_Permission_AccessLevel["SchemaAlter"] = "SCHEMA_ALTER";
    Falcon_Permission_AccessLevel["SchemaCreate"] = "SCHEMA_CREATE";
})(Falcon_Permission_AccessLevel || (Falcon_Permission_AccessLevel = {}));
export var Falcon_PredicateNode_LogicalOp;
(function (Falcon_PredicateNode_LogicalOp) {
    Falcon_PredicateNode_LogicalOp["And"] = "AND";
    Falcon_PredicateNode_LogicalOp["Not"] = "NOT";
    Falcon_PredicateNode_LogicalOp["Or"] = "OR";
    Falcon_PredicateNode_LogicalOp["Unknown"] = "UNKNOWN";
})(Falcon_PredicateNode_LogicalOp || (Falcon_PredicateNode_LogicalOp = {}));
export var Falcon_PredicateNode_Predicate_CompareOp;
(function (Falcon_PredicateNode_Predicate_CompareOp) {
    Falcon_PredicateNode_Predicate_CompareOp["BeginsWith"] = "BEGINS_WITH";
    Falcon_PredicateNode_Predicate_CompareOp["BeginsWithNocase"] = "BEGINS_WITH_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Bt"] = "BT";
    Falcon_PredicateNode_Predicate_CompareOp["Contains"] = "CONTAINS";
    Falcon_PredicateNode_Predicate_CompareOp["ContainsNocase"] = "CONTAINS_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["EndsWith"] = "ENDS_WITH";
    Falcon_PredicateNode_Predicate_CompareOp["EndsWithNocase"] = "ENDS_WITH_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Eq"] = "EQ";
    Falcon_PredicateNode_Predicate_CompareOp["EqNocase"] = "EQ_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Ge"] = "GE";
    Falcon_PredicateNode_Predicate_CompareOp["GeNocase"] = "GE_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Gt"] = "GT";
    Falcon_PredicateNode_Predicate_CompareOp["GtNocase"] = "GT_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["In"] = "IN";
    Falcon_PredicateNode_Predicate_CompareOp["InSubquery"] = "IN_SUBQUERY";
    Falcon_PredicateNode_Predicate_CompareOp["IsNull"] = "IS_NULL";
    Falcon_PredicateNode_Predicate_CompareOp["Le"] = "LE";
    Falcon_PredicateNode_Predicate_CompareOp["LeNocase"] = "LE_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Like"] = "LIKE";
    Falcon_PredicateNode_Predicate_CompareOp["Lt"] = "LT";
    Falcon_PredicateNode_Predicate_CompareOp["LtNocase"] = "LT_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Ne"] = "NE";
    Falcon_PredicateNode_Predicate_CompareOp["NeNocase"] = "NE_NOCASE";
    Falcon_PredicateNode_Predicate_CompareOp["Unknown"] = "UNKNOWN";
})(Falcon_PredicateNode_Predicate_CompareOp || (Falcon_PredicateNode_Predicate_CompareOp = {}));
export var Falcon_Priority_Type;
(function (Falcon_Priority_Type) {
    Falcon_Priority_Type["Batch"] = "BATCH";
    Falcon_Priority_Type["Interactive"] = "INTERACTIVE";
})(Falcon_Priority_Type || (Falcon_Priority_Type = {}));
export var Falcon_RegionSpec_Strategy;
(function (Falcon_RegionSpec_Strategy) {
    Falcon_RegionSpec_Strategy["Hash"] = "HASH";
})(Falcon_RegionSpec_Strategy || (Falcon_RegionSpec_Strategy = {}));
export var Falcon_Relationship_Type;
(function (Falcon_Relationship_Type) {
    Falcon_Relationship_Type["Foreignkey"] = "FOREIGNKEY";
    Falcon_Relationship_Type["Generic"] = "GENERIC";
})(Falcon_Relationship_Type || (Falcon_Relationship_Type = {}));
export var Falcon_ScriptObject_Type;
(function (Falcon_ScriptObject_Type) {
    Falcon_ScriptObject_Type["ScriptDatabase"] = "SCRIPT_DATABASE";
    Falcon_ScriptObject_Type["ScriptServer"] = "SCRIPT_SERVER";
    Falcon_ScriptObject_Type["ScriptTable"] = "SCRIPT_TABLE";
    Falcon_ScriptObject_Type["ScriptView"] = "SCRIPT_VIEW";
})(Falcon_ScriptObject_Type || (Falcon_ScriptObject_Type = {}));
export var Falcon_ShowObject_Type;
(function (Falcon_ShowObject_Type) {
    Falcon_ShowObject_Type["ShowDatabase"] = "SHOW_DATABASE";
    Falcon_ShowObject_Type["ShowDatabases"] = "SHOW_DATABASES";
    Falcon_ShowObject_Type["ShowTable"] = "SHOW_TABLE";
    Falcon_ShowObject_Type["ShowTables"] = "SHOW_TABLES";
    Falcon_ShowObject_Type["ShowUserSchema"] = "SHOW_USER_SCHEMA";
    Falcon_ShowObject_Type["ShowUserSchemas"] = "SHOW_USER_SCHEMAS";
    Falcon_ShowObject_Type["ShowView"] = "SHOW_VIEW";
    Falcon_ShowObject_Type["ShowViews"] = "SHOW_VIEWS";
})(Falcon_ShowObject_Type || (Falcon_ShowObject_Type = {}));
export var Falcon_TableProto_Type;
(function (Falcon_TableProto_Type) {
    Falcon_TableProto_Type["Dimension"] = "DIMENSION";
    Falcon_TableProto_Type["Fact"] = "FACT";
    Falcon_TableProto_Type["Unknown"] = "UNKNOWN";
})(Falcon_TableProto_Type || (Falcon_TableProto_Type = {}));
export var Falcon_TableStatProto_ServingStatus;
(function (Falcon_TableStatProto_ServingStatus) {
    Falcon_TableStatProto_ServingStatus["Error"] = "ERROR";
    Falcon_TableStatProto_ServingStatus["Inprogress"] = "INPROGRESS";
    Falcon_TableStatProto_ServingStatus["Offline"] = "OFFLINE";
    Falcon_TableStatProto_ServingStatus["Queued"] = "QUEUED";
    Falcon_TableStatProto_ServingStatus["Ready"] = "READY";
    Falcon_TableStatProto_ServingStatus["Stale"] = "STALE";
})(Falcon_TableStatProto_ServingStatus || (Falcon_TableStatProto_ServingStatus = {}));
export var Falcon_TableStatProto_VersionInfo_Availability;
(function (Falcon_TableStatProto_VersionInfo_Availability) {
    Falcon_TableStatProto_VersionInfo_Availability["Error"] = "ERROR";
    Falcon_TableStatProto_VersionInfo_Availability["NotYetReady"] = "NOT_YET_READY";
    Falcon_TableStatProto_VersionInfo_Availability["Offline"] = "OFFLINE";
    Falcon_TableStatProto_VersionInfo_Availability["Ready"] = "READY";
})(Falcon_TableStatProto_VersionInfo_Availability || (Falcon_TableStatProto_VersionInfo_Availability = {}));
export var Falcon_UpdatePermissionRequest_Type;
(function (Falcon_UpdatePermissionRequest_Type) {
    Falcon_UpdatePermissionRequest_Type["Grant"] = "GRANT";
    Falcon_UpdatePermissionRequest_Type["Revoke"] = "REVOKE";
})(Falcon_UpdatePermissionRequest_Type || (Falcon_UpdatePermissionRequest_Type = {}));
export var Falcon_UpdatePolicy_Mode;
(function (Falcon_UpdatePolicy_Mode) {
    Falcon_UpdatePolicy_Mode["Manual"] = "MANUAL";
    Falcon_UpdatePolicy_Mode["OnLoadAsync"] = "ON_LOAD_ASYNC";
})(Falcon_UpdatePolicy_Mode || (Falcon_UpdatePolicy_Mode = {}));
export var Falcon_ValueProto_Type;
(function (Falcon_ValueProto_Type) {
    Falcon_ValueProto_Type["TypeBool"] = "TYPE_BOOL";
    Falcon_ValueProto_Type["TypeDouble"] = "TYPE_DOUBLE";
    Falcon_ValueProto_Type["TypeInt64"] = "TYPE_INT64";
    Falcon_ValueProto_Type["TypeNull"] = "TYPE_NULL";
    Falcon_ValueProto_Type["TypeString"] = "TYPE_STRING";
    Falcon_ValueProto_Type["TypeStringCase"] = "TYPE_STRING_CASE";
})(Falcon_ValueProto_Type || (Falcon_ValueProto_Type = {}));
export var Falcon_Compression_FileSystemPathProto_FileSystem;
(function (Falcon_Compression_FileSystemPathProto_FileSystem) {
    Falcon_Compression_FileSystemPathProto_FileSystem["Hdfs"] = "HDFS";
    Falcon_Compression_FileSystemPathProto_FileSystem["Posix"] = "POSIX";
    Falcon_Compression_FileSystemPathProto_FileSystem["S3A"] = "S3A";
})(Falcon_Compression_FileSystemPathProto_FileSystem || (Falcon_Compression_FileSystemPathProto_FileSystem = {}));
export var Falcon_Loader_DataWriterProto_Type;
(function (Falcon_Loader_DataWriterProto_Type) {
    Falcon_Loader_DataWriterProto_Type["File"] = "FILE";
})(Falcon_Loader_DataWriterProto_Type || (Falcon_Loader_DataWriterProto_Type = {}));
export var Google_Protobuf_Edition;
(function (Google_Protobuf_Edition) {
    Google_Protobuf_Edition["Edition_1TestOnly"] = "EDITION_1_TEST_ONLY";
    Google_Protobuf_Edition["Edition_2TestOnly"] = "EDITION_2_TEST_ONLY";
    Google_Protobuf_Edition["Edition_2023"] = "EDITION_2023";
    Google_Protobuf_Edition["Edition_99997TestOnly"] = "EDITION_99997_TEST_ONLY";
    Google_Protobuf_Edition["Edition_99998TestOnly"] = "EDITION_99998_TEST_ONLY";
    Google_Protobuf_Edition["Edition_99999TestOnly"] = "EDITION_99999_TEST_ONLY";
    Google_Protobuf_Edition["EditionProto2"] = "EDITION_PROTO2";
    Google_Protobuf_Edition["EditionProto3"] = "EDITION_PROTO3";
    Google_Protobuf_Edition["EditionUnknown"] = "EDITION_UNKNOWN";
})(Google_Protobuf_Edition || (Google_Protobuf_Edition = {}));
export var Google_Protobuf_ExtensionRangeOptions_VerificationState;
(function (Google_Protobuf_ExtensionRangeOptions_VerificationState) {
    Google_Protobuf_ExtensionRangeOptions_VerificationState["Declaration"] = "DECLARATION";
    Google_Protobuf_ExtensionRangeOptions_VerificationState["Unverified"] = "UNVERIFIED";
})(Google_Protobuf_ExtensionRangeOptions_VerificationState || (Google_Protobuf_ExtensionRangeOptions_VerificationState = {}));
export var Google_Protobuf_FeatureSet_EnumType;
(function (Google_Protobuf_FeatureSet_EnumType) {
    Google_Protobuf_FeatureSet_EnumType["Closed"] = "CLOSED";
    Google_Protobuf_FeatureSet_EnumType["EnumTypeUnknown"] = "ENUM_TYPE_UNKNOWN";
    Google_Protobuf_FeatureSet_EnumType["Open"] = "OPEN";
})(Google_Protobuf_FeatureSet_EnumType || (Google_Protobuf_FeatureSet_EnumType = {}));
export var Google_Protobuf_FeatureSet_FieldPresence;
(function (Google_Protobuf_FeatureSet_FieldPresence) {
    Google_Protobuf_FeatureSet_FieldPresence["Explicit"] = "EXPLICIT";
    Google_Protobuf_FeatureSet_FieldPresence["FieldPresenceUnknown"] = "FIELD_PRESENCE_UNKNOWN";
    Google_Protobuf_FeatureSet_FieldPresence["Implicit"] = "IMPLICIT";
    Google_Protobuf_FeatureSet_FieldPresence["LegacyRequired"] = "LEGACY_REQUIRED";
})(Google_Protobuf_FeatureSet_FieldPresence || (Google_Protobuf_FeatureSet_FieldPresence = {}));
export var Google_Protobuf_FeatureSet_JsonFormat;
(function (Google_Protobuf_FeatureSet_JsonFormat) {
    Google_Protobuf_FeatureSet_JsonFormat["Allow"] = "ALLOW";
    Google_Protobuf_FeatureSet_JsonFormat["JsonFormatUnknown"] = "JSON_FORMAT_UNKNOWN";
    Google_Protobuf_FeatureSet_JsonFormat["LegacyBestEffort"] = "LEGACY_BEST_EFFORT";
})(Google_Protobuf_FeatureSet_JsonFormat || (Google_Protobuf_FeatureSet_JsonFormat = {}));
export var Google_Protobuf_FeatureSet_MessageEncoding;
(function (Google_Protobuf_FeatureSet_MessageEncoding) {
    Google_Protobuf_FeatureSet_MessageEncoding["Delimited"] = "DELIMITED";
    Google_Protobuf_FeatureSet_MessageEncoding["LengthPrefixed"] = "LENGTH_PREFIXED";
    Google_Protobuf_FeatureSet_MessageEncoding["MessageEncodingUnknown"] = "MESSAGE_ENCODING_UNKNOWN";
})(Google_Protobuf_FeatureSet_MessageEncoding || (Google_Protobuf_FeatureSet_MessageEncoding = {}));
export var Google_Protobuf_FeatureSet_RepeatedFieldEncoding;
(function (Google_Protobuf_FeatureSet_RepeatedFieldEncoding) {
    Google_Protobuf_FeatureSet_RepeatedFieldEncoding["Expanded"] = "EXPANDED";
    Google_Protobuf_FeatureSet_RepeatedFieldEncoding["Packed"] = "PACKED";
    Google_Protobuf_FeatureSet_RepeatedFieldEncoding["RepeatedFieldEncodingUnknown"] = "REPEATED_FIELD_ENCODING_UNKNOWN";
})(Google_Protobuf_FeatureSet_RepeatedFieldEncoding || (Google_Protobuf_FeatureSet_RepeatedFieldEncoding = {}));
export var Google_Protobuf_FeatureSet_Utf8Validation;
(function (Google_Protobuf_FeatureSet_Utf8Validation) {
    Google_Protobuf_FeatureSet_Utf8Validation["None"] = "NONE";
    Google_Protobuf_FeatureSet_Utf8Validation["Utf8ValidationUnknown"] = "UTF8_VALIDATION_UNKNOWN";
    Google_Protobuf_FeatureSet_Utf8Validation["Verify"] = "VERIFY";
})(Google_Protobuf_FeatureSet_Utf8Validation || (Google_Protobuf_FeatureSet_Utf8Validation = {}));
export var Google_Protobuf_FieldDescriptorProto_Label;
(function (Google_Protobuf_FieldDescriptorProto_Label) {
    Google_Protobuf_FieldDescriptorProto_Label["LabelOptional"] = "LABEL_OPTIONAL";
    Google_Protobuf_FieldDescriptorProto_Label["LabelRepeated"] = "LABEL_REPEATED";
    Google_Protobuf_FieldDescriptorProto_Label["LabelRequired"] = "LABEL_REQUIRED";
})(Google_Protobuf_FieldDescriptorProto_Label || (Google_Protobuf_FieldDescriptorProto_Label = {}));
export var Google_Protobuf_FieldDescriptorProto_Type;
(function (Google_Protobuf_FieldDescriptorProto_Type) {
    Google_Protobuf_FieldDescriptorProto_Type["TypeBool"] = "TYPE_BOOL";
    Google_Protobuf_FieldDescriptorProto_Type["TypeBytes"] = "TYPE_BYTES";
    Google_Protobuf_FieldDescriptorProto_Type["TypeDouble"] = "TYPE_DOUBLE";
    Google_Protobuf_FieldDescriptorProto_Type["TypeEnum"] = "TYPE_ENUM";
    Google_Protobuf_FieldDescriptorProto_Type["TypeFixed32"] = "TYPE_FIXED32";
    Google_Protobuf_FieldDescriptorProto_Type["TypeFixed64"] = "TYPE_FIXED64";
    Google_Protobuf_FieldDescriptorProto_Type["TypeFloat"] = "TYPE_FLOAT";
    Google_Protobuf_FieldDescriptorProto_Type["TypeGroup"] = "TYPE_GROUP";
    Google_Protobuf_FieldDescriptorProto_Type["TypeInt32"] = "TYPE_INT32";
    Google_Protobuf_FieldDescriptorProto_Type["TypeInt64"] = "TYPE_INT64";
    Google_Protobuf_FieldDescriptorProto_Type["TypeMessage"] = "TYPE_MESSAGE";
    Google_Protobuf_FieldDescriptorProto_Type["TypeSfixed32"] = "TYPE_SFIXED32";
    Google_Protobuf_FieldDescriptorProto_Type["TypeSfixed64"] = "TYPE_SFIXED64";
    Google_Protobuf_FieldDescriptorProto_Type["TypeSint32"] = "TYPE_SINT32";
    Google_Protobuf_FieldDescriptorProto_Type["TypeSint64"] = "TYPE_SINT64";
    Google_Protobuf_FieldDescriptorProto_Type["TypeString"] = "TYPE_STRING";
    Google_Protobuf_FieldDescriptorProto_Type["TypeUint32"] = "TYPE_UINT32";
    Google_Protobuf_FieldDescriptorProto_Type["TypeUint64"] = "TYPE_UINT64";
})(Google_Protobuf_FieldDescriptorProto_Type || (Google_Protobuf_FieldDescriptorProto_Type = {}));
export var Google_Protobuf_FieldOptions_CType;
(function (Google_Protobuf_FieldOptions_CType) {
    Google_Protobuf_FieldOptions_CType["Cord"] = "CORD";
    Google_Protobuf_FieldOptions_CType["String"] = "STRING";
    Google_Protobuf_FieldOptions_CType["StringPiece"] = "STRING_PIECE";
})(Google_Protobuf_FieldOptions_CType || (Google_Protobuf_FieldOptions_CType = {}));
export var Google_Protobuf_FieldOptions_JsType;
(function (Google_Protobuf_FieldOptions_JsType) {
    Google_Protobuf_FieldOptions_JsType["JsNormal"] = "JS_NORMAL";
    Google_Protobuf_FieldOptions_JsType["JsNumber"] = "JS_NUMBER";
    Google_Protobuf_FieldOptions_JsType["JsString"] = "JS_STRING";
})(Google_Protobuf_FieldOptions_JsType || (Google_Protobuf_FieldOptions_JsType = {}));
export var Google_Protobuf_FieldOptions_OptionRetention;
(function (Google_Protobuf_FieldOptions_OptionRetention) {
    Google_Protobuf_FieldOptions_OptionRetention["RetentionRuntime"] = "RETENTION_RUNTIME";
    Google_Protobuf_FieldOptions_OptionRetention["RetentionSource"] = "RETENTION_SOURCE";
    Google_Protobuf_FieldOptions_OptionRetention["RetentionUnknown"] = "RETENTION_UNKNOWN";
})(Google_Protobuf_FieldOptions_OptionRetention || (Google_Protobuf_FieldOptions_OptionRetention = {}));
export var Google_Protobuf_FieldOptions_OptionTargetType;
(function (Google_Protobuf_FieldOptions_OptionTargetType) {
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeEnum"] = "TARGET_TYPE_ENUM";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeEnumEntry"] = "TARGET_TYPE_ENUM_ENTRY";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeExtensionRange"] = "TARGET_TYPE_EXTENSION_RANGE";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeField"] = "TARGET_TYPE_FIELD";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeFile"] = "TARGET_TYPE_FILE";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeMessage"] = "TARGET_TYPE_MESSAGE";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeMethod"] = "TARGET_TYPE_METHOD";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeOneof"] = "TARGET_TYPE_ONEOF";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeService"] = "TARGET_TYPE_SERVICE";
    Google_Protobuf_FieldOptions_OptionTargetType["TargetTypeUnknown"] = "TARGET_TYPE_UNKNOWN";
})(Google_Protobuf_FieldOptions_OptionTargetType || (Google_Protobuf_FieldOptions_OptionTargetType = {}));
export var Google_Protobuf_FileOptions_OptimizeMode;
(function (Google_Protobuf_FileOptions_OptimizeMode) {
    Google_Protobuf_FileOptions_OptimizeMode["CodeSize"] = "CODE_SIZE";
    Google_Protobuf_FileOptions_OptimizeMode["LiteRuntime"] = "LITE_RUNTIME";
    Google_Protobuf_FileOptions_OptimizeMode["Speed"] = "SPEED";
})(Google_Protobuf_FileOptions_OptimizeMode || (Google_Protobuf_FileOptions_OptimizeMode = {}));
export var Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic;
(function (Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic) {
    Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic["Alias"] = "ALIAS";
    Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic["None"] = "NONE";
    Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic["Set"] = "SET";
})(Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic || (Google_Protobuf_GeneratedCodeInfo_Annotation_Semantic = {}));
export var Google_Protobuf_MethodOptions_IdempotencyLevel;
(function (Google_Protobuf_MethodOptions_IdempotencyLevel) {
    Google_Protobuf_MethodOptions_IdempotencyLevel["IdempotencyUnknown"] = "IDEMPOTENCY_UNKNOWN";
    Google_Protobuf_MethodOptions_IdempotencyLevel["Idempotent"] = "IDEMPOTENT";
    Google_Protobuf_MethodOptions_IdempotencyLevel["NoSideEffects"] = "NO_SIDE_EFFECTS";
})(Google_Protobuf_MethodOptions_IdempotencyLevel || (Google_Protobuf_MethodOptions_IdempotencyLevel = {}));
export var Join__Graph;
(function (Join__Graph) {
    Join__Graph["Name_0"] = "NAME_0_";
    Join__Graph["Name_1"] = "NAME_1_";
})(Join__Graph || (Join__Graph = {}));
export var Net_TraceEvent_ChronoType;
(function (Net_TraceEvent_ChronoType) {
    Net_TraceEvent_ChronoType["ChronoConcurrent"] = "CHRONO_CONCURRENT";
    Net_TraceEvent_ChronoType["ChronoSequential"] = "CHRONO_SEQUENTIAL";
})(Net_TraceEvent_ChronoType || (Net_TraceEvent_ChronoType = {}));
export var Net_TraceEvent_ClockAlign_Type;
(function (Net_TraceEvent_ClockAlign_Type) {
    Net_TraceEvent_ClockAlign_Type["LocalClock"] = "LOCAL_CLOCK";
    Net_TraceEvent_ClockAlign_Type["RemoteClockKnown"] = "REMOTE_CLOCK_KNOWN";
    Net_TraceEvent_ClockAlign_Type["RemoteClockUnknown"] = "REMOTE_CLOCK_UNKNOWN";
})(Net_TraceEvent_ClockAlign_Type || (Net_TraceEvent_ClockAlign_Type = {}));
export var Net_Rpc_ThriftOptions_ProtocolType;
(function (Net_Rpc_ThriftOptions_ProtocolType) {
    Net_Rpc_ThriftOptions_ProtocolType["Binary"] = "BINARY";
    Net_Rpc_ThriftOptions_ProtocolType["Json"] = "JSON";
})(Net_Rpc_ThriftOptions_ProtocolType || (Net_Rpc_ThriftOptions_ProtocolType = {}));
export var Net_Zoo_ZnodeDataProto_Compression;
(function (Net_Zoo_ZnodeDataProto_Compression) {
    Net_Zoo_ZnodeDataProto_Compression["None"] = "NONE";
    Net_Zoo_ZnodeDataProto_Compression["Snappy"] = "SNAPPY";
})(Net_Zoo_ZnodeDataProto_Compression || (Net_Zoo_ZnodeDataProto_Compression = {}));
export var Net_Zoo_ZnodeDataProto_Type;
(function (Net_Zoo_ZnodeDataProto_Type) {
    Net_Zoo_ZnodeDataProto_Type["Data"] = "DATA";
    Net_Zoo_ZnodeDataProto_Type["Inode"] = "INODE";
})(Net_Zoo_ZnodeDataProto_Type || (Net_Zoo_ZnodeDataProto_Type = {}));
export var Notification_Channel_E;
(function (Notification_Channel_E) {
    Notification_Channel_E["Browser"] = "BROWSER";
    Notification_Channel_E["Email"] = "EMAIL";
    Notification_Channel_E["Mobile"] = "MOBILE";
    Notification_Channel_E["Service"] = "SERVICE";
    Notification_Channel_E["Slack"] = "SLACK";
})(Notification_Channel_E || (Notification_Channel_E = {}));
export var Notification_DeliveryMode;
(function (Notification_DeliveryMode) {
    Notification_DeliveryMode["EndOfDaySummary"] = "END_OF_DAY_SUMMARY";
    Notification_DeliveryMode["Immediate"] = "IMMEDIATE";
})(Notification_DeliveryMode || (Notification_DeliveryMode = {}));
export var Notification_DeliveryState_Status;
(function (Notification_DeliveryState_Status) {
    Notification_DeliveryState_Status["Failed"] = "FAILED";
    Notification_DeliveryState_Status["Filtered"] = "FILTERED";
    Notification_DeliveryState_Status["Pending"] = "PENDING";
    Notification_DeliveryState_Status["Success"] = "SUCCESS";
})(Notification_DeliveryState_Status || (Notification_DeliveryState_Status = {}));
export var Notification_Event;
(function (Notification_Event) {
    Notification_Event["AuthoredObjectEdited"] = "AUTHORED_OBJECT_EDITED";
    Notification_Event["AuthoredObjectShared"] = "AUTHORED_OBJECT_SHARED";
    Notification_Event["ClusterUpgraded"] = "CLUSTER_UPGRADED";
    Notification_Event["FavoriteObjectEdited"] = "FAVORITE_OBJECT_EDITED";
    Notification_Event["HomeObjectEdited"] = "HOME_OBJECT_EDITED";
    Notification_Event["ObjectShared"] = "OBJECT_SHARED";
    Notification_Event["ScheduledPinboardAvailable"] = "SCHEDULED_PINBOARD_AVAILABLE";
})(Notification_Event || (Notification_Event = {}));
export var Notification_EventCatagory;
(function (Notification_EventCatagory) {
    Notification_EventCatagory["Admin"] = "ADMIN";
    Notification_EventCatagory["DataLoad"] = "DATA_LOAD";
    Notification_EventCatagory["Edit"] = "EDIT";
    Notification_EventCatagory["ScheduledActivity"] = "SCHEDULED_ACTIVITY";
    Notification_EventCatagory["Sharing"] = "SHARING";
    Notification_EventCatagory["Spotiq"] = "SPOTIQ";
})(Notification_EventCatagory || (Notification_EventCatagory = {}));
export var Notification_Message_Parameter_Type;
(function (Notification_Message_Parameter_Type) {
    Notification_Message_Parameter_Type["Integer"] = "INTEGER";
    Notification_Message_Parameter_Type["MetadataObject"] = "METADATA_OBJECT";
    Notification_Message_Parameter_Type["String"] = "STRING";
    Notification_Message_Parameter_Type["Timestamp"] = "TIMESTAMP";
})(Notification_Message_Parameter_Type || (Notification_Message_Parameter_Type = {}));
export var Notification_Notification_Status;
(function (Notification_Notification_Status) {
    Notification_Notification_Status["Deleted"] = "DELETED";
    Notification_Notification_Status["New"] = "NEW";
    Notification_Notification_Status["Read"] = "READ";
    Notification_Notification_Status["Unread"] = "UNREAD";
})(Notification_Notification_Status || (Notification_Notification_Status = {}));
export var Notification_Priority;
(function (Notification_Priority) {
    Notification_Priority["High"] = "HIGH";
    Notification_Priority["Low"] = "LOW";
})(Notification_Priority || (Notification_Priority = {}));
export var Notification_Target_E;
(function (Notification_Target_E) {
    Notification_Target_E["BroswerChrome"] = "BROSWER_CHROME";
    Notification_Target_E["BrowserEdge"] = "BROWSER_EDGE";
    Notification_Target_E["BrowserSafari"] = "BROWSER_SAFARI";
    Notification_Target_E["Email"] = "EMAIL";
    Notification_Target_E["MobileAndroid"] = "MOBILE_ANDROID";
    Notification_Target_E["MobileIos"] = "MOBILE_IOS";
    Notification_Target_E["ServiceHttp"] = "SERVICE_HTTP";
    Notification_Target_E["ServiceRpc"] = "SERVICE_RPC";
    Notification_Target_E["Slack"] = "SLACK";
})(Notification_Target_E || (Notification_Target_E = {}));
export var OrientationValues;
(function (OrientationValues) {
    OrientationValues["Landscape"] = "LANDSCAPE";
    OrientationValues["Portrait"] = "PORTRAIT";
})(OrientationValues || (OrientationValues = {}));
export var Sage_A3AnalysisStatus_State;
(function (Sage_A3AnalysisStatus_State) {
    Sage_A3AnalysisStatus_State["Cancelled"] = "CANCELLED";
    Sage_A3AnalysisStatus_State["Done"] = "DONE";
    Sage_A3AnalysisStatus_State["Failed"] = "FAILED";
    Sage_A3AnalysisStatus_State["NotFound"] = "NOT_FOUND";
    Sage_A3AnalysisStatus_State["NotStarted"] = "NOT_STARTED";
    Sage_A3AnalysisStatus_State["Queued"] = "QUEUED";
    Sage_A3AnalysisStatus_State["Running"] = "RUNNING";
})(Sage_A3AnalysisStatus_State || (Sage_A3AnalysisStatus_State = {}));
export var Sage_A3AnalysisType_E;
(function (Sage_A3AnalysisType_E) {
    Sage_A3AnalysisType_E["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    Sage_A3AnalysisType_E["Change"] = "CHANGE";
    Sage_A3AnalysisType_E["Data"] = "DATA";
    Sage_A3AnalysisType_E["RelatedInsights"] = "RELATED_INSIGHTS";
    Sage_A3AnalysisType_E["Table"] = "TABLE";
    Sage_A3AnalysisType_E["Unknown"] = "UNKNOWN";
    Sage_A3AnalysisType_E["Visualization"] = "VISUALIZATION";
})(Sage_A3AnalysisType_E || (Sage_A3AnalysisType_E = {}));
export var Sage_AggregationLevel_E;
(function (Sage_AggregationLevel_E) {
    Sage_AggregationLevel_E["Aggregate"] = "AGGREGATE";
    Sage_AggregationLevel_E["NonAggregate"] = "NON_AGGREGATE";
})(Sage_AggregationLevel_E || (Sage_AggregationLevel_E = {}));
export var Sage_AggregationType_E;
(function (Sage_AggregationType_E) {
    Sage_AggregationType_E["AggregateDistinct"] = "AGGREGATE_DISTINCT";
    Sage_AggregationType_E["Average"] = "AVERAGE";
    Sage_AggregationType_E["Count"] = "COUNT";
    Sage_AggregationType_E["Max"] = "MAX";
    Sage_AggregationType_E["Median"] = "MEDIAN";
    Sage_AggregationType_E["Min"] = "MIN";
    Sage_AggregationType_E["None"] = "NONE";
    Sage_AggregationType_E["Percentile"] = "PERCENTILE";
    Sage_AggregationType_E["Rank"] = "RANK";
    Sage_AggregationType_E["RankPercentile"] = "RANK_PERCENTILE";
    Sage_AggregationType_E["StdDeviation"] = "STD_DEVIATION";
    Sage_AggregationType_E["Sum"] = "SUM";
    Sage_AggregationType_E["UniqueCount"] = "UNIQUE_COUNT";
    Sage_AggregationType_E["Variance"] = "VARIANCE";
})(Sage_AggregationType_E || (Sage_AggregationType_E = {}));
export var Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection;
(function (Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection) {
    Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection["High"] = "HIGH";
    Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection["Low"] = "LOW";
    Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection["Unknown"] = "UNKNOWN";
})(Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection || (Sage_AnalysisAlgorithm_DataPoint_AnomalyDirection = {}));
export var Sage_AnalysisAlgorithm_Type;
(function (Sage_AnalysisAlgorithm_Type) {
    Sage_AnalysisAlgorithm_Type["AbsDiffMajority"] = "ABS_DIFF_MAJORITY";
    Sage_AnalysisAlgorithm_Type["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    Sage_AnalysisAlgorithm_Type["CrossCorrelation"] = "CROSS_CORRELATION";
    Sage_AnalysisAlgorithm_Type["Forecast"] = "FORECAST";
    Sage_AnalysisAlgorithm_Type["KeyDrivers"] = "KEY_DRIVERS";
    Sage_AnalysisAlgorithm_Type["LinearRegression"] = "LINEAR_REGRESSION";
    Sage_AnalysisAlgorithm_Type["MadMedian"] = "MAD_MEDIAN";
    Sage_AnalysisAlgorithm_Type["Shesd"] = "SHESD";
    Sage_AnalysisAlgorithm_Type["StdevMean"] = "STDEV_MEAN";
    Sage_AnalysisAlgorithm_Type["TrendAnalysis"] = "TREND_ANALYSIS";
    Sage_AnalysisAlgorithm_Type["WhatIf"] = "WHAT_IF";
})(Sage_AnalysisAlgorithm_Type || (Sage_AnalysisAlgorithm_Type = {}));
export var Sage_AnalysisContext_AnalysisType;
(function (Sage_AnalysisContext_AnalysisType) {
    Sage_AnalysisContext_AnalysisType["InstantInsights"] = "INSTANT_INSIGHTS";
    Sage_AnalysisContext_AnalysisType["PostProcessor"] = "POST_PROCESSOR";
    Sage_AnalysisContext_AnalysisType["ScheduledAnalysis"] = "SCHEDULED_ANALYSIS";
    Sage_AnalysisContext_AnalysisType["SuggestColumns"] = "SUGGEST_COLUMNS";
    Sage_AnalysisContext_AnalysisType["SyncAnalysis"] = "SYNC_ANALYSIS";
})(Sage_AnalysisContext_AnalysisType || (Sage_AnalysisContext_AnalysisType = {}));
export var Sage_AnalysisDescriptor_AnalysisClass;
(function (Sage_AnalysisDescriptor_AnalysisClass) {
    Sage_AnalysisDescriptor_AnalysisClass["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    Sage_AnalysisDescriptor_AnalysisClass["CrossCorrelation"] = "CROSS_CORRELATION";
    Sage_AnalysisDescriptor_AnalysisClass["CustomRAnalysis"] = "CUSTOM_R_ANALYSIS";
    Sage_AnalysisDescriptor_AnalysisClass["DiffExplanation"] = "DIFF_EXPLANATION";
    Sage_AnalysisDescriptor_AnalysisClass["Forecast"] = "FORECAST";
    Sage_AnalysisDescriptor_AnalysisClass["KeyDrivers"] = "KEY_DRIVERS";
    Sage_AnalysisDescriptor_AnalysisClass["OutlierDetection"] = "OUTLIER_DETECTION";
    Sage_AnalysisDescriptor_AnalysisClass["TrendAnalysis"] = "TREND_ANALYSIS";
    Sage_AnalysisDescriptor_AnalysisClass["WhatIf"] = "WHAT_IF";
})(Sage_AnalysisDescriptor_AnalysisClass || (Sage_AnalysisDescriptor_AnalysisClass = {}));
export var Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType;
(function (Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType) {
    Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType["Csv"] = "CSV";
    Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType["Error"] = "ERROR";
    Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType["Png"] = "PNG";
})(Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType || (Sage_AnalysisDescriptor_CustomRAnalysis_ROutputType = {}));
export var Sage_AnomalyExplanationAnalysisRequest_ExplorationType;
(function (Sage_AnomalyExplanationAnalysisRequest_ExplorationType) {
    Sage_AnomalyExplanationAnalysisRequest_ExplorationType["AnomalyExplanation"] = "ANOMALY_EXPLANATION";
    Sage_AnomalyExplanationAnalysisRequest_ExplorationType["Classification"] = "CLASSIFICATION";
    Sage_AnomalyExplanationAnalysisRequest_ExplorationType["Unknown"] = "UNKNOWN";
})(Sage_AnomalyExplanationAnalysisRequest_ExplorationType || (Sage_AnomalyExplanationAnalysisRequest_ExplorationType = {}));
export var Sage_BooleanTypeProto_E;
(function (Sage_BooleanTypeProto_E) {
    Sage_BooleanTypeProto_E["And"] = "AND";
    Sage_BooleanTypeProto_E["Default"] = "DEFAULT";
    Sage_BooleanTypeProto_E["Or"] = "OR";
})(Sage_BooleanTypeProto_E || (Sage_BooleanTypeProto_E = {}));
export var Sage_BuildReason_E;
(function (Sage_BuildReason_E) {
    Sage_BuildReason_E["DataVersionForceUpdated"] = "DATA_VERSION_FORCE_UPDATED";
    Sage_BuildReason_E["FalconConfigUpdated"] = "FALCON_CONFIG_UPDATED";
    Sage_BuildReason_E["Forced"] = "FORCED";
    Sage_BuildReason_E["GetSampleTokensFailed"] = "GET_SAMPLE_TOKENS_FAILED";
    Sage_BuildReason_E["MetadataServingColumnsChanged"] = "METADATA_SERVING_COLUMNS_CHANGED";
    Sage_BuildReason_E["MetadataServingGroupsChanged"] = "METADATA_SERVING_GROUPS_CHANGED";
    Sage_BuildReason_E["MetadataServingUsersChanged"] = "METADATA_SERVING_USERS_CHANGED";
    Sage_BuildReason_E["PinSageBuildingFailed"] = "PIN_SAGE_BUILDING_FAILED";
    Sage_BuildReason_E["PinSageBuildingInvalidFuture"] = "PIN_SAGE_BUILDING_INVALID_FUTURE";
    Sage_BuildReason_E["PinSageServingFailed"] = "PIN_SAGE_SERVING_FAILED";
    Sage_BuildReason_E["SampleTokenStreamScheduleFailed"] = "SAMPLE_TOKEN_STREAM_SCHEDULE_FAILED";
    Sage_BuildReason_E["SampleTokenStreamSetupFailed"] = "SAMPLE_TOKEN_STREAM_SETUP_FAILED";
    Sage_BuildReason_E["SamplingFailed"] = "SAMPLING_FAILED";
    Sage_BuildReason_E["TableAssignmentChanged"] = "TABLE_ASSIGNMENT_CHANGED";
    Sage_BuildReason_E["TokenStreamScheduleFailed"] = "TOKEN_STREAM_SCHEDULE_FAILED";
    Sage_BuildReason_E["TokenStreamSetupFailed"] = "TOKEN_STREAM_SETUP_FAILED";
    Sage_BuildReason_E["Unknown"] = "UNKNOWN";
    Sage_BuildReason_E["UpdateFailed"] = "UPDATE_FAILED";
})(Sage_BuildReason_E || (Sage_BuildReason_E = {}));
export var Sage_CcaColumnConfigRequest_Action;
(function (Sage_CcaColumnConfigRequest_Action) {
    Sage_CcaColumnConfigRequest_Action["Delete"] = "DELETE";
    Sage_CcaColumnConfigRequest_Action["Reset"] = "RESET";
    Sage_CcaColumnConfigRequest_Action["Save"] = "SAVE";
})(Sage_CcaColumnConfigRequest_Action || (Sage_CcaColumnConfigRequest_Action = {}));
export var Sage_CcaColumnConfig_Type;
(function (Sage_CcaColumnConfig_Type) {
    Sage_CcaColumnConfig_Type["Chart"] = "CHART";
    Sage_CcaColumnConfig_Type["Ubr"] = "UBR";
    Sage_CcaColumnConfig_Type["User"] = "USER";
})(Sage_CcaColumnConfig_Type || (Sage_CcaColumnConfig_Type = {}));
export var Sage_ColumnIndexSkipReason_E;
(function (Sage_ColumnIndexSkipReason_E) {
    Sage_ColumnIndexSkipReason_E["SkipCantCreateQuery"] = "SKIP_CANT_CREATE_QUERY";
    Sage_ColumnIndexSkipReason_E["SkipConnectionAuthFailed"] = "SKIP_CONNECTION_AUTH_FAILED";
    Sage_ColumnIndexSkipReason_E["SkipDataIndexDisabled"] = "SKIP_DATA_INDEX_DISABLED";
    Sage_ColumnIndexSkipReason_E["SkipDate"] = "SKIP_DATE";
    Sage_ColumnIndexSkipReason_E["SkipDbViewTable"] = "SKIP_DB_VIEW_TABLE";
    Sage_ColumnIndexSkipReason_E["SkipDontIndex"] = "SKIP_DONT_INDEX";
    Sage_ColumnIndexSkipReason_E["SkipEmptyQueries"] = "SKIP_EMPTY_QUERIES";
    Sage_ColumnIndexSkipReason_E["SkipExceededDefaultMaxSize"] = "SKIP_EXCEEDED_DEFAULT_MAX_SIZE";
    Sage_ColumnIndexSkipReason_E["SkipExceededExtDsDefaultMaxSize"] = "SKIP_EXCEEDED_EXT_DS_DEFAULT_MAX_SIZE";
    Sage_ColumnIndexSkipReason_E["SkipExceededExtDsGlobalMaxSize"] = "SKIP_EXCEEDED_EXT_DS_GLOBAL_MAX_SIZE";
    Sage_ColumnIndexSkipReason_E["SkipExceededGlobalMaxSize"] = "SKIP_EXCEEDED_GLOBAL_MAX_SIZE";
    Sage_ColumnIndexSkipReason_E["SkipExternalDsDataIndexDisabled"] = "SKIP_EXTERNAL_DS_DATA_INDEX_DISABLED";
    Sage_ColumnIndexSkipReason_E["SkipFormulaColumnNotIndexable"] = "SKIP_FORMULA_COLUMN_NOT_INDEXABLE";
    Sage_ColumnIndexSkipReason_E["SkipFormulaIndexingDisabled"] = "SKIP_FORMULA_INDEXING_DISABLED";
    Sage_ColumnIndexSkipReason_E["SkipHiddenColumn"] = "SKIP_HIDDEN_COLUMN";
    Sage_ColumnIndexSkipReason_E["SkipIndexingDisabledOnTable"] = "SKIP_INDEXING_DISABLED_ON_TABLE";
    Sage_ColumnIndexSkipReason_E["SkipInternalStatsTable"] = "SKIP_INTERNAL_STATS_TABLE";
    Sage_ColumnIndexSkipReason_E["SkipInvalidFalconRequest"] = "SKIP_INVALID_FALCON_REQUEST";
    Sage_ColumnIndexSkipReason_E["SkipLowRelevance"] = "SKIP_LOW_RELEVANCE";
    Sage_ColumnIndexSkipReason_E["SkipMapped"] = "SKIP_MAPPED";
    Sage_ColumnIndexSkipReason_E["SkipNone"] = "SKIP_NONE";
    Sage_ColumnIndexSkipReason_E["SkipNonActiveUser"] = "SKIP_NON_ACTIVE_USER";
    Sage_ColumnIndexSkipReason_E["SkipNotAttribute"] = "SKIP_NOT_ATTRIBUTE";
    Sage_ColumnIndexSkipReason_E["SkipNoData"] = "SKIP_NO_DATA";
    Sage_ColumnIndexSkipReason_E["SkipParameterizedConnection"] = "SKIP_PARAMETERIZED_CONNECTION";
    Sage_ColumnIndexSkipReason_E["SkipPublishedTable"] = "SKIP_PUBLISHED_TABLE";
    Sage_ColumnIndexSkipReason_E["SkipSamplingFailed"] = "SKIP_SAMPLING_FAILED";
    Sage_ColumnIndexSkipReason_E["SkipSegmentNotBuilt"] = "SKIP_SEGMENT_NOT_BUILT";
    Sage_ColumnIndexSkipReason_E["SkipSetupTokenStreamFailed"] = "SKIP_SETUP_TOKEN_STREAM_FAILED";
    Sage_ColumnIndexSkipReason_E["SkipTableAbsentOnCdw"] = "SKIP_TABLE_ABSENT_ON_CDW";
    Sage_ColumnIndexSkipReason_E["SkipTableWithInputParameters"] = "SKIP_TABLE_WITH_INPUT_PARAMETERS";
    Sage_ColumnIndexSkipReason_E["SkipUnknownTier"] = "SKIP_UNKNOWN_TIER";
})(Sage_ColumnIndexSkipReason_E || (Sage_ColumnIndexSkipReason_E = {}));
export var Sage_ColumnIndexSourceType_E;
(function (Sage_ColumnIndexSourceType_E) {
    Sage_ColumnIndexSourceType_E["FalconQuery"] = "FALCON_QUERY";
    Sage_ColumnIndexSourceType_E["InlineValues"] = "INLINE_VALUES";
    Sage_ColumnIndexSourceType_E["RlsAwareExternalQuery"] = "RLS_AWARE_EXTERNAL_QUERY";
    Sage_ColumnIndexSourceType_E["RlsAwareFalconQuery"] = "RLS_AWARE_FALCON_QUERY";
})(Sage_ColumnIndexSourceType_E || (Sage_ColumnIndexSourceType_E = {}));
export var Sage_ColumnIndexTypeReason_E;
(function (Sage_ColumnIndexTypeReason_E) {
    Sage_ColumnIndexTypeReason_E["DataScore"] = "DATA_SCORE";
    Sage_ColumnIndexTypeReason_E["EntityDetected"] = "ENTITY_DETECTED";
    Sage_ColumnIndexTypeReason_E["ExceededMaxDefaultCardinality"] = "EXCEEDED_MAX_DEFAULT_CARDINALITY";
    Sage_ColumnIndexTypeReason_E["ExceededMaxGlobalCardinality"] = "EXCEEDED_MAX_GLOBAL_CARDINALITY";
    Sage_ColumnIndexTypeReason_E["ExceededMaxLongTokens"] = "EXCEEDED_MAX_LONG_TOKENS";
    Sage_ColumnIndexTypeReason_E["FalconDataTypeNotChar"] = "FALCON_DATA_TYPE_NOT_CHAR";
    Sage_ColumnIndexTypeReason_E["IgnoreRelevance"] = "IGNORE_RELEVANCE";
    Sage_ColumnIndexTypeReason_E["User"] = "USER";
})(Sage_ColumnIndexTypeReason_E || (Sage_ColumnIndexTypeReason_E = {}));
export var Sage_ColumnIndexType_E;
(function (Sage_ColumnIndexType_E) {
    Sage_ColumnIndexType_E["Default"] = "DEFAULT";
    Sage_ColumnIndexType_E["DontIndex"] = "DONT_INDEX";
    Sage_ColumnIndexType_E["PrefixAndSubstring"] = "PREFIX_AND_SUBSTRING";
    Sage_ColumnIndexType_E["PrefixAndWordSubstring"] = "PREFIX_AND_WORD_SUBSTRING";
    Sage_ColumnIndexType_E["PrefixOnly"] = "PREFIX_ONLY";
})(Sage_ColumnIndexType_E || (Sage_ColumnIndexType_E = {}));
export var Sage_ColumnType_E;
(function (Sage_ColumnType_E) {
    Sage_ColumnType_E["Attribute"] = "ATTRIBUTE";
    Sage_ColumnType_E["Measure"] = "MEASURE";
    Sage_ColumnType_E["Unknown"] = "UNKNOWN";
})(Sage_ColumnType_E || (Sage_ColumnType_E = {}));
export var Sage_CompareTypeProto_E;
(function (Sage_CompareTypeProto_E) {
    Sage_CompareTypeProto_E["BeginsWith"] = "BEGINS_WITH";
    Sage_CompareTypeProto_E["Bw"] = "BW";
    Sage_CompareTypeProto_E["BwInc"] = "BW_INC";
    Sage_CompareTypeProto_E["BwIncMax"] = "BW_INC_MAX";
    Sage_CompareTypeProto_E["BwIncMin"] = "BW_INC_MIN";
    Sage_CompareTypeProto_E["Contains"] = "CONTAINS";
    Sage_CompareTypeProto_E["EndsWith"] = "ENDS_WITH";
    Sage_CompareTypeProto_E["Eq"] = "EQ";
    Sage_CompareTypeProto_E["Ge"] = "GE";
    Sage_CompareTypeProto_E["Gt"] = "GT";
    Sage_CompareTypeProto_E["In"] = "IN";
    Sage_CompareTypeProto_E["Le"] = "LE";
    Sage_CompareTypeProto_E["Like"] = "LIKE";
    Sage_CompareTypeProto_E["Lt"] = "LT";
    Sage_CompareTypeProto_E["Ne"] = "NE";
    Sage_CompareTypeProto_E["NotIn"] = "NOT_IN";
})(Sage_CompareTypeProto_E || (Sage_CompareTypeProto_E = {}));
export var Sage_DateFilterProto_DateFilterType;
(function (Sage_DateFilterProto_DateFilterType) {
    Sage_DateFilterProto_DateFilterType["ExactDate"] = "EXACT_DATE";
    Sage_DateFilterProto_DateFilterType["ExactDateRange"] = "EXACT_DATE_RANGE";
    Sage_DateFilterProto_DateFilterType["ExactDateTime"] = "EXACT_DATE_TIME";
    Sage_DateFilterProto_DateFilterType["ExactTime"] = "EXACT_TIME";
    Sage_DateFilterProto_DateFilterType["LastNPeriod"] = "LAST_N_PERIOD";
    Sage_DateFilterProto_DateFilterType["LastPeriod"] = "LAST_PERIOD";
    Sage_DateFilterProto_DateFilterType["MonthOnly"] = "MONTH_ONLY";
    Sage_DateFilterProto_DateFilterType["MonthYear"] = "MONTH_YEAR";
    Sage_DateFilterProto_DateFilterType["NextNPeriod"] = "NEXT_N_PERIOD";
    Sage_DateFilterProto_DateFilterType["NextPeriod"] = "NEXT_PERIOD";
    Sage_DateFilterProto_DateFilterType["Now"] = "NOW";
    Sage_DateFilterProto_DateFilterType["NumDateFilters"] = "NUM_DATE_FILTERS";
    Sage_DateFilterProto_DateFilterType["NPeriodAgo"] = "N_PERIOD_AGO";
    Sage_DateFilterProto_DateFilterType["PeriodOnly"] = "PERIOD_ONLY";
    Sage_DateFilterProto_DateFilterType["PeriodToDate"] = "PERIOD_TO_DATE";
    Sage_DateFilterProto_DateFilterType["QuarterOnly"] = "QUARTER_ONLY";
    Sage_DateFilterProto_DateFilterType["QuarterYear"] = "QUARTER_YEAR";
    Sage_DateFilterProto_DateFilterType["ThisPeriod"] = "THIS_PERIOD";
    Sage_DateFilterProto_DateFilterType["Today"] = "TODAY";
    Sage_DateFilterProto_DateFilterType["Tomorrow"] = "TOMORROW";
    Sage_DateFilterProto_DateFilterType["WeekdayOnly"] = "WEEKDAY_ONLY";
    Sage_DateFilterProto_DateFilterType["YearOnly"] = "YEAR_ONLY";
    Sage_DateFilterProto_DateFilterType["Yesterday"] = "YESTERDAY";
})(Sage_DateFilterProto_DateFilterType || (Sage_DateFilterProto_DateFilterType = {}));
export var Sage_DateFilterProto_DatePeriod;
(function (Sage_DateFilterProto_DatePeriod) {
    Sage_DateFilterProto_DatePeriod["Day"] = "DAY";
    Sage_DateFilterProto_DatePeriod["Hour"] = "HOUR";
    Sage_DateFilterProto_DatePeriod["Minute"] = "MINUTE";
    Sage_DateFilterProto_DatePeriod["Month"] = "MONTH";
    Sage_DateFilterProto_DatePeriod["NumDatePeriods"] = "NUM_DATE_PERIODS";
    Sage_DateFilterProto_DatePeriod["Quarter"] = "QUARTER";
    Sage_DateFilterProto_DatePeriod["Second"] = "SECOND";
    Sage_DateFilterProto_DatePeriod["Week"] = "WEEK";
    Sage_DateFilterProto_DatePeriod["Year"] = "YEAR";
})(Sage_DateFilterProto_DatePeriod || (Sage_DateFilterProto_DatePeriod = {}));
export var Sage_DateFilterProto_Month;
(function (Sage_DateFilterProto_Month) {
    Sage_DateFilterProto_Month["April"] = "APRIL";
    Sage_DateFilterProto_Month["August"] = "AUGUST";
    Sage_DateFilterProto_Month["December"] = "DECEMBER";
    Sage_DateFilterProto_Month["February"] = "FEBRUARY";
    Sage_DateFilterProto_Month["January"] = "JANUARY";
    Sage_DateFilterProto_Month["July"] = "JULY";
    Sage_DateFilterProto_Month["June"] = "JUNE";
    Sage_DateFilterProto_Month["March"] = "MARCH";
    Sage_DateFilterProto_Month["May"] = "MAY";
    Sage_DateFilterProto_Month["November"] = "NOVEMBER";
    Sage_DateFilterProto_Month["NumMonths"] = "NUM_MONTHS";
    Sage_DateFilterProto_Month["October"] = "OCTOBER";
    Sage_DateFilterProto_Month["September"] = "SEPTEMBER";
})(Sage_DateFilterProto_Month || (Sage_DateFilterProto_Month = {}));
export var Sage_DateFilterProto_Quarter;
(function (Sage_DateFilterProto_Quarter) {
    Sage_DateFilterProto_Quarter["NumQuarters"] = "NUM_QUARTERS";
    Sage_DateFilterProto_Quarter["Q1"] = "Q1";
    Sage_DateFilterProto_Quarter["Q2"] = "Q2";
    Sage_DateFilterProto_Quarter["Q3"] = "Q3";
    Sage_DateFilterProto_Quarter["Q4"] = "Q4";
})(Sage_DateFilterProto_Quarter || (Sage_DateFilterProto_Quarter = {}));
export var Sage_DateFilterProto_WeekDay;
(function (Sage_DateFilterProto_WeekDay) {
    Sage_DateFilterProto_WeekDay["Friday"] = "FRIDAY";
    Sage_DateFilterProto_WeekDay["Monday"] = "MONDAY";
    Sage_DateFilterProto_WeekDay["NumWeekDays"] = "NUM_WEEK_DAYS";
    Sage_DateFilterProto_WeekDay["Saturday"] = "SATURDAY";
    Sage_DateFilterProto_WeekDay["Sunday"] = "SUNDAY";
    Sage_DateFilterProto_WeekDay["Thursday"] = "THURSDAY";
    Sage_DateFilterProto_WeekDay["Tuesday"] = "TUESDAY";
    Sage_DateFilterProto_WeekDay["Wednesday"] = "WEDNESDAY";
})(Sage_DateFilterProto_WeekDay || (Sage_DateFilterProto_WeekDay = {}));
export var Sage_EditType_E;
(function (Sage_EditType_E) {
    Sage_EditType_E["Editable"] = "EDITABLE";
    Sage_EditType_E["Hidden"] = "HIDDEN";
    Sage_EditType_E["MultiSelection"] = "MULTI_SELECTION";
    Sage_EditType_E["NonEditable"] = "NON_EDITABLE";
    Sage_EditType_E["Text"] = "TEXT";
})(Sage_EditType_E || (Sage_EditType_E = {}));
export var Sage_EntityCategory_E;
(function (Sage_EntityCategory_E) {
    Sage_EntityCategory_E["CompanyOrg"] = "COMPANY_ORG";
    Sage_EntityCategory_E["Default"] = "DEFAULT";
    Sage_EntityCategory_E["LatLong"] = "LAT_LONG";
    Sage_EntityCategory_E["Money"] = "MONEY";
    Sage_EntityCategory_E["NumTypes"] = "NUM_TYPES";
    Sage_EntityCategory_E["Person"] = "PERSON";
    Sage_EntityCategory_E["Place"] = "PLACE";
    Sage_EntityCategory_E["Product"] = "PRODUCT";
    Sage_EntityCategory_E["Time"] = "TIME";
    Sage_EntityCategory_E["ZipCode"] = "ZIP_CODE";
})(Sage_EntityCategory_E || (Sage_EntityCategory_E = {}));
export var Sage_FeedbackType_E;
(function (Sage_FeedbackType_E) {
    Sage_FeedbackType_E["Association"] = "ASSOCIATION";
    Sage_FeedbackType_E["NumTypes"] = "NUM_TYPES";
    Sage_FeedbackType_E["Synonym"] = "SYNONYM";
})(Sage_FeedbackType_E || (Sage_FeedbackType_E = {}));
export var Sage_I18nGroup_E;
(function (Sage_I18nGroup_E) {
    Sage_I18nGroup_E["DateFilter"] = "DATE_FILTER";
    Sage_I18nGroup_E["DayOfWeek"] = "DAY_OF_WEEK";
    Sage_I18nGroup_E["Month"] = "MONTH";
    Sage_I18nGroup_E["None"] = "NONE";
    Sage_I18nGroup_E["Quarter"] = "QUARTER";
})(Sage_I18nGroup_E || (Sage_I18nGroup_E = {}));
export var Sage_IndexCategory_E;
(function (Sage_IndexCategory_E) {
    Sage_IndexCategory_E["Global"] = "GLOBAL";
    Sage_IndexCategory_E["NumCategory"] = "NUM_CATEGORY";
    Sage_IndexCategory_E["Personal"] = "PERSONAL";
})(Sage_IndexCategory_E || (Sage_IndexCategory_E = {}));
export var Sage_IndexSourceType_E;
(function (Sage_IndexSourceType_E) {
    Sage_IndexSourceType_E["ExternalDs"] = "EXTERNAL_DS";
    Sage_IndexSourceType_E["Falcon"] = "FALCON";
    Sage_IndexSourceType_E["Metadata"] = "METADATA";
    Sage_IndexSourceType_E["Unknown"] = "UNKNOWN";
    Sage_IndexSourceType_E["Usage"] = "USAGE";
})(Sage_IndexSourceType_E || (Sage_IndexSourceType_E = {}));
export var Sage_IndexType_E;
(function (Sage_IndexType_E) {
    Sage_IndexType_E["Data"] = "DATA";
    Sage_IndexType_E["Metadata"] = "METADATA";
})(Sage_IndexType_E || (Sage_IndexType_E = {}));
export var Sage_InsightFeature_Type;
(function (Sage_InsightFeature_Type) {
    Sage_InsightFeature_Type["AllAnomaliesObvious"] = "ALL_ANOMALIES_OBVIOUS";
    Sage_InsightFeature_Type["AllChangesExpected"] = "ALL_CHANGES_EXPECTED";
    Sage_InsightFeature_Type["AnomalousPointUninteresting"] = "ANOMALOUS_POINT_UNINTERESTING";
    Sage_InsightFeature_Type["AttributeColumnUninteresting"] = "ATTRIBUTE_COLUMN_UNINTERESTING";
    Sage_InsightFeature_Type["AttributeFilterCombinationUninteresting"] = "ATTRIBUTE_FILTER_COMBINATION_UNINTERESTING";
    Sage_InsightFeature_Type["BetterDateBucket"] = "BETTER_DATE_BUCKET";
    Sage_InsightFeature_Type["CorrelationObvious"] = "CORRELATION_OBVIOUS";
    Sage_InsightFeature_Type["DataSourceUninteresting"] = "DATA_SOURCE_UNINTERESTING";
    Sage_InsightFeature_Type["DiffExpected"] = "DIFF_EXPECTED";
    Sage_InsightFeature_Type["DiffValueUninteresting"] = "DIFF_VALUE_UNINTERESTING";
    Sage_InsightFeature_Type["FilterColumnUninteresting"] = "FILTER_COLUMN_UNINTERESTING";
    Sage_InsightFeature_Type["MeasureColumnUninteresting"] = "MEASURE_COLUMN_UNINTERESTING";
    Sage_InsightFeature_Type["MeasureFilterCombinationObvious"] = "MEASURE_FILTER_COMBINATION_OBVIOUS";
    Sage_InsightFeature_Type["TrendBetterDateAttribute"] = "TREND_BETTER_DATE_ATTRIBUTE";
    Sage_InsightFeature_Type["TrendObvious"] = "TREND_OBVIOUS";
})(Sage_InsightFeature_Type || (Sage_InsightFeature_Type = {}));
export var Sage_JoinProto_JoinType;
(function (Sage_JoinProto_JoinType) {
    Sage_JoinProto_JoinType["Cross"] = "CROSS";
    Sage_JoinProto_JoinType["FullOuter"] = "FULL_OUTER";
    Sage_JoinProto_JoinType["Inner"] = "INNER";
    Sage_JoinProto_JoinType["LeftOuter"] = "LEFT_OUTER";
    Sage_JoinProto_JoinType["RightOuter"] = "RIGHT_OUTER";
})(Sage_JoinProto_JoinType || (Sage_JoinProto_JoinType = {}));
export var Sage_KeyType_E;
(function (Sage_KeyType_E) {
    Sage_KeyType_E["DelimiterNormalized"] = "DELIMITER_NORMALIZED";
    Sage_KeyType_E["Morphed"] = "MORPHED";
    Sage_KeyType_E["Stemmed"] = "STEMMED";
    Sage_KeyType_E["Undefined"] = "UNDEFINED";
    Sage_KeyType_E["Unstemmed"] = "UNSTEMMED";
})(Sage_KeyType_E || (Sage_KeyType_E = {}));
export var Sage_Locale_E;
(function (Sage_Locale_E) {
    Sage_Locale_E["Default"] = "DEFAULT";
    Sage_Locale_E["AfZa"] = "af_ZA";
    Sage_Locale_E["DaDk"] = "da_DK";
    Sage_Locale_E["DeCh"] = "de_CH";
    Sage_Locale_E["DeDe"] = "de_DE";
    Sage_Locale_E["EnAu"] = "en_AU";
    Sage_Locale_E["EnCa"] = "en_CA";
    Sage_Locale_E["EnDe"] = "en_DE";
    Sage_Locale_E["EnGb"] = "en_GB";
    Sage_Locale_E["EnIn"] = "en_IN";
    Sage_Locale_E["EnNz"] = "en_NZ";
    Sage_Locale_E["EnUs"] = "en_US";
    Sage_Locale_E["EsEs"] = "es_ES";
    Sage_Locale_E["EsMx"] = "es_MX";
    Sage_Locale_E["EsUs"] = "es_US";
    Sage_Locale_E["FiFi"] = "fi_FI";
    Sage_Locale_E["FrCa"] = "fr_CA";
    Sage_Locale_E["FrFr"] = "fr_FR";
    Sage_Locale_E["ItIt"] = "it_IT";
    Sage_Locale_E["JaJp"] = "ja_JP";
    Sage_Locale_E["KoKr"] = "ko_KR";
    Sage_Locale_E["NbNo"] = "nb_NO";
    Sage_Locale_E["NlNl"] = "nl_NL";
    Sage_Locale_E["PtBr"] = "pt_BR";
    Sage_Locale_E["PtPt"] = "pt_PT";
    Sage_Locale_E["RuRu"] = "ru_RU";
    Sage_Locale_E["SvSe"] = "sv_SE";
    Sage_Locale_E["ZhCn"] = "zh_CN";
    Sage_Locale_E["ZhHant"] = "zh_HANT";
})(Sage_Locale_E || (Sage_Locale_E = {}));
export var Sage_LogicalMetadataRequest_Type;
(function (Sage_LogicalMetadataRequest_Type) {
    Sage_LogicalMetadataRequest_Type["Full"] = "FULL";
    Sage_LogicalMetadataRequest_Type["Incremental"] = "INCREMENTAL";
})(Sage_LogicalMetadataRequest_Type || (Sage_LogicalMetadataRequest_Type = {}));
export var Sage_LogicalMetadataResponse_EntityType;
(function (Sage_LogicalMetadataResponse_EntityType) {
    Sage_LogicalMetadataResponse_EntityType["LogicalColumn"] = "LOGICAL_COLUMN";
    Sage_LogicalMetadataResponse_EntityType["LogicalRelationship"] = "LOGICAL_RELATIONSHIP";
    Sage_LogicalMetadataResponse_EntityType["LogicalTable"] = "LOGICAL_TABLE";
    Sage_LogicalMetadataResponse_EntityType["Variable"] = "VARIABLE";
})(Sage_LogicalMetadataResponse_EntityType || (Sage_LogicalMetadataResponse_EntityType = {}));
export var Sage_LogicalMetadataResponse_ErrorCode;
(function (Sage_LogicalMetadataResponse_ErrorCode) {
    Sage_LogicalMetadataResponse_ErrorCode["Error"] = "ERROR";
    Sage_LogicalMetadataResponse_ErrorCode["Ok"] = "OK";
})(Sage_LogicalMetadataResponse_ErrorCode || (Sage_LogicalMetadataResponse_ErrorCode = {}));
export var Sage_LogicalMetadataResponse_WorksheetType;
(function (Sage_LogicalMetadataResponse_WorksheetType) {
    Sage_LogicalMetadataResponse_WorksheetType["Container"] = "CONTAINER";
    Sage_LogicalMetadataResponse_WorksheetType["NumTypes"] = "NUM_TYPES";
    Sage_LogicalMetadataResponse_WorksheetType["View"] = "VIEW";
})(Sage_LogicalMetadataResponse_WorksheetType || (Sage_LogicalMetadataResponse_WorksheetType = {}));
export var Sage_LogicalTableType_E;
(function (Sage_LogicalTableType_E) {
    Sage_LogicalTableType_E["NumTypes"] = "NUM_TYPES";
    Sage_LogicalTableType_E["OneToOne"] = "ONE_TO_ONE";
    Sage_LogicalTableType_E["UserTable"] = "USER_TABLE";
    Sage_LogicalTableType_E["Worksheet"] = "WORKSHEET";
})(Sage_LogicalTableType_E || (Sage_LogicalTableType_E = {}));
export var Sage_MatchType_E;
(function (Sage_MatchType_E) {
    Sage_MatchType_E["Approximate"] = "APPROXIMATE";
    Sage_MatchType_E["ApproximatePrefix"] = "APPROXIMATE_PREFIX";
    Sage_MatchType_E["ApproximateWordPrefix"] = "APPROXIMATE_WORD_PREFIX";
    Sage_MatchType_E["Exact"] = "EXACT";
    Sage_MatchType_E["ExactStemmed"] = "EXACT_STEMMED";
    Sage_MatchType_E["PartialSubstring"] = "PARTIAL_SUBSTRING";
    Sage_MatchType_E["Prefix"] = "PREFIX";
    Sage_MatchType_E["Substring"] = "SUBSTRING";
    Sage_MatchType_E["Suffix"] = "SUFFIX";
    Sage_MatchType_E["Undefined"] = "UNDEFINED";
    Sage_MatchType_E["WordPrefix"] = "WORD_PREFIX";
})(Sage_MatchType_E || (Sage_MatchType_E = {}));
export var Sage_NlQueryComplexity_E;
(function (Sage_NlQueryComplexity_E) {
    Sage_NlQueryComplexity_E["Complex"] = "COMPLEX";
    Sage_NlQueryComplexity_E["Simple"] = "SIMPLE";
    Sage_NlQueryComplexity_E["Unknown"] = "UNKNOWN";
})(Sage_NlQueryComplexity_E || (Sage_NlQueryComplexity_E = {}));
export var Sage_NlTokenType_E;
(function (Sage_NlTokenType_E) {
    Sage_NlTokenType_E["Aggregate"] = "AGGREGATE";
    Sage_NlTokenType_E["Attribute"] = "ATTRIBUTE";
    Sage_NlTokenType_E["Filter"] = "FILTER";
    Sage_NlTokenType_E["Keyword"] = "KEYWORD";
    Sage_NlTokenType_E["Measure"] = "MEASURE";
    Sage_NlTokenType_E["NumTypes"] = "NUM_TYPES";
})(Sage_NlTokenType_E || (Sage_NlTokenType_E = {}));
export var Sage_PhraseType_E;
(function (Sage_PhraseType_E) {
    Sage_PhraseType_E["AggregatedAttributeValuePhrase"] = "AGGREGATED_ATTRIBUTE_VALUE_PHRASE";
    Sage_PhraseType_E["AggregatedColumnPhrase"] = "AGGREGATED_COLUMN_PHRASE";
    Sage_PhraseType_E["Begin"] = "BEGIN";
    Sage_PhraseType_E["CalendarPhrase"] = "CALENDAR_PHRASE";
    Sage_PhraseType_E["DelimiterPhrase"] = "DELIMITER_PHRASE";
    Sage_PhraseType_E["End"] = "END";
    Sage_PhraseType_E["FilteredCountPhrase"] = "FILTERED_COUNT_PHRASE";
    Sage_PhraseType_E["FilterPhrase"] = "FILTER_PHRASE";
    Sage_PhraseType_E["FormulaPhrase"] = "FORMULA_PHRASE";
    Sage_PhraseType_E["ForEachPhrase"] = "FOR_EACH_PHRASE";
    Sage_PhraseType_E["GeofilterPhrase"] = "GEOFILTER_PHRASE";
    Sage_PhraseType_E["GroupByColumnPhrase"] = "GROUP_BY_COLUMN_PHRASE";
    Sage_PhraseType_E["GrowthPhrase"] = "GROWTH_PHRASE";
    Sage_PhraseType_E["HavingPhrase"] = "HAVING_PHRASE";
    Sage_PhraseType_E["InFilterPhrase"] = "IN_FILTER_PHRASE";
    Sage_PhraseType_E["InFilterSubqueryPhrase"] = "IN_FILTER_SUBQUERY_PHRASE";
    Sage_PhraseType_E["OfFilterPhrase"] = "OF_FILTER_PHRASE";
    Sage_PhraseType_E["OfPhrase"] = "OF_PHRASE";
    Sage_PhraseType_E["OfSortByPhrase"] = "OF_SORT_BY_PHRASE";
    Sage_PhraseType_E["PercentageOfFilterPhrase"] = "PERCENTAGE_OF_FILTER_PHRASE";
    Sage_PhraseType_E["PercentageOfPhrase"] = "PERCENTAGE_OF_PHRASE";
    Sage_PhraseType_E["PercentageOfSortByPhrase"] = "PERCENTAGE_OF_SORT_BY_PHRASE";
    Sage_PhraseType_E["PivotPhrase"] = "PIVOT_PHRASE";
    Sage_PhraseType_E["ShowColumnPhrase"] = "SHOW_COLUMN_PHRASE";
    Sage_PhraseType_E["SkipTokenPhrase"] = "SKIP_TOKEN_PHRASE";
    Sage_PhraseType_E["SortByPhrase"] = "SORT_BY_PHRASE";
    Sage_PhraseType_E["StopWordPhrase"] = "STOP_WORD_PHRASE";
    Sage_PhraseType_E["TopBottomFilterPhrase"] = "TOP_BOTTOM_FILTER_PHRASE";
    Sage_PhraseType_E["TopBottomPhrase"] = "TOP_BOTTOM_PHRASE";
    Sage_PhraseType_E["UndefinedPhrase"] = "UNDEFINED_PHRASE";
    Sage_PhraseType_E["VersusPhrase"] = "VERSUS_PHRASE";
    Sage_PhraseType_E["VersusSubqueryPhrase"] = "VERSUS_SUBQUERY_PHRASE";
})(Sage_PhraseType_E || (Sage_PhraseType_E = {}));
export var Sage_PhysicalTableType_E;
(function (Sage_PhysicalTableType_E) {
    Sage_PhysicalTableType_E["NumTypes"] = "NUM_TYPES";
    Sage_PhysicalTableType_E["Statsdb"] = "STATSDB";
    Sage_PhysicalTableType_E["System"] = "SYSTEM";
    Sage_PhysicalTableType_E["User"] = "USER";
})(Sage_PhysicalTableType_E || (Sage_PhysicalTableType_E = {}));
export var Sage_ProviderType_E;
(function (Sage_ProviderType_E) {
    Sage_ProviderType_E["AdminViaCli"] = "ADMIN_VIA_CLI";
    Sage_ProviderType_E["EnliteRewriters"] = "ENLITE_REWRITERS";
    Sage_ProviderType_E["NumTypes"] = "NUM_TYPES";
    Sage_ProviderType_E["UserViaFrontEnd"] = "USER_VIA_FRONT_END";
})(Sage_ProviderType_E || (Sage_ProviderType_E = {}));
export var Sage_QvColumnProto_Property;
(function (Sage_QvColumnProto_Property) {
    Sage_QvColumnProto_Property["GrowthDimension"] = "GROWTH_DIMENSION";
    Sage_QvColumnProto_Property["IsFormula"] = "IS_FORMULA";
    Sage_QvColumnProto_Property["IsGrouping"] = "IS_GROUPING";
    Sage_QvColumnProto_Property["IsOutput"] = "IS_OUTPUT";
    Sage_QvColumnProto_Property["SortAscending"] = "SORT_ASCENDING";
    Sage_QvColumnProto_Property["SortDescending"] = "SORT_DESCENDING";
})(Sage_QvColumnProto_Property || (Sage_QvColumnProto_Property = {}));
export var Sage_QvFilterProto_Property;
(function (Sage_QvFilterProto_Property) {
    Sage_QvFilterProto_Property["IncludeNull"] = "INCLUDE_NULL";
    Sage_QvFilterProto_Property["IsDateFilter"] = "IS_DATE_FILTER";
    Sage_QvFilterProto_Property["IsFormula"] = "IS_FORMULA";
    Sage_QvFilterProto_Property["IsInSubquery"] = "IS_IN_SUBQUERY";
})(Sage_QvFilterProto_Property || (Sage_QvFilterProto_Property = {}));
export var Sage_QvTableProto_TableType;
(function (Sage_QvTableProto_TableType) {
    Sage_QvTableProto_TableType["AggWorksheet"] = "AGG_WORKSHEET";
    Sage_QvTableProto_TableType["BaseTable"] = "BASE_TABLE";
    Sage_QvTableProto_TableType["QueryTable"] = "QUERY_TABLE";
    Sage_QvTableProto_TableType["Unknown"] = "UNKNOWN";
    Sage_QvTableProto_TableType["Worksheet"] = "WORKSHEET";
})(Sage_QvTableProto_TableType || (Sage_QvTableProto_TableType = {}));
export var Sage_QueryTableProto_FilterType;
(function (Sage_QueryTableProto_FilterType) {
    Sage_QueryTableProto_FilterType["Date"] = "DATE";
    Sage_QueryTableProto_FilterType["Geo"] = "GEO";
    Sage_QueryTableProto_FilterType["Simple"] = "SIMPLE";
})(Sage_QueryTableProto_FilterType || (Sage_QueryTableProto_FilterType = {}));
export var Sage_QueryTemplateRuleProto_MatchType;
(function (Sage_QueryTemplateRuleProto_MatchType) {
    Sage_QueryTemplateRuleProto_MatchType["Prefix"] = "PREFIX";
    Sage_QueryTemplateRuleProto_MatchType["Suffix"] = "SUFFIX";
    Sage_QueryTemplateRuleProto_MatchType["Unordered"] = "UNORDERED";
})(Sage_QueryTemplateRuleProto_MatchType || (Sage_QueryTemplateRuleProto_MatchType = {}));
export var Sage_RequestType_E;
(function (Sage_RequestType_E) {
    Sage_RequestType_E["Classic"] = "CLASSIC";
    Sage_RequestType_E["Enlite"] = "ENLITE";
})(Sage_RequestType_E || (Sage_RequestType_E = {}));
export var Sage_SageExpression_ExpressionClass;
(function (Sage_SageExpression_ExpressionClass) {
    Sage_SageExpression_ExpressionClass["ExprColumn"] = "EXPR_COLUMN";
    Sage_SageExpression_ExpressionClass["ExprConstant"] = "EXPR_CONSTANT";
    Sage_SageExpression_ExpressionClass["ExprFunction"] = "EXPR_FUNCTION";
    Sage_SageExpression_ExpressionClass["ExprVariable"] = "EXPR_VARIABLE";
})(Sage_SageExpression_ExpressionClass || (Sage_SageExpression_ExpressionClass = {}));
export var Sage_SparseBitmapProto_Version;
(function (Sage_SparseBitmapProto_Version) {
    Sage_SparseBitmapProto_Version["V1"] = "V1";
    Sage_SparseBitmapProto_Version["V2"] = "V2";
    Sage_SparseBitmapProto_Version["V3"] = "V3";
})(Sage_SparseBitmapProto_Version || (Sage_SparseBitmapProto_Version = {}));
export var Sage_SynonymSource_E;
(function (Sage_SynonymSource_E) {
    Sage_SynonymSource_E["AutoGenerated"] = "AUTO_GENERATED";
    Sage_SynonymSource_E["NlSynonymDictionary"] = "NL_SYNONYM_DICTIONARY";
    Sage_SynonymSource_E["SynonymDictionary"] = "SYNONYM_DICTIONARY";
    Sage_SynonymSource_E["Unknown"] = "UNKNOWN";
    Sage_SynonymSource_E["UserDefined"] = "USER_DEFINED";
    Sage_SynonymSource_E["Wordnet"] = "WORDNET";
})(Sage_SynonymSource_E || (Sage_SynonymSource_E = {}));
export var Sage_TimeBucketQualifierProto_E;
(function (Sage_TimeBucketQualifierProto_E) {
    Sage_TimeBucketQualifierProto_E["DayOverDay"] = "DAY_OVER_DAY";
    Sage_TimeBucketQualifierProto_E["MonthOverMonth"] = "MONTH_OVER_MONTH";
    Sage_TimeBucketQualifierProto_E["None"] = "NONE";
    Sage_TimeBucketQualifierProto_E["QuarterOverQuarter"] = "QUARTER_OVER_QUARTER";
    Sage_TimeBucketQualifierProto_E["WeekOverWeek"] = "WEEK_OVER_WEEK";
    Sage_TimeBucketQualifierProto_E["YearOverYear"] = "YEAR_OVER_YEAR";
})(Sage_TimeBucketQualifierProto_E || (Sage_TimeBucketQualifierProto_E = {}));
export var Sage_TimeBucket_E;
(function (Sage_TimeBucket_E) {
    Sage_TimeBucket_E["Auto"] = "AUTO";
    Sage_TimeBucket_E["Daily"] = "DAILY";
    Sage_TimeBucket_E["DayOfMonth"] = "DAY_OF_MONTH";
    Sage_TimeBucket_E["DayOfQuarter"] = "DAY_OF_QUARTER";
    Sage_TimeBucket_E["DayOfWeek"] = "DAY_OF_WEEK";
    Sage_TimeBucket_E["DayOfYear"] = "DAY_OF_YEAR";
    Sage_TimeBucket_E["Hourly"] = "HOURLY";
    Sage_TimeBucket_E["HourOfDay"] = "HOUR_OF_DAY";
    Sage_TimeBucket_E["Monthly"] = "MONTHLY";
    Sage_TimeBucket_E["MonthOfQuarter"] = "MONTH_OF_QUARTER";
    Sage_TimeBucket_E["MonthOfYear"] = "MONTH_OF_YEAR";
    Sage_TimeBucket_E["NoBucket"] = "NO_BUCKET";
    Sage_TimeBucket_E["Quarterly"] = "QUARTERLY";
    Sage_TimeBucket_E["QuarterOfYear"] = "QUARTER_OF_YEAR";
    Sage_TimeBucket_E["Weekly"] = "WEEKLY";
    Sage_TimeBucket_E["WeekOfMonth"] = "WEEK_OF_MONTH";
    Sage_TimeBucket_E["WeekOfQuarter"] = "WEEK_OF_QUARTER";
    Sage_TimeBucket_E["WeekOfYear"] = "WEEK_OF_YEAR";
    Sage_TimeBucket_E["Yearly"] = "YEARLY";
})(Sage_TimeBucket_E || (Sage_TimeBucket_E = {}));
export var Sage_TokenType_E;
(function (Sage_TokenType_E) {
    Sage_TokenType_E["Any"] = "ANY";
    Sage_TokenType_E["Attribute"] = "ATTRIBUTE";
    Sage_TokenType_E["Bool"] = "BOOL";
    Sage_TokenType_E["Calendar"] = "CALENDAR";
    Sage_TokenType_E["Constant"] = "CONSTANT";
    Sage_TokenType_E["Date"] = "DATE";
    Sage_TokenType_E["DateBucket"] = "DATE_BUCKET";
    Sage_TokenType_E["Delimiter"] = "DELIMITER";
    Sage_TokenType_E["Double"] = "DOUBLE";
    Sage_TokenType_E["EndFsm"] = "END_FSM";
    Sage_TokenType_E["Formula"] = "FORMULA";
    Sage_TokenType_E["FunctionName"] = "FUNCTION_NAME";
    Sage_TokenType_E["IncludeFsm"] = "INCLUDE_FSM";
    Sage_TokenType_E["Integer"] = "INTEGER";
    Sage_TokenType_E["Keyword"] = "KEYWORD";
    Sage_TokenType_E["MaxType"] = "MAX_TYPE";
    Sage_TokenType_E["Measure"] = "MEASURE";
    Sage_TokenType_E["NamedPhrase"] = "NAMED_PHRASE";
    Sage_TokenType_E["Operator"] = "OPERATOR";
    Sage_TokenType_E["Parameter"] = "PARAMETER";
    Sage_TokenType_E["PositiveInt"] = "POSITIVE_INT";
    Sage_TokenType_E["PrefixValue"] = "PREFIX_VALUE";
    Sage_TokenType_E["SkipToken"] = "SKIP_TOKEN";
    Sage_TokenType_E["StopWord"] = "STOP_WORD";
    Sage_TokenType_E["String"] = "STRING";
    Sage_TokenType_E["SubstringValue"] = "SUBSTRING_VALUE";
    Sage_TokenType_E["SuffixValue"] = "SUFFIX_VALUE";
    Sage_TokenType_E["TemplateArg"] = "TEMPLATE_ARG";
    Sage_TokenType_E["Time"] = "TIME";
    Sage_TokenType_E["Unrecognized"] = "UNRECOGNIZED";
    Sage_TokenType_E["Value"] = "VALUE";
    Sage_TokenType_E["Year"] = "YEAR";
})(Sage_TokenType_E || (Sage_TokenType_E = {}));
export var Sage_VisualizationAnalysisRequest_CurrentDataOptions;
(function (Sage_VisualizationAnalysisRequest_CurrentDataOptions) {
    Sage_VisualizationAnalysisRequest_CurrentDataOptions["CurrentOnly"] = "CURRENT_ONLY";
    Sage_VisualizationAnalysisRequest_CurrentDataOptions["Exclude"] = "EXCLUDE";
    Sage_VisualizationAnalysisRequest_CurrentDataOptions["Include"] = "INCLUDE";
})(Sage_VisualizationAnalysisRequest_CurrentDataOptions || (Sage_VisualizationAnalysisRequest_CurrentDataOptions = {}));
export var Sage_Auto_Complete_V2_AcContext_Version;
(function (Sage_Auto_Complete_V2_AcContext_Version) {
    Sage_Auto_Complete_V2_AcContext_Version["V1"] = "V1";
    Sage_Auto_Complete_V2_AcContext_Version["V2"] = "V2";
})(Sage_Auto_Complete_V2_AcContext_Version || (Sage_Auto_Complete_V2_AcContext_Version = {}));
export var Sage_Auto_Complete_V2_AcVersion_E;
(function (Sage_Auto_Complete_V2_AcVersion_E) {
    Sage_Auto_Complete_V2_AcVersion_E["MaxVersion"] = "MAX_VERSION";
    Sage_Auto_Complete_V2_AcVersion_E["Pre_4_3"] = "PRE_4_3";
    Sage_Auto_Complete_V2_AcVersion_E["V_4_3"] = "V_4_3";
    Sage_Auto_Complete_V2_AcVersion_E["V_4_4_1"] = "V_4_4_1";
    Sage_Auto_Complete_V2_AcVersion_E["V_4_4_1_3"] = "V_4_4_1_3";
    Sage_Auto_Complete_V2_AcVersion_E["V_4_5"] = "V_4_5";
    Sage_Auto_Complete_V2_AcVersion_E["V_4_5_1"] = "V_4_5_1";
    Sage_Auto_Complete_V2_AcVersion_E["V_5"] = "V_5";
    Sage_Auto_Complete_V2_AcVersion_E["V_5_2"] = "V_5_2";
    Sage_Auto_Complete_V2_AcVersion_E["V_6_2"] = "V_6_2";
    Sage_Auto_Complete_V2_AcVersion_E["V_6_3_1"] = "V_6_3_1";
    Sage_Auto_Complete_V2_AcVersion_E["V_8_0_0Cl"] = "V_8_0_0_CL";
    Sage_Auto_Complete_V2_AcVersion_E["V_8_2_0Cl"] = "V_8_2_0_CL";
    Sage_Auto_Complete_V2_AcVersion_E["V_8_7_0Cl"] = "V_8_7_0_CL";
    Sage_Auto_Complete_V2_AcVersion_E["V_8_8_0Cl"] = "V_8_8_0_CL";
    Sage_Auto_Complete_V2_AcVersion_E["V_8_8_1Sw"] = "V_8_8_1_SW";
    Sage_Auto_Complete_V2_AcVersion_E["V_9_1_0Cl"] = "V_9_1_0_CL";
    Sage_Auto_Complete_V2_AcVersion_E["V_9_5_0Cl"] = "V_9_5_0_CL";
})(Sage_Auto_Complete_V2_AcVersion_E || (Sage_Auto_Complete_V2_AcVersion_E = {}));
export var Sage_Auto_Complete_V2_ChartIntent_ChartType;
(function (Sage_Auto_Complete_V2_ChartIntent_ChartType) {
    Sage_Auto_Complete_V2_ChartIntent_ChartType["Bar"] = "BAR";
    Sage_Auto_Complete_V2_ChartIntent_ChartType["Line"] = "LINE";
    Sage_Auto_Complete_V2_ChartIntent_ChartType["Pie"] = "PIE";
})(Sage_Auto_Complete_V2_ChartIntent_ChartType || (Sage_Auto_Complete_V2_ChartIntent_ChartType = {}));
export var Sage_Auto_Complete_V2_ClientAction_E;
(function (Sage_Auto_Complete_V2_ClientAction_E) {
    Sage_Auto_Complete_V2_ClientAction_E["ChangeVisualConfiguration"] = "CHANGE_VISUAL_CONFIGURATION";
    Sage_Auto_Complete_V2_ClientAction_E["HighlightFilters"] = "HIGHLIGHT_FILTERS";
    Sage_Auto_Complete_V2_ClientAction_E["HighlightTable"] = "HIGHLIGHT_TABLE";
    Sage_Auto_Complete_V2_ClientAction_E["SeeResults"] = "SEE_RESULTS";
})(Sage_Auto_Complete_V2_ClientAction_E || (Sage_Auto_Complete_V2_ClientAction_E = {}));
export var Sage_Auto_Complete_V2_CompletionScope_E;
(function (Sage_Auto_Complete_V2_CompletionScope_E) {
    Sage_Auto_Complete_V2_CompletionScope_E["InScope"] = "IN_SCOPE";
    Sage_Auto_Complete_V2_CompletionScope_E["JoinableThroughChasmTrap"] = "JOINABLE_THROUGH_CHASM_TRAP";
    Sage_Auto_Complete_V2_CompletionScope_E["NonJoinableScope"] = "NON_JOINABLE_SCOPE";
    Sage_Auto_Complete_V2_CompletionScope_E["OutOfScope"] = "OUT_OF_SCOPE";
})(Sage_Auto_Complete_V2_CompletionScope_E || (Sage_Auto_Complete_V2_CompletionScope_E = {}));
export var Sage_Auto_Complete_V2_CompletionType_E;
(function (Sage_Auto_Complete_V2_CompletionType_E) {
    Sage_Auto_Complete_V2_CompletionType_E["Classic"] = "CLASSIC";
    Sage_Auto_Complete_V2_CompletionType_E["Nlp"] = "NLP";
    Sage_Auto_Complete_V2_CompletionType_E["ProcessNl"] = "PROCESS_NL";
})(Sage_Auto_Complete_V2_CompletionType_E || (Sage_Auto_Complete_V2_CompletionType_E = {}));
export var Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType;
(function (Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType) {
    Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType["Add"] = "ADD";
    Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType["Compare"] = "COMPARE";
    Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType["Filter"] = "FILTER";
    Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType["Replace"] = "REPLACE";
})(Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType || (Sage_Auto_Complete_V2_ConstrainedSearchContext_ExplorationType = {}));
export var Sage_Auto_Complete_V2_DataScopeTableType_E;
(function (Sage_Auto_Complete_V2_DataScopeTableType_E) {
    Sage_Auto_Complete_V2_DataScopeTableType_E["Logical"] = "LOGICAL";
    Sage_Auto_Complete_V2_DataScopeTableType_E["UserDefined"] = "USER_DEFINED";
    Sage_Auto_Complete_V2_DataScopeTableType_E["Worksheet"] = "WORKSHEET";
})(Sage_Auto_Complete_V2_DataScopeTableType_E || (Sage_Auto_Complete_V2_DataScopeTableType_E = {}));
export var Sage_Auto_Complete_V2_ErrorCode_E;
(function (Sage_Auto_Complete_V2_ErrorCode_E) {
    Sage_Auto_Complete_V2_ErrorCode_E["AmbiguousToken"] = "AMBIGUOUS_TOKEN";
    Sage_Auto_Complete_V2_ErrorCode_E["BadRecognizedTokens"] = "BAD_RECOGNIZED_TOKENS";
    Sage_Auto_Complete_V2_ErrorCode_E["BadTokenSequence"] = "BAD_TOKEN_SEQUENCE";
    Sage_Auto_Complete_V2_ErrorCode_E["Cancelled"] = "CANCELLED";
    Sage_Auto_Complete_V2_ErrorCode_E["Failure"] = "FAILURE";
    Sage_Auto_Complete_V2_ErrorCode_E["ForbiddenWord"] = "FORBIDDEN_WORD";
    Sage_Auto_Complete_V2_ErrorCode_E["InconsistentJoinPath"] = "INCONSISTENT_JOIN_PATH";
    Sage_Auto_Complete_V2_ErrorCode_E["IncrementalRequestNotApplicable"] = "INCREMENTAL_REQUEST_NOT_APPLICABLE";
    Sage_Auto_Complete_V2_ErrorCode_E["InvalidColumn"] = "INVALID_COLUMN";
    Sage_Auto_Complete_V2_ErrorCode_E["InvalidJoinPath"] = "INVALID_JOIN_PATH";
    Sage_Auto_Complete_V2_ErrorCode_E["InvalidRequest"] = "INVALID_REQUEST";
    Sage_Auto_Complete_V2_ErrorCode_E["InvalidTable"] = "INVALID_TABLE";
    Sage_Auto_Complete_V2_ErrorCode_E["InvalidTransform"] = "INVALID_TRANSFORM";
    Sage_Auto_Complete_V2_ErrorCode_E["JoinPathAmbiguity"] = "JOIN_PATH_AMBIGUITY";
    Sage_Auto_Complete_V2_ErrorCode_E["LessonPlanUpgraded"] = "LESSON_PLAN_UPGRADED";
    Sage_Auto_Complete_V2_ErrorCode_E["LessonPlanUpgradeFailed"] = "LESSON_PLAN_UPGRADE_FAILED";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmDisabled"] = "LLM_DISABLED";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmFormat"] = "LLM_FORMAT";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmNotEnoughQuestions"] = "LLM_NOT_ENOUGH_QUESTIONS";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmNotFoundInPensieve"] = "LLM_NOT_FOUND_IN_PENSIEVE";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmPensieveWriteError"] = "LLM_PENSIEVE_WRITE_ERROR";
    Sage_Auto_Complete_V2_ErrorCode_E["LlmUnavailable"] = "LLM_UNAVAILABLE";
    Sage_Auto_Complete_V2_ErrorCode_E["NestedAggrWarning"] = "NESTED_AGGR_WARNING";
    Sage_Auto_Complete_V2_ErrorCode_E["NestingGroupAggrNotAllowed"] = "NESTING_GROUP_AGGR_NOT_ALLOWED";
    Sage_Auto_Complete_V2_ErrorCode_E["NotFound"] = "NOT_FOUND";
    Sage_Auto_Complete_V2_ErrorCode_E["NotReady"] = "NOT_READY";
    Sage_Auto_Complete_V2_ErrorCode_E["NoJoinPath"] = "NO_JOIN_PATH";
    Sage_Auto_Complete_V2_ErrorCode_E["NoMatch"] = "NO_MATCH";
    Sage_Auto_Complete_V2_ErrorCode_E["PermissionDenied"] = "PERMISSION_DENIED";
    Sage_Auto_Complete_V2_ErrorCode_E["QueryTemplateToTemplateEntryMismatch"] = "QUERY_TEMPLATE_TO_TEMPLATE_ENTRY_MISMATCH";
    Sage_Auto_Complete_V2_ErrorCode_E["RelationshipGraphHasCycles"] = "RELATIONSHIP_GRAPH_HAS_CYCLES";
    Sage_Auto_Complete_V2_ErrorCode_E["RemoveFormulaDependencyFailure"] = "REMOVE_FORMULA_DEPENDENCY_FAILURE";
    Sage_Auto_Complete_V2_ErrorCode_E["Success"] = "SUCCESS";
    Sage_Auto_Complete_V2_ErrorCode_E["TimeOutError"] = "TIME_OUT_ERROR";
    Sage_Auto_Complete_V2_ErrorCode_E["UnknownUser"] = "UNKNOWN_USER";
    Sage_Auto_Complete_V2_ErrorCode_E["UnsupportedLanguage"] = "UNSUPPORTED_LANGUAGE";
    Sage_Auto_Complete_V2_ErrorCode_E["UserGroupMaskNotSet"] = "USER_GROUP_MASK_NOT_SET";
})(Sage_Auto_Complete_V2_ErrorCode_E || (Sage_Auto_Complete_V2_ErrorCode_E = {}));
export var Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType;
(function (Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType) {
    Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType["ForbiddenByData"] = "FORBIDDEN_BY_DATA";
    Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType["ForbiddenByLang"] = "FORBIDDEN_BY_LANG";
})(Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType || (Sage_Auto_Complete_V2_ErrorDebugInfo_ForbiddenType = {}));
export var Sage_Auto_Complete_V2_ErrorSeverity_E;
(function (Sage_Auto_Complete_V2_ErrorSeverity_E) {
    Sage_Auto_Complete_V2_ErrorSeverity_E["Error"] = "ERROR";
    Sage_Auto_Complete_V2_ErrorSeverity_E["Suggestion"] = "SUGGESTION";
    Sage_Auto_Complete_V2_ErrorSeverity_E["Warning"] = "WARNING";
})(Sage_Auto_Complete_V2_ErrorSeverity_E || (Sage_Auto_Complete_V2_ErrorSeverity_E = {}));
export var Sage_Auto_Complete_V2_FeatureFlag_E;
(function (Sage_Auto_Complete_V2_FeatureFlag_E) {
    Sage_Auto_Complete_V2_FeatureFlag_E["AutoResolveJoinAmbiguity"] = "AUTO_RESOLVE_JOIN_AMBIGUITY";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableApproximateMatches"] = "DISABLE_APPROXIMATE_MATCHES";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableDataBasedAutoBucketing"] = "DISABLE_DATA_BASED_AUTO_BUCKETING";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableFollowUpSuggestions"] = "DISABLE_FOLLOW_UP_SUGGESTIONS";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableObjectSearch"] = "DISABLE_OBJECT_SEARCH";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableSearchHistoryLookup"] = "DISABLE_SEARCH_HISTORY_LOOKUP";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableTokenization"] = "DISABLE_TOKENIZATION";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableUbr"] = "DISABLE_UBR";
    Sage_Auto_Complete_V2_FeatureFlag_E["DisableUbrFeedbackLookup"] = "DISABLE_UBR_FEEDBACK_LOOKUP";
    Sage_Auto_Complete_V2_FeatureFlag_E["EnableDataBasedAutoBucketing"] = "ENABLE_DATA_BASED_AUTO_BUCKETING";
    Sage_Auto_Complete_V2_FeatureFlag_E["EnableNlpTokenizer"] = "ENABLE_NLP_TOKENIZER";
    Sage_Auto_Complete_V2_FeatureFlag_E["EnableOutOfScopeMatches"] = "ENABLE_OUT_OF_SCOPE_MATCHES";
    Sage_Auto_Complete_V2_FeatureFlag_E["EnableRequestProfiling"] = "ENABLE_REQUEST_PROFILING";
    Sage_Auto_Complete_V2_FeatureFlag_E["EnableSearchHistory"] = "ENABLE_SEARCH_HISTORY";
    Sage_Auto_Complete_V2_FeatureFlag_E["LookupEnlitePreferredColumns"] = "LOOKUP_ENLITE_PREFERRED_COLUMNS";
    Sage_Auto_Complete_V2_FeatureFlag_E["LookupOnlyColumns"] = "LOOKUP_ONLY_COLUMNS";
    Sage_Auto_Complete_V2_FeatureFlag_E["NumFeatureFlags"] = "NUM_FEATURE_FLAGS";
    Sage_Auto_Complete_V2_FeatureFlag_E["ShowDebugInfo"] = "SHOW_DEBUG_INFO";
    Sage_Auto_Complete_V2_FeatureFlag_E["SingleTokenCompletionsOnly"] = "SINGLE_TOKEN_COMPLETIONS_ONLY";
    Sage_Auto_Complete_V2_FeatureFlag_E["UseWhiteSpaceInfo"] = "USE_WHITE_SPACE_INFO";
    Sage_Auto_Complete_V2_FeatureFlag_E["WriteRequestSnapshot"] = "WRITE_REQUEST_SNAPSHOT";
})(Sage_Auto_Complete_V2_FeatureFlag_E || (Sage_Auto_Complete_V2_FeatureFlag_E = {}));
export var Sage_Auto_Complete_V2_FeedbackType_E;
(function (Sage_Auto_Complete_V2_FeedbackType_E) {
    Sage_Auto_Complete_V2_FeedbackType_E["Dislike"] = "DISLIKE";
    Sage_Auto_Complete_V2_FeedbackType_E["Like"] = "LIKE";
    Sage_Auto_Complete_V2_FeedbackType_E["NumFeedbackTypes"] = "NUM_FEEDBACK_TYPES";
})(Sage_Auto_Complete_V2_FeedbackType_E || (Sage_Auto_Complete_V2_FeedbackType_E = {}));
export var Sage_Auto_Complete_V2_FollowUpSortConditionType_E;
(function (Sage_Auto_Complete_V2_FollowUpSortConditionType_E) {
    Sage_Auto_Complete_V2_FollowUpSortConditionType_E["Column"] = "COLUMN";
    Sage_Auto_Complete_V2_FollowUpSortConditionType_E["Interleave"] = "INTERLEAVE";
})(Sage_Auto_Complete_V2_FollowUpSortConditionType_E || (Sage_Auto_Complete_V2_FollowUpSortConditionType_E = {}));
export var Sage_Auto_Complete_V2_FollowUpSuggestionType_E;
(function (Sage_Auto_Complete_V2_FollowUpSuggestionType_E) {
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["Aggregation"] = "AGGREGATION";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["Filter"] = "FILTER";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["GroupBy"] = "GROUP_BY";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["None"] = "NONE";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["QueryModification"] = "QUERY_MODIFICATION";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["ReplaceAggregatedColumn"] = "REPLACE_AGGREGATED_COLUMN";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["ReplaceDateBucket"] = "REPLACE_DATE_BUCKET";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["ReplaceGroupBy"] = "REPLACE_GROUP_BY";
    Sage_Auto_Complete_V2_FollowUpSuggestionType_E["Versus"] = "VERSUS";
})(Sage_Auto_Complete_V2_FollowUpSuggestionType_E || (Sage_Auto_Complete_V2_FollowUpSuggestionType_E = {}));
export var Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType;
(function (Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType) {
    Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType["ForbiddenByData"] = "FORBIDDEN_BY_DATA";
    Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType["ForbiddenByLang"] = "FORBIDDEN_BY_LANG";
})(Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType || (Sage_Auto_Complete_V2_ForbiddenWordInfo_ForbiddenType = {}));
export var Sage_Auto_Complete_V2_FormulaInfo_FormulaType;
(function (Sage_Auto_Complete_V2_FormulaInfo_FormulaType) {
    Sage_Auto_Complete_V2_FormulaInfo_FormulaType["AiGenerated"] = "AI_GENERATED";
    Sage_Auto_Complete_V2_FormulaInfo_FormulaType["Answer"] = "ANSWER";
    Sage_Auto_Complete_V2_FormulaInfo_FormulaType["Unknown"] = "UNKNOWN";
    Sage_Auto_Complete_V2_FormulaInfo_FormulaType["Worksheet"] = "WORKSHEET";
})(Sage_Auto_Complete_V2_FormulaInfo_FormulaType || (Sage_Auto_Complete_V2_FormulaInfo_FormulaType = {}));
export var Sage_Auto_Complete_V2_LanguageSkillType_E;
(function (Sage_Auto_Complete_V2_LanguageSkillType_E) {
    Sage_Auto_Complete_V2_LanguageSkillType_E["Attribute"] = "ATTRIBUTE";
    Sage_Auto_Complete_V2_LanguageSkillType_E["Comparison"] = "COMPARISON";
    Sage_Auto_Complete_V2_LanguageSkillType_E["CustomCalendar"] = "CUSTOM_CALENDAR";
    Sage_Auto_Complete_V2_LanguageSkillType_E["Filters"] = "FILTERS";
    Sage_Auto_Complete_V2_LanguageSkillType_E["ForEach"] = "FOR_EACH";
    Sage_Auto_Complete_V2_LanguageSkillType_E["Geofilter"] = "GEOFILTER";
    Sage_Auto_Complete_V2_LanguageSkillType_E["GrowthOf"] = "GROWTH_OF";
    Sage_Auto_Complete_V2_LanguageSkillType_E["Having"] = "HAVING";
    Sage_Auto_Complete_V2_LanguageSkillType_E["InFilter"] = "IN_FILTER";
    Sage_Auto_Complete_V2_LanguageSkillType_E["Measure"] = "MEASURE";
    Sage_Auto_Complete_V2_LanguageSkillType_E["NoSkill"] = "NO_SKILL";
    Sage_Auto_Complete_V2_LanguageSkillType_E["SortBy"] = "SORT_BY";
    Sage_Auto_Complete_V2_LanguageSkillType_E["TimeBucket"] = "TIME_BUCKET";
    Sage_Auto_Complete_V2_LanguageSkillType_E["TimeFilters"] = "TIME_FILTERS";
    Sage_Auto_Complete_V2_LanguageSkillType_E["TopBottom"] = "TOP_BOTTOM";
})(Sage_Auto_Complete_V2_LanguageSkillType_E || (Sage_Auto_Complete_V2_LanguageSkillType_E = {}));
export var Sage_Auto_Complete_V2_LanguageType_E;
(function (Sage_Auto_Complete_V2_LanguageType_E) {
    Sage_Auto_Complete_V2_LanguageType_E["Answer"] = "ANSWER";
    Sage_Auto_Complete_V2_LanguageType_E["ConstrainedSearch"] = "CONSTRAINED_SEARCH";
    Sage_Auto_Complete_V2_LanguageType_E["Formula"] = "FORMULA";
    Sage_Auto_Complete_V2_LanguageType_E["FormulaTranslation"] = "FORMULA_TRANSLATION";
    Sage_Auto_Complete_V2_LanguageType_E["NumLanguageTypes"] = "NUM_LANGUAGE_TYPES";
    Sage_Auto_Complete_V2_LanguageType_E["RlsFormula"] = "RLS_FORMULA";
    Sage_Auto_Complete_V2_LanguageType_E["Worksheet"] = "WORKSHEET";
})(Sage_Auto_Complete_V2_LanguageType_E || (Sage_Auto_Complete_V2_LanguageType_E = {}));
export var Sage_Auto_Complete_V2_LessonAdviceType_E;
(function (Sage_Auto_Complete_V2_LessonAdviceType_E) {
    Sage_Auto_Complete_V2_LessonAdviceType_E["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    Sage_Auto_Complete_V2_LessonAdviceType_E["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    Sage_Auto_Complete_V2_LessonAdviceType_E["CustomCalendar"] = "CUSTOM_CALENDAR";
    Sage_Auto_Complete_V2_LessonAdviceType_E["Done"] = "DONE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["ErrorRemove"] = "ERROR_REMOVE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["ForEach"] = "FOR_EACH";
    Sage_Auto_Complete_V2_LessonAdviceType_E["Geofilter"] = "GEOFILTER";
    Sage_Auto_Complete_V2_LessonAdviceType_E["GrowthOf"] = "GROWTH_OF";
    Sage_Auto_Complete_V2_LessonAdviceType_E["Having"] = "HAVING";
    Sage_Auto_Complete_V2_LessonAdviceType_E["InitialAttribute"] = "INITIAL_ATTRIBUTE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["InitialMeasure"] = "INITIAL_MEASURE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["InFilter"] = "IN_FILTER";
    Sage_Auto_Complete_V2_LessonAdviceType_E["LessonNotPossible"] = "LESSON_NOT_POSSIBLE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["LessonNotStarted"] = "LESSON_NOT_STARTED";
    Sage_Auto_Complete_V2_LessonAdviceType_E["MeasureColumn"] = "MEASURE_COLUMN";
    Sage_Auto_Complete_V2_LessonAdviceType_E["PhraseDone"] = "PHRASE_DONE";
    Sage_Auto_Complete_V2_LessonAdviceType_E["PositiveInt"] = "POSITIVE_INT";
    Sage_Auto_Complete_V2_LessonAdviceType_E["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    Sage_Auto_Complete_V2_LessonAdviceType_E["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    Sage_Auto_Complete_V2_LessonAdviceType_E["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    Sage_Auto_Complete_V2_LessonAdviceType_E["SortBy"] = "SORT_BY";
    Sage_Auto_Complete_V2_LessonAdviceType_E["TimeBucket"] = "TIME_BUCKET";
    Sage_Auto_Complete_V2_LessonAdviceType_E["TimeFilters"] = "TIME_FILTERS";
    Sage_Auto_Complete_V2_LessonAdviceType_E["TopBottom"] = "TOP_BOTTOM";
    Sage_Auto_Complete_V2_LessonAdviceType_E["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(Sage_Auto_Complete_V2_LessonAdviceType_E || (Sage_Auto_Complete_V2_LessonAdviceType_E = {}));
export var Sage_Auto_Complete_V2_LessonType_E;
(function (Sage_Auto_Complete_V2_LessonType_E) {
    Sage_Auto_Complete_V2_LessonType_E["DisambiguationLesson"] = "DisambiguationLesson";
    Sage_Auto_Complete_V2_LessonType_E["FormulaLesson"] = "FormulaLesson";
    Sage_Auto_Complete_V2_LessonType_E["LanguageLesson"] = "LanguageLesson";
})(Sage_Auto_Complete_V2_LessonType_E || (Sage_Auto_Complete_V2_LessonType_E = {}));
export var Sage_Auto_Complete_V2_NlIncrementalQueryType_E;
(function (Sage_Auto_Complete_V2_NlIncrementalQueryType_E) {
    Sage_Auto_Complete_V2_NlIncrementalQueryType_E["EditTable"] = "EDIT_TABLE";
    Sage_Auto_Complete_V2_NlIncrementalQueryType_E["NlIntent"] = "NL_INTENT";
    Sage_Auto_Complete_V2_NlIncrementalQueryType_E["Transform"] = "TRANSFORM";
})(Sage_Auto_Complete_V2_NlIncrementalQueryType_E || (Sage_Auto_Complete_V2_NlIncrementalQueryType_E = {}));
export var Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type;
(function (Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type) {
    Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type["NumTypes"] = "NUM_TYPES";
    Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type["SortBy"] = "SORT_BY";
})(Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type || (Sage_Auto_Complete_V2_NlPhraseMappingInfo_Type = {}));
export var Sage_Auto_Complete_V2_NlqRewriteSourceType_E;
(function (Sage_Auto_Complete_V2_NlqRewriteSourceType_E) {
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["ContextCache"] = "CONTEXT_CACHE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["ContextChoice"] = "CONTEXT_CHOICE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["InferredRewrite"] = "INFERRED_REWRITE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["NumSources"] = "NUM_SOURCES";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["QueryRewrite"] = "QUERY_REWRITE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["SearchToggle"] = "SEARCH_TOGGLE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["SuperlativeRewrite"] = "SUPERLATIVE_REWRITE";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["UbrFeedback"] = "UBR_FEEDBACK";
    Sage_Auto_Complete_V2_NlqRewriteSourceType_E["Unknown"] = "UNKNOWN";
})(Sage_Auto_Complete_V2_NlqRewriteSourceType_E || (Sage_Auto_Complete_V2_NlqRewriteSourceType_E = {}));
export var Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E;
(function (Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E) {
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Date"] = "DATE";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Entropy"] = "ENTROPY";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Forbidden"] = "FORBIDDEN";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Ignore"] = "IGNORE";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Keyword"] = "KEYWORD";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["NumTypes"] = "NUM_TYPES";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Refinement"] = "REFINEMENT";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["SearchToggle"] = "SEARCH_TOGGLE";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Superlative"] = "SUPERLATIVE";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Undefined"] = "UNDEFINED";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["Unknown"] = "UNKNOWN";
    Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E["UnmatchedEntity"] = "UNMATCHED_ENTITY";
})(Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E || (Sage_Auto_Complete_V2_NlqRewriteSuggestionType_E = {}));
export var Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType;
(function (Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType) {
    Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType["Child"] = "CHILD";
    Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType["NeighbourhoodWord"] = "NEIGHBOURHOOD_WORD";
    Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType["Parent"] = "PARENT";
    Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType["Unknown"] = "UNKNOWN";
})(Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType || (Sage_Auto_Complete_V2_NlQueryContextToken_ContextRelationType = {}));
export var Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket;
(function (Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket) {
    Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket["High"] = "HIGH";
    Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket["Low"] = "LOW";
    Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket["Medium"] = "MEDIUM";
})(Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket || (Sage_Auto_Complete_V2_NlTokenMappingInfo_SegmentMatchConfidenceBucket = {}));
export var Sage_Auto_Complete_V2_Object_ActionProto_ActionType;
(function (Sage_Auto_Complete_V2_Object_ActionProto_ActionType) {
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminAddNewGroup"] = "ADMIN_ADD_NEW_GROUP";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminAddNewUser"] = "ADMIN_ADD_NEW_USER";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminManageBusinessDataModel"] = "ADMIN_MANAGE_BUSINESS_DATA_MODEL";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminManageDataSecurity"] = "ADMIN_MANAGE_DATA_SECURITY";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminManageJobs"] = "ADMIN_MANAGE_JOBS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewGroups"] = "ADMIN_VIEW_GROUPS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewSystemHealthAlertsAndEvents"] = "ADMIN_VIEW_SYSTEM_HEALTH_ALERTS_AND_EVENTS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewSystemHealthClusterManager"] = "ADMIN_VIEW_SYSTEM_HEALTH_CLUSTER_MANAGER";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewSystemHealthData"] = "ADMIN_VIEW_SYSTEM_HEALTH_DATA";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewSystemHealthOverview"] = "ADMIN_VIEW_SYSTEM_HEALTH_OVERVIEW";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["AdminViewUsers"] = "ADMIN_VIEW_USERS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["CreatePinboard"] = "CREATE_PINBOARD";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["CreateWorksheet"] = "CREATE_WORKSHEET";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["EditProfile"] = "EDIT_PROFILE";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["UploadData"] = "UPLOAD_DATA";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["UploadSchema"] = "UPLOAD_SCHEMA";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["ViewAnswers"] = "VIEW_ANSWERS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["ViewDataSources"] = "VIEW_DATA_SOURCES";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["ViewDataTables"] = "VIEW_DATA_TABLES";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["ViewPinboards"] = "VIEW_PINBOARDS";
    Sage_Auto_Complete_V2_Object_ActionProto_ActionType["ViewSchema"] = "VIEW_SCHEMA";
})(Sage_Auto_Complete_V2_Object_ActionProto_ActionType || (Sage_Auto_Complete_V2_Object_ActionProto_ActionType = {}));
export var Sage_Auto_Complete_V2_Object_Type;
(function (Sage_Auto_Complete_V2_Object_Type) {
    Sage_Auto_Complete_V2_Object_Type["Action"] = "ACTION";
    Sage_Auto_Complete_V2_Object_Type["Answer"] = "ANSWER";
    Sage_Auto_Complete_V2_Object_Type["HelpPage"] = "HELP_PAGE";
    Sage_Auto_Complete_V2_Object_Type["Pinboard"] = "PINBOARD";
})(Sage_Auto_Complete_V2_Object_Type || (Sage_Auto_Complete_V2_Object_Type = {}));
export var Sage_Auto_Complete_V2_Object_VizType;
(function (Sage_Auto_Complete_V2_Object_VizType) {
    Sage_Auto_Complete_V2_Object_VizType["Chart"] = "CHART";
    Sage_Auto_Complete_V2_Object_VizType["Headline"] = "HEADLINE";
    Sage_Auto_Complete_V2_Object_VizType["Table"] = "TABLE";
})(Sage_Auto_Complete_V2_Object_VizType || (Sage_Auto_Complete_V2_Object_VizType = {}));
export var Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType;
(function (Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType) {
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["AddColumn"] = "ADD_COLUMN";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Chart"] = "CHART";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Drill"] = "DRILL";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Filter"] = "FILTER";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["NlQuery"] = "NL_QUERY";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["NumIntents"] = "NUM_INTENTS";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Open"] = "OPEN";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Pin"] = "PIN";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Share"] = "SHARE";
    Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType["Sort"] = "SORT";
})(Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType || (Sage_Auto_Complete_V2_ProcessNlIntentResponse_IntentType = {}));
export var Sage_Auto_Complete_V2_QueryCompletionType_E;
(function (Sage_Auto_Complete_V2_QueryCompletionType_E) {
    Sage_Auto_Complete_V2_QueryCompletionType_E["NlCompletion"] = "NL_COMPLETION";
    Sage_Auto_Complete_V2_QueryCompletionType_E["NlPrimingCompletion"] = "NL_PRIMING_COMPLETION";
    Sage_Auto_Complete_V2_QueryCompletionType_E["PhraseHistoryOthers"] = "PHRASE_HISTORY_OTHERS";
    Sage_Auto_Complete_V2_QueryCompletionType_E["PhraseHistorySelf"] = "PHRASE_HISTORY_SELF";
    Sage_Auto_Complete_V2_QueryCompletionType_E["Rewrite"] = "REWRITE";
    Sage_Auto_Complete_V2_QueryCompletionType_E["SearchHistoryOthers"] = "SEARCH_HISTORY_OTHERS";
    Sage_Auto_Complete_V2_QueryCompletionType_E["SearchHistorySelf"] = "SEARCH_HISTORY_SELF";
    Sage_Auto_Complete_V2_QueryCompletionType_E["Synonym"] = "SYNONYM";
    Sage_Auto_Complete_V2_QueryCompletionType_E["Undefined"] = "UNDEFINED";
})(Sage_Auto_Complete_V2_QueryCompletionType_E || (Sage_Auto_Complete_V2_QueryCompletionType_E = {}));
export var Sage_Auto_Complete_V2_QueryModificationSource_E;
(function (Sage_Auto_Complete_V2_QueryModificationSource_E) {
    Sage_Auto_Complete_V2_QueryModificationSource_E["AdminAdded"] = "ADMIN_ADDED";
    Sage_Auto_Complete_V2_QueryModificationSource_E["EnableExploration"] = "ENABLE_EXPLORATION";
    Sage_Auto_Complete_V2_QueryModificationSource_E["PreviouslySelected"] = "PREVIOUSLY_SELECTED";
    Sage_Auto_Complete_V2_QueryModificationSource_E["QueryTemplateSourced"] = "QUERY_TEMPLATE_SOURCED";
    Sage_Auto_Complete_V2_QueryModificationSource_E["UsageBased"] = "USAGE_BASED";
})(Sage_Auto_Complete_V2_QueryModificationSource_E || (Sage_Auto_Complete_V2_QueryModificationSource_E = {}));
export var Sage_Auto_Complete_V2_QueryTemplateBoundState_Type;
(function (Sage_Auto_Complete_V2_QueryTemplateBoundState_Type) {
    Sage_Auto_Complete_V2_QueryTemplateBoundState_Type["FilterColumn"] = "FILTER_COLUMN";
    Sage_Auto_Complete_V2_QueryTemplateBoundState_Type["FilterValue"] = "FILTER_VALUE";
})(Sage_Auto_Complete_V2_QueryTemplateBoundState_Type || (Sage_Auto_Complete_V2_QueryTemplateBoundState_Type = {}));
export var Sage_Auto_Complete_V2_QueryTemplateType_E;
(function (Sage_Auto_Complete_V2_QueryTemplateType_E) {
    Sage_Auto_Complete_V2_QueryTemplateType_E["Attribute"] = "ATTRIBUTE";
    Sage_Auto_Complete_V2_QueryTemplateType_E["AttributeColumn"] = "ATTRIBUTE_COLUMN";
    Sage_Auto_Complete_V2_QueryTemplateType_E["ColumnOpFilter"] = "COLUMN_OP_FILTER";
    Sage_Auto_Complete_V2_QueryTemplateType_E["CustomCalendar"] = "CUSTOM_CALENDAR";
    Sage_Auto_Complete_V2_QueryTemplateType_E["ForEach"] = "FOR_EACH";
    Sage_Auto_Complete_V2_QueryTemplateType_E["Geofilter"] = "GEOFILTER";
    Sage_Auto_Complete_V2_QueryTemplateType_E["GrowthOf"] = "GROWTH_OF";
    Sage_Auto_Complete_V2_QueryTemplateType_E["Having"] = "HAVING";
    Sage_Auto_Complete_V2_QueryTemplateType_E["InFilter"] = "IN_FILTER";
    Sage_Auto_Complete_V2_QueryTemplateType_E["Measure"] = "MEASURE";
    Sage_Auto_Complete_V2_QueryTemplateType_E["MeasureColumn"] = "MEASURE_COLUMN";
    Sage_Auto_Complete_V2_QueryTemplateType_E["NoSkill"] = "NO_SKILL";
    Sage_Auto_Complete_V2_QueryTemplateType_E["SimpleOpAttributeFilter"] = "SIMPLE_OP_ATTRIBUTE_FILTER";
    Sage_Auto_Complete_V2_QueryTemplateType_E["SimpleOpMeasureFilter"] = "SIMPLE_OP_MEASURE_FILTER";
    Sage_Auto_Complete_V2_QueryTemplateType_E["SingleColumnVersus"] = "SINGLE_COLUMN_VERSUS";
    Sage_Auto_Complete_V2_QueryTemplateType_E["SortBy"] = "SORT_BY";
    Sage_Auto_Complete_V2_QueryTemplateType_E["TimeBucket"] = "TIME_BUCKET";
    Sage_Auto_Complete_V2_QueryTemplateType_E["TimeFilters"] = "TIME_FILTERS";
    Sage_Auto_Complete_V2_QueryTemplateType_E["TopBottom"] = "TOP_BOTTOM";
    Sage_Auto_Complete_V2_QueryTemplateType_E["Undefined"] = "UNDEFINED";
    Sage_Auto_Complete_V2_QueryTemplateType_E["Value1VsValue2"] = "VALUE1_VS_VALUE2";
})(Sage_Auto_Complete_V2_QueryTemplateType_E || (Sage_Auto_Complete_V2_QueryTemplateType_E = {}));
export var Sage_Auto_Complete_V2_QueryTransformType_E;
(function (Sage_Auto_Complete_V2_QueryTransformType_E) {
    Sage_Auto_Complete_V2_QueryTransformType_E["AddAttribute"] = "ADD_ATTRIBUTE";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddAutoResolvedDateBucketsToTokens"] = "ADD_AUTO_RESOLVED_DATE_BUCKETS_TO_TOKENS";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddColumn"] = "ADD_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddEmptyGroupBy"] = "ADD_EMPTY_GROUP_BY";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddFilter"] = "ADD_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddHavingFilter"] = "ADD_HAVING_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddInFilter"] = "ADD_IN_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddMeasure"] = "ADD_MEASURE";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddPredicateFilter"] = "ADD_PREDICATE_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddSortColumn"] = "ADD_SORT_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddTimeBucketQualifier"] = "ADD_TIME_BUCKET_QUALIFIER";
    Sage_Auto_Complete_V2_QueryTransformType_E["AddVersus"] = "ADD_VERSUS";
    Sage_Auto_Complete_V2_QueryTransformType_E["ChangeAggregation"] = "CHANGE_AGGREGATION";
    Sage_Auto_Complete_V2_QueryTransformType_E["ChangeTimeBucket"] = "CHANGE_TIME_BUCKET";
    Sage_Auto_Complete_V2_QueryTransformType_E["DeprecatedAddFormula"] = "DEPRECATED_ADD_FORMULA";
    Sage_Auto_Complete_V2_QueryTransformType_E["DeprecatedAddTimeBucket"] = "DEPRECATED_ADD_TIME_BUCKET";
    Sage_Auto_Complete_V2_QueryTransformType_E["DeprecatedRemoveFormula"] = "DEPRECATED_REMOVE_FORMULA";
    Sage_Auto_Complete_V2_QueryTransformType_E["DeprecatedRemoveTimeBucket"] = "DEPRECATED_REMOVE_TIME_BUCKET";
    Sage_Auto_Complete_V2_QueryTransformType_E["DrillDown"] = "DRILL_DOWN";
    Sage_Auto_Complete_V2_QueryTransformType_E["EditFilter"] = "EDIT_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["NumTransforms"] = "NUM_TRANSFORMS";
    Sage_Auto_Complete_V2_QueryTransformType_E["PopulatePeriodToDateFiltersInTokens"] = "POPULATE_PERIOD_TO_DATE_FILTERS_IN_TOKENS";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllDateRangeFiltersForColumn"] = "REMOVE_ALL_DATE_RANGE_FILTERS_FOR_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllFiltersForColumn"] = "REMOVE_ALL_FILTERS_FOR_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllHavingFilters"] = "REMOVE_ALL_HAVING_FILTERS";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllHavingFiltersByAggregate"] = "REMOVE_ALL_HAVING_FILTERS_BY_AGGREGATE";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllHavingFiltersByColumn"] = "REMOVE_ALL_HAVING_FILTERS_BY_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllPhrasesByColumn"] = "REMOVE_ALL_PHRASES_BY_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveAllSortPhrases"] = "REMOVE_ALL_SORT_PHRASES";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveColumn"] = "REMOVE_COLUMN";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveFilter"] = "REMOVE_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveHavingFilter"] = "REMOVE_HAVING_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveInFilter"] = "REMOVE_IN_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveNonFilterPhrases"] = "REMOVE_NON_FILTER_PHRASES";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemovePredicateFilter"] = "REMOVE_PREDICATE_FILTER";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveTimeBucketQualifier"] = "REMOVE_TIME_BUCKET_QUALIFIER";
    Sage_Auto_Complete_V2_QueryTransformType_E["RemoveVersus"] = "REMOVE_VERSUS";
})(Sage_Auto_Complete_V2_QueryTransformType_E || (Sage_Auto_Complete_V2_QueryTransformType_E = {}));
export var Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type;
(function (Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type) {
    Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type["Attribute"] = "ATTRIBUTE";
    Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type["DateBucket"] = "DATE_BUCKET";
    Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type["DateColumn"] = "DATE_COLUMN";
    Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type["Measure"] = "MEASURE";
})(Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type || (Sage_Auto_Complete_V2_ReplaceableColumnPropertiesList_Type = {}));
export var Sage_Auto_Complete_V2_RequestStage_E;
(function (Sage_Auto_Complete_V2_RequestStage_E) {
    Sage_Auto_Complete_V2_RequestStage_E["Completion"] = "COMPLETION";
    Sage_Auto_Complete_V2_RequestStage_E["HintGen"] = "HINT_GEN";
    Sage_Auto_Complete_V2_RequestStage_E["QueryCompletion"] = "QUERY_COMPLETION";
    Sage_Auto_Complete_V2_RequestStage_E["QueryGen"] = "QUERY_GEN";
    Sage_Auto_Complete_V2_RequestStage_E["QueryTransformation"] = "QUERY_TRANSFORMATION";
    Sage_Auto_Complete_V2_RequestStage_E["Queue"] = "QUEUE";
    Sage_Auto_Complete_V2_RequestStage_E["Tokenization"] = "TOKENIZATION";
})(Sage_Auto_Complete_V2_RequestStage_E || (Sage_Auto_Complete_V2_RequestStage_E = {}));
export var Sage_Auto_Complete_V2_SageProgram_ProgramType;
(function (Sage_Auto_Complete_V2_SageProgram_ProgramType) {
    Sage_Auto_Complete_V2_SageProgram_ProgramType["ChasmTrap"] = "CHASM_TRAP";
    Sage_Auto_Complete_V2_SageProgram_ProgramType["QueryOnQuery"] = "QUERY_ON_QUERY";
    Sage_Auto_Complete_V2_SageProgram_ProgramType["Simple"] = "SIMPLE";
    Sage_Auto_Complete_V2_SageProgram_ProgramType["Unknown"] = "UNKNOWN";
})(Sage_Auto_Complete_V2_SageProgram_ProgramType || (Sage_Auto_Complete_V2_SageProgram_ProgramType = {}));
export var Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory;
(function (Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory) {
    Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory["Alpha"] = "ALPHA";
    Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory["Custom"] = "CUSTOM";
    Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory["Default"] = "DEFAULT";
    Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory["None"] = "NONE";
})(Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory || (Sage_Auto_Complete_V2_SageQuery_ColumnSortInfo_ColumnSortCategory = {}));
export var Sage_Auto_Complete_V2_SageQuery_FilterType;
(function (Sage_Auto_Complete_V2_SageQuery_FilterType) {
    Sage_Auto_Complete_V2_SageQuery_FilterType["Geo"] = "GEO";
    Sage_Auto_Complete_V2_SageQuery_FilterType["NumFilters"] = "NUM_FILTERS";
    Sage_Auto_Complete_V2_SageQuery_FilterType["Simple"] = "SIMPLE";
})(Sage_Auto_Complete_V2_SageQuery_FilterType || (Sage_Auto_Complete_V2_SageQuery_FilterType = {}));
export var Sage_Auto_Complete_V2_SearchAssistPayload_Version;
(function (Sage_Auto_Complete_V2_SearchAssistPayload_Version) {
    Sage_Auto_Complete_V2_SearchAssistPayload_Version["V1"] = "V1";
    Sage_Auto_Complete_V2_SearchAssistPayload_Version["V2"] = "V2";
})(Sage_Auto_Complete_V2_SearchAssistPayload_Version || (Sage_Auto_Complete_V2_SearchAssistPayload_Version = {}));
export var Sage_Auto_Complete_V2_TemplateEntry_Type;
(function (Sage_Auto_Complete_V2_TemplateEntry_Type) {
    Sage_Auto_Complete_V2_TemplateEntry_Type["Text"] = "TEXT";
    Sage_Auto_Complete_V2_TemplateEntry_Type["Token"] = "TOKEN";
})(Sage_Auto_Complete_V2_TemplateEntry_Type || (Sage_Auto_Complete_V2_TemplateEntry_Type = {}));
export var Sage_Auto_Complete_V2_TokenEditOp_E;
(function (Sage_Auto_Complete_V2_TokenEditOp_E) {
    Sage_Auto_Complete_V2_TokenEditOp_E["Delete"] = "DELETE";
    Sage_Auto_Complete_V2_TokenEditOp_E["Insert"] = "INSERT";
    Sage_Auto_Complete_V2_TokenEditOp_E["Replace"] = "REPLACE";
})(Sage_Auto_Complete_V2_TokenEditOp_E || (Sage_Auto_Complete_V2_TokenEditOp_E = {}));
export var Sage_Auto_Complete_V2_UserRating_E;
(function (Sage_Auto_Complete_V2_UserRating_E) {
    Sage_Auto_Complete_V2_UserRating_E["Bad"] = "BAD";
    Sage_Auto_Complete_V2_UserRating_E["Good"] = "GOOD";
    Sage_Auto_Complete_V2_UserRating_E["Ugly"] = "UGLY";
    Sage_Auto_Complete_V2_UserRating_E["Unknown"] = "UNKNOWN";
})(Sage_Auto_Complete_V2_UserRating_E || (Sage_Auto_Complete_V2_UserRating_E = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceElement_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceElement_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["NewLine"] = "NEW_LINE";
    Sage_Auto_Complete_V2_WhiteSpaceElement_Type["Space"] = "SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceElement_Type || (Sage_Auto_Complete_V2_WhiteSpaceElement_Type = {}));
export var Sage_Auto_Complete_V2_WhiteSpaceInfo_Type;
(function (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type) {
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["Complex"] = "COMPLEX";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["NoWhiteSpace"] = "NO_WHITE_SPACE";
    Sage_Auto_Complete_V2_WhiteSpaceInfo_Type["SingleSpace"] = "SINGLE_SPACE";
})(Sage_Auto_Complete_V2_WhiteSpaceInfo_Type || (Sage_Auto_Complete_V2_WhiteSpaceInfo_Type = {}));
export var Sage_Nlp_Language;
(function (Sage_Nlp_Language) {
    Sage_Nlp_Language["English"] = "English";
    Sage_Nlp_Language["Unknown"] = "Unknown";
})(Sage_Nlp_Language || (Sage_Nlp_Language = {}));
export var Sage_Nlp_PosTag_E;
(function (Sage_Nlp_PosTag_E) {
    Sage_Nlp_PosTag_E["Adjective"] = "ADJECTIVE";
    Sage_Nlp_PosTag_E["AdjectiveComparative"] = "ADJECTIVE_COMPARATIVE";
    Sage_Nlp_PosTag_E["AdjectiveSuperlative"] = "ADJECTIVE_SUPERLATIVE";
    Sage_Nlp_PosTag_E["Adverb"] = "ADVERB";
    Sage_Nlp_PosTag_E["AdverbComparative"] = "ADVERB_COMPARATIVE";
    Sage_Nlp_PosTag_E["AdverbSuperlative"] = "ADVERB_SUPERLATIVE";
    Sage_Nlp_PosTag_E["CardinalNumber"] = "CARDINAL_NUMBER";
    Sage_Nlp_PosTag_E["Ignore"] = "IGNORE";
    Sage_Nlp_PosTag_E["Noun"] = "NOUN";
    Sage_Nlp_PosTag_E["Predeterminer"] = "PREDETERMINER";
    Sage_Nlp_PosTag_E["Preposition"] = "PREPOSITION";
    Sage_Nlp_PosTag_E["Pronoun"] = "PRONOUN";
    Sage_Nlp_PosTag_E["Undefined"] = "UNDEFINED";
    Sage_Nlp_PosTag_E["Verb"] = "VERB";
})(Sage_Nlp_PosTag_E || (Sage_Nlp_PosTag_E = {}));
export var Sage_Nlp_ParseLabel_E;
(function (Sage_Nlp_ParseLabel_E) {
    Sage_Nlp_ParseLabel_E["Other"] = "OTHER";
    Sage_Nlp_ParseLabel_E["Root"] = "ROOT";
    Sage_Nlp_ParseLabel_E["Advcl"] = "advcl";
    Sage_Nlp_ParseLabel_E["Advmod"] = "advmod";
    Sage_Nlp_ParseLabel_E["Amod"] = "amod";
    Sage_Nlp_ParseLabel_E["Aux"] = "aux";
    Sage_Nlp_ParseLabel_E["Auxpass"] = "auxpass";
    Sage_Nlp_ParseLabel_E["Cc"] = "cc";
    Sage_Nlp_ParseLabel_E["Ccomp"] = "ccomp";
    Sage_Nlp_ParseLabel_E["Conj"] = "conj";
    Sage_Nlp_ParseLabel_E["Cop"] = "cop";
    Sage_Nlp_ParseLabel_E["Csubj"] = "csubj";
    Sage_Nlp_ParseLabel_E["Dep"] = "dep";
    Sage_Nlp_ParseLabel_E["Det"] = "det";
    Sage_Nlp_ParseLabel_E["Dobj"] = "dobj";
    Sage_Nlp_ParseLabel_E["Expl"] = "expl";
    Sage_Nlp_ParseLabel_E["Infmod"] = "infmod";
    Sage_Nlp_ParseLabel_E["Iobj"] = "iobj";
    Sage_Nlp_ParseLabel_E["Mark"] = "mark";
    Sage_Nlp_ParseLabel_E["Mwe"] = "mwe";
    Sage_Nlp_ParseLabel_E["Neg"] = "neg";
    Sage_Nlp_ParseLabel_E["Nn"] = "nn";
    Sage_Nlp_ParseLabel_E["Npadvmod"] = "npadvmod";
    Sage_Nlp_ParseLabel_E["Nsubj"] = "nsubj";
    Sage_Nlp_ParseLabel_E["Nsubjpass"] = "nsubjpass";
    Sage_Nlp_ParseLabel_E["Num"] = "num";
    Sage_Nlp_ParseLabel_E["Number"] = "number";
    Sage_Nlp_ParseLabel_E["Partmod"] = "partmod";
    Sage_Nlp_ParseLabel_E["Pcomp"] = "pcomp";
    Sage_Nlp_ParseLabel_E["Pobj"] = "pobj";
    Sage_Nlp_ParseLabel_E["Poss"] = "poss";
    Sage_Nlp_ParseLabel_E["Possessive"] = "possessive";
    Sage_Nlp_ParseLabel_E["Predet"] = "predet";
    Sage_Nlp_ParseLabel_E["Prep"] = "prep";
    Sage_Nlp_ParseLabel_E["Prt"] = "prt";
    Sage_Nlp_ParseLabel_E["Punct"] = "punct";
    Sage_Nlp_ParseLabel_E["Quantmod"] = "quantmod";
    Sage_Nlp_ParseLabel_E["Rcmod"] = "rcmod";
    Sage_Nlp_ParseLabel_E["Tmod"] = "tmod";
})(Sage_Nlp_ParseLabel_E || (Sage_Nlp_ParseLabel_E = {}));
export var Scheduler_NodeSchedule_Type;
(function (Scheduler_NodeSchedule_Type) {
    Scheduler_NodeSchedule_Type["AllHosts"] = "ALL_HOSTS";
    Scheduler_NodeSchedule_Type["Default"] = "DEFAULT";
    Scheduler_NodeSchedule_Type["HostList"] = "HOST_LIST";
    Scheduler_NodeSchedule_Type["Size"] = "SIZE";
})(Scheduler_NodeSchedule_Type || (Scheduler_NodeSchedule_Type = {}));
export var Scheduler_PeriodicSchedule_Type;
(function (Scheduler_PeriodicSchedule_Type) {
    Scheduler_PeriodicSchedule_Type["Cron"] = "CRON";
    Scheduler_PeriodicSchedule_Type["Default"] = "DEFAULT";
})(Scheduler_PeriodicSchedule_Type || (Scheduler_PeriodicSchedule_Type = {}));
export var Scheduler_TimeSchedule_Periodicity;
(function (Scheduler_TimeSchedule_Periodicity) {
    Scheduler_TimeSchedule_Periodicity["Default"] = "DEFAULT";
    Scheduler_TimeSchedule_Periodicity["OneTime"] = "ONE_TIME";
    Scheduler_TimeSchedule_Periodicity["Periodic"] = "PERIODIC";
})(Scheduler_TimeSchedule_Periodicity || (Scheduler_TimeSchedule_Periodicity = {}));
export var Scriptability_ActionType_E;
(function (Scriptability_ActionType_E) {
    Scriptability_ActionType_E["Callback"] = "CALLBACK";
    Scriptability_ActionType_E["Url"] = "URL";
})(Scriptability_ActionType_E || (Scriptability_ActionType_E = {}));
export var Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory;
(function (Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory) {
    Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory["Alpha"] = "ALPHA";
    Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory["Custom"] = "CUSTOM";
    Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory["Default"] = "DEFAULT";
    Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory["None"] = "NONE";
})(Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory || (Scriptability_AnswerEDocProto_ColumnSortInfo_ColumnSortCategory = {}));
export var Scriptability_AvailabilityContentType_E;
(function (Scriptability_AvailabilityContentType_E) {
    Scriptability_AvailabilityContentType_E["Global"] = "GLOBAL";
    Scriptability_AvailabilityContentType_E["Local"] = "LOCAL";
})(Scriptability_AvailabilityContentType_E || (Scriptability_AvailabilityContentType_E = {}));
export var Scriptability_EDocExportSchemaVersion_E;
(function (Scriptability_EDocExportSchemaVersion_E) {
    Scriptability_EDocExportSchemaVersion_E["Default"] = "DEFAULT";
    Scriptability_EDocExportSchemaVersion_E["V1"] = "V1";
    Scriptability_EDocExportSchemaVersion_E["V2"] = "V2";
})(Scriptability_EDocExportSchemaVersion_E || (Scriptability_EDocExportSchemaVersion_E = {}));
export var Scriptability_EDocFormatType_E;
(function (Scriptability_EDocFormatType_E) {
    Scriptability_EDocFormatType_E["Json"] = "JSON";
    Scriptability_EDocFormatType_E["Proto"] = "PROTO";
    Scriptability_EDocFormatType_E["Yaml"] = "YAML";
})(Scriptability_EDocFormatType_E || (Scriptability_EDocFormatType_E = {}));
export var Scriptability_EDocObjectType_E;
(function (Scriptability_EDocObjectType_E) {
    Scriptability_EDocObjectType_E["ActionObject"] = "ACTION_OBJECT";
    Scriptability_EDocObjectType_E["Answer"] = "ANSWER";
    Scriptability_EDocObjectType_E["Cohort"] = "COHORT";
    Scriptability_EDocObjectType_E["ColumnSecurityRules"] = "COLUMN_SECURITY_RULES";
    Scriptability_EDocObjectType_E["Connection"] = "CONNECTION";
    Scriptability_EDocObjectType_E["Feedback"] = "FEEDBACK";
    Scriptability_EDocObjectType_E["Join"] = "JOIN";
    Scriptability_EDocObjectType_E["Liveboard"] = "LIVEBOARD";
    Scriptability_EDocObjectType_E["LogicalTable"] = "LOGICAL_TABLE";
    Scriptability_EDocObjectType_E["Model"] = "MODEL";
    Scriptability_EDocObjectType_E["MonitorAlerts"] = "MONITOR_ALERTS";
    Scriptability_EDocObjectType_E["Pinboard"] = "PINBOARD";
    Scriptability_EDocObjectType_E["PinboardAnswerBook"] = "PINBOARD_ANSWER_BOOK";
    Scriptability_EDocObjectType_E["QuestionAnswerBook"] = "QUESTION_ANSWER_BOOK";
    Scriptability_EDocObjectType_E["Role"] = "ROLE";
    Scriptability_EDocObjectType_E["SqlView"] = "SQL_VIEW";
    Scriptability_EDocObjectType_E["Table"] = "TABLE";
    Scriptability_EDocObjectType_E["User"] = "USER";
    Scriptability_EDocObjectType_E["UserGroup"] = "USER_GROUP";
    Scriptability_EDocObjectType_E["View"] = "VIEW";
    Scriptability_EDocObjectType_E["Worksheet"] = "WORKSHEET";
})(Scriptability_EDocObjectType_E || (Scriptability_EDocObjectType_E = {}));
export var Scriptability_ImportAction_E;
(function (Scriptability_ImportAction_E) {
    Scriptability_ImportAction_E["Create"] = "CREATE";
    Scriptability_ImportAction_E["Update"] = "UPDATE";
    Scriptability_ImportAction_E["UpdateOrCreate"] = "UPDATE_OR_CREATE";
})(Scriptability_ImportAction_E || (Scriptability_ImportAction_E = {}));
export var Scriptability_ImportEPackRequest_ImportPolicy;
(function (Scriptability_ImportEPackRequest_ImportPolicy) {
    Scriptability_ImportEPackRequest_ImportPolicy["AllOrNone"] = "ALL_OR_NONE";
    Scriptability_ImportEPackRequest_ImportPolicy["Partial"] = "PARTIAL";
    Scriptability_ImportEPackRequest_ImportPolicy["PartialObject"] = "PARTIAL_OBJECT";
    Scriptability_ImportEPackRequest_ImportPolicy["ValidateOnly"] = "VALIDATE_ONLY";
})(Scriptability_ImportEPackRequest_ImportPolicy || (Scriptability_ImportEPackRequest_ImportPolicy = {}));
export var Scriptability_ProgressStatusCode;
(function (Scriptability_ProgressStatusCode) {
    Scriptability_ProgressStatusCode["Completed"] = "COMPLETED";
    Scriptability_ProgressStatusCode["Failed"] = "FAILED";
    Scriptability_ProgressStatusCode["InProgress"] = "IN_PROGRESS";
    Scriptability_ProgressStatusCode["InQueue"] = "IN_QUEUE";
})(Scriptability_ProgressStatusCode || (Scriptability_ProgressStatusCode = {}));
export var Scriptability_TableActionProto_Type;
(function (Scriptability_TableActionProto_Type) {
    Scriptability_TableActionProto_Type["Create"] = "CREATE";
    Scriptability_TableActionProto_Type["Delete"] = "DELETE";
    Scriptability_TableActionProto_Type["Update"] = "UPDATE";
})(Scriptability_TableActionProto_Type || (Scriptability_TableActionProto_Type = {}));
export var Scriptability_UrlActionDetails_AuthenticationType_E;
(function (Scriptability_UrlActionDetails_AuthenticationType_E) {
    Scriptability_UrlActionDetails_AuthenticationType_E["ApiKey"] = "API_KEY";
    Scriptability_UrlActionDetails_AuthenticationType_E["Basic"] = "BASIC";
    Scriptability_UrlActionDetails_AuthenticationType_E["Bearer"] = "BEARER";
    Scriptability_UrlActionDetails_AuthenticationType_E["None"] = "NONE";
})(Scriptability_UrlActionDetails_AuthenticationType_E || (Scriptability_UrlActionDetails_AuthenticationType_E = {}));
export const EurekaSearchTokenFragmentDoc = lazyGql(() => gql `
    fragment eurekaSearchToken on eureka_EurekaSearchToken {
  value
  guid
  type
  highlights {
    start
    end
  }
}
    `);
export const EurekaCompletionsFragmentDoc = lazyGql(() => gql `
    fragment eurekaCompletions on eureka_CompleteResponse {
  requestIdentifiers {
    apiRequestId
    appActivityId
  }
  result {
    columnResult {
      name
    }
    columnValueResult {
      value
      name
    }
    objectResult {
      guid
      name
      authorName
      authorGuid
      type
      parentGuid
    }
    userResult {
      name
      guid
    }
    viewCount
    type
    score
    debugInfo
    numPrefixTokens
    token {
      ...eurekaSearchToken
    }
    numSuffixTokens
    objectSecurityInfo {
      objectId
      objectType
      objectIdForDeletionCheck
      objectTypeForDeletionCheck
      isD13ySourced
    }
    isRecentlyViewed
  }
  tokens {
    ...eurekaSearchToken
  }
  queryResult {
    query
    type
    fieldName
    fieldType
  }
}
    ${EurekaSearchTokenFragmentDoc}`);
export const FormatConfigFragmentDoc = lazyGql(() => gql `
    fragment formatConfig on FormatConfig {
  category
  numberFormatConfig {
    decimals
    negativeValueFormat
    removeTrailingZeroes
    toSeparateThousands
    unit
  }
  percentageFormatConfig {
    decimals
    removeTrailingZeroes
  }
  currencyFormatConfig {
    decimals
    locale
    removeTrailingZeroes
    toSeparateThousands
    unit
  }
  customFormatConfig {
    format
  }
  isCategoryEditable
}
    `);
export const ConditionalFormattingFragmentDoc = lazyGql(() => gql `
    fragment conditionalFormatting on ConditionalFormatting {
  rows {
    backgroundFormatType
    value
    operator
    fontProperties {
      bold
      color
      italic
      strikeThrough
      underline
    }
    gradientBackgroundAttrs {
      backgroundFormatRange
      backgroundFormatMidpoint
      colors
    }
    plotAsBand
    rangeValues {
      max
      min
    }
    solidBackgroundAttrs {
      color
    }
  }
}
    `);
export const SwitchOrgDocument = lazyGql(() => gql `
    mutation switchOrg($orgId: String!) {
  Session__switchOrg(orgid: $orgId)
}
    `);
export function useSwitchOrgMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(SwitchOrgDocument, options);
}
export const GetUserAccessibleOrgsDocument = lazyGql(() => gql `
    query getUserAccessibleOrgs {
  getUserAccessibleOrgs {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `);
export function useGetUserAccessibleOrgsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAccessibleOrgsDocument, options);
}
export function useGetUserAccessibleOrgsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAccessibleOrgsDocument, options);
}
export const GetUserAccessibleOrgsByParamsDocument = lazyGql(() => gql `
    query getUserAccessibleOrgsByParams($inputData: AccessibleOrgsInput!) {
  getUserAccessibleOrgsByParams(inputData: $inputData) {
    Data {
      orgs {
        orgId
        orgName
        description
        allUserGroupId
        defaultAdminUserGroupId
        privileges
        isActive
        nonEmbedAccess
      }
      canAdministerAllOrgs
      currentOrgId
    }
    Error
  }
}
    `);
export function useGetUserAccessibleOrgsByParamsQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery(GetUserAccessibleOrgsByParamsDocument, options);
}
export function useGetUserAccessibleOrgsByParamsLazyQuery(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery(GetUserAccessibleOrgsByParamsDocument, options);
}
export const UpdateEurekaCompletionsDocument = lazyGql(() => gql `
    mutation updateEurekaCompletions($params: Input_eureka_CompleteRequest) {
  mutationComplete(request: $params) {
    ...eurekaCompletions
  }
}
    ${EurekaCompletionsFragmentDoc}`);
export function useUpdateEurekaCompletionsMutation(baseOptions) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation(UpdateEurekaCompletionsDocument, options);
}
//# sourceMappingURL=graphql-types.js.map